module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "014b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("e53d");
var has = __webpack_require__("07e3");
var DESCRIPTORS = __webpack_require__("8e60");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var META = __webpack_require__("ebfd").KEY;
var $fails = __webpack_require__("294c");
var shared = __webpack_require__("dbdb");
var setToStringTag = __webpack_require__("45f2");
var uid = __webpack_require__("62a0");
var wks = __webpack_require__("5168");
var wksExt = __webpack_require__("ccb9");
var wksDefine = __webpack_require__("6718");
var enumKeys = __webpack_require__("47ee");
var isArray = __webpack_require__("9003");
var anObject = __webpack_require__("e4ae");
var isObject = __webpack_require__("f772");
var toObject = __webpack_require__("241e");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var createDesc = __webpack_require__("aebd");
var _create = __webpack_require__("a159");
var gOPNExt = __webpack_require__("0395");
var $GOPD = __webpack_require__("bf0b");
var $GOPS = __webpack_require__("9aa9");
var $DP = __webpack_require__("d9f6");
var $keys = __webpack_require__("c3a1");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("6abf").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("355d").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("b8e3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("35e8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0395":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("36c3");
var gOPN = __webpack_require__("6abf").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "03e6":
/***/ (function(module, exports) {

module.exports = require("mathjs-expression-parser");

/***/ }),

/***/ "07e3":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "08a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d241");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "09fa":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("4588");
var toLength = __webpack_require__("9def");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("9b43");
var IObject = __webpack_require__("626a");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var asc = __webpack_require__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "0f88":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var uid = __webpack_require__("ca5a");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "0fc9":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "1169":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("52a7");
var createDesc = __webpack_require__("4630");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var has = __webpack_require__("69a8");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "13a1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("96b3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2e632289", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "1654":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("71c1")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("30f1")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1691":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "1991":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var invoke = __webpack_require__("31f4");
var html = __webpack_require__("fab2");
var cel = __webpack_require__("230e");
var global = __webpack_require__("7726");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("2d95")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1bc3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("f772");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "1c4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("9b43");
var $export = __webpack_require__("5ca1");
var toObject = __webpack_require__("4bf8");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var toLength = __webpack_require__("9def");
var createProperty = __webpack_require__("f1ae");
var getIterFn = __webpack_require__("27ee");

$export($export.S + $export.F * !__webpack_require__("5cc5")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
var document = __webpack_require__("e53d").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "1fa8":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("cb7c");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "2099":
/***/ (function(module, exports) {

ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
"use strict";
var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var lang = acequire("./lib/lang");
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;
var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var Tokenizer = acequire("./tokenizer").Tokenizer;
var comparePoints = Range.comparePoints;

var SnippetManager = function() {
    this.snippetMap = {};
    this.snippetNameMap = {};
};

(function() {
    oop.implement(this, EventEmitter);
    
    this.getTokenizer = function() {
        function TabstopToken(str, _, stack) {
            str = str.substr(1);
            if (/^\d+$/.test(str) && !stack.inFormatString)
                return [{tabstopId: parseInt(str, 10)}];
            return [{text: str}];
        }
        function escape(ch) {
            return "(?:[^\\\\" + ch + "]|\\\\.)";
        }
        SnippetManager.$tokenizer = new Tokenizer({
            start: [
                {regex: /:/, onMatch: function(val, state, stack) {
                    if (stack.length && stack[0].expectIf) {
                        stack[0].expectIf = false;
                        stack[0].elseBranch = stack[0];
                        return [stack[0]];
                    }
                    return ":";
                }},
                {regex: /\\./, onMatch: function(val, state, stack) {
                    var ch = val[1];
                    if (ch == "}" && stack.length) {
                        val = ch;
                    }else if ("`$\\".indexOf(ch) != -1) {
                        val = ch;
                    } else if (stack.inFormatString) {
                        if (ch == "n")
                            val = "\n";
                        else if (ch == "t")
                            val = "\n";
                        else if ("ulULE".indexOf(ch) != -1) {
                            val = {changeCase: ch, local: ch > "a"};
                        }
                    }

                    return [val];
                }},
                {regex: /}/, onMatch: function(val, state, stack) {
                    return [stack.length ? stack.shift() : val];
                }},
                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
                    var t = TabstopToken(str.substr(1), state, stack);
                    stack.unshift(t[0]);
                    return t;
                }, next: "snippetVar"},
                {regex: /\n/, token: "newline", merge: false}
            ],
            snippetVar: [
                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
                    stack[0].choices = val.slice(1, -1).split(",");
                }, next: "start"},
                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
                 onMatch: function(val, state, stack) {
                    var ts = stack[0];
                    ts.fmtString = val;

                    val = this.splitRegex.exec(val);
                    ts.guard = val[1];
                    ts.fmt = val[2];
                    ts.flag = val[3];
                    return "";
                }, next: "start"},
                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
                    stack[0].code = val.splice(1, -1);
                    return "";
                }, next: "start"},
                {regex: "\\?", onMatch: function(val, state, stack) {
                    if (stack[0])
                        stack[0].expectIf = true;
                }, next: "start"},
                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
            ],
            formatString: [
                {regex: "/(" + escape("/") + "+)/", token: "regex"},
                {regex: "", onMatch: function(val, state, stack) {
                    stack.inFormatString = true;
                }, next: "start"}
            ]
        });
        SnippetManager.prototype.getTokenizer = function() {
            return SnippetManager.$tokenizer;
        };
        return SnippetManager.$tokenizer;
    };

    this.tokenizeTmSnippet = function(str, startState) {
        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
            return x.value || x;
        });
    };

    this.$getDefaultValue = function(editor, name) {
        if (/^[A-Z]\d+$/.test(name)) {
            var i = name.substr(1);
            return (this.variables[name[0] + "__"] || {})[i];
        }
        if (/^\d+$/.test(name)) {
            return (this.variables.__ || {})[name];
        }
        name = name.replace(/^TM_/, "");

        if (!editor)
            return;
        var s = editor.session;
        switch(name) {
            case "CURRENT_WORD":
                var r = s.getWordRange();
            case "SELECTION":
            case "SELECTED_TEXT":
                return s.getTextRange(r);
            case "CURRENT_LINE":
                return s.getLine(editor.getCursorPosition().row);
            case "PREV_LINE": // not possible in textmate
                return s.getLine(editor.getCursorPosition().row - 1);
            case "LINE_INDEX":
                return editor.getCursorPosition().column;
            case "LINE_NUMBER":
                return editor.getCursorPosition().row + 1;
            case "SOFT_TABS":
                return s.getUseSoftTabs() ? "YES" : "NO";
            case "TAB_SIZE":
                return s.getTabSize();
            case "FILENAME":
            case "FILEPATH":
                return "";
            case "FULLNAME":
                return "Ace";
        }
    };
    this.variables = {};
    this.getVariableValue = function(editor, varName) {
        if (this.variables.hasOwnProperty(varName))
            return this.variables[varName](editor, varName) || "";
        return this.$getDefaultValue(editor, varName) || "";
    };
    this.tmStrFormat = function(str, ch, editor) {
        var flag = ch.flag || "";
        var re = ch.guard;
        re = new RegExp(re, flag.replace(/[^gi]/, ""));
        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
        var _self = this;
        var formatted = str.replace(re, function() {
            _self.variables.__ = arguments;
            var fmtParts = _self.resolveVariables(fmtTokens, editor);
            var gChangeCase = "E";
            for (var i  = 0; i < fmtParts.length; i++) {
                var ch = fmtParts[i];
                if (typeof ch == "object") {
                    fmtParts[i] = "";
                    if (ch.changeCase && ch.local) {
                        var next = fmtParts[i + 1];
                        if (next && typeof next == "string") {
                            if (ch.changeCase == "u")
                                fmtParts[i] = next[0].toUpperCase();
                            else
                                fmtParts[i] = next[0].toLowerCase();
                            fmtParts[i + 1] = next.substr(1);
                        }
                    } else if (ch.changeCase) {
                        gChangeCase = ch.changeCase;
                    }
                } else if (gChangeCase == "U") {
                    fmtParts[i] = ch.toUpperCase();
                } else if (gChangeCase == "L") {
                    fmtParts[i] = ch.toLowerCase();
                }
            }
            return fmtParts.join("");
        });
        this.variables.__ = null;
        return formatted;
    };

    this.resolveVariables = function(snippet, editor) {
        var result = [];
        for (var i = 0; i < snippet.length; i++) {
            var ch = snippet[i];
            if (typeof ch == "string") {
                result.push(ch);
            } else if (typeof ch != "object") {
                continue;
            } else if (ch.skip) {
                gotoNext(ch);
            } else if (ch.processed < i) {
                continue;
            } else if (ch.text) {
                var value = this.getVariableValue(editor, ch.text);
                if (value && ch.fmtString)
                    value = this.tmStrFormat(value, ch);
                ch.processed = i;
                if (ch.expectIf == null) {
                    if (value) {
                        result.push(value);
                        gotoNext(ch);
                    }
                } else {
                    if (value) {
                        ch.skip = ch.elseBranch;
                    } else
                        gotoNext(ch);
                }
            } else if (ch.tabstopId != null) {
                result.push(ch);
            } else if (ch.changeCase != null) {
                result.push(ch);
            }
        }
        function gotoNext(ch) {
            var i1 = snippet.indexOf(ch, i + 1);
            if (i1 != -1)
                i = i1;
        }
        return result;
    };

    this.insertSnippetForSelection = function(editor, snippetText) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var tabString = editor.session.getTabString();
        var indentString = line.match(/^\s*/)[0];
        
        if (cursor.column < indentString.length)
            indentString = indentString.slice(0, cursor.column);

        snippetText = snippetText.replace(/\r/g, "");
        var tokens = this.tokenizeTmSnippet(snippetText);
        tokens = this.resolveVariables(tokens, editor);
        tokens = tokens.map(function(x) {
            if (x == "\n")
                return x + indentString;
            if (typeof x == "string")
                return x.replace(/\t/g, tabString);
            return x;
        });
        var tabstops = [];
        tokens.forEach(function(p, i) {
            if (typeof p != "object")
                return;
            var id = p.tabstopId;
            var ts = tabstops[id];
            if (!ts) {
                ts = tabstops[id] = [];
                ts.index = id;
                ts.value = "";
            }
            if (ts.indexOf(p) !== -1)
                return;
            ts.push(p);
            var i1 = tokens.indexOf(p, i + 1);
            if (i1 === -1)
                return;

            var value = tokens.slice(i + 1, i1);
            var isNested = value.some(function(t) {return typeof t === "object";});
            if (isNested && !ts.value) {
                ts.value = value;
            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
                ts.value = value.join("");
            }
        });
        tabstops.forEach(function(ts) {ts.length = 0;});
        var expanding = {};
        function copyValue(val) {
            var copy = [];
            for (var i = 0; i < val.length; i++) {
                var p = val[i];
                if (typeof p == "object") {
                    if (expanding[p.tabstopId])
                        continue;
                    var j = val.lastIndexOf(p, i - 1);
                    p = copy[j] || {tabstopId: p.tabstopId};
                }
                copy[i] = p;
            }
            return copy;
        }
        for (var i = 0; i < tokens.length; i++) {
            var p = tokens[i];
            if (typeof p != "object")
                continue;
            var id = p.tabstopId;
            var i1 = tokens.indexOf(p, i + 1);
            if (expanding[id]) {
                if (expanding[id] === p)
                    expanding[id] = null;
                continue;
            }
            
            var ts = tabstops[id];
            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
            arg.unshift(i + 1, Math.max(0, i1 - i));
            arg.push(p);
            expanding[id] = p;
            tokens.splice.apply(tokens, arg);

            if (ts.indexOf(p) === -1)
                ts.push(p);
        }
        var row = 0, column = 0;
        var text = "";
        tokens.forEach(function(t) {
            if (typeof t === "string") {
                var lines = t.split("\n");
                if (lines.length > 1){
                    column = lines[lines.length - 1].length;
                    row += lines.length - 1;
                } else
                    column += t.length;
                text += t;
            } else {
                if (!t.start)
                    t.start = {row: row, column: column};
                else
                    t.end = {row: row, column: column};
            }
        });
        var range = editor.getSelectionRange();
        var end = editor.session.replace(range, text);

        var tabstopManager = new TabstopManager(editor);
        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
    };
    
    this.insertSnippet = function(editor, snippetText) {
        var self = this;
        if (editor.inVirtualSelectionMode)
            return self.insertSnippetForSelection(editor, snippetText);
        
        editor.forEachSelection(function() {
            self.insertSnippetForSelection(editor, snippetText);
        }, null, {keepOrder: true});
        
        if (editor.tabstopManager)
            editor.tabstopManager.tabNext();
    };

    this.$getScope = function(editor) {
        var scope = editor.session.$mode.$id || "";
        scope = scope.split("/").pop();
        if (scope === "html" || scope === "php") {
            if (scope === "php" && !editor.session.$mode.inlinePhp) 
                scope = "html";
            var c = editor.getCursorPosition();
            var state = editor.session.getState(c.row);
            if (typeof state === "object") {
                state = state[0];
            }
            if (state.substring) {
                if (state.substring(0, 3) == "js-")
                    scope = "javascript";
                else if (state.substring(0, 4) == "css-")
                    scope = "css";
                else if (state.substring(0, 4) == "php-")
                    scope = "php";
            }
        }
        
        return scope;
    };

    this.getActiveScopes = function(editor) {
        var scope = this.$getScope(editor);
        var scopes = [scope];
        var snippetMap = this.snippetMap;
        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
        }
        scopes.push("_");
        return scopes;
    };

    this.expandWithTab = function(editor, options) {
        var self = this;
        var result = editor.forEachSelection(function() {
            return self.expandSnippetForSelection(editor, options);
        }, null, {keepOrder: true});
        if (result && editor.tabstopManager)
            editor.tabstopManager.tabNext();
        return result;
    };
    
    this.expandSnippetForSelection = function(editor, options) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var before = line.substring(0, cursor.column);
        var after = line.substr(cursor.column);

        var snippetMap = this.snippetMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = this.findMatchingSnippet(snippets, before, after);
            return !!snippet;
        }, this);
        if (!snippet)
            return false;
        if (options && options.dryRun)
            return true;
        editor.session.doc.removeInLine(cursor.row,
            cursor.column - snippet.replaceBefore.length,
            cursor.column + snippet.replaceAfter.length
        );

        this.variables.M__ = snippet.matchBefore;
        this.variables.T__ = snippet.matchAfter;
        this.insertSnippetForSelection(editor, snippet.content);

        this.variables.M__ = this.variables.T__ = null;
        return true;
    };

    this.findMatchingSnippet = function(snippetList, before, after) {
        for (var i = snippetList.length; i--;) {
            var s = snippetList[i];
            if (s.startRe && !s.startRe.test(before))
                continue;
            if (s.endRe && !s.endRe.test(after))
                continue;
            if (!s.startRe && !s.endRe)
                continue;

            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
            return s;
        }
    };

    this.snippetMap = {};
    this.snippetNameMap = {};
    this.register = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;
        var self = this;
        
        if (!snippets) 
            snippets = [];
        
        function wrapRegexp(src) {
            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
                src = "(?:" + src + ")";

            return src || "";
        }
        function guardedRegexp(re, guard, opening) {
            re = wrapRegexp(re);
            guard = wrapRegexp(guard);
            if (opening) {
                re = guard + re;
                if (re && re[re.length - 1] != "$")
                    re = re + "$";
            } else {
                re = re + guard;
                if (re && re[0] != "^")
                    re = "^" + re;
            }
            return new RegExp(re);
        }

        function addSnippet(s) {
            if (!s.scope)
                s.scope = scope || "_";
            scope = s.scope;
            if (!snippetMap[scope]) {
                snippetMap[scope] = [];
                snippetNameMap[scope] = {};
            }

            var map = snippetNameMap[scope];
            if (s.name) {
                var old = map[s.name];
                if (old)
                    self.unregister(old);
                map[s.name] = s;
            }
            snippetMap[scope].push(s);

            if (s.tabTrigger && !s.trigger) {
                if (!s.guard && /^\w/.test(s.tabTrigger))
                    s.guard = "\\b";
                s.trigger = lang.escapeRegExp(s.tabTrigger);
            }
            
            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
                return;
            
            s.startRe = guardedRegexp(s.trigger, s.guard, true);
            s.triggerRe = new RegExp(s.trigger, "", true);

            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
        }

        if (snippets && snippets.content)
            addSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(addSnippet);
        
        this._signal("registerSnippets", {scope: scope});
    };
    this.unregister = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;

        function removeSnippet(s) {
            var nameMap = snippetNameMap[s.scope||scope];
            if (nameMap && nameMap[s.name]) {
                delete nameMap[s.name];
                var map = snippetMap[s.scope||scope];
                var i = map && map.indexOf(s);
                if (i >= 0)
                    map.splice(i, 1);
            }
        }
        if (snippets.content)
            removeSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(removeSnippet);
    };
    this.parseSnippetFile = function(str) {
        str = str.replace(/\r/g, "");
        var list = [], snippet = {};
        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
        var m;
        while (m = re.exec(str)) {
            if (m[1]) {
                try {
                    snippet = JSON.parse(m[1]);
                    list.push(snippet);
                } catch (e) {}
            } if (m[4]) {
                snippet.content = m[4].replace(/^\t/gm, "");
                list.push(snippet);
                snippet = {};
            } else {
                var key = m[2], val = m[3];
                if (key == "regex") {
                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
                    snippet.guard = guardRe.exec(val)[1];
                    snippet.trigger = guardRe.exec(val)[1];
                    snippet.endTrigger = guardRe.exec(val)[1];
                    snippet.endGuard = guardRe.exec(val)[1];
                } else if (key == "snippet") {
                    snippet.tabTrigger = val.match(/^\S*/)[0];
                    if (!snippet.name)
                        snippet.name = val;
                } else {
                    snippet[key] = val;
                }
            }
        }
        return list;
    };
    this.getSnippetByName = function(name, editor) {
        var snippetMap = this.snippetNameMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = snippets[name];
            return !!snippet;
        }, this);
        return snippet;
    };

}).call(SnippetManager.prototype);


var TabstopManager = function(editor) {
    if (editor.tabstopManager)
        return editor.tabstopManager;
    editor.tabstopManager = this;
    this.$onChange = this.onChange.bind(this);
    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
    this.$onChangeSession = this.onChangeSession.bind(this);
    this.$onAfterExec = this.onAfterExec.bind(this);
    this.attach(editor);
};
(function() {
    this.attach = function(editor) {
        this.index = 0;
        this.ranges = [];
        this.tabstops = [];
        this.$openTabstops = null;
        this.selectedTabstop = null;

        this.editor = editor;
        this.editor.on("change", this.$onChange);
        this.editor.on("changeSelection", this.$onChangeSelection);
        this.editor.on("changeSession", this.$onChangeSession);
        this.editor.commands.on("afterExec", this.$onAfterExec);
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.detach = function() {
        this.tabstops.forEach(this.removeTabstopMarkers, this);
        this.ranges = null;
        this.tabstops = null;
        this.selectedTabstop = null;
        this.editor.removeListener("change", this.$onChange);
        this.editor.removeListener("changeSelection", this.$onChangeSelection);
        this.editor.removeListener("changeSession", this.$onChangeSession);
        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.tabstopManager = null;
        this.editor = null;
    };

    this.onChange = function(delta) {
        var changeRange = delta;
        var isRemove = delta.action[0] == "r";
        var start = delta.start;
        var end = delta.end;
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;
        var colDiff = end.column - start.column;

        if (isRemove) {
            lineDif = -lineDif;
            colDiff = -colDiff;
        }
        if (!this.$inChange && isRemove) {
            var ts = this.selectedTabstop;
            var changedOutside = ts && !ts.some(function(r) {
                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
            });
            if (changedOutside)
                return this.detach();
        }
        var ranges = this.ranges;
        for (var i = 0; i < ranges.length; i++) {
            var r = ranges[i];
            if (r.end.row < start.row)
                continue;

            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
                this.removeRange(r);
                i--;
                continue;
            }

            if (r.start.row == startRow && r.start.column > start.column)
                r.start.column += colDiff;
            if (r.end.row == startRow && r.end.column >= start.column)
                r.end.column += colDiff;
            if (r.start.row >= startRow)
                r.start.row += lineDif;
            if (r.end.row >= startRow)
                r.end.row += lineDif;

            if (comparePoints(r.start, r.end) > 0)
                this.removeRange(r);
        }
        if (!ranges.length)
            this.detach();
    };
    this.updateLinkedFields = function() {
        var ts = this.selectedTabstop;
        if (!ts || !ts.hasLinkedRanges)
            return;
        this.$inChange = true;
        var session = this.editor.session;
        var text = session.getTextRange(ts.firstNonLinked);
        for (var i = ts.length; i--;) {
            var range = ts[i];
            if (!range.linked)
                continue;
            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
            session.replace(range, fmt);
        }
        this.$inChange = false;
    };
    this.onAfterExec = function(e) {
        if (e.command && !e.command.readOnly)
            this.updateLinkedFields();
    };
    this.onChangeSelection = function() {
        if (!this.editor)
            return;
        var lead = this.editor.selection.lead;
        var anchor = this.editor.selection.anchor;
        var isEmpty = this.editor.selection.isEmpty();
        for (var i = this.ranges.length; i--;) {
            if (this.ranges[i].linked)
                continue;
            var containsLead = this.ranges[i].contains(lead.row, lead.column);
            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
            if (containsLead && containsAnchor)
                return;
        }
        this.detach();
    };
    this.onChangeSession = function() {
        this.detach();
    };
    this.tabNext = function(dir) {
        var max = this.tabstops.length;
        var index = this.index + (dir || 1);
        index = Math.min(Math.max(index, 1), max);
        if (index == max)
            index = 0;
        this.selectTabstop(index);
        if (index === 0)
            this.detach();
    };
    this.selectTabstop = function(index) {
        this.$openTabstops = null;
        var ts = this.tabstops[this.index];
        if (ts)
            this.addTabstopMarkers(ts);
        this.index = index;
        ts = this.tabstops[this.index];
        if (!ts || !ts.length)
            return;
        
        this.selectedTabstop = ts;
        if (!this.editor.inVirtualSelectionMode) {        
            var sel = this.editor.multiSelect;
            sel.toSingleRange(ts.firstNonLinked.clone());
            for (var i = ts.length; i--;) {
                if (ts.hasLinkedRanges && ts[i].linked)
                    continue;
                sel.addRange(ts[i].clone(), true);
            }
            if (sel.ranges[0])
                sel.addRange(sel.ranges[0].clone());
        } else {
            this.editor.selection.setRange(ts.firstNonLinked);
        }
        
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.addTabstops = function(tabstops, start, end) {
        if (!this.$openTabstops)
            this.$openTabstops = [];
        if (!tabstops[0]) {
            var p = Range.fromPoints(end, end);
            moveRelative(p.start, start);
            moveRelative(p.end, start);
            tabstops[0] = [p];
            tabstops[0].index = 0;
        }

        var i = this.index;
        var arg = [i + 1, 0];
        var ranges = this.ranges;
        tabstops.forEach(function(ts, index) {
            var dest = this.$openTabstops[index] || ts;
                
            for (var i = ts.length; i--;) {
                var p = ts[i];
                var range = Range.fromPoints(p.start, p.end || p.start);
                movePoint(range.start, start);
                movePoint(range.end, start);
                range.original = p;
                range.tabstop = dest;
                ranges.push(range);
                if (dest != ts)
                    dest.unshift(range);
                else
                    dest[i] = range;
                if (p.fmtString) {
                    range.linked = true;
                    dest.hasLinkedRanges = true;
                } else if (!dest.firstNonLinked)
                    dest.firstNonLinked = range;
            }
            if (!dest.firstNonLinked)
                dest.hasLinkedRanges = false;
            if (dest === ts) {
                arg.push(dest);
                this.$openTabstops[index] = dest;
            }
            this.addTabstopMarkers(dest);
        }, this);
        
        if (arg.length > 2) {
            if (this.tabstops.length)
                arg.push(arg.splice(2, 1)[0]);
            this.tabstops.splice.apply(this.tabstops, arg);
        }
    };

    this.addTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            if  (!range.markerId)
                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
        });
    };
    this.removeTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            session.removeMarker(range.markerId);
            range.markerId = null;
        });
    };
    this.removeRange = function(range) {
        var i = range.tabstop.indexOf(range);
        range.tabstop.splice(i, 1);
        i = this.ranges.indexOf(range);
        this.ranges.splice(i, 1);
        this.editor.session.removeMarker(range.markerId);
        if (!range.tabstop.length) {
            i = this.tabstops.indexOf(range.tabstop);
            if (i != -1)
                this.tabstops.splice(i, 1);
            if (!this.tabstops.length)
                this.detach();
        }
    };

    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys({
        "Tab": function(ed) {
            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
                return;
            }

            ed.tabstopManager.tabNext(1);
        },
        "Shift-Tab": function(ed) {
            ed.tabstopManager.tabNext(-1);
        },
        "Esc": function(ed) {
            ed.tabstopManager.detach();
        },
        "Return": function(ed) {
            return false;
        }
    });
}).call(TabstopManager.prototype);



var changeTracker = {};
changeTracker.onChange = Anchor.prototype.onChange;
changeTracker.setPosition = function(row, column) {
    this.pos.row = row;
    this.pos.column = column;
};
changeTracker.update = function(pos, delta, $insertRight) {
    this.$insertRight = $insertRight;
    this.pos = pos; 
    this.onChange(delta);
};

var movePoint = function(point, diff) {
    if (point.row == 0)
        point.column += diff.column;
    point.row += diff.row;
};

var moveRelative = function(point, start) {
    if (point.row == start.row)
        point.column -= start.column;
    point.row -= start.row;
};


acequire("./lib/dom").importCssString("\
.ace_snippet-marker {\
    -moz-box-sizing: border-box;\
    box-sizing: border-box;\
    background: rgba(194, 193, 208, 0.09);\
    border: 1px dotted rgba(211, 208, 235, 0.62);\
    position: absolute;\
}");

exports.snippetManager = new SnippetManager();


var Editor = acequire("./editor").Editor;
(function() {
    this.insertSnippet = function(content, options) {
        return exports.snippetManager.insertSnippet(this, content, options);
    };
    this.expandSnippet = function(options) {
        return exports.snippetManager.expandWithTab(this, options);
    };
}).call(Editor.prototype);

});

ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Renderer = acequire("../virtual_renderer").VirtualRenderer;
var Editor = acequire("../editor").Editor;
var Range = acequire("../range").Range;
var event = acequire("../lib/event");
var lang = acequire("../lib/lang");
var dom = acequire("../lib/dom");

var $singleLineEditor = function(el) {
    var renderer = new Renderer(el);

    renderer.$maxLines = 4;

    var editor = new Editor(renderer);

    editor.setHighlightActiveLine(false);
    editor.setShowPrintMargin(false);
    editor.renderer.setShowGutter(false);
    editor.renderer.setHighlightGutterLine(false);

    editor.$mouseHandler.$focusWaitTimout = 0;
    editor.$highlightTagPending = true;

    return editor;
};

var AcePopup = function(parentNode) {
    var el = dom.createElement("div");
    var popup = new $singleLineEditor(el);

    if (parentNode)
        parentNode.appendChild(el);
    el.style.display = "none";
    popup.renderer.content.style.cursor = "default";
    popup.renderer.setStyle("ace_autocomplete");

    popup.setOption("displayIndentGuides", false);
    popup.setOption("dragDelay", 150);

    var noop = function(){};

    popup.focus = noop;
    popup.$isFocused = true;

    popup.renderer.$cursorLayer.restartTimer = noop;
    popup.renderer.$cursorLayer.element.style.opacity = 0;

    popup.renderer.$maxLines = 8;
    popup.renderer.$keepTextAreaAtCursor = false;

    popup.setHighlightActiveLine(false);
    popup.session.highlight("");
    popup.session.$searchHighlight.clazz = "ace_highlight-marker";

    popup.on("mousedown", function(e) {
        var pos = e.getDocumentPosition();
        popup.selection.moveToPosition(pos);
        selectionMarker.start.row = selectionMarker.end.row = pos.row;
        e.stop();
    });

    var lastMouseEvent;
    var hoverMarker = new Range(-1,0,-1,Infinity);
    var selectionMarker = new Range(-1,0,-1,Infinity);
    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
    popup.setSelectOnHover = function(val) {
        if (!val) {
            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
        } else if (hoverMarker.id) {
            popup.session.removeMarker(hoverMarker.id);
            hoverMarker.id = null;
        }
    };
    popup.setSelectOnHover(false);
    popup.on("mousemove", function(e) {
        if (!lastMouseEvent) {
            lastMouseEvent = e;
            return;
        }
        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
            return;
        }
        lastMouseEvent = e;
        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
        var row = lastMouseEvent.getDocumentPosition().row;
        if (hoverMarker.start.row != row) {
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row);
        }
    });
    popup.renderer.on("beforeRender", function() {
        if (lastMouseEvent && hoverMarker.start.row != -1) {
            lastMouseEvent.$pos = null;
            var row = lastMouseEvent.getDocumentPosition().row;
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row, true);
        }
    });
    popup.renderer.on("afterRender", function() {
        var row = popup.getRow();
        var t = popup.renderer.$textLayer;
        var selected = t.element.childNodes[row - t.config.firstRow];
        if (selected == t.selectedNode)
            return;
        if (t.selectedNode)
            dom.removeCssClass(t.selectedNode, "ace_selected");
        t.selectedNode = selected;
        if (selected)
            dom.addCssClass(selected, "ace_selected");
    });
    var hideHoverMarker = function() { setHoverMarker(-1); };
    var setHoverMarker = function(row, suppressRedraw) {
        if (row !== hoverMarker.start.row) {
            hoverMarker.start.row = hoverMarker.end.row = row;
            if (!suppressRedraw)
                popup.session._emit("changeBackMarker");
            popup._emit("changeHoverMarker");
        }
    };
    popup.getHoveredRow = function() {
        return hoverMarker.start.row;
    };

    event.addListener(popup.container, "mouseout", hideHoverMarker);
    popup.on("hide", hideHoverMarker);
    popup.on("changeSelection", hideHoverMarker);

    popup.session.doc.getLength = function() {
        return popup.data.length;
    };
    popup.session.doc.getLine = function(i) {
        var data = popup.data[i];
        if (typeof data == "string")
            return data;
        return (data && data.value) || "";
    };

    var bgTokenizer = popup.session.bgTokenizer;
    bgTokenizer.$tokenizeRow = function(row) {
        var data = popup.data[row];
        var tokens = [];
        if (!data)
            return tokens;
        if (typeof data == "string")
            data = {value: data};
        if (!data.caption)
            data.caption = data.value || data.name;

        var last = -1;
        var flag, c;
        for (var i = 0; i < data.caption.length; i++) {
            c = data.caption[i];
            flag = data.matchMask & (1 << i) ? 1 : 0;
            if (last !== flag) {
                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
                last = flag;
            } else {
                tokens[tokens.length - 1].value += c;
            }
        }

        if (data.meta) {
            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
            var metaData = data.meta;
            if (metaData.length + data.caption.length > maxW - 2) {
                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026";
            }
            tokens.push({type: "rightAlignedText", value: metaData});
        }
        return tokens;
    };
    bgTokenizer.$updateOnChange = noop;
    bgTokenizer.start = noop;

    popup.session.$computeWidth = function() {
        return this.screenWidth = 0;
    };

    popup.$blockScrolling = Infinity;
    popup.isOpen = false;
    popup.isTopdown = false;
    popup.autoSelect = true;

    popup.data = [];
    popup.setData = function(list) {
        popup.setValue(lang.stringRepeat("\n", list.length), -1);
        popup.data = list || [];
        popup.setRow(0);
    };
    popup.getData = function(row) {
        return popup.data[row];
    };

    popup.getRow = function() {
        return selectionMarker.start.row;
    };
    popup.setRow = function(line) {
        line = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length, line));
        if (selectionMarker.start.row != line) {
            popup.selection.clearSelection();
            selectionMarker.start.row = selectionMarker.end.row = line || 0;
            popup.session._emit("changeBackMarker");
            popup.moveCursorTo(line || 0, 0);
            if (popup.isOpen)
                popup._signal("select");
        }
    };

    popup.on("changeSelection", function() {
        if (popup.isOpen)
            popup.setRow(popup.selection.lead.row);
        popup.renderer.scrollCursorIntoView();
    });

    popup.hide = function() {
        this.container.style.display = "none";
        this._signal("hide");
        popup.isOpen = false;
    };
    popup.show = function(pos, lineHeight, topdownOnly) {
        var el = this.container;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var renderer = this.renderer;
        var maxH = renderer.$maxLines * lineHeight * 1.4;
        var top = pos.top + this.$borderSize;
        var allowTopdown = top > screenHeight / 2 && !topdownOnly;
        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
            renderer.$maxPixelHeight = top - 2 * this.$borderSize;
            el.style.top = "";
            el.style.bottom = screenHeight - top + "px";
            popup.isTopdown = false;
        } else {
            top += lineHeight;
            renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
            el.style.top = top + "px";
            el.style.bottom = "";
            popup.isTopdown = true;
        }

        el.style.display = "";
        this.renderer.$textLayer.checkForSizeChanges();

        var left = pos.left;
        if (left + el.offsetWidth > screenWidth)
            left = screenWidth - el.offsetWidth;

        el.style.left = left + "px";

        this._signal("show");
        lastMouseEvent = null;
        popup.isOpen = true;
    };

    popup.getTextLeftOffset = function() {
        return this.$borderSize + this.renderer.$padding + this.$imageSize;
    };

    popup.$imageSize = 0;
    popup.$borderSize = 1;

    return popup;
};

dom.importCssString("\
.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
    background-color: #CAD6FA;\
    z-index: 1;\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    border: 1px solid #abbffe;\
    margin-top: -1px;\
    background: rgba(233,233,253,0.4);\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    position: absolute;\
    z-index: 2;\
}\
.ace_editor.ace_autocomplete .ace_scroller {\
   background: none;\
   border: none;\
   box-shadow: none;\
}\
.ace_rightAlignedText {\
    color: gray;\
    display: inline-block;\
    position: absolute;\
    right: 4px;\
    text-align: right;\
    z-index: -1;\
}\
.ace_editor.ace_autocomplete .ace_completion-highlight{\
    color: #000;\
    text-shadow: 0 0 0.01em;\
}\
.ace_editor.ace_autocomplete {\
    width: 280px;\
    z-index: 200000;\
    background: #fbfbfb;\
    color: #444;\
    border: 1px lightgray solid;\
    position: fixed;\
    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
    line-height: 1.4;\
}");

exports.AcePopup = AcePopup;

});

ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.parForEach = function(array, fn, callback) {
    var completed = 0;
    var arLength = array.length;
    if (arLength === 0)
        callback();
    for (var i = 0; i < arLength; i++) {
        fn(array[i], function(result, err) {
            completed++;
            if (completed === arLength)
                callback(result, err);
        });
    }
};

var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;

exports.retrievePrecedingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos-1; i >= 0; i--) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf.reverse().join("");
};

exports.retrieveFollowingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos; i < text.length; i++) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf;
};

exports.getCompletionPrefix = function (editor) {
    var pos = editor.getCursorPosition();
    var line = editor.session.getLine(pos.row);
    var prefix;
    editor.completers.forEach(function(completer) {
        if (completer.identifierRegexps) {
            completer.identifierRegexps.forEach(function(identifierRegex) {
                if (!prefix && identifierRegex)
                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
            }.bind(this));
        }
    }.bind(this));
    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
};

});

ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
"use strict";

var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var AcePopup = acequire("./autocomplete/popup").AcePopup;
var util = acequire("./autocomplete/util");
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var dom = acequire("./lib/dom");
var snippetManager = acequire("./snippets").snippetManager;

var Autocomplete = function() {
    this.autoInsert = false;
    this.autoSelect = true;
    this.exactMatch = false;
    this.gatherCompletionsId = 0;
    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys(this.commands);

    this.blurListener = this.blurListener.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.mousedownListener = this.mousedownListener.bind(this);
    this.mousewheelListener = this.mousewheelListener.bind(this);

    this.changeTimer = lang.delayedCall(function() {
        this.updateCompletions(true);
    }.bind(this));

    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
};

(function() {

    this.$init = function() {
        this.popup = new AcePopup(document.body || document.documentElement);
        this.popup.on("click", function(e) {
            this.insertMatch();
            e.stop();
        }.bind(this));
        this.popup.focus = this.editor.focus.bind(this.editor);
        this.popup.on("show", this.tooltipTimer.bind(null, null));
        this.popup.on("select", this.tooltipTimer.bind(null, null));
        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
        return this.popup;
    };

    this.getPopup = function() {
        return this.popup || this.$init();
    };

    this.openPopup = function(editor, prefix, keepPopupPosition) {
        if (!this.popup)
            this.$init();

	this.popup.autoSelect = this.autoSelect;

        this.popup.setData(this.completions.filtered);

        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        
        var renderer = editor.renderer;
        this.popup.setRow(this.autoSelect ? 0 : -1);
        if (!keepPopupPosition) {
            this.popup.setTheme(editor.getTheme());
            this.popup.setFontSize(editor.getFontSize());

            var lineHeight = renderer.layerConfig.lineHeight;

            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
            pos.left -= this.popup.getTextLeftOffset();

            var rect = editor.container.getBoundingClientRect();
            pos.top += rect.top - renderer.layerConfig.offset;
            pos.left += rect.left - editor.renderer.scrollLeft;
            pos.left += renderer.gutterWidth;

            this.popup.show(pos, lineHeight);
        } else if (keepPopupPosition && !prefix) {
            this.detach();
        }
    };

    this.detach = function() {
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.off("changeSelection", this.changeListener);
        this.editor.off("blur", this.blurListener);
        this.editor.off("mousedown", this.mousedownListener);
        this.editor.off("mousewheel", this.mousewheelListener);
        this.changeTimer.cancel();
        this.hideDocTooltip();

        this.gatherCompletionsId += 1;
        if (this.popup && this.popup.isOpen)
            this.popup.hide();

        if (this.base)
            this.base.detach();
        this.activated = false;
        this.completions = this.base = null;
    };

    this.changeListener = function(e) {
        var cursor = this.editor.selection.lead;
        if (cursor.row != this.base.row || cursor.column < this.base.column) {
            this.detach();
        }
        if (this.activated)
            this.changeTimer.schedule();
        else
            this.detach();
    };

    this.blurListener = function(e) {
        var el = document.activeElement;
        var text = this.editor.textInput.getElement();
        var fromTooltip = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget);
        var container = this.popup && this.popup.container;
        if (el != text && el.parentNode != container && !fromTooltip
            && el != this.tooltipNode && e.relatedTarget != text
        ) {
            this.detach();
        }
    };

    this.mousedownListener = function(e) {
        this.detach();
    };

    this.mousewheelListener = function(e) {
        this.detach();
    };

    this.goTo = function(where) {
        var row = this.popup.getRow();
        var max = this.popup.session.getLength() - 1;

        switch(where) {
            case "up": row = row <= 0 ? max : row - 1; break;
            case "down": row = row >= max ? -1 : row + 1; break;
            case "start": row = 0; break;
            case "end": row = max; break;
        }

        this.popup.setRow(row);
    };

    this.insertMatch = function(data, options) {
        if (!data)
            data = this.popup.getData(this.popup.getRow());
        if (!data)
            return false;

        if (data.completer && data.completer.insertMatch) {
            data.completer.insertMatch(this.editor, data);
        } else {
            if (this.completions.filterText) {
                var ranges = this.editor.selection.getAllRanges();
                for (var i = 0, range; range = ranges[i]; i++) {
                    range.start.column -= this.completions.filterText.length;
                    this.editor.session.remove(range);
                }
            }
            if (data.snippet)
                snippetManager.insertSnippet(this.editor, data.snippet);
            else
                this.editor.execCommand("insertstring", data.value || data);
        }
        this.detach();
    };


    this.commands = {
        "Up": function(editor) { editor.completer.goTo("up"); },
        "Down": function(editor) { editor.completer.goTo("down"); },
        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },

        "Esc": function(editor) { editor.completer.detach(); },
        "Return": function(editor) { return editor.completer.insertMatch(); },
        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
        "Tab": function(editor) {
            var result = editor.completer.insertMatch();
            if (!result && !editor.tabstopManager)
                editor.completer.goTo("down");
            else
                return result;
        },

        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
    };

    this.gatherCompletions = function(editor, callback) {
        var session = editor.getSession();
        var pos = editor.getCursorPosition();

        var prefix = util.getCompletionPrefix(editor);

        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
        this.base.$insertRight = true;

        var matches = [];
        var total = editor.completers.length;
        editor.completers.forEach(function(completer, i) {
            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
                if (!err && results)
                    matches = matches.concat(results);
                callback(null, {
                    prefix: util.getCompletionPrefix(editor),
                    matches: matches,
                    finished: (--total === 0)
                });
            });
        });
        return true;
    };

    this.showPopup = function(editor) {
        if (this.editor)
            this.detach();

        this.activated = true;

        this.editor = editor;
        if (editor.completer != this) {
            if (editor.completer)
                editor.completer.detach();
            editor.completer = this;
        }

        editor.on("changeSelection", this.changeListener);
        editor.on("blur", this.blurListener);
        editor.on("mousedown", this.mousedownListener);
        editor.on("mousewheel", this.mousewheelListener);

        this.updateCompletions();
    };

    this.updateCompletions = function(keepPopupPosition) {
        if (keepPopupPosition && this.base && this.completions) {
            var pos = this.editor.getCursorPosition();
            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
            if (prefix == this.completions.filterText)
                return;
            this.completions.setFilter(prefix);
            if (!this.completions.filtered.length)
                return this.detach();
            if (this.completions.filtered.length == 1
            && this.completions.filtered[0].value == prefix
            && !this.completions.filtered[0].snippet)
                return this.detach();
            this.openPopup(this.editor, prefix, keepPopupPosition);
            return;
        }
        var _id = this.gatherCompletionsId;
        this.gatherCompletions(this.editor, function(err, results) {
            var detachIfFinished = function() {
                if (!results.finished) return;
                return this.detach();
            }.bind(this);

            var prefix = results.prefix;
            var matches = results && results.matches;

            if (!matches || !matches.length)
                return detachIfFinished();
            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
                return;

            this.completions = new FilteredList(matches);

            if (this.exactMatch)
                this.completions.exactMatch = true;

            this.completions.setFilter(prefix);
            var filtered = this.completions.filtered;
            if (!filtered.length)
                return detachIfFinished();
            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
                return detachIfFinished();
            if (this.autoInsert && filtered.length == 1 && results.finished)
                return this.insertMatch(filtered[0]);

            this.openPopup(this.editor, prefix, keepPopupPosition);
        }.bind(this));
    };

    this.cancelContextMenu = function() {
        this.editor.$mouseHandler.cancelContextMenu();
    };

    this.updateDocTooltip = function() {
        var popup = this.popup;
        var all = popup.data;
        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
        var doc = null;
        if (!selected || !this.editor || !this.popup.isOpen)
            return this.hideDocTooltip();
        this.editor.completers.some(function(completer) {
            if (completer.getDocTooltip)
                doc = completer.getDocTooltip(selected);
            return doc;
        });
        if (!doc)
            doc = selected;

        if (typeof doc == "string")
            doc = {docText: doc};
        if (!doc || !(doc.docHTML || doc.docText))
            return this.hideDocTooltip();
        this.showDocTooltip(doc);
    };

    this.showDocTooltip = function(item) {
        if (!this.tooltipNode) {
            this.tooltipNode = dom.createElement("div");
            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
            this.tooltipNode.style.margin = 0;
            this.tooltipNode.style.pointerEvents = "auto";
            this.tooltipNode.tabIndex = -1;
            this.tooltipNode.onblur = this.blurListener.bind(this);
            this.tooltipNode.onclick = this.onTooltipClick.bind(this);
        }

        var tooltipNode = this.tooltipNode;
        if (item.docHTML) {
            tooltipNode.innerHTML = item.docHTML;
        } else if (item.docText) {
            tooltipNode.textContent = item.docText;
        }

        if (!tooltipNode.parentNode)
            document.body.appendChild(tooltipNode);
        var popup = this.popup;
        var rect = popup.container.getBoundingClientRect();
        tooltipNode.style.top = popup.container.style.top;
        tooltipNode.style.bottom = popup.container.style.bottom;

        if (window.innerWidth - rect.right < 320) {
            tooltipNode.style.right = window.innerWidth - rect.left + "px";
            tooltipNode.style.left = "";
        } else {
            tooltipNode.style.left = (rect.right + 1) + "px";
            tooltipNode.style.right = "";
        }
        tooltipNode.style.display = "block";
    };

    this.hideDocTooltip = function() {
        this.tooltipTimer.cancel();
        if (!this.tooltipNode) return;
        var el = this.tooltipNode;
        if (!this.editor.isFocused() && document.activeElement == el)
            this.editor.focus();
        this.tooltipNode = null;
        if (el.parentNode)
            el.parentNode.removeChild(el);
    };

    this.onTooltipClick = function(e) {
        var a = e.target;
        while (a && a != this.tooltipNode) {
            if (a.nodeName == "A" && a.href) {
                a.rel = "noreferrer";
                a.target = "_blank";
                break;
            }
            a = a.parentNode;
        }
    };

}).call(Autocomplete.prototype);

Autocomplete.startCommand = {
    name: "startAutocomplete",
    exec: function(editor) {
        if (!editor.completer)
            editor.completer = new Autocomplete();
        editor.completer.autoInsert = false;
        editor.completer.autoSelect = true;
        editor.completer.showPopup(editor);
        editor.completer.cancelContextMenu();
    },
    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
};

var FilteredList = function(array, filterText) {
    this.all = array;
    this.filtered = array;
    this.filterText = filterText || "";
    this.exactMatch = false;
};
(function(){
    this.setFilter = function(str) {
        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
            var matches = this.filtered;
        else
            var matches = this.all;

        this.filterText = str;
        matches = this.filterCompletions(matches, this.filterText);
        matches = matches.sort(function(a, b) {
            return b.exactMatch - a.exactMatch || b.score - a.score;
        });
        var prev = null;
        matches = matches.filter(function(item){
            var caption = item.snippet || item.caption || item.value;
            if (caption === prev) return false;
            prev = caption;
            return true;
        });

        this.filtered = matches;
    };
    this.filterCompletions = function(items, needle) {
        var results = [];
        var upper = needle.toUpperCase();
        var lower = needle.toLowerCase();
        loop: for (var i = 0, item; item = items[i]; i++) {
            var caption = item.value || item.caption || item.snippet;
            if (!caption) continue;
            var lastIndex = -1;
            var matchMask = 0;
            var penalty = 0;
            var index, distance;

            if (this.exactMatch) {
                if (needle !== caption.substr(0, needle.length))
                    continue loop;
            }else{
                for (var j = 0; j < needle.length; j++) {
                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
                    if (index < 0)
                        continue loop;
                    distance = index - lastIndex - 1;
                    if (distance > 0) {
                        if (lastIndex === -1)
                            penalty += 10;
                        penalty += distance;
                    }
                    matchMask = matchMask | (1 << index);
                    lastIndex = index;
                }
            }
            item.matchMask = matchMask;
            item.exactMatch = penalty ? 0 : 1;
            item.score = (item.score || 0) - penalty;
            results.push(item);
        }
        return results;
    };
}).call(FilteredList.prototype);

exports.Autocomplete = Autocomplete;
exports.FilteredList = FilteredList;

});

ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
    var Range = acequire("../range").Range;
    
    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

    function getWordIndex(doc, pos) {
        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
        return textBefore.split(splitRegex).length - 1;
    }
    function wordDistance(doc, pos) {
        var prefixPos = getWordIndex(doc, pos);
        var words = doc.getValue().split(splitRegex);
        var wordScores = Object.create(null);
        
        var currentWord = words[prefixPos];

        words.forEach(function(word, idx) {
            if (!word || word === currentWord) return;

            var distance = Math.abs(prefixPos - idx);
            var score = words.length - distance;
            if (wordScores[word]) {
                wordScores[word] = Math.max(score, wordScores[word]);
            } else {
                wordScores[word] = score;
            }
        });
        return wordScores;
    }

    exports.getCompletions = function(editor, session, pos, prefix, callback) {
        var wordScore = wordDistance(session, pos, prefix);
        var wordList = Object.keys(wordScore);
        callback(null, wordList.map(function(word) {
            return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
            };
        }));
    };
});

ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
"use strict";

var snippetManager = acequire("../snippets").snippetManager;
var Autocomplete = acequire("../autocomplete").Autocomplete;
var config = acequire("../config");
var lang = acequire("../lib/lang");
var util = acequire("../autocomplete/util");

var textCompleter = acequire("../autocomplete/text_completer");
var keyWordCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        if (session.$mode.completer) {
            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
        }
        var state = editor.session.getState(pos.row);
        var completions = session.$mode.getCompletions(state, session, pos, prefix);
        callback(null, completions);
    }
};

var snippetCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        var snippetMap = snippetManager.snippetMap;
        var completions = [];
        snippetManager.getActiveScopes(editor).forEach(function(scope) {
            var snippets = snippetMap[scope] || [];
            for (var i = snippets.length; i--;) {
                var s = snippets[i];
                var caption = s.name || s.tabTrigger;
                if (!caption)
                    continue;
                completions.push({
                    caption: caption,
                    snippet: s.content,
                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
                    type: "snippet"
                });
            }
        }, this);
        callback(null, completions);
    },
    getDocTooltip: function(item) {
        if (item.type == "snippet" && !item.docHTML) {
            item.docHTML = [
                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
                lang.escapeHTML(item.snippet)
            ].join("");
        }
    }
};

var completers = [snippetCompleter, textCompleter, keyWordCompleter];
exports.setCompleters = function(val) {
    completers.length = 0;
    if (val) completers.push.apply(completers, val);
};
exports.addCompleter = function(completer) {
    completers.push(completer);
};
exports.textCompleter = textCompleter;
exports.keyWordCompleter = keyWordCompleter;
exports.snippetCompleter = snippetCompleter;

var expandSnippet = {
    name: "expandSnippet",
    exec: function(editor) {
        return snippetManager.expandWithTab(editor);
    },
    bindKey: "Tab"
};

var onChangeMode = function(e, editor) {
    loadSnippetsForMode(editor.session.$mode);
};

var loadSnippetsForMode = function(mode) {
    var id = mode.$id;
    if (!snippetManager.files)
        snippetManager.files = {};
    loadSnippetFile(id);
    if (mode.modes)
        mode.modes.forEach(loadSnippetsForMode);
};

var loadSnippetFile = function(id) {
    if (!id || snippetManager.files[id])
        return;
    var snippetFilePath = id.replace("mode", "snippets");
    snippetManager.files[id] = {};
    config.loadModule(snippetFilePath, function(m) {
        if (m) {
            snippetManager.files[id] = m;
            if (!m.snippets && m.snippetText)
                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
            snippetManager.register(m.snippets || [], m.scope);
            if (m.includeScopes) {
                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
                m.includeScopes.forEach(function(x) {
                    loadSnippetFile("ace/mode/" + x);
                });
            }
        }
    });
};

var doLiveAutocomplete = function(e) {
    var editor = e.editor;
    var hasCompleter = editor.completer && editor.completer.activated;
    if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor))
            editor.completer.detach();
    }
    else if (e.command.name === "insertstring") {
        var prefix = util.getCompletionPrefix(editor);
        if (prefix && !hasCompleter) {
            if (!editor.completer) {
                editor.completer = new Autocomplete();
            }
            editor.completer.autoInsert = false;
            editor.completer.showPopup(editor);
        }
    }
};

var Editor = acequire("../editor").Editor;
acequire("../config").defineOptions(Editor.prototype, "editor", {
    enableBasicAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.addCommand(Autocomplete.startCommand);
            } else {
                this.commands.removeCommand(Autocomplete.startCommand);
            }
        },
        value: false
    },
    enableLiveAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.on('afterExec', doLiveAutocomplete);
            } else {
                this.commands.removeListener('afterExec', doLiveAutocomplete);
            }
        },
        value: false
    },
    enableSnippets: {
        set: function(val) {
            if (val) {
                this.commands.addCommand(expandSnippet);
                this.on("changeMode", onChangeMode);
                onChangeMode(null, this);
            } else {
                this.commands.removeCommand(expandSnippet);
                this.off("changeMode", onChangeMode);
            }
        },
        value: false
    }
});
});
                (function() {
                    ace.acequire(["ace/ext/language_tools"], function() {});
                })();
            

/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "241e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "25ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dadb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "25eb":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "27ee":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("23c6");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var Iterators = __webpack_require__("84f2");
module.exports = __webpack_require__("8378").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "28a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("aae3");
var anObject = __webpack_require__("cb7c");
var speciesConstructor = __webpack_require__("ebd6");
var advanceStringIndex = __webpack_require__("0390");
var toLength = __webpack_require__("9def");
var callRegExpExec = __webpack_require__("5f1b");
var regexpExec = __webpack_require__("520a");
var fails = __webpack_require__("79e5");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("214f")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "294c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2cdf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".col[data-v-47da686d]{padding:3px}", ""]);

// exports


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2db7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, "ul.v-context{padding:0}.subtable{overflow-x:scroll;background:#fffbe7}.hide-selects /deep/ .v-data-table__checkbox{visibility:hidden}", ""]);

// exports


/***/ }),

/***/ "2f21":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("79e5");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "30f1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var $iterCreate = __webpack_require__("8f60");
var setToStringTag = __webpack_require__("45f2");
var getPrototypeOf = __webpack_require__("53e2");
var ITERATOR = __webpack_require__("5168")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "31f4":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32fc":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("e53d").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "335c":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("6b4c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "3389":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-divider[data-v-4f42e0ac]{margin-bottom:10px}.v-input[data-v-4f42e0ac]{margin:0 0 15px 0}", ""]);

// exports


/***/ }),

/***/ "33a4":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("84f2");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "34ef":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ec30")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "355d":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "35e8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");
module.exports = __webpack_require__("8e60") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "36b0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".date-picker-clear-btn[data-v-018e8802]{cursor:pointer;margin-top:5px;margin-left:10px;margin-right:10px}", ""]);

// exports


/***/ }),

/***/ "36bd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("4bf8");
var toAbsoluteIndex = __webpack_require__("77f1");
var toLength = __webpack_require__("9def");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "36c3":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("335c");
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "36f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardTemplateProperties_vue_vue_type_style_index_0_id_3273e1a5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("daf1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardTemplateProperties_vue_vue_type_style_index_0_id_3273e1a5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardTemplateProperties_vue_vue_type_style_index_0_id_3273e1a5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardTemplateProperties_vue_vue_type_style_index_0_id_3273e1a5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3846":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("9e1e") && /./g.flags != 'g') __webpack_require__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0bfb")
});


/***/ }),

/***/ "386b":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("5ca1");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ "386d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var sameValue = __webpack_require__("83a1");
var regExpExec = __webpack_require__("5f1b");

// @@search logic
__webpack_require__("214f")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "3a38":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "3b2b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var inheritIfRequired = __webpack_require__("5dbc");
var dP = __webpack_require__("86cc").f;
var gOPN = __webpack_require__("9093").f;
var isRegExp = __webpack_require__("aae3");
var $flags = __webpack_require__("0bfb");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("9e1e") && (!CORRECT_NEW || __webpack_require__("79e5")(function () {
  re2[__webpack_require__("2b4c")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("2aba")(global, 'RegExp', $RegExp);
}

__webpack_require__("7a56")('RegExp');


/***/ }),

/***/ "3d9d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".pbas-data-table-container[data-v-4beddfd7]{padding:0!important}.pbas-data-table-container[data-v-4beddfd7] .container{padding-top:0!important;padding-bottom:0!important}.pbas-data-table-container[data-v-4beddfd7] .v-data-table table{height:1px}.pbas-data-table-container[data-v-4beddfd7] .v-data-table td{padding:0;white-space:nowrap;user-select:none;height:100%}.pbas-data-table-container[data-v-4beddfd7] .v-data-table__mobile-row{height:auto!important}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tr{height:1px}.pbas-data-table-container[data-v-4beddfd7] .v-data-table td>div{padding:5px 16px;height:100%;display:flex;min-height:1px}.pbas-data-table-container[data-v-4beddfd7] .v-data-table td>div.v-data-table__checkbox{padding-left:0;margin-left:16px}.pbas-data-table-container[data-v-4beddfd7] .v-data-table td>div>*{align-self:center}.pbas-data-table-container[data-v-4beddfd7] .v-data-table th[role=columnheader]{padding:5px 16px;white-space:nowrap;height:auto;text-transform:uppercase;font-weight:800}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.03)}.pbas-data-table-container[data-v-4beddfd7] .v-messages{min-height:auto!important}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tbody .v-input__slot{margin:0!important}.pbas-data-table-container[data-v-4beddfd7] .v-data-table .v-data-table__wrapper{max-height:var(--max-height)}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tbody td .v-input--selection-controls{padding:0!important;margin:0!important;margin-top:0!important;margin-top:4px!important;display:inline-block}.pbas-data-table-container[data-v-4beddfd7] .v-data-table__wrapper{max-height:400px}.pbas-data-table-container[data-v-4beddfd7] .theme--light.v-data-table .v-data-table-header th.sortable:hover{opacity:1}.v-data-table.elevation-1 .col[data-v-4beddfd7]{padding-top:0!important;padding-bottom:0!important}.v-data-table__expand-icon[data-v-4beddfd7]{transform-origin:50%}.subtable[data-v-4beddfd7]{overflow-x:scroll;background:#fffbe7}.expanded[data-v-4beddfd7]{background:#fff2ac!important}.pbas-data-table-container[data-v-4beddfd7] .v-data-table__mobile-row__wrapper{display:inline-block}.pbas-data-table-container[data-v-4beddfd7] .v-data-table__mobile-row__wrapper{white-space:pre-wrap}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tbody tr.expanded.expanded__content{box-shadow:none}.pbas-data-table-container[data-v-4beddfd7] .v-data-table{width:100%}.pbas-data-table-container[data-v-4beddfd7] .v-data-table tbody table{background:#fffbe7}", ""]);

// exports


/***/ }),

/***/ "4051":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_0_id_36c8de00_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b034");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_0_id_36c8de00_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_0_id_36c8de00_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialCard_vue_vue_type_style_index_0_id_36c8de00_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "45f2":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("d9f6").f;
var has = __webpack_require__("07e3");
var TAG = __webpack_require__("5168")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "4603":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".pbas-data-table-container[data-v-9e5fd4a8]{padding:0!important}.pbas-data-table-container[data-v-9e5fd4a8] .container{padding-top:0!important;padding-bottom:0!important}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table table{height:1px}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table td{padding:0;white-space:nowrap;user-select:none;height:100%}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table__mobile-row{height:auto!important}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tr{height:1px}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table td>div{padding:5px 16px;height:100%;display:flex;min-height:1px}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table td>div.v-data-table__checkbox{padding-left:0;margin-left:16px}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table td>div>*{align-self:center}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table th[role=columnheader]{padding:5px 16px;white-space:nowrap;height:auto;text-transform:uppercase;font-weight:800}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.03)}.pbas-data-table-container[data-v-9e5fd4a8] .v-messages{min-height:auto!important}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tbody .v-input__slot{margin:0!important}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table .v-data-table__wrapper{max-height:var(--max-height)}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tbody td .v-input--selection-controls{padding:0!important;margin:0!important;margin-top:0!important;margin-top:4px!important;display:inline-block}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table__wrapper{max-height:400px}.pbas-data-table-container[data-v-9e5fd4a8] .theme--light.v-data-table .v-data-table-header th.sortable:hover{opacity:1}.v-data-table.elevation-1 .col[data-v-9e5fd4a8]{padding-top:0!important;padding-bottom:0!important}.v-data-table__expand-icon[data-v-9e5fd4a8]{transform-origin:50%}.subtable[data-v-9e5fd4a8]{overflow-x:scroll;background:#fffbe7}.expanded[data-v-9e5fd4a8]{background:#fff2ac!important}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table__mobile-row__wrapper{display:inline-block}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table__mobile-row__wrapper{white-space:pre-wrap}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tbody tr.expanded.expanded__content{box-shadow:none}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table{width:100%}.pbas-data-table-container[data-v-9e5fd4a8] .v-data-table tbody table{background:#fffbe7}", ""]);

// exports


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "47ee":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("c3a1");
var gOPS = __webpack_require__("9aa9");
var pIE = __webpack_require__("355d");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "481b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4875":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib");

/***/ }),

/***/ "48c0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__("386b")('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),

/***/ "497d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, "ul.v-context{padding:0}.subtable{overflow-x:scroll;background:#fffbe7}.hide-selects /deep/ .v-data-table__checkbox{visibility:hidden}", ""]);

// exports


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "49d9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2cdf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("efc6863c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4a59":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var getIterFn = __webpack_require__("27ee");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4f2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7614");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("c26b");
var validate = __webpack_require__("b39a");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("e0b8")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "50ed":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "5168":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("dbdb")('wks');
var uid = __webpack_require__("62a0");
var Symbol = __webpack_require__("e53d").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "51cd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".wrap-text[data-v-df63b094]{-webkit-line-clamp:unset!important;white-space:normal}", ""]);

// exports


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "53e2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("07e3");
var toObject = __webpack_require__("241e");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "544f":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".ace_editor[data-v-0639c179]{width:100%;height:100%}", ""]);

// exports


/***/ }),

/***/ "551c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var global = __webpack_require__("7726");
var ctx = __webpack_require__("9b43");
var classof = __webpack_require__("23c6");
var $export = __webpack_require__("5ca1");
var isObject = __webpack_require__("d3f4");
var aFunction = __webpack_require__("d8e8");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var speciesConstructor = __webpack_require__("ebd6");
var task = __webpack_require__("1991").set;
var microtask = __webpack_require__("8079")();
var newPromiseCapabilityModule = __webpack_require__("a5b8");
var perform = __webpack_require__("9c80");
var userAgent = __webpack_require__("a25f");
var promiseResolve = __webpack_require__("bcaa");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("2b4c")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("dcbc")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("7f20")($Promise, PROMISE);
__webpack_require__("7a56")(PROMISE);
Wrapper = __webpack_require__("8378")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("5cc5")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5559":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("dbdb")('keys');
var uid = __webpack_require__("62a0");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "55dd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("5ca1");
var aFunction = __webpack_require__("d8e8");
var toObject = __webpack_require__("4bf8");
var fails = __webpack_require__("79e5");
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__("2f21")($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "584a":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "5a33":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3d9d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7f5ecc0c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5b4e":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("36c3");
var toLength = __webpack_require__("b447");
var toAbsoluteIndex = __webpack_require__("0fc9");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5cc5":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("2b4c")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "5d58":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("d8d6");

/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var setPrototypeOf = __webpack_require__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5df3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("02f4")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("01f9")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "5f8c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("36b0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0b196ebc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "62a0":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "63b6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var ctx = __webpack_require__("d864");
var hide = __webpack_require__("35e8");
var has = __webpack_require__("07e3");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "63ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_id_318081f3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cb73");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_id_318081f3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_id_318081f3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeEditor_vue_vue_type_style_index_0_id_318081f3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6456":
/***/ (function(module, exports) {

module.exports = require("url-parse");

/***/ }),

/***/ "65d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
  * vue-class-component v7.0.2
  * (c) 2015-present Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__("8bbf"));

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

exports.default = Component;
exports.createDecorator = createDecorator;
exports.mixins = mixins;


/***/ }),

/***/ "6718":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var LIBRARY = __webpack_require__("b8e3");
var wksExt = __webpack_require__("ccb9");
var defineProperty = __webpack_require__("d9f6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "67ab":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ca5a")('meta');
var isObject = __webpack_require__("d3f4");
var has = __webpack_require__("69a8");
var setDesc = __webpack_require__("86cc").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("79e5")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "67bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("f921");

/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "69d3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('asyncIterator');


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6abf":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("e6f3");
var hiddenKeys = __webpack_require__("1691").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "6b4c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("3846");
var anObject = __webpack_require__("cb7c");
var $flags = __webpack_require__("0bfb");
var DESCRIPTORS = __webpack_require__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6c1c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c367");
var global = __webpack_require__("e53d");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var TO_STRING_TAG = __webpack_require__("5168")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "6cd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_0_id_4beddfd7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5a33");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_0_id_4beddfd7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_0_id_4beddfd7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasSimpleTable_vue_vue_type_style_index_0_id_4beddfd7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6d68":
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/javascript_worker';
module.exports.src = "\"no use strict\";!function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}}(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/javascript/jshint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function outer(modules,cache,entry){function newRequire(name,jumped){if(!cache[name]){if(!modules[name]){var currentRequire=\"function\"==typeof acequire&&acequire;if(!jumped&&currentRequire)return currentRequire(name,!0);if(previousRequire)return previousRequire(name,!0);var err=Error(\"Cannot find module '\"+name+\"'\");throw err.code=\"MODULE_NOT_FOUND\",err}var m=cache[name]={exports:{}};modules[name][0].call(m.exports,function(x){var id=modules[name][1][x];return newRequire(id?id:x)},m,m.exports,outer,modules,cache,entry)}return cache[name].exports}for(var previousRequire=\"function\"==typeof acequire&&acequire,i=0;entry.length>i;i++)newRequire(entry[i]);return newRequire(entry[0])}({\"/node_modules/browserify/node_modules/events/events.js\":[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length)){if(er=arguments[1],er instanceof Error)throw er;throw TypeError('Uncaught, unspecified \"error\" event.')}if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),\"function\"==typeof console.trace&&console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this\n}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],\"/node_modules/jshint/data/ascii-identifier-data.js\":[function(_dereq_,module){for(var identifierStartTable=[],i=0;128>i;i++)identifierStartTable[i]=36===i||i>=65&&90>=i||95===i||i>=97&&122>=i;for(var identifierPartTable=[],i=0;128>i;i++)identifierPartTable[i]=identifierStartTable[i]||i>=48&&57>=i;module.exports={asciiIdentifierStartTable:identifierStartTable,asciiIdentifierPartTable:identifierPartTable}},{}],\"/node_modules/jshint/lodash.js\":[function(_dereq_,module,exports){(function(global){(function(){function baseFindIndex(array,predicate,fromRight){for(var length=array.length,index=fromRight?length:-1;fromRight?index--:length>++index;)if(predicate(array[index],index,array))return index;return-1}function baseIndexOf(array,value,fromIndex){if(value!==value)return indexOfNaN(array,fromIndex);for(var index=fromIndex-1,length=array.length;length>++index;)if(array[index]===value)return index;return-1}function baseIsFunction(value){return\"function\"==typeof value||!1}function baseToString(value){return\"string\"==typeof value?value:null==value?\"\":value+\"\"}function indexOfNaN(array,fromIndex,fromRight){for(var length=array.length,index=fromIndex+(fromRight?0:-1);fromRight?index--:length>++index;){var other=array[index];if(other!==other)return index}return-1}function isObjectLike(value){return!!value&&\"object\"==typeof value}function lodash(){}function arrayCopy(source,array){var index=-1,length=source.length;for(array||(array=Array(length));length>++index;)array[index]=source[index];return array}function arrayEach(array,iteratee){for(var index=-1,length=array.length;length>++index&&iteratee(array[index],index,array)!==!1;);return array}function arrayFilter(array,predicate){for(var index=-1,length=array.length,resIndex=-1,result=[];length>++index;){var value=array[index];predicate(value,index,array)&&(result[++resIndex]=value)}return result}function arrayMap(array,iteratee){for(var index=-1,length=array.length,result=Array(length);length>++index;)result[index]=iteratee(array[index],index,array);return result}function arrayMax(array){for(var index=-1,length=array.length,result=NEGATIVE_INFINITY;length>++index;){var value=array[index];value>result&&(result=value)}return result}function arraySome(array,predicate){for(var index=-1,length=array.length;length>++index;)if(predicate(array[index],index,array))return!0;return!1}function assignWith(object,source,customizer){var props=keys(source);push.apply(props,getSymbols(source));for(var index=-1,length=props.length;length>++index;){var key=props[index],value=object[key],result=customizer(value,source[key],key,object,source);(result===result?result===value:value!==value)&&(value!==undefined||key in object)||(object[key]=result)}return object}function baseCopy(source,props,object){object||(object={});for(var index=-1,length=props.length;length>++index;){var key=props[index];object[key]=source[key]}return object}function baseCallback(func,thisArg,argCount){var type=typeof func;return\"function\"==type?thisArg===undefined?func:bindCallback(func,thisArg,argCount):null==func?identity:\"object\"==type?baseMatches(func):thisArg===undefined?property(func):baseMatchesProperty(func,thisArg)}function baseClone(value,isDeep,customizer,key,object,stackA,stackB){var result;if(customizer&&(result=object?customizer(value,key,object):customizer(value)),result!==undefined)return result;if(!isObject(value))return value;var isArr=isArray(value);if(isArr){if(result=initCloneArray(value),!isDeep)return arrayCopy(value,result)}else{var tag=objToString.call(value),isFunc=tag==funcTag;if(tag!=objectTag&&tag!=argsTag&&(!isFunc||object))return cloneableTags[tag]?initCloneByTag(value,tag,isDeep):object?value:{};if(result=initCloneObject(isFunc?{}:value),!isDeep)return baseAssign(result,value)}stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==value)return stackB[length];return stackA.push(value),stackB.push(result),(isArr?arrayEach:baseForOwn)(value,function(subValue,key){result[key]=baseClone(subValue,isDeep,customizer,key,value,stackA,stackB)}),result}function baseFilter(collection,predicate){var result=[];return baseEach(collection,function(value,index,collection){predicate(value,index,collection)&&result.push(value)}),result}function baseForIn(object,iteratee){return baseFor(object,iteratee,keysIn)}function baseForOwn(object,iteratee){return baseFor(object,iteratee,keys)}function baseGet(object,path,pathKey){if(null!=object){pathKey!==undefined&&pathKey in toObject(object)&&(path=[pathKey]);for(var index=-1,length=path.length;null!=object&&length>++index;)var result=object=object[path[index]];return result}}function baseIsEqual(value,other,customizer,isLoose,stackA,stackB){if(value===other)return 0!==value||1/value==1/other;var valType=typeof value,othType=typeof other;return\"function\"!=valType&&\"object\"!=valType&&\"function\"!=othType&&\"object\"!=othType||null==value||null==other?value!==value&&other!==other:baseIsEqualDeep(value,other,baseIsEqual,customizer,isLoose,stackA,stackB)}function baseIsEqualDeep(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;objIsArr||(objTag=objToString.call(object),objTag==argsTag?objTag=objectTag:objTag!=objectTag&&(objIsArr=isTypedArray(object))),othIsArr||(othTag=objToString.call(other),othTag==argsTag?othTag=objectTag:othTag!=objectTag&&(othIsArr=isTypedArray(other)));var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&!objIsArr&&!objIsObj)return equalByTag(object,other,objTag);if(!isLoose){var valWrapped=objIsObj&&hasOwnProperty.call(object,\"__wrapped__\"),othWrapped=othIsObj&&hasOwnProperty.call(other,\"__wrapped__\");if(valWrapped||othWrapped)return equalFunc(valWrapped?object.value():object,othWrapped?other.value():other,customizer,isLoose,stackA,stackB)}if(!isSameTag)return!1;stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==object)return stackB[length]==other;stackA.push(object),stackB.push(other);var result=(objIsArr?equalArrays:equalObjects)(object,other,equalFunc,customizer,isLoose,stackA,stackB);return stackA.pop(),stackB.pop(),result}function baseIsMatch(object,props,values,strictCompareFlags,customizer){for(var index=-1,length=props.length,noCustomizer=!customizer;length>++index;)if(noCustomizer&&strictCompareFlags[index]?values[index]!==object[props[index]]:!(props[index]in object))return!1;for(index=-1;length>++index;){var key=props[index],objValue=object[key],srcValue=values[index];if(noCustomizer&&strictCompareFlags[index])var result=objValue!==undefined||key in object;else result=customizer?customizer(objValue,srcValue,key):undefined,result===undefined&&(result=baseIsEqual(srcValue,objValue,customizer,!0));if(!result)return!1}return!0}function baseMatches(source){var props=keys(source),length=props.length;if(!length)return constant(!0);if(1==length){var key=props[0],value=source[key];if(isStrictComparable(value))return function(object){return null==object?!1:object[key]===value&&(value!==undefined||key in toObject(object))}}for(var values=Array(length),strictCompareFlags=Array(length);length--;)value=source[props[length]],values[length]=value,strictCompareFlags[length]=isStrictComparable(value);return function(object){return null!=object&&baseIsMatch(toObject(object),props,values,strictCompareFlags)}}function baseMatchesProperty(path,value){var isArr=isArray(path),isCommon=isKey(path)&&isStrictComparable(value),pathKey=path+\"\";return path=toPath(path),function(object){if(null==object)return!1;var key=pathKey;if(object=toObject(object),!(!isArr&&isCommon||key in object)){if(object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),null==object)return!1;key=last(path),object=toObject(object)}return object[key]===value?value!==undefined||key in object:baseIsEqual(value,object[key],null,!0)}}function baseMerge(object,source,customizer,stackA,stackB){if(!isObject(object))return object;var isSrcArr=isLength(source.length)&&(isArray(source)||isTypedArray(source));if(!isSrcArr){var props=keys(source);push.apply(props,getSymbols(source))}return arrayEach(props||source,function(srcValue,key){if(props&&(key=srcValue,srcValue=source[key]),isObjectLike(srcValue))stackA||(stackA=[]),stackB||(stackB=[]),baseMergeDeep(object,source,key,baseMerge,customizer,stackA,stackB);else{var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue),!isSrcArr&&result===undefined||!isCommon&&(result===result?result===value:value!==value)||(object[key]=result)}}),object}function baseMergeDeep(object,source,key,mergeFunc,customizer,stackA,stackB){for(var length=stackA.length,srcValue=source[key];length--;)if(stackA[length]==srcValue)return object[key]=stackB[length],undefined;var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue,isLength(srcValue.length)&&(isArray(srcValue)||isTypedArray(srcValue))?result=isArray(value)?value:getLength(value)?arrayCopy(value):[]:isPlainObject(srcValue)||isArguments(srcValue)?result=isArguments(value)?toPlainObject(value):isPlainObject(value)?value:{}:isCommon=!1),stackA.push(srcValue),stackB.push(result),isCommon?object[key]=mergeFunc(result,srcValue,customizer,stackA,stackB):(result===result?result!==value:value===value)&&(object[key]=result)}function baseProperty(key){return function(object){return null==object?undefined:object[key]}}function basePropertyDeep(path){var pathKey=path+\"\";return path=toPath(path),function(object){return baseGet(object,path,pathKey)}}function baseSlice(array,start,end){var index=-1,length=array.length;start=null==start?0:+start||0,0>start&&(start=-start>length?0:length+start),end=end===undefined||end>length?length:+end||0,0>end&&(end+=length),length=start>end?0:end-start>>>0,start>>>=0;for(var result=Array(length);length>++index;)result[index]=array[index+start];return result}function baseSome(collection,predicate){var result;return baseEach(collection,function(value,index,collection){return result=predicate(value,index,collection),!result}),!!result}function baseValues(object,props){for(var index=-1,length=props.length,result=Array(length);length>++index;)result[index]=object[props[index]];return result}function binaryIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(\"number\"==typeof value&&value===value&&HALF_MAX_ARRAY_LENGTH>=high){for(;high>low;){var mid=low+high>>>1,computed=array[mid];(retHighest?value>=computed:value>computed)?low=mid+1:high=mid}return high}return binaryIndexBy(array,value,identity,retHighest)}function binaryIndexBy(array,value,iteratee,retHighest){value=iteratee(value);for(var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsUndef=value===undefined;high>low;){var mid=floor((low+high)/2),computed=iteratee(array[mid]),isReflexive=computed===computed;if(valIsNaN)var setLow=isReflexive||retHighest;else setLow=valIsUndef?isReflexive&&(retHighest||computed!==undefined):retHighest?value>=computed:value>computed;setLow?low=mid+1:high=mid}return nativeMin(high,MAX_ARRAY_INDEX)}function bindCallback(func,thisArg,argCount){if(\"function\"!=typeof func)return identity;if(thisArg===undefined)return func;switch(argCount){case 1:return function(value){return func.call(thisArg,value)};case 3:return function(value,index,collection){return func.call(thisArg,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(thisArg,accumulator,value,index,collection)};case 5:return function(value,other,key,object,source){return func.call(thisArg,value,other,key,object,source)}}return function(){return func.apply(thisArg,arguments)}}function bufferClone(buffer){return bufferSlice.call(buffer,0)}function createAssigner(assigner){return restParam(function(object,sources){var index=-1,length=null==object?0:sources.length,customizer=length>2&&sources[length-2],guard=length>2&&sources[2],thisArg=length>1&&sources[length-1];for(\"function\"==typeof customizer?(customizer=bindCallback(customizer,thisArg,5),length-=2):(customizer=\"function\"==typeof thisArg?thisArg:null,length-=customizer?1:0),guard&&isIterateeCall(sources[0],sources[1],guard)&&(customizer=3>length?null:customizer,length=1);length>++index;){var source=sources[index];source&&assigner(object,source,customizer)}return object})}function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){var length=collection?getLength(collection):0;if(!isLength(length))return eachFunc(collection,iteratee);for(var index=fromRight?length:-1,iterable=toObject(collection);(fromRight?index--:length>++index)&&iteratee(iterable[index],index,iterable)!==!1;);return collection}}function createBaseFor(fromRight){return function(object,iteratee,keysFunc){for(var iterable=toObject(object),props=keysFunc(object),length=props.length,index=fromRight?length:-1;fromRight?index--:length>++index;){var key=props[index];if(iteratee(iterable[key],key,iterable)===!1)break}return object}}function createFindIndex(fromRight){return function(array,predicate,thisArg){return array&&array.length?(predicate=getCallback(predicate,thisArg,3),baseFindIndex(array,predicate,fromRight)):-1}}function createForEach(arrayFunc,eachFunc){return function(collection,iteratee,thisArg){return\"function\"==typeof iteratee&&thisArg===undefined&&isArray(collection)?arrayFunc(collection,iteratee):eachFunc(collection,bindCallback(iteratee,thisArg,3))}}function equalArrays(array,other,equalFunc,customizer,isLoose,stackA,stackB){var index=-1,arrLength=array.length,othLength=other.length,result=!0;if(arrLength!=othLength&&!(isLoose&&othLength>arrLength))return!1;for(;result&&arrLength>++index;){var arrValue=array[index],othValue=other[index];if(result=undefined,customizer&&(result=isLoose?customizer(othValue,arrValue,index):customizer(arrValue,othValue,index)),result===undefined)if(isLoose)for(var othIndex=othLength;othIndex--&&(othValue=other[othIndex],!(result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB))););else result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB)}return!!result}function equalByTag(object,other,tag){switch(tag){case boolTag:case dateTag:return+object==+other;case errorTag:return object.name==other.name&&object.message==other.message;case numberTag:return object!=+object?other!=+other:0==object?1/object==1/other:object==+other;case regexpTag:case stringTag:return object==other+\"\"}return!1}function equalObjects(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isLoose)return!1;for(var skipCtor=isLoose,index=-1;objLength>++index;){var key=objProps[index],result=isLoose?key in other:hasOwnProperty.call(other,key);if(result){var objValue=object[key],othValue=other[key];result=undefined,customizer&&(result=isLoose?customizer(othValue,objValue,key):customizer(objValue,othValue,key)),result===undefined&&(result=objValue&&objValue===othValue||equalFunc(objValue,othValue,customizer,isLoose,stackA,stackB))}if(!result)return!1;skipCtor||(skipCtor=\"constructor\"==key)}if(!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;if(objCtor!=othCtor&&\"constructor\"in object&&\"constructor\"in other&&!(\"function\"==typeof objCtor&&objCtor instanceof objCtor&&\"function\"==typeof othCtor&&othCtor instanceof othCtor))return!1}return!0}function getCallback(func,thisArg,argCount){var result=lodash.callback||callback;return result=result===callback?baseCallback:result,argCount?result(func,thisArg,argCount):result}function getIndexOf(collection,target,fromIndex){var result=lodash.indexOf||indexOf;return result=result===indexOf?baseIndexOf:result,collection?result(collection,target,fromIndex):result}function initCloneArray(array){var length=array.length,result=new array.constructor(length);return length&&\"string\"==typeof array[0]&&hasOwnProperty.call(array,\"index\")&&(result.index=array.index,result.input=array.input),result}function initCloneObject(object){var Ctor=object.constructor;return\"function\"==typeof Ctor&&Ctor instanceof Ctor||(Ctor=Object),new Ctor}function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return bufferClone(object);case boolTag:case dateTag:return new Ctor(+object);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:var buffer=object.buffer;return new Ctor(isDeep?bufferClone(buffer):buffer,object.byteOffset,object.length);case numberTag:case stringTag:return new Ctor(object);case regexpTag:var result=new Ctor(object.source,reFlags.exec(object));result.lastIndex=object.lastIndex}return result}function isIndex(value,length){return value=+value,length=null==length?MAX_SAFE_INTEGER:length,value>-1&&0==value%1&&length>value}function isIterateeCall(value,index,object){if(!isObject(object))return!1;var type=typeof index;if(\"number\"==type)var length=getLength(object),prereq=isLength(length)&&isIndex(index,length);else prereq=\"string\"==type&&index in object;if(prereq){var other=object[index];return value===value?value===other:other!==other}return!1}function isKey(value,object){var type=typeof value;if(\"string\"==type&&reIsPlainProp.test(value)||\"number\"==type)return!0;if(isArray(value))return!1;var result=!reIsDeepProp.test(value);return result||null!=object&&value in toObject(object)}function isLength(value){return\"number\"==typeof value&&value>-1&&0==value%1&&MAX_SAFE_INTEGER>=value}function isStrictComparable(value){return value===value&&(0===value?1/value>0:!isObject(value))}function shimIsPlainObject(value){var Ctor;if(lodash.support,!isObjectLike(value)||objToString.call(value)!=objectTag||!hasOwnProperty.call(value,\"constructor\")&&(Ctor=value.constructor,\"function\"==typeof Ctor&&!(Ctor instanceof Ctor)))return!1;var result;return baseForIn(value,function(subValue,key){result=key}),result===undefined||hasOwnProperty.call(value,result)}function shimKeys(object){for(var props=keysIn(object),propsLength=props.length,length=propsLength&&object.length,support=lodash.support,allowIndexes=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object)),index=-1,result=[];propsLength>++index;){var key=props[index];(allowIndexes&&isIndex(key,length)||hasOwnProperty.call(object,key))&&result.push(key)}return result}function toObject(value){return isObject(value)?value:Object(value)}function toPath(value){if(isArray(value))return value;var result=[];return baseToString(value).replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,\"$1\"):number||match)}),result}function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length)return-1;if(\"number\"==typeof fromIndex)fromIndex=0>fromIndex?nativeMax(length+fromIndex,0):fromIndex;else if(fromIndex){var index=binaryIndex(array,value),other=array[index];return(value===value?value===other:other!==other)?index:-1}return baseIndexOf(array,value,fromIndex||0)}function last(array){var length=array?array.length:0;return length?array[length-1]:undefined}function slice(array,start,end){var length=array?array.length:0;return length?(end&&\"number\"!=typeof end&&isIterateeCall(array,start,end)&&(start=0,end=length),baseSlice(array,start,end)):[]}function unzip(array){for(var index=-1,length=(array&&array.length&&arrayMax(arrayMap(array,getLength)))>>>0,result=Array(length);length>++index;)result[index]=arrayMap(array,baseProperty(index));return result}function includes(collection,target,fromIndex,guard){var length=collection?getLength(collection):0;return isLength(length)||(collection=values(collection),length=collection.length),length?(fromIndex=\"number\"!=typeof fromIndex||guard&&isIterateeCall(target,fromIndex,guard)?0:0>fromIndex?nativeMax(length+fromIndex,0):fromIndex||0,\"string\"==typeof collection||!isArray(collection)&&isString(collection)?length>fromIndex&&collection.indexOf(target,fromIndex)>-1:getIndexOf(collection,target,fromIndex)>-1):!1}function reject(collection,predicate,thisArg){var func=isArray(collection)?arrayFilter:baseFilter;return predicate=getCallback(predicate,thisArg,3),func(collection,function(value,index,collection){return!predicate(value,index,collection)})}function some(collection,predicate,thisArg){var func=isArray(collection)?arraySome:baseSome;return thisArg&&isIterateeCall(collection,predicate,thisArg)&&(predicate=null),(\"function\"!=typeof predicate||thisArg!==undefined)&&(predicate=getCallback(predicate,thisArg,3)),func(collection,predicate)}function restParam(func,start){if(\"function\"!=typeof func)throw new TypeError(FUNC_ERROR_TEXT);return start=nativeMax(start===undefined?func.length-1:+start||0,0),function(){for(var args=arguments,index=-1,length=nativeMax(args.length-start,0),rest=Array(length);length>++index;)rest[index]=args[start+index];switch(start){case 0:return func.call(this,rest);case 1:return func.call(this,args[0],rest);case 2:return func.call(this,args[0],args[1],rest)}var otherArgs=Array(start+1);for(index=-1;start>++index;)otherArgs[index]=args[index];return otherArgs[start]=rest,func.apply(this,otherArgs)}}function clone(value,isDeep,customizer,thisArg){return isDeep&&\"boolean\"!=typeof isDeep&&isIterateeCall(value,isDeep,customizer)?isDeep=!1:\"function\"==typeof isDeep&&(thisArg=customizer,customizer=isDeep,isDeep=!1),customizer=\"function\"==typeof customizer&&bindCallback(customizer,thisArg,1),baseClone(value,isDeep,customizer)}function isArguments(value){var length=isObjectLike(value)?value.length:undefined;return isLength(length)&&objToString.call(value)==argsTag}function isEmpty(value){if(null==value)return!0;var length=getLength(value);return isLength(length)&&(isArray(value)||isString(value)||isArguments(value)||isObjectLike(value)&&isFunction(value.splice))?!length:!keys(value).length}function isObject(value){var type=typeof value;return\"function\"==type||!!value&&\"object\"==type}function isNative(value){return null==value?!1:objToString.call(value)==funcTag?reIsNative.test(fnToString.call(value)):isObjectLike(value)&&reIsHostCtor.test(value)}function isNumber(value){return\"number\"==typeof value||isObjectLike(value)&&objToString.call(value)==numberTag}function isString(value){return\"string\"==typeof value||isObjectLike(value)&&objToString.call(value)==stringTag}function isTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objToString.call(value)]}function toPlainObject(value){return baseCopy(value,keysIn(value))}function has(object,path){if(null==object)return!1;var result=hasOwnProperty.call(object,path);return result||isKey(path)||(path=toPath(path),object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),path=last(path),result=null!=object&&hasOwnProperty.call(object,path)),result}function keysIn(object){if(null==object)return[];isObject(object)||(object=Object(object));var length=object.length;length=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object))&&length||0;for(var Ctor=object.constructor,index=-1,isProto=\"function\"==typeof Ctor&&Ctor.prototype===object,result=Array(length),skipIndexes=length>0;length>++index;)result[index]=index+\"\";for(var key in object)skipIndexes&&isIndex(key,length)||\"constructor\"==key&&(isProto||!hasOwnProperty.call(object,key))||result.push(key);return result}function values(object){return baseValues(object,keys(object))}function escapeRegExp(string){return string=baseToString(string),string&&reHasRegExpChars.test(string)?string.replace(reRegExpChars,\"\\\\$&\"):string}function callback(func,thisArg,guard){return guard&&isIterateeCall(func,thisArg,guard)&&(thisArg=null),baseCallback(func,thisArg)}function constant(value){return function(){return value}}function identity(value){return value}function property(path){return isKey(path)?baseProperty(path):basePropertyDeep(path)}var undefined,VERSION=\"3.7.0\",FUNC_ERROR_TEXT=\"Expected a function\",argsTag=\"[object Arguments]\",arrayTag=\"[object Array]\",boolTag=\"[object Boolean]\",dateTag=\"[object Date]\",errorTag=\"[object Error]\",funcTag=\"[object Function]\",mapTag=\"[object Map]\",numberTag=\"[object Number]\",objectTag=\"[object Object]\",regexpTag=\"[object RegExp]\",setTag=\"[object Set]\",stringTag=\"[object String]\",weakMapTag=\"[object WeakMap]\",arrayBufferTag=\"[object ArrayBuffer]\",float32Tag=\"[object Float32Array]\",float64Tag=\"[object Float64Array]\",int8Tag=\"[object Int8Array]\",int16Tag=\"[object Int16Array]\",int32Tag=\"[object Int32Array]\",uint8Tag=\"[object Uint8Array]\",uint8ClampedTag=\"[object Uint8ClampedArray]\",uint16Tag=\"[object Uint16Array]\",uint32Tag=\"[object Uint32Array]\",reIsDeepProp=/\\.|\\[(?:[^[\\]]+|([\"'])(?:(?!\\1)[^\\n\\\\]|\\\\.)*?)\\1\\]/,reIsPlainProp=/^\\w*$/,rePropName=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\n\\\\]|\\\\.)*?)\\2)\\]/g,reRegExpChars=/[.*+?^${}()|[\\]\\/\\\\]/g,reHasRegExpChars=RegExp(reRegExpChars.source),reEscapeChar=/\\\\(\\\\)?/g,reFlags=/\\w*$/,reIsHostCtor=/^\\[object .+?Constructor\\]$/,typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[stringTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=!0,cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[mapTag]=cloneableTags[setTag]=cloneableTags[weakMapTag]=!1;var objectTypes={\"function\":!0,object:!0},freeExports=objectTypes[typeof exports]&&exports&&!exports.nodeType&&exports,freeModule=objectTypes[typeof module]&&module&&!module.nodeType&&module,freeGlobal=freeExports&&freeModule&&\"object\"==typeof global&&global&&global.Object&&global,freeSelf=objectTypes[typeof self]&&self&&self.Object&&self,freeWindow=objectTypes[typeof window]&&window&&window.Object&&window,moduleExports=freeModule&&freeModule.exports===freeExports&&freeExports,root=freeGlobal||freeWindow!==(this&&this.window)&&freeWindow||freeSelf||this,arrayProto=Array.prototype,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp(\"^\"+escapeRegExp(objToString).replace(/toString|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\"),ArrayBuffer=isNative(ArrayBuffer=root.ArrayBuffer)&&ArrayBuffer,bufferSlice=isNative(bufferSlice=ArrayBuffer&&new ArrayBuffer(0).slice)&&bufferSlice,floor=Math.floor,getOwnPropertySymbols=isNative(getOwnPropertySymbols=Object.getOwnPropertySymbols)&&getOwnPropertySymbols,getPrototypeOf=isNative(getPrototypeOf=Object.getPrototypeOf)&&getPrototypeOf,push=arrayProto.push,preventExtensions=isNative(Object.preventExtensions=Object.preventExtensions)&&preventExtensions,propertyIsEnumerable=objectProto.propertyIsEnumerable,Uint8Array=isNative(Uint8Array=root.Uint8Array)&&Uint8Array,Float64Array=function(){try{var func=isNative(func=root.Float64Array)&&func,result=new func(new ArrayBuffer(10),0,1)&&func}catch(e){}return result}(),nativeAssign=function(){var object={1:0},func=preventExtensions&&isNative(func=Object.assign)&&func;try{func(preventExtensions(object),\"xo\")}catch(e){}return!object[1]&&func}(),nativeIsArray=isNative(nativeIsArray=Array.isArray)&&nativeIsArray,nativeKeys=isNative(nativeKeys=Object.keys)&&nativeKeys,nativeMax=Math.max,nativeMin=Math.min,NEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,MAX_ARRAY_LENGTH=Math.pow(2,32)-1,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1,FLOAT64_BYTES_PER_ELEMENT=Float64Array?Float64Array.BYTES_PER_ELEMENT:0,MAX_SAFE_INTEGER=Math.pow(2,53)-1,support=lodash.support={};(function(x){var Ctor=function(){this.x=x},props=[];Ctor.prototype={valueOf:x,y:x};for(var key in new Ctor)props.push(key);support.funcDecomp=/\\bthis\\b/.test(function(){return this}),support.funcNames=\"string\"==typeof Function.name;try{support.nonEnumArgs=!propertyIsEnumerable.call(arguments,1)}catch(e){support.nonEnumArgs=!0}})(1,0);var baseAssign=nativeAssign||function(object,source){return null==source?object:baseCopy(source,getSymbols(source),baseCopy(source,keys(source),object))},baseEach=createBaseEach(baseForOwn),baseFor=createBaseFor();bufferSlice||(bufferClone=ArrayBuffer&&Uint8Array?function(buffer){var byteLength=buffer.byteLength,floatLength=Float64Array?floor(byteLength/FLOAT64_BYTES_PER_ELEMENT):0,offset=floatLength*FLOAT64_BYTES_PER_ELEMENT,result=new ArrayBuffer(byteLength);if(floatLength){var view=new Float64Array(result,0,floatLength);view.set(new Float64Array(buffer,0,floatLength))}return byteLength!=offset&&(view=new Uint8Array(result,offset),view.set(new Uint8Array(buffer,offset))),result}:constant(null));var getLength=baseProperty(\"length\"),getSymbols=getOwnPropertySymbols?function(object){return getOwnPropertySymbols(toObject(object))}:constant([]),findLastIndex=createFindIndex(!0),zip=restParam(unzip),forEach=createForEach(arrayEach,baseEach),isArray=nativeIsArray||function(value){return isObjectLike(value)&&isLength(value.length)&&objToString.call(value)==arrayTag},isFunction=baseIsFunction(/x/)||Uint8Array&&!baseIsFunction(Uint8Array)?function(value){return objToString.call(value)==funcTag}:baseIsFunction,isPlainObject=getPrototypeOf?function(value){if(!value||objToString.call(value)!=objectTag)return!1;var valueOf=value.valueOf,objProto=isNative(valueOf)&&(objProto=getPrototypeOf(valueOf))&&getPrototypeOf(objProto);return objProto?value==objProto||getPrototypeOf(value)==objProto:shimIsPlainObject(value)}:shimIsPlainObject,assign=createAssigner(function(object,source,customizer){return customizer?assignWith(object,source,customizer):baseAssign(object,source)}),keys=nativeKeys?function(object){if(object)var Ctor=object.constructor,length=object.length;return\"function\"==typeof Ctor&&Ctor.prototype===object||\"function\"!=typeof object&&isLength(length)?shimKeys(object):isObject(object)?nativeKeys(object):[]}:shimKeys,merge=createAssigner(baseMerge);lodash.assign=assign,lodash.callback=callback,lodash.constant=constant,lodash.forEach=forEach,lodash.keys=keys,lodash.keysIn=keysIn,lodash.merge=merge,lodash.property=property,lodash.reject=reject,lodash.restParam=restParam,lodash.slice=slice,lodash.toPlainObject=toPlainObject,lodash.unzip=unzip,lodash.values=values,lodash.zip=zip,lodash.each=forEach,lodash.extend=assign,lodash.iteratee=callback,lodash.clone=clone,lodash.escapeRegExp=escapeRegExp,lodash.findLastIndex=findLastIndex,lodash.has=has,lodash.identity=identity,lodash.includes=includes,lodash.indexOf=indexOf,lodash.isArguments=isArguments,lodash.isArray=isArray,lodash.isEmpty=isEmpty,lodash.isFunction=isFunction,lodash.isNative=isNative,lodash.isNumber=isNumber,lodash.isObject=isObject,lodash.isPlainObject=isPlainObject,lodash.isString=isString,lodash.isTypedArray=isTypedArray,lodash.last=last,lodash.some=some,lodash.any=some,lodash.contains=includes,lodash.include=includes,lodash.VERSION=VERSION,freeExports&&freeModule?moduleExports?(freeModule.exports=lodash)._=lodash:freeExports._=lodash:root._=lodash\n}).call(this)}).call(this,\"undefined\"!=typeof global?global:\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{}],\"/node_modules/jshint/src/jshint.js\":[function(_dereq_,module,exports){var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),vars=_dereq_(\"./vars.js\"),messages=_dereq_(\"./messages.js\"),Lexer=_dereq_(\"./lex.js\").Lexer,reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,style=_dereq_(\"./style.js\"),options=_dereq_(\"./options.js\"),scopeManager=_dereq_(\"./scope-manager.js\"),JSHINT=function(){\"use strict\";function checkOption(name,t){return name=name.trim(),/^[+-]W\\d{3}$/g.test(name)?!0:-1!==options.validNames.indexOf(name)||\"jslint\"===t.type||_.has(options.removed,name)?!0:(error(\"E001\",t,name),!1)}function isString(obj){return\"[object String]\"===Object.prototype.toString.call(obj)}function isIdentifier(tkn,value){return tkn?tkn.identifier&&tkn.value===value?!0:!1:!1}function isReserved(token){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(token.isProperty)return!1}return!0}function supplant(str,data){return str.replace(/\\{([^{}]*)\\}/g,function(a,b){var r=data[b];return\"string\"==typeof r||\"number\"==typeof r?r:a})}function combine(dest,src){Object.keys(src).forEach(function(name){_.has(JSHINT.blacklist,name)||(dest[name]=src[name])})}function processenforceall(){if(state.option.enforceall){for(var enforceopt in options.bool.enforcing)void 0!==state.option[enforceopt]||options.noenforceall[enforceopt]||(state.option[enforceopt]=!0);for(var relaxopt in options.bool.relaxing)void 0===state.option[relaxopt]&&(state.option[relaxopt]=!1)}}function assume(){processenforceall(),state.option.esversion||state.option.moz||(state.option.esversion=state.option.es3?3:state.option.esnext?6:5),state.inES5()&&combine(predefined,vars.ecmaIdentifiers[5]),state.inES6()&&combine(predefined,vars.ecmaIdentifiers[6]),state.option.module&&(state.option.strict===!0&&(state.option.strict=\"global\"),state.inES6()||warning(\"W134\",state.tokens.next,\"module\",6)),state.option.couch&&combine(predefined,vars.couch),state.option.qunit&&combine(predefined,vars.qunit),state.option.rhino&&combine(predefined,vars.rhino),state.option.shelljs&&(combine(predefined,vars.shelljs),combine(predefined,vars.node)),state.option.typed&&combine(predefined,vars.typed),state.option.phantom&&(combine(predefined,vars.phantom),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.prototypejs&&combine(predefined,vars.prototypejs),state.option.node&&(combine(predefined,vars.node),combine(predefined,vars.typed),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.devel&&combine(predefined,vars.devel),state.option.dojo&&combine(predefined,vars.dojo),state.option.browser&&(combine(predefined,vars.browser),combine(predefined,vars.typed)),state.option.browserify&&(combine(predefined,vars.browser),combine(predefined,vars.typed),combine(predefined,vars.browserify),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.nonstandard&&combine(predefined,vars.nonstandard),state.option.jasmine&&combine(predefined,vars.jasmine),state.option.jquery&&combine(predefined,vars.jquery),state.option.mootools&&combine(predefined,vars.mootools),state.option.worker&&combine(predefined,vars.worker),state.option.wsh&&combine(predefined,vars.wsh),state.option.globalstrict&&state.option.strict!==!1&&(state.option.strict=\"global\"),state.option.yui&&combine(predefined,vars.yui),state.option.mocha&&combine(predefined,vars.mocha)}function quit(code,line,chr){var percentage=Math.floor(100*(line/state.lines.length)),message=messages.errors[code].desc;throw{name:\"JSHintError\",line:line,character:chr,message:message+\" (\"+percentage+\"% scanned).\",raw:message,code:code}}function removeIgnoredMessages(){var ignored=state.ignoredLines;_.isEmpty(ignored)||(JSHINT.errors=_.reject(JSHINT.errors,function(err){return ignored[err.line]}))}function warning(code,t,a,b,c,d){var ch,l,w,msg;if(/^W\\d{3}$/.test(code)){if(state.ignored[code])return;msg=messages.warnings[code]}else/E\\d{3}/.test(code)?msg=messages.errors[code]:/I\\d{3}/.test(code)&&(msg=messages.info[code]);return t=t||state.tokens.next||{},\"(end)\"===t.id&&(t=state.tokens.curr),l=t.line||0,ch=t.from||0,w={id:\"(error)\",raw:msg.desc,code:msg.code,evidence:state.lines[l-1]||\"\",line:l,character:ch,scope:JSHINT.scope,a:a,b:b,c:c,d:d},w.reason=supplant(msg.desc,w),JSHINT.errors.push(w),removeIgnoredMessages(),JSHINT.errors.length>=state.option.maxerr&&quit(\"E043\",l,ch),w}function warningAt(m,l,ch,a,b,c,d){return warning(m,{line:l,from:ch},a,b,c,d)}function error(m,t,a,b,c,d){warning(m,t,a,b,c,d)}function errorAt(m,l,ch,a,b,c,d){return error(m,{line:l,from:ch},a,b,c,d)}function addInternalSrc(elem,src){var i;return i={id:\"(internal)\",elem:elem,value:src},JSHINT.internals.push(i),i}function doOption(){var nt=state.tokens.next,body=nt.body.match(/(-\\s+)?[^\\s,:]+(?:\\s*:\\s*(-\\s+)?[^\\s,]+)?/g)||[],predef={};if(\"globals\"===nt.type){body.forEach(function(g,idx){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(\"-\"===key||!key.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}\"-\"===key.charAt(0)?(key=key.slice(1),val=!1,JSHINT.blacklist[key]=key,delete predefined[key]):predef[key]=\"true\"===val}),combine(predefined,predef);for(var key in predef)_.has(predef,key)&&(declared[key]=nt)}\"exported\"===nt.type&&body.forEach(function(e,idx){if(!e.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}state.funct[\"(scope)\"].addExported(e)}),\"members\"===nt.type&&(membersOnly=membersOnly||{},body.forEach(function(m){var ch1=m.charAt(0),ch2=m.charAt(m.length-1);ch1!==ch2||'\"'!==ch1&&\"'\"!==ch1||(m=m.substr(1,m.length-2).replace('\\\\\"','\"')),membersOnly[m]=!1}));var numvals=[\"maxstatements\",\"maxparams\",\"maxdepth\",\"maxcomplexity\",\"maxerr\",\"maxlen\",\"indent\"];(\"jshint\"===nt.type||\"jslint\"===nt.type)&&(body.forEach(function(g){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(checkOption(key,nt))if(numvals.indexOf(key)>=0)if(\"false\"!==val){if(val=+val,\"number\"!=typeof val||!isFinite(val)||0>=val||Math.floor(val)!==val)return error(\"E032\",nt,g[1].trim()),void 0;state.option[key]=val}else state.option[key]=\"indent\"===key?4:!1;else{if(\"validthis\"===key)return state.funct[\"(global)\"]?void error(\"E009\"):\"true\"!==val&&\"false\"!==val?void error(\"E002\",nt):(state.option.validthis=\"true\"===val,void 0);if(\"quotmark\"!==key)if(\"shadow\"!==key)if(\"unused\"!==key)if(\"latedef\"!==key)if(\"ignore\"!==key)if(\"strict\"!==key){\"module\"===key&&(hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"module\"));var esversions={es3:3,es5:5,esnext:6};if(!_.has(esversions,key)){if(\"esversion\"===key){switch(val){case\"5\":state.inES5(!0)&&warning(\"I003\");case\"3\":case\"6\":state.option.moz=!1,state.option.esversion=+val;break;case\"2015\":state.option.moz=!1,state.option.esversion=6;break;default:error(\"E002\",nt)}return hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"esversion\"),void 0}var match=/^([+-])(W\\d{3})$/g.exec(key);if(match)return state.ignored[match[2]]=\"-\"===match[1],void 0;var tn;return\"true\"===val||\"false\"===val?(\"jslint\"===nt.type?(tn=options.renamed[key]||key,state.option[tn]=\"true\"===val,void 0!==options.inverted[tn]&&(state.option[tn]=!state.option[tn])):state.option[key]=\"true\"===val,\"newcap\"===key&&(state.option[\"(explicitNewcap)\"]=!0),void 0):(error(\"E002\",nt),void 0)}switch(val){case\"true\":state.option.moz=!1,state.option.esversion=esversions[key];break;case\"false\":state.option.moz||(state.option.esversion=5);break;default:error(\"E002\",nt)}}else switch(val){case\"true\":state.option.strict=!0;break;case\"false\":state.option.strict=!1;break;case\"func\":case\"global\":case\"implied\":state.option.strict=val;break;default:error(\"E002\",nt)}else switch(val){case\"line\":state.ignoredLines[nt.line]=!0,removeIgnoredMessages();break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.latedef=!0;break;case\"false\":state.option.latedef=!1;break;case\"nofunc\":state.option.latedef=\"nofunc\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.unused=!0;break;case\"false\":state.option.unused=!1;break;case\"vars\":case\"strict\":state.option.unused=val;break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.shadow=!0;break;case\"outer\":state.option.shadow=\"outer\";break;case\"false\":case\"inner\":state.option.shadow=\"inner\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":case\"false\":state.option.quotmark=\"true\"===val;break;case\"double\":case\"single\":state.option.quotmark=val;break;default:error(\"E002\",nt)}}}),assume())}function peek(p){var t,i=p||0,j=lookahead.length;if(j>i)return lookahead[i];for(;i>=j;)t=lookahead[j],t||(t=lookahead[j]=lex.token()),j+=1;return t||\"(end)\"!==state.tokens.next.id?t:state.tokens.next}function peekIgnoreEOL(){var t,i=0;do t=peek(i++);while(\"(endline)\"===t.id);return t}function advance(id,t){switch(state.tokens.curr.id){case\"(number)\":\".\"===state.tokens.next.id&&warning(\"W005\",state.tokens.curr);break;case\"-\":(\"-\"===state.tokens.next.id||\"--\"===state.tokens.next.id)&&warning(\"W006\");break;case\"+\":(\"+\"===state.tokens.next.id||\"++\"===state.tokens.next.id)&&warning(\"W007\")}for(id&&state.tokens.next.id!==id&&(t?\"(end)\"===state.tokens.next.id?error(\"E019\",t,t.id):error(\"E020\",state.tokens.next,id,t.id,t.line,state.tokens.next.value):(\"(identifier)\"!==state.tokens.next.type||state.tokens.next.value!==id)&&warning(\"W116\",state.tokens.next,id,state.tokens.next.value)),state.tokens.prev=state.tokens.curr,state.tokens.curr=state.tokens.next;;){if(state.tokens.next=lookahead.shift()||lex.token(),state.tokens.next||quit(\"E041\",state.tokens.curr.line),\"(end)\"===state.tokens.next.id||\"(error)\"===state.tokens.next.id)return;if(state.tokens.next.check&&state.tokens.next.check(),state.tokens.next.isSpecial)\"falls through\"===state.tokens.next.type?state.tokens.curr.caseFallsThrough=!0:doOption();else if(\"(endline)\"!==state.tokens.next.id)break}}function isInfix(token){return token.infix||!token.identifier&&!token.template&&!!token.led}function isEndOfExpr(){var curr=state.tokens.curr,next=state.tokens.next;return\";\"===next.id||\"}\"===next.id||\":\"===next.id?!0:isInfix(next)===isInfix(curr)||\"yield\"===curr.id&&state.inMoz()?curr.line!==startLine(next):!1}function isBeginOfExpr(prev){return!prev.left&&\"unary\"!==prev.arity}function expression(rbp,initial){var left,isArray=!1,isObject=!1,isLetExpr=!1;state.nameStack.push(),initial||\"let\"!==state.tokens.next.value||\"(\"!==peek(0).value||(state.inMoz()||warning(\"W118\",state.tokens.next,\"let expressions\"),isLetExpr=!0,state.funct[\"(scope)\"].stack(),advance(\"let\"),advance(\"(\"),state.tokens.prev.fud(),advance(\")\")),\"(end)\"===state.tokens.next.id&&error(\"E006\",state.tokens.curr);var isDangerous=state.option.asi&&state.tokens.prev.line!==startLine(state.tokens.curr)&&_.contains([\"]\",\")\"],state.tokens.prev.id)&&_.contains([\"[\",\"(\"],state.tokens.curr.id);if(isDangerous&&warning(\"W014\",state.tokens.curr,state.tokens.curr.id),advance(),initial&&(state.funct[\"(verb)\"]=state.tokens.curr.value,state.tokens.curr.beginsStmt=!0),initial===!0&&state.tokens.curr.fud)left=state.tokens.curr.fud();else for(state.tokens.curr.nud?left=state.tokens.curr.nud():error(\"E030\",state.tokens.curr,state.tokens.curr.id);(state.tokens.next.lbp>rbp||\"(template)\"===state.tokens.next.type)&&!isEndOfExpr();)isArray=\"Array\"===state.tokens.curr.value,isObject=\"Object\"===state.tokens.curr.value,left&&(left.value||left.first&&left.first.value)&&(\"new\"!==left.value||left.first&&left.first.value&&\".\"===left.first.value)&&(isArray=!1,left.value!==state.tokens.curr.value&&(isObject=!1)),advance(),isArray&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W009\",state.tokens.curr),isObject&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W010\",state.tokens.curr),left&&state.tokens.curr.led?left=state.tokens.curr.led(left):error(\"E033\",state.tokens.curr,state.tokens.curr.id);return isLetExpr&&state.funct[\"(scope)\"].unstack(),state.nameStack.pop(),left}function startLine(token){return token.startLine||token.line}function nobreaknonadjacent(left,right){left=left||state.tokens.curr,right=right||state.tokens.next,state.option.laxbreak||left.line===startLine(right)||warning(\"W014\",right,right.value)}function nolinebreak(t){t=t||state.tokens.curr,t.line!==startLine(state.tokens.next)&&warning(\"E022\",t,t.value)}function nobreakcomma(left,right){left.line!==startLine(right)&&(state.option.laxcomma||(comma.first&&(warning(\"I001\"),comma.first=!1),warning(\"W014\",left,right.value)))}function comma(opts){if(opts=opts||{},opts.peek?nobreakcomma(state.tokens.prev,state.tokens.curr):(nobreakcomma(state.tokens.curr,state.tokens.next),advance(\",\")),state.tokens.next.identifier&&(!opts.property||!state.inES5()))switch(state.tokens.next.value){case\"break\":case\"case\":case\"catch\":case\"continue\":case\"default\":case\"do\":case\"else\":case\"finally\":case\"for\":case\"if\":case\"in\":case\"instanceof\":case\"return\":case\"switch\":case\"throw\":case\"try\":case\"var\":case\"let\":case\"while\":case\"with\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}if(\"(punctuator)\"===state.tokens.next.type)switch(state.tokens.next.value){case\"}\":case\"]\":case\",\":if(opts.allowTrailing)return!0;case\")\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}return!0}function symbol(s,p){var x=state.syntax[s];return x&&\"object\"==typeof x||(state.syntax[s]=x={id:s,lbp:p,value:s}),x}function delim(s){var x=symbol(s,0);return x.delim=!0,x}function stmt(s,f){var x=delim(s);return x.identifier=x.reserved=!0,x.fud=f,x}function blockstmt(s,f){var x=stmt(s,f);return x.block=!0,x}function reserveName(x){var c=x.id.charAt(0);return(c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c)&&(x.identifier=x.reserved=!0),x}function prefix(s,f){var x=symbol(s,150);return reserveName(x),x.nud=\"function\"==typeof f?f:function(){return this.arity=\"unary\",this.right=expression(150),(\"++\"===this.id||\"--\"===this.id)&&(state.option.plusplus?warning(\"W016\",this,this.id):!this.right||this.right.identifier&&!isReserved(this.right)||\".\"===this.right.id||\"[\"===this.right.id||warning(\"W017\",this),this.right&&this.right.isMetaProperty?error(\"E031\",this):this.right&&this.right.identifier&&state.funct[\"(scope)\"].block.modify(this.right.value,this)),this},x}function type(s,f){var x=delim(s);return x.type=s,x.nud=f,x}function reserve(name,func){var x=type(name,func);return x.identifier=!0,x.reserved=!0,x}function FutureReservedWord(name,meta){var x=type(name,meta&&meta.nud||function(){return this});return meta=meta||{},meta.isFutureReservedWord=!0,x.value=name,x.identifier=!0,x.reserved=!0,x.meta=meta,x}function reservevar(s,v){return reserve(s,function(){return\"function\"==typeof v&&v(this),this})}function infix(s,f,p,w){var x=symbol(s,p);return reserveName(x),x.infix=!0,x.led=function(left){return w||nobreaknonadjacent(state.tokens.prev,state.tokens.curr),\"in\"!==s&&\"instanceof\"!==s||\"!\"!==left.id||warning(\"W018\",left,\"!\"),\"function\"==typeof f?f(left,this):(this.left=left,this.right=expression(p),this)},x}function application(s){var x=symbol(s,42);return x.led=function(left){return nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left,this.right=doFunction({type:\"arrow\",loneArg:left}),this},x}function relation(s,f){var x=symbol(s,100);return x.led=function(left){nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left;var right=this.right=expression(100);return isIdentifier(left,\"NaN\")||isIdentifier(right,\"NaN\")?warning(\"W019\",this):f&&f.apply(this,[left,right]),left&&right||quit(\"E041\",state.tokens.curr.line),\"!\"===left.id&&warning(\"W018\",left,\"!\"),\"!\"===right.id&&warning(\"W018\",right,\"!\"),this},x}function isPoorRelation(node){return node&&(\"(number)\"===node.type&&0===+node.value||\"(string)\"===node.type&&\"\"===node.value||\"null\"===node.type&&!state.option.eqnull||\"true\"===node.type||\"false\"===node.type||\"undefined\"===node.type)}function isTypoTypeof(left,right,state){var values;return state.option.notypeof?!1:left&&right?(values=state.inES6()?typeofValues.es6:typeofValues.es3,\"(identifier)\"===right.type&&\"typeof\"===right.value&&\"(string)\"===left.type?!_.contains(values,left.value):!1):!1}function isGlobalEval(left,state){var isGlobal=!1;return\"this\"===left.type&&null===state.funct[\"(context)\"]?isGlobal=!0:\"(identifier)\"===left.type&&(state.option.node&&\"global\"===left.value?isGlobal=!0:!state.option.browser||\"window\"!==left.value&&\"document\"!==left.value||(isGlobal=!0)),isGlobal}function findNativePrototype(left){function walkPrototype(obj){return\"object\"==typeof obj?\"prototype\"===obj.right?obj:walkPrototype(obj.left):void 0}function walkNative(obj){for(;!obj.identifier&&\"object\"==typeof obj.left;)obj=obj.left;return obj.identifier&&natives.indexOf(obj.value)>=0?obj.value:void 0}var natives=[\"Array\",\"ArrayBuffer\",\"Boolean\",\"Collator\",\"DataView\",\"Date\",\"DateTimeFormat\",\"Error\",\"EvalError\",\"Float32Array\",\"Float64Array\",\"Function\",\"Infinity\",\"Intl\",\"Int16Array\",\"Int32Array\",\"Int8Array\",\"Iterator\",\"Number\",\"NumberFormat\",\"Object\",\"RangeError\",\"ReferenceError\",\"RegExp\",\"StopIteration\",\"String\",\"SyntaxError\",\"TypeError\",\"Uint16Array\",\"Uint32Array\",\"Uint8Array\",\"Uint8ClampedArray\",\"URIError\"],prototype=walkPrototype(left);return prototype?walkNative(prototype):void 0}function checkLeftSideAssign(left,assignToken,options){var allowDestructuring=options&&options.allowDestructuring;if(assignToken=assignToken||left,state.option.freeze){var nativeObject=findNativePrototype(left);nativeObject&&warning(\"W121\",left,nativeObject)}return left.identifier&&!left.isMetaProperty&&state.funct[\"(scope)\"].block.reassign(left.value,left),\".\"===left.id?((!left.left||\"arguments\"===left.left.value&&!state.isStrict())&&warning(\"E031\",assignToken),state.nameStack.set(state.tokens.prev),!0):\"{\"===left.id||\"[\"===left.id?(allowDestructuring&&state.tokens.curr.left.destructAssign?state.tokens.curr.left.destructAssign.forEach(function(t){t.id&&state.funct[\"(scope)\"].block.modify(t.id,t.token)}):\"{\"!==left.id&&left.left?\"arguments\"!==left.left.value||state.isStrict()||warning(\"E031\",assignToken):warning(\"E031\",assignToken),\"[\"===left.id&&state.nameStack.set(left.right),!0):left.isMetaProperty?(error(\"E031\",assignToken),!0):left.identifier&&!isReserved(left)?(\"exception\"===state.funct[\"(scope)\"].labeltype(left.value)&&warning(\"W022\",left),state.nameStack.set(left),!0):(left===state.syntax[\"function\"]&&warning(\"W023\",state.tokens.curr),!1)}function assignop(s,f,p){var x=infix(s,\"function\"==typeof f?f:function(left,that){return that.left=left,left&&checkLeftSideAssign(left,that,{allowDestructuring:!0})?(that.right=expression(10),that):(error(\"E031\",that),void 0)},p);return x.exps=!0,x.assign=!0,x}function bitwise(s,f,p){var x=symbol(s,p);return reserveName(x),x.led=\"function\"==typeof f?f:function(left){return state.option.bitwise&&warning(\"W016\",this,this.id),this.left=left,this.right=expression(p),this},x}function bitwiseassignop(s){return assignop(s,function(left,that){return state.option.bitwise&&warning(\"W016\",that,that.id),left&&checkLeftSideAssign(left,that)?(that.right=expression(10),that):(error(\"E031\",that),void 0)},20)}function suffix(s){var x=symbol(s,150);return x.led=function(left){return state.option.plusplus?warning(\"W016\",this,this.id):left.identifier&&!isReserved(left)||\".\"===left.id||\"[\"===left.id||warning(\"W017\",this),left.isMetaProperty?error(\"E031\",this):left&&left.identifier&&state.funct[\"(scope)\"].block.modify(left.value,left),this.left=left,this},x}function optionalidentifier(fnparam,prop,preserve){if(state.tokens.next.identifier){preserve||advance();var curr=state.tokens.curr,val=state.tokens.curr.value;return isReserved(curr)?prop&&state.inES5()?val:fnparam&&\"undefined\"===val?val:(warning(\"W024\",state.tokens.curr,state.tokens.curr.id),val):val}}function identifier(fnparam,prop){var i=optionalidentifier(fnparam,prop,!1);if(i)return i;if(\"...\"===state.tokens.next.value){if(state.inES6(!0)||warning(\"W119\",state.tokens.next,\"spread/rest operator\",\"6\"),advance(),checkPunctuator(state.tokens.next,\"...\"))for(warning(\"E024\",state.tokens.next,\"...\");checkPunctuator(state.tokens.next,\"...\");)advance();return state.tokens.next.identifier?identifier(fnparam,prop):(warning(\"E024\",state.tokens.curr,\"...\"),void 0)}error(\"E030\",state.tokens.next,state.tokens.next.value),\";\"!==state.tokens.next.id&&advance()}function reachable(controlToken){var t,i=0;if(\";\"===state.tokens.next.id&&!controlToken.inBracelessBlock)for(;;){do t=peek(i),i+=1;while(\"(end)\"!==t.id&&\"(comment)\"===t.id);if(t.reach)return;if(\"(endline)\"!==t.id){if(\"function\"===t.id){state.option.latedef===!0&&warning(\"W026\",t);break}warning(\"W027\",t,t.value,controlToken.value);break}}}function parseFinalSemicolon(){if(\";\"!==state.tokens.next.id){if(state.tokens.next.isUnclosed)return advance();var sameLine=startLine(state.tokens.next)===state.tokens.curr.line&&\"(end)\"!==state.tokens.next.id,blockEnd=checkPunctuator(state.tokens.next,\"}\");sameLine&&!blockEnd?errorAt(\"E058\",state.tokens.curr.line,state.tokens.curr.character):state.option.asi||(blockEnd&&!state.option.lastsemic||!sameLine)&&warningAt(\"W033\",state.tokens.curr.line,state.tokens.curr.character)}else advance(\";\")}function statement(){var r,i=indent,t=state.tokens.next,hasOwnScope=!1;if(\";\"===t.id)return advance(\";\"),void 0;var res=isReserved(t);if(res&&t.meta&&t.meta.isFutureReservedWord&&\":\"===peek().id&&(warning(\"W024\",t,t.id),res=!1),t.identifier&&!res&&\":\"===peek().id&&(advance(),advance(\":\"),hasOwnScope=!0,state.funct[\"(scope)\"].stack(),state.funct[\"(scope)\"].block.addBreakLabel(t.value,{token:state.tokens.curr}),state.tokens.next.labelled||\"{\"===state.tokens.next.value||warning(\"W028\",state.tokens.next,t.value,state.tokens.next.value),state.tokens.next.label=t.value,t=state.tokens.next),\"{\"===t.id){var iscase=\"case\"===state.funct[\"(verb)\"]&&\":\"===state.tokens.curr.value;return block(!0,!0,!1,!1,iscase),void 0}return r=expression(0,!0),!r||r.identifier&&\"function\"===r.value||\"(punctuator)\"===r.type&&r.left&&r.left.identifier&&\"function\"===r.left.value||state.isStrict()||\"global\"!==state.option.strict||warning(\"E007\"),t.block||(state.option.expr||r&&r.exps?state.option.nonew&&r&&r.left&&\"(\"===r.id&&\"new\"===r.left.id&&warning(\"W031\",t):warning(\"W030\",state.tokens.curr),parseFinalSemicolon()),indent=i,hasOwnScope&&state.funct[\"(scope)\"].unstack(),r}function statements(){for(var p,a=[];!state.tokens.next.reach&&\"(end)\"!==state.tokens.next.id;)\";\"===state.tokens.next.id?(p=peek(),(!p||\"(\"!==p.id&&\"[\"!==p.id)&&warning(\"W032\"),advance(\";\")):a.push(statement());return a}function directives(){for(var i,p,pn;\"(string)\"===state.tokens.next.id;){if(p=peek(0),\"(endline)\"===p.id){i=1;do pn=peek(i++);while(\"(endline)\"===pn.id);if(\";\"===pn.id)p=pn;else{if(\"[\"===pn.value||\".\"===pn.value)break;state.option.asi&&\"(\"!==pn.value||warning(\"W033\",state.tokens.next)}}else{if(\".\"===p.id||\"[\"===p.id)break;\";\"!==p.id&&warning(\"W033\",p)}advance();var directive=state.tokens.curr.value;(state.directive[directive]||\"use strict\"===directive&&\"implied\"===state.option.strict)&&warning(\"W034\",state.tokens.curr,directive),state.directive[directive]=!0,\";\"===p.id&&advance(\";\")}state.isStrict()&&(state.option[\"(explicitNewcap)\"]||(state.option.newcap=!0),state.option.undef=!0)}function block(ordinary,stmt,isfunc,isfatarrow,iscase){var a,m,t,line,d,b=inblock,old_indent=indent;inblock=ordinary,t=state.tokens.next;var metrics=state.funct[\"(metrics)\"];if(metrics.nestedBlockDepth+=1,metrics.verifyMaxNestedBlockDepthPerFunction(),\"{\"===state.tokens.next.id){if(advance(\"{\"),state.funct[\"(scope)\"].stack(),line=state.tokens.curr.line,\"}\"!==state.tokens.next.id){for(indent+=state.option.indent;!ordinary&&state.tokens.next.from>indent;)indent+=state.option.indent;if(isfunc){m={};for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);directives(),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\"))}a=statements(),metrics.statementCount+=a.length,indent-=state.option.indent}advance(\"}\",t),isfunc&&(state.funct[\"(scope)\"].validateParams(),m&&(state.directive=m)),state.funct[\"(scope)\"].unstack(),indent=old_indent}else if(ordinary)state.funct[\"(noblockscopedvar)\"]=\"for\"!==state.tokens.next.id,state.funct[\"(scope)\"].stack(),(!stmt||state.option.curly)&&warning(\"W116\",state.tokens.next,\"{\",state.tokens.next.value),state.tokens.next.inBracelessBlock=!0,indent+=state.option.indent,a=[statement()],indent-=state.option.indent,state.funct[\"(scope)\"].unstack(),delete state.funct[\"(noblockscopedvar)\"];else if(isfunc){if(state.funct[\"(scope)\"].stack(),m={},!stmt||isfatarrow||state.inMoz()||error(\"W118\",state.tokens.curr,\"function closure expressions\"),!stmt)for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);expression(10),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\")),state.funct[\"(scope)\"].unstack()}else error(\"E021\",state.tokens.next,\"{\",state.tokens.next.value);switch(state.funct[\"(verb)\"]){case\"break\":case\"continue\":case\"return\":case\"throw\":if(iscase)break;default:state.funct[\"(verb)\"]=null}return inblock=b,!ordinary||!state.option.noempty||a&&0!==a.length||warning(\"W035\",state.tokens.prev),metrics.nestedBlockDepth-=1,a}function countMember(m){membersOnly&&\"boolean\"!=typeof membersOnly[m]&&warning(\"W036\",state.tokens.curr,m),\"number\"==typeof member[m]?member[m]+=1:member[m]=1}function comprehensiveArrayExpression(){var res={};res.exps=!0,state.funct[\"(comparray)\"].stack();var reversed=!1;return\"for\"!==state.tokens.next.value&&(reversed=!0,state.inMoz()||warning(\"W116\",state.tokens.next,\"for\",state.tokens.next.value),state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"for\"),\"each\"===state.tokens.next.value&&(advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"define\"),res.left=expression(130),_.contains([\"in\",\"of\"],state.tokens.next.value)?advance():error(\"E045\",state.tokens.curr),state.funct[\"(comparray)\"].setState(\"generate\"),expression(10),advance(\")\"),\"if\"===state.tokens.next.value&&(advance(\"if\"),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"filter\"),res.filter=expression(10),advance(\")\")),reversed||(state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"]\"),state.funct[\"(comparray)\"].unstack(),res}function isMethod(){return state.funct[\"(statement)\"]&&\"class\"===state.funct[\"(statement)\"].type||state.funct[\"(context)\"]&&\"class\"===state.funct[\"(context)\"][\"(verb)\"]}function isPropertyName(token){return token.identifier||\"(string)\"===token.id||\"(number)\"===token.id}function propertyName(preserveOrToken){var id,preserve=!0;return\"object\"==typeof preserveOrToken?id=preserveOrToken:(preserve=preserveOrToken,id=optionalidentifier(!1,!0,preserve)),id?\"object\"==typeof id&&(\"(string)\"===id.id||\"(identifier)\"===id.id?id=id.value:\"(number)\"===id.id&&(id=\"\"+id.value)):\"(string)\"===state.tokens.next.id?(id=state.tokens.next.value,preserve||advance()):\"(number)\"===state.tokens.next.id&&(id=\"\"+state.tokens.next.value,preserve||advance()),\"hasOwnProperty\"===id&&warning(\"W001\"),id}function functionparams(options){function addParam(addParamArgs){state.funct[\"(scope)\"].addParam.apply(state.funct[\"(scope)\"],addParamArgs)}var next,ident,t,paramsIds=[],tokens=[],pastDefault=!1,pastRest=!1,arity=0,loneArg=options&&options.loneArg;if(loneArg&&loneArg.identifier===!0)return state.funct[\"(scope)\"].addParam(loneArg.value,loneArg),{arity:1,params:[loneArg.value]};if(next=state.tokens.next,options&&options.parsedOpening||advance(\"(\"),\")\"===state.tokens.next.id)return advance(\")\"),void 0;for(;;){arity++;var currentParams=[];if(_.contains([\"{\",\"[\"],state.tokens.next.id)){tokens=destructuringPattern();for(t in tokens)t=tokens[t],t.id&&(paramsIds.push(t.id),currentParams.push([t.id,t.token]))}else if(checkPunctuator(state.tokens.next,\"...\")&&(pastRest=!0),ident=identifier(!0))paramsIds.push(ident),currentParams.push([ident,state.tokens.curr]);else for(;!checkPunctuators(state.tokens.next,[\",\",\")\"]);)advance();if(pastDefault&&\"=\"!==state.tokens.next.id&&error(\"W138\",state.tokens.current),\"=\"===state.tokens.next.id&&(state.inES6()||warning(\"W119\",state.tokens.next,\"default parameters\",\"6\"),advance(\"=\"),pastDefault=!0,expression(10)),currentParams.forEach(addParam),\",\"!==state.tokens.next.id)return advance(\")\",next),{arity:arity,params:paramsIds};pastRest&&warning(\"W131\",state.tokens.next),comma()}}function functor(name,token,overwrites){var funct={\"(name)\":name,\"(breakage)\":0,\"(loopage)\":0,\"(tokens)\":{},\"(properties)\":{},\"(catch)\":!1,\"(global)\":!1,\"(line)\":null,\"(character)\":null,\"(metrics)\":null,\"(statement)\":null,\"(context)\":null,\"(scope)\":null,\"(comparray)\":null,\"(generator)\":null,\"(arrow)\":null,\"(params)\":null};return token&&_.extend(funct,{\"(line)\":token.line,\"(character)\":token.character,\"(metrics)\":createMetrics(token)}),_.extend(funct,overwrites),funct[\"(context)\"]&&(funct[\"(scope)\"]=funct[\"(context)\"][\"(scope)\"],funct[\"(comparray)\"]=funct[\"(context)\"][\"(comparray)\"]),funct}function isFunctor(token){return\"(scope)\"in token}function hasParsedCode(funct){return funct[\"(global)\"]&&!funct[\"(verb)\"]}function doTemplateLiteral(left){function end(){if(state.tokens.curr.template&&state.tokens.curr.tail&&state.tokens.curr.context===ctx)return!0;var complete=state.tokens.next.template&&state.tokens.next.tail&&state.tokens.next.context===ctx;return complete&&advance(),complete||state.tokens.next.isUnclosed}var ctx=this.context,noSubst=this.noSubst,depth=this.depth;if(!noSubst)for(;!end();)!state.tokens.next.template||state.tokens.next.depth>depth?expression(0):advance();return{id:\"(template)\",type:\"(template)\",tag:left}}function doFunction(options){var f,token,name,statement,classExprBinding,isGenerator,isArrow,ignoreLoopFunc,oldOption=state.option,oldIgnored=state.ignored;options&&(name=options.name,statement=options.statement,classExprBinding=options.classExprBinding,isGenerator=\"generator\"===options.type,isArrow=\"arrow\"===options.type,ignoreLoopFunc=options.ignoreLoopFunc),state.option=Object.create(state.option),state.ignored=Object.create(state.ignored),state.funct=functor(name||state.nameStack.infer(),state.tokens.next,{\"(statement)\":statement,\"(context)\":state.funct,\"(arrow)\":isArrow,\"(generator)\":isGenerator}),f=state.funct,token=state.tokens.curr,token.funct=state.funct,functions.push(state.funct),state.funct[\"(scope)\"].stack(\"functionouter\");var internallyAccessibleName=name||classExprBinding;internallyAccessibleName&&state.funct[\"(scope)\"].block.add(internallyAccessibleName,classExprBinding?\"class\":\"function\",state.tokens.curr,!1),state.funct[\"(scope)\"].stack(\"functionparams\");var paramsInfo=functionparams(options);return paramsInfo?(state.funct[\"(params)\"]=paramsInfo.params,state.funct[\"(metrics)\"].arity=paramsInfo.arity,state.funct[\"(metrics)\"].verifyMaxParametersPerFunction()):state.funct[\"(metrics)\"].arity=0,isArrow&&(state.inES6(!0)||warning(\"W119\",state.tokens.curr,\"arrow function syntax (=>)\",\"6\"),options.loneArg||advance(\"=>\")),block(!1,!0,!0,isArrow),!state.option.noyield&&isGenerator&&\"yielded\"!==state.funct[\"(generator)\"]&&warning(\"W124\",state.tokens.curr),state.funct[\"(metrics)\"].verifyMaxStatementsPerFunction(),state.funct[\"(metrics)\"].verifyMaxComplexityPerFunction(),state.funct[\"(unusedOption)\"]=state.option.unused,state.option=oldOption,state.ignored=oldIgnored,state.funct[\"(last)\"]=state.tokens.curr.line,state.funct[\"(lastcharacter)\"]=state.tokens.curr.character,state.funct[\"(scope)\"].unstack(),state.funct[\"(scope)\"].unstack(),state.funct=state.funct[\"(context)\"],ignoreLoopFunc||state.option.loopfunc||!state.funct[\"(loopage)\"]||f[\"(isCapturing)\"]&&warning(\"W083\",token),f}function createMetrics(functionStartToken){return{statementCount:0,nestedBlockDepth:-1,ComplexityCount:1,arity:0,verifyMaxStatementsPerFunction:function(){state.option.maxstatements&&this.statementCount>state.option.maxstatements&&warning(\"W071\",functionStartToken,this.statementCount)\n},verifyMaxParametersPerFunction:function(){_.isNumber(state.option.maxparams)&&this.arity>state.option.maxparams&&warning(\"W072\",functionStartToken,this.arity)},verifyMaxNestedBlockDepthPerFunction:function(){state.option.maxdepth&&this.nestedBlockDepth>0&&this.nestedBlockDepth===state.option.maxdepth+1&&warning(\"W073\",null,this.nestedBlockDepth)},verifyMaxComplexityPerFunction:function(){var max=state.option.maxcomplexity,cc=this.ComplexityCount;max&&cc>max&&warning(\"W074\",functionStartToken,cc)}}}function increaseComplexityCount(){state.funct[\"(metrics)\"].ComplexityCount+=1}function checkCondAssignment(expr){var id,paren;switch(expr&&(id=expr.id,paren=expr.paren,\",\"===id&&(expr=expr.exprs[expr.exprs.length-1])&&(id=expr.id,paren=paren||expr.paren)),id){case\"=\":case\"+=\":case\"-=\":case\"*=\":case\"%=\":case\"&=\":case\"|=\":case\"^=\":case\"/=\":paren||state.option.boss||warning(\"W084\")}}function checkProperties(props){if(state.inES5())for(var name in props)props[name]&&props[name].setterToken&&!props[name].getterToken&&warning(\"W078\",props[name].setterToken)}function metaProperty(name,c){if(checkPunctuator(state.tokens.next,\".\")){var left=state.tokens.curr.id;advance(\".\");var id=identifier();return state.tokens.curr.isMetaProperty=!0,name!==id?error(\"E057\",state.tokens.prev,left,id):c(),state.tokens.curr}}function destructuringPattern(options){var isAssignment=options&&options.assignment;return state.inES6()||warning(\"W104\",state.tokens.curr,isAssignment?\"destructuring assignment\":\"destructuring binding\",\"6\"),destructuringPatternRecursive(options)}function destructuringPatternRecursive(options){var ids,identifiers=[],openingParsed=options&&options.openingParsed,isAssignment=options&&options.assignment,recursiveOptions=isAssignment?{assignment:isAssignment}:null,firstToken=openingParsed?state.tokens.curr:state.tokens.next,nextInnerDE=function(){var ident;if(checkPunctuators(state.tokens.next,[\"[\",\"{\"])){ids=destructuringPatternRecursive(recursiveOptions);for(var id in ids)id=ids[id],identifiers.push({id:id.id,token:id.token})}else if(checkPunctuator(state.tokens.next,\",\"))identifiers.push({id:null,token:state.tokens.curr});else{if(!checkPunctuator(state.tokens.next,\"(\")){var is_rest=checkPunctuator(state.tokens.next,\"...\");if(isAssignment){var identifierToken=is_rest?peek(0):state.tokens.next;identifierToken.identifier||warning(\"E030\",identifierToken,identifierToken.value);var assignTarget=expression(155);assignTarget&&(checkLeftSideAssign(assignTarget),assignTarget.identifier&&(ident=assignTarget.value))}else ident=identifier();return ident&&identifiers.push({id:ident,token:state.tokens.curr}),is_rest}advance(\"(\"),nextInnerDE(),advance(\")\")}return!1},assignmentProperty=function(){var id;checkPunctuator(state.tokens.next,\"[\")?(advance(\"[\"),expression(10),advance(\"]\"),advance(\":\"),nextInnerDE()):\"(string)\"===state.tokens.next.id||\"(number)\"===state.tokens.next.id?(advance(),advance(\":\"),nextInnerDE()):(id=identifier(),checkPunctuator(state.tokens.next,\":\")?(advance(\":\"),nextInnerDE()):id&&(isAssignment&&checkLeftSideAssign(state.tokens.curr),identifiers.push({id:id,token:state.tokens.curr})))};if(checkPunctuator(firstToken,\"[\")){openingParsed||advance(\"[\"),checkPunctuator(state.tokens.next,\"]\")&&warning(\"W137\",state.tokens.curr);for(var element_after_rest=!1;!checkPunctuator(state.tokens.next,\"]\");)nextInnerDE()&&!element_after_rest&&checkPunctuator(state.tokens.next,\",\")&&(warning(\"W130\",state.tokens.next),element_after_rest=!0),checkPunctuator(state.tokens.next,\"=\")&&(checkPunctuator(state.tokens.prev,\"...\")?advance(\"]\"):advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"]\")||advance(\",\");advance(\"]\")}else if(checkPunctuator(firstToken,\"{\")){for(openingParsed||advance(\"{\"),checkPunctuator(state.tokens.next,\"}\")&&warning(\"W137\",state.tokens.curr);!checkPunctuator(state.tokens.next,\"}\")&&(assignmentProperty(),checkPunctuator(state.tokens.next,\"=\")&&(advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"}\")||(advance(\",\"),!checkPunctuator(state.tokens.next,\"}\"))););advance(\"}\")}return identifiers}function destructuringPatternMatch(tokens,value){var first=value.first;first&&_.zip(tokens,Array.isArray(first)?first:[first]).forEach(function(val){var token=val[0],value=val[1];token&&value?token.first=value:token&&token.first&&!value&&warning(\"W080\",token.first,token.first.value)})}function blockVariableStatement(type,statement,context){var tokens,lone,value,letblock,prefix=context&&context.prefix,inexport=context&&context.inexport,isLet=\"let\"===type,isConst=\"const\"===type;for(state.inES6()||warning(\"W104\",state.tokens.curr,type,\"6\"),isLet&&\"(\"===state.tokens.next.value?(state.inMoz()||warning(\"W118\",state.tokens.next,\"let block\"),advance(\"(\"),state.funct[\"(scope)\"].stack(),letblock=!0):state.funct[\"(noblockscopedvar)\"]&&error(\"E048\",state.tokens.curr,isConst?\"Const\":\"Let\"),statement.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),!prefix&&isConst&&\"=\"!==state.tokens.next.id&&warning(\"E012\",state.tokens.curr,state.tokens.curr.value);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],state.funct[\"(scope)\"].block.isGlobal()&&predefined[t.id]===!1&&warning(\"W079\",t.token,t.id),t.id&&!state.funct[\"(noblockscopedvar)\"]&&(state.funct[\"(scope)\"].addlabel(t.id,{type:type,token:t.token}),names.push(t.token),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.token.value,t.token)));if(\"=\"===state.tokens.next.id&&(advance(\"=\"),prefix||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),!prefix&&\"=\"===peek(0).id&&state.tokens.next.identifier&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),statement.first=statement.first.concat(names),\",\"!==state.tokens.next.id)break;comma()}return letblock&&(advance(\")\"),block(!0,!0),statement.block=!0,state.funct[\"(scope)\"].unstack()),statement}function classdef(isStatement){return state.inES6()||warning(\"W104\",state.tokens.curr,\"class\",\"6\"),isStatement?(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"class\",token:state.tokens.curr})):state.tokens.next.identifier&&\"extends\"!==state.tokens.next.value?(this.name=identifier(),this.namedExpr=!0):this.name=state.nameStack.infer(),classtail(this),this}function classtail(c){var wasInClassBody=state.inClassBody;\"extends\"===state.tokens.next.value&&(advance(\"extends\"),c.heritage=expression(10)),state.inClassBody=!0,advance(\"{\"),c.body=classbody(c),advance(\"}\"),state.inClassBody=wasInClassBody}function classbody(c){for(var name,isStatic,isGenerator,getset,computed,props=Object.create(null),staticProps=Object.create(null),i=0;\"}\"!==state.tokens.next.id;++i)if(name=state.tokens.next,isStatic=!1,isGenerator=!1,getset=null,\";\"!==name.id){if(\"*\"===name.id&&(isGenerator=!0,advance(\"*\"),name=state.tokens.next),\"[\"===name.id)name=computedPropertyName(),computed=!0;else{if(!isPropertyName(name)){warning(\"W052\",state.tokens.next,state.tokens.next.value||state.tokens.next.type),advance();continue}advance(),computed=!1,name.identifier&&\"static\"===name.value&&(checkPunctuator(state.tokens.next,\"*\")&&(isGenerator=!0,advance(\"*\")),(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,isStatic=!0,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())),!name.identifier||\"get\"!==name.value&&\"set\"!==name.value||(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,getset=name,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())}if(!checkPunctuator(state.tokens.next,\"(\")){for(error(\"E054\",state.tokens.next,state.tokens.next.value);\"}\"!==state.tokens.next.id&&!checkPunctuator(state.tokens.next,\"(\");)advance();\"(\"!==state.tokens.next.value&&doFunction({statement:c})}if(computed||(getset?saveAccessor(getset.value,isStatic?staticProps:props,name.value,name,!0,isStatic):(\"constructor\"===name.value?state.nameStack.set(c):state.nameStack.set(name),saveProperty(isStatic?staticProps:props,name.value,name,!0,isStatic))),getset&&\"constructor\"===name.value){var propDesc=\"get\"===getset.value?\"class getter method\":\"class setter method\";error(\"E049\",name,propDesc,\"constructor\")}else\"prototype\"===name.value&&error(\"E049\",name,\"class method\",\"prototype\");propertyName(name),doFunction({statement:c,type:isGenerator?\"generator\":null,classExprBinding:c.namedExpr?c.name:null})}else warning(\"W032\"),advance(\";\");checkProperties(props)}function saveProperty(props,name,tkn,isClass,isStatic){var msg=[\"key\",\"class method\",\"static class method\"];msg=msg[(isClass||!1)+(isStatic||!1)],tkn.identifier&&(name=tkn.value),props[name]&&\"__proto__\"!==name?warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name].basic=!0,props[name].basictkn=tkn}function saveAccessor(accessorType,props,name,tkn,isClass,isStatic){var flagName=\"get\"===accessorType?\"getterToken\":\"setterToken\",msg=\"\";isClass?(isStatic&&(msg+=\"static \"),msg+=accessorType+\"ter method\"):msg=\"key\",state.tokens.curr.accessorType=accessorType,state.nameStack.set(tkn),props[name]?(props[name].basic||props[name][flagName])&&\"__proto__\"!==name&&warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name][flagName]=tkn}function computedPropertyName(){advance(\"[\"),state.inES6()||warning(\"W119\",state.tokens.curr,\"computed property names\",\"6\");var value=expression(10);return advance(\"]\"),value}function checkPunctuators(token,values){return\"(punctuator)\"===token.type?_.contains(values,token.value):!1}function checkPunctuator(token,value){return\"(punctuator)\"===token.type&&token.value===value}function destructuringAssignOrJsonValue(){var block=lookupBlockType();block.notJson?(!state.inES6()&&block.isDestAssign&&warning(\"W104\",state.tokens.curr,\"destructuring assignment\",\"6\"),statements()):(state.option.laxbreak=!0,state.jsonMode=!0,jsonValue())}function jsonValue(){function jsonObject(){var o={},t=state.tokens.next;if(advance(\"{\"),\"}\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E026\",state.tokens.next,t.line);else{if(\"}\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id?error(\"E028\",state.tokens.next):\"(string)\"!==state.tokens.next.id&&warning(\"W095\",state.tokens.next,state.tokens.next.value)}if(o[state.tokens.next.value]===!0?warning(\"W075\",state.tokens.next,\"key\",state.tokens.next.value):\"__proto__\"===state.tokens.next.value&&!state.option.proto||\"__iterator__\"===state.tokens.next.value&&!state.option.iterator?warning(\"W096\",state.tokens.next,state.tokens.next.value):o[state.tokens.next.value]=!0,advance(),advance(\":\"),jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"}\")}function jsonArray(){var t=state.tokens.next;if(advance(\"[\"),\"]\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E027\",state.tokens.next,t.line);else{if(\"]\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id&&error(\"E028\",state.tokens.next)}if(jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"]\")}switch(state.tokens.next.id){case\"{\":jsonObject();break;case\"[\":jsonArray();break;case\"true\":case\"false\":case\"null\":case\"(number)\":case\"(string)\":advance();break;case\"-\":advance(\"-\"),advance(\"(number)\");break;default:error(\"E003\",state.tokens.next)}}var api,declared,functions,inblock,indent,lookahead,lex,member,membersOnly,predefined,stack,urls,bang={\"<\":!0,\"<=\":!0,\"==\":!0,\"===\":!0,\"!==\":!0,\"!=\":!0,\">\":!0,\">=\":!0,\"+\":!0,\"-\":!0,\"*\":!0,\"/\":!0,\"%\":!0},functionicity=[\"closure\",\"exception\",\"global\",\"label\",\"outer\",\"unused\",\"var\"],extraModules=[],emitter=new events.EventEmitter,typeofValues={};typeofValues.legacy=[\"xml\",\"unknown\"],typeofValues.es3=[\"undefined\",\"boolean\",\"number\",\"string\",\"function\",\"object\"],typeofValues.es3=typeofValues.es3.concat(typeofValues.legacy),typeofValues.es6=typeofValues.es3.concat(\"symbol\"),type(\"(number)\",function(){return this}),type(\"(string)\",function(){return this}),state.syntax[\"(identifier)\"]={type:\"(identifier)\",lbp:0,identifier:!0,nud:function(){var v=this.value;return\"=>\"===state.tokens.next.id?this:(state.funct[\"(comparray)\"].check(v)||state.funct[\"(scope)\"].block.use(v,state.tokens.curr),this)},led:function(){error(\"E033\",state.tokens.next,state.tokens.next.value)}};var baseTemplateSyntax={lbp:0,identifier:!1,template:!0};state.syntax[\"(template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template middle)\"]=_.extend({type:\"(template middle)\",middle:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template tail)\"]=_.extend({type:\"(template tail)\",tail:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(no subst template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!0,tail:!0},baseTemplateSyntax),type(\"(regexp)\",function(){return this}),delim(\"(endline)\"),delim(\"(begin)\"),delim(\"(end)\").reach=!0,delim(\"(error)\").reach=!0,delim(\"}\").reach=!0,delim(\")\"),delim(\"]\"),delim('\"').reach=!0,delim(\"'\").reach=!0,delim(\";\"),delim(\":\").reach=!0,delim(\"#\"),reserve(\"else\"),reserve(\"case\").reach=!0,reserve(\"catch\"),reserve(\"default\").reach=!0,reserve(\"finally\"),reservevar(\"arguments\",function(x){state.isStrict()&&state.funct[\"(global)\"]&&warning(\"E008\",x)}),reservevar(\"eval\"),reservevar(\"false\"),reservevar(\"Infinity\"),reservevar(\"null\"),reservevar(\"this\",function(x){state.isStrict()&&!isMethod()&&!state.option.validthis&&(state.funct[\"(statement)\"]&&state.funct[\"(name)\"].charAt(0)>\"Z\"||state.funct[\"(global)\"])&&warning(\"W040\",x)}),reservevar(\"true\"),reservevar(\"undefined\"),assignop(\"=\",\"assign\",20),assignop(\"+=\",\"assignadd\",20),assignop(\"-=\",\"assignsub\",20),assignop(\"*=\",\"assignmult\",20),assignop(\"/=\",\"assigndiv\",20).nud=function(){error(\"E014\")},assignop(\"%=\",\"assignmod\",20),bitwiseassignop(\"&=\"),bitwiseassignop(\"|=\"),bitwiseassignop(\"^=\"),bitwiseassignop(\"<<=\"),bitwiseassignop(\">>=\"),bitwiseassignop(\">>>=\"),infix(\",\",function(left,that){var expr;if(that.exprs=[left],state.option.nocomma&&warning(\"W127\"),!comma({peek:!0}))return that;for(;;){if(!(expr=expression(10)))break;if(that.exprs.push(expr),\",\"!==state.tokens.next.value||!comma())break}return that},10,!0),infix(\"?\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(10),advance(\":\"),that[\"else\"]=expression(10),that},30);var orPrecendence=40;infix(\"||\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(orPrecendence),that},orPrecendence),infix(\"&&\",\"and\",50),bitwise(\"|\",\"bitor\",70),bitwise(\"^\",\"bitxor\",80),bitwise(\"&\",\"bitand\",90),relation(\"==\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));switch(!0){case!eqnull&&state.option.eqeqeq:this.from=this.character,warning(\"W116\",this,\"===\",\"==\");break;case isPoorRelation(left):warning(\"W041\",this,\"===\",left.value);break;case isPoorRelation(right):warning(\"W041\",this,\"===\",right.value);break;case isTypoTypeof(right,left,state):warning(\"W122\",this,right.value);break;case isTypoTypeof(left,right,state):warning(\"W122\",this,left.value)}return this}),relation(\"===\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!=\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));return!eqnull&&state.option.eqeqeq?(this.from=this.character,warning(\"W116\",this,\"!==\",\"!=\")):isPoorRelation(left)?warning(\"W041\",this,\"!==\",left.value):isPoorRelation(right)?warning(\"W041\",this,\"!==\",right.value):isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!==\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"<\"),relation(\">\"),relation(\"<=\"),relation(\">=\"),bitwise(\"<<\",\"shiftleft\",120),bitwise(\">>\",\"shiftright\",120),bitwise(\">>>\",\"shiftrightunsigned\",120),infix(\"in\",\"in\",120),infix(\"instanceof\",\"instanceof\",120),infix(\"+\",function(left,that){var right;return that.left=left,that.right=right=expression(130),left&&right&&\"(string)\"===left.id&&\"(string)\"===right.id?(left.value+=right.value,left.character=right.character,!state.option.scripturl&&reg.javascriptURL.test(left.value)&&warning(\"W050\",left),left):that},130),prefix(\"+\",\"num\"),prefix(\"+++\",function(){return warning(\"W007\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"+++\",function(left){return warning(\"W007\"),this.left=left,this.right=expression(130),this},130),infix(\"-\",\"sub\",130),prefix(\"-\",\"neg\"),prefix(\"---\",function(){return warning(\"W006\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"---\",function(left){return warning(\"W006\"),this.left=left,this.right=expression(130),this},130),infix(\"*\",\"mult\",140),infix(\"/\",\"div\",140),infix(\"%\",\"mod\",140),suffix(\"++\"),prefix(\"++\",\"preinc\"),state.syntax[\"++\"].exps=!0,suffix(\"--\"),prefix(\"--\",\"predec\"),state.syntax[\"--\"].exps=!0,prefix(\"delete\",function(){var p=expression(10);return p?(\".\"!==p.id&&\"[\"!==p.id&&warning(\"W051\"),this.first=p,p.identifier&&!state.isStrict()&&(p.forgiveUndef=!0),this):this}).exps=!0,prefix(\"~\",function(){return state.option.bitwise&&warning(\"W016\",this,\"~\"),this.arity=\"unary\",this.right=expression(150),this}),prefix(\"...\",function(){return state.inES6(!0)||warning(\"W119\",this,\"spread/rest operator\",\"6\"),state.tokens.next.identifier||\"(string)\"===state.tokens.next.type||checkPunctuators(state.tokens.next,[\"[\",\"(\"])||error(\"E030\",state.tokens.next,state.tokens.next.value),expression(150),this}),prefix(\"!\",function(){return this.arity=\"unary\",this.right=expression(150),this.right||quit(\"E041\",this.line||0),bang[this.right.id]===!0&&warning(\"W018\",this,\"!\"),this}),prefix(\"typeof\",function(){var p=expression(150);return this.first=this.right=p,p||quit(\"E041\",this.line||0,this.character||0),p.identifier&&(p.forgiveUndef=!0),this}),prefix(\"new\",function(){var mp=metaProperty(\"target\",function(){state.inES6(!0)||warning(\"W119\",state.tokens.prev,\"new.target\",\"6\");for(var inFunction,c=state.funct;c&&(inFunction=!c[\"(global)\"],c[\"(arrow)\"]);)c=c[\"(context)\"];inFunction||warning(\"W136\",state.tokens.prev,\"new.target\")});if(mp)return mp;var i,c=expression(155);if(c&&\"function\"!==c.id)if(c.identifier)switch(c[\"new\"]=!0,c.value){case\"Number\":case\"String\":case\"Boolean\":case\"Math\":case\"JSON\":warning(\"W053\",state.tokens.prev,c.value);break;case\"Symbol\":state.inES6()&&warning(\"W053\",state.tokens.prev,c.value);break;case\"Function\":state.option.evil||warning(\"W054\");break;case\"Date\":case\"RegExp\":case\"this\":break;default:\"function\"!==c.id&&(i=c.value.substr(0,1),state.option.newcap&&(\"A\">i||i>\"Z\")&&!state.funct[\"(scope)\"].isPredefined(c.value)&&warning(\"W055\",state.tokens.curr))}else\".\"!==c.id&&\"[\"!==c.id&&\"(\"!==c.id&&warning(\"W056\",state.tokens.curr);else state.option.supernew||warning(\"W057\",this);return\"(\"===state.tokens.next.id||state.option.supernew||warning(\"W058\",state.tokens.curr,state.tokens.curr.value),this.first=this.right=c,this}),state.syntax[\"new\"].exps=!0,prefix(\"void\").exps=!0,infix(\".\",function(left,that){var m=identifier(!1,!0);return\"string\"==typeof m&&countMember(m),that.left=left,that.right=m,m&&\"hasOwnProperty\"===m&&\"=\"===state.tokens.next.value&&warning(\"W001\"),!left||\"arguments\"!==left.value||\"callee\"!==m&&\"caller\"!==m?state.option.evil||!left||\"document\"!==left.value||\"write\"!==m&&\"writeln\"!==m||warning(\"W060\",left):state.option.noarg?warning(\"W059\",left,m):state.isStrict()&&error(\"E008\"),state.option.evil||\"eval\"!==m&&\"execScript\"!==m||isGlobalEval(left,state)&&warning(\"W061\"),that},160,!0),infix(\"(\",function(left,that){state.option.immed&&left&&!left.immed&&\"function\"===left.id&&warning(\"W062\");var n=0,p=[];if(left&&\"(identifier)\"===left.type&&left.value.match(/^[A-Z]([A-Z0-9_$]*[a-z][A-Za-z0-9_$]*)?$/)&&-1===\"Array Number String Boolean Date Object Error Symbol\".indexOf(left.value)&&(\"Math\"===left.value?warning(\"W063\",left):state.option.newcap&&warning(\"W064\",left)),\")\"!==state.tokens.next.id)for(;p[p.length]=expression(10),n+=1,\",\"===state.tokens.next.id;)comma();return advance(\")\"),\"object\"==typeof left&&(state.inES5()||\"parseInt\"!==left.value||1!==n||warning(\"W065\",state.tokens.curr),state.option.evil||(\"eval\"===left.value||\"Function\"===left.value||\"execScript\"===left.value?(warning(\"W061\",left),p[0]&&\"(string)\"===[0].id&&addInternalSrc(left,p[0].value)):!p[0]||\"(string)\"!==p[0].id||\"setTimeout\"!==left.value&&\"setInterval\"!==left.value?!p[0]||\"(string)\"!==p[0].id||\".\"!==left.value||\"window\"!==left.left.value||\"setTimeout\"!==left.right&&\"setInterval\"!==left.right||(warning(\"W066\",left),addInternalSrc(left,p[0].value)):(warning(\"W066\",left),addInternalSrc(left,p[0].value))),left.identifier||\".\"===left.id||\"[\"===left.id||\"=>\"===left.id||\"(\"===left.id||\"&&\"===left.id||\"||\"===left.id||\"?\"===left.id||state.inES6()&&left[\"(name)\"]||warning(\"W067\",that)),that.left=left,that},155,!0).exps=!0,prefix(\"(\",function(){var pn1,ret,triggerFnExpr,first,last,pn=state.tokens.next,i=-1,parens=1,opening=state.tokens.curr,preceeding=state.tokens.prev,isNecessary=!state.option.singleGroups;do\"(\"===pn.value?parens+=1:\")\"===pn.value&&(parens-=1),i+=1,pn1=pn,pn=peek(i);while((0!==parens||\")\"!==pn1.value)&&\";\"!==pn.value&&\"(end)\"!==pn.type);if(\"function\"===state.tokens.next.id&&(triggerFnExpr=state.tokens.next.immed=!0),\"=>\"===pn.value)return doFunction({type:\"arrow\",parsedOpening:!0});var exprs=[];if(\")\"!==state.tokens.next.id)for(;exprs.push(expression(10)),\",\"===state.tokens.next.id;)state.option.nocomma&&warning(\"W127\"),comma();return advance(\")\",this),state.option.immed&&exprs[0]&&\"function\"===exprs[0].id&&\"(\"!==state.tokens.next.id&&\".\"!==state.tokens.next.id&&\"[\"!==state.tokens.next.id&&warning(\"W068\",this),exprs.length?(exprs.length>1?(ret=Object.create(state.syntax[\",\"]),ret.exprs=exprs,first=exprs[0],last=exprs[exprs.length-1],isNecessary||(isNecessary=preceeding.assign||preceeding.delim)):(ret=first=last=exprs[0],isNecessary||(isNecessary=opening.beginsStmt&&(\"{\"===ret.id||triggerFnExpr||isFunctor(ret))||triggerFnExpr&&(!isEndOfExpr()||\"}\"!==state.tokens.prev.id)||isFunctor(ret)&&!isEndOfExpr()||\"{\"===ret.id&&\"=>\"===preceeding.id||\"(number)\"===ret.type&&checkPunctuator(pn,\".\")&&/^\\d+$/.test(ret.value))),ret&&(!isNecessary&&(first.left||first.right||ret.exprs)&&(isNecessary=!isBeginOfExpr(preceeding)&&first.lbp<=preceeding.lbp||!isEndOfExpr()&&last.lbp<state.tokens.next.lbp),isNecessary||warning(\"W126\",opening),ret.paren=!0),ret):void 0}),application(\"=>\"),infix(\"[\",function(left,that){var s,e=expression(10);return e&&\"(string)\"===e.type&&(state.option.evil||\"eval\"!==e.value&&\"execScript\"!==e.value||isGlobalEval(left,state)&&warning(\"W061\"),countMember(e.value),!state.option.sub&&reg.identifier.test(e.value)&&(s=state.syntax[e.value],s&&isReserved(s)||warning(\"W069\",state.tokens.prev,e.value))),advance(\"]\",that),e&&\"hasOwnProperty\"===e.value&&\"=\"===state.tokens.next.value&&warning(\"W001\"),that.left=left,that.right=e,that},160,!0),prefix(\"[\",function(){var blocktype=lookupBlockType();if(blocktype.isCompArray)return state.option.esnext||state.inMoz()||warning(\"W118\",state.tokens.curr,\"array comprehension\"),comprehensiveArrayExpression();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;var b=state.tokens.curr.line!==startLine(state.tokens.next);for(this.first=[],b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));\"(end)\"!==state.tokens.next.id;){for(;\",\"===state.tokens.next.id;){if(!state.option.elision){if(state.inES5()){warning(\"W128\");do advance(\",\");while(\",\"===state.tokens.next.id);continue}warning(\"W070\")}advance(\",\")}if(\"]\"===state.tokens.next.id)break;if(this.first.push(expression(10)),\",\"!==state.tokens.next.id)break;if(comma({allowTrailing:!0}),\"]\"===state.tokens.next.id&&!state.inES5()){warning(\"W070\",state.tokens.curr);break}}return b&&(indent-=state.option.indent),advance(\"]\",this),this}),function(x){x.nud=function(){var b,f,i,p,t,nextVal,isGeneratorMethod=!1,props=Object.create(null);b=state.tokens.curr.line!==startLine(state.tokens.next),b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));var blocktype=lookupBlockType();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;for(;\"}\"!==state.tokens.next.id;){if(nextVal=state.tokens.next.value,!state.tokens.next.identifier||\",\"!==peekIgnoreEOL().id&&\"}\"!==peekIgnoreEOL().id)if(\":\"===peek().id||\"get\"!==nextVal&&\"set\"!==nextVal){if(\"*\"===state.tokens.next.value&&\"(punctuator)\"===state.tokens.next.type?(state.inES6()||warning(\"W104\",state.tokens.next,\"generator functions\",\"6\"),advance(\"*\"),isGeneratorMethod=!0):isGeneratorMethod=!1,\"[\"===state.tokens.next.id)i=computedPropertyName(),state.nameStack.set(i);else if(state.nameStack.set(state.tokens.next),i=propertyName(),saveProperty(props,i,state.tokens.next),\"string\"!=typeof i)break;\"(\"===state.tokens.next.value?(state.inES6()||warning(\"W104\",state.tokens.curr,\"concise methods\",\"6\"),doFunction({type:isGeneratorMethod?\"generator\":null})):(advance(\":\"),expression(10))}else advance(nextVal),state.inES5()||error(\"E034\"),i=propertyName(),i||state.inES6()||error(\"E035\"),i&&saveAccessor(nextVal,props,i,state.tokens.curr),t=state.tokens.next,f=doFunction(),p=f[\"(params)\"],\"get\"===nextVal&&i&&p?warning(\"W076\",t,p[0],i):\"set\"!==nextVal||!i||p&&1===p.length||warning(\"W077\",t,i);else state.inES6()||warning(\"W104\",state.tokens.next,\"object short notation\",\"6\"),i=propertyName(!0),saveProperty(props,i,state.tokens.next),expression(10);if(countMember(i),\",\"!==state.tokens.next.id)break;comma({allowTrailing:!0,property:!0}),\",\"===state.tokens.next.id?warning(\"W070\",state.tokens.curr):\"}\"!==state.tokens.next.id||state.inES5()||warning(\"W070\",state.tokens.curr)}return b&&(indent-=state.option.indent),advance(\"}\",this),checkProperties(props),this},x.fud=function(){error(\"E036\",state.tokens.curr)}}(delim(\"{\"));var conststatement=stmt(\"const\",function(context){return blockVariableStatement(\"const\",this,context)});conststatement.exps=!0;var letstatement=stmt(\"let\",function(context){return blockVariableStatement(\"let\",this,context)});letstatement.exps=!0;var varstatement=stmt(\"var\",function(context){var tokens,lone,value,prefix=context&&context.prefix,inexport=context&&context.inexport,implied=context&&context.implied,report=!(context&&context.ignore);for(this.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),prefix&&implied||!report||!state.option.varstmt||warning(\"W132\",this),this.first=this.first.concat(names);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],!implied&&state.funct[\"(global)\"]&&(predefined[t.id]===!1?warning(\"W079\",t.token,t.id):state.option.futurehostile===!1&&(!state.inES5()&&vars.ecmaIdentifiers[5][t.id]===!1||!state.inES6()&&vars.ecmaIdentifiers[6][t.id]===!1)&&warning(\"W129\",t.token,t.id)),t.id&&(\"for\"===implied?(state.funct[\"(scope)\"].has(t.id)||report&&warning(\"W088\",t.token,t.id),state.funct[\"(scope)\"].block.use(t.id,t.token)):(state.funct[\"(scope)\"].addlabel(t.id,{type:\"var\",token:t.token}),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.id,t.token)),names.push(t.token)));if(\"=\"===state.tokens.next.id&&(state.nameStack.set(state.tokens.curr),advance(\"=\"),prefix||!report||state.funct[\"(loopage)\"]||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),\"=\"===peek(0).id&&state.tokens.next.identifier&&(!prefix&&report&&!state.funct[\"(params)\"]||-1===state.funct[\"(params)\"].indexOf(state.tokens.next.value))&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),\",\"!==state.tokens.next.id)break;comma()}return this});varstatement.exps=!0,blockstmt(\"class\",function(){return classdef.call(this,!0)}),blockstmt(\"function\",function(context){var inexport=context&&context.inexport,generator=!1;\"*\"===state.tokens.next.value&&(advance(\"*\"),state.inES6({strict:!0})?generator=!0:warning(\"W119\",state.tokens.curr,\"function*\",\"6\")),inblock&&warning(\"W082\",state.tokens.curr);var i=optionalidentifier();return state.funct[\"(scope)\"].addlabel(i,{type:\"function\",token:state.tokens.curr}),void 0===i?warning(\"W025\"):inexport&&state.funct[\"(scope)\"].setExported(i,state.tokens.prev),doFunction({name:i,statement:this,type:generator?\"generator\":null,ignoreLoopFunc:inblock}),\"(\"===state.tokens.next.id&&state.tokens.next.line===state.tokens.curr.line&&error(\"E039\"),this}),prefix(\"function\",function(){var generator=!1;\"*\"===state.tokens.next.value&&(state.inES6()||warning(\"W119\",state.tokens.curr,\"function*\",\"6\"),advance(\"*\"),generator=!0);var i=optionalidentifier();return doFunction({name:i,type:generator?\"generator\":null}),this}),blockstmt(\"if\",function(){var t=state.tokens.next;increaseComplexityCount(),state.condition=!0,advance(\"(\");var expr=expression(0);checkCondAssignment(expr);var forinifcheck=null;state.option.forin&&state.forinifcheckneeded&&(state.forinifcheckneeded=!1,forinifcheck=state.forinifchecks[state.forinifchecks.length-1],forinifcheck.type=\"(punctuator)\"===expr.type&&\"!\"===expr.value?\"(negative)\":\"(positive)\"),advance(\")\",t),state.condition=!1;var s=block(!0,!0);return forinifcheck&&\"(negative)\"===forinifcheck.type&&s&&s[0]&&\"(identifier)\"===s[0].type&&\"continue\"===s[0].value&&(forinifcheck.type=\"(negative-with-continue)\"),\"else\"===state.tokens.next.id&&(advance(\"else\"),\"if\"===state.tokens.next.id||\"switch\"===state.tokens.next.id?statement():block(!0,!0)),this}),blockstmt(\"try\",function(){function doCatch(){if(advance(\"catch\"),advance(\"(\"),state.funct[\"(scope)\"].stack(\"catchparams\"),checkPunctuators(state.tokens.next,[\"[\",\"{\"])){var tokens=destructuringPattern();_.each(tokens,function(token){token.id&&state.funct[\"(scope)\"].addParam(token.id,token,\"exception\")})}else\"(identifier)\"!==state.tokens.next.type?warning(\"E030\",state.tokens.next,state.tokens.next.value):state.funct[\"(scope)\"].addParam(identifier(),state.tokens.curr,\"exception\");\"if\"===state.tokens.next.value&&(state.inMoz()||warning(\"W118\",state.tokens.curr,\"catch filter\"),advance(\"if\"),expression(0)),advance(\")\"),block(!1),state.funct[\"(scope)\"].unstack()}var b;for(block(!0);\"catch\"===state.tokens.next.id;)increaseComplexityCount(),b&&!state.inMoz()&&warning(\"W118\",state.tokens.next,\"multiple catch blocks\"),doCatch(),b=!0;return\"finally\"===state.tokens.next.id?(advance(\"finally\"),block(!0),void 0):(b||error(\"E021\",state.tokens.next,\"catch\",state.tokens.next.value),this)}),blockstmt(\"while\",function(){var t=state.tokens.next;return state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this}).labelled=!0,blockstmt(\"with\",function(){var t=state.tokens.next;return state.isStrict()?error(\"E010\",state.tokens.curr):state.option.withstmt||warning(\"W085\",state.tokens.curr),advance(\"(\"),expression(0),advance(\")\",t),block(!0,!0),this}),blockstmt(\"switch\",function(){var t=state.tokens.next,g=!1,noindent=!1;\nfor(state.funct[\"(breakage)\"]+=1,advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),t=state.tokens.next,advance(\"{\"),state.tokens.next.from===indent&&(noindent=!0),noindent||(indent+=state.option.indent),this.cases=[];;)switch(state.tokens.next.id){case\"case\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"case\":case\"continue\":case\"return\":case\"switch\":case\"throw\":break;default:state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"case\")}advance(\"case\"),this.cases.push(expression(0)),increaseComplexityCount(),g=!0,advance(\":\"),state.funct[\"(verb)\"]=\"case\";break;case\"default\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"continue\":case\"return\":case\"throw\":break;default:this.cases.length&&(state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"default\"))}advance(\"default\"),g=!0,advance(\":\");break;case\"}\":return noindent||(indent-=state.option.indent),advance(\"}\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(verb)\"]=void 0,void 0;case\"(end)\":return error(\"E023\",state.tokens.next,\"}\"),void 0;default:if(indent+=state.option.indent,g)switch(state.tokens.curr.id){case\",\":return error(\"E040\"),void 0;case\":\":g=!1,statements();break;default:return error(\"E025\",state.tokens.curr),void 0}else{if(\":\"!==state.tokens.curr.id)return error(\"E021\",state.tokens.next,\"case\",state.tokens.next.value),void 0;advance(\":\"),error(\"E024\",state.tokens.curr,\":\"),statements()}indent-=state.option.indent}return this}).labelled=!0,stmt(\"debugger\",function(){return state.option.debug||warning(\"W087\",this),this}).exps=!0,function(){var x=stmt(\"do\",function(){state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),this.first=block(!0,!0),advance(\"while\");var t=state.tokens.next;return advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this});x.labelled=!0,x.exps=!0}(),blockstmt(\"for\",function(){var s,t=state.tokens.next,letscope=!1,foreachtok=null;\"each\"===t.value&&(foreachtok=t,advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),increaseComplexityCount(),advance(\"(\");var nextop,comma,initializer,i=0,inof=[\"in\",\"of\"],level=0;checkPunctuators(state.tokens.next,[\"{\",\"[\"])&&++level;do{if(nextop=peek(i),++i,checkPunctuators(nextop,[\"{\",\"[\"])?++level:checkPunctuators(nextop,[\"}\",\"]\"])&&--level,0>level)break;0===level&&(!comma&&checkPunctuator(nextop,\",\")?comma=nextop:!initializer&&checkPunctuator(nextop,\"=\")&&(initializer=nextop))}while(level>0||!_.contains(inof,nextop.value)&&\";\"!==nextop.value&&\"(end)\"!==nextop.type);if(_.contains(inof,nextop.value)){state.inES6()||\"of\"!==nextop.value||warning(\"W104\",nextop,\"for of\",\"6\");var ok=!(initializer||comma);if(initializer&&error(\"W133\",comma,nextop.value,\"initializer is forbidden\"),comma&&error(\"W133\",comma,nextop.value,\"more than one ForBinding\"),\"var\"===state.tokens.next.id?(advance(\"var\"),state.tokens.curr.fud({prefix:!0})):\"let\"===state.tokens.next.id||\"const\"===state.tokens.next.id?(advance(state.tokens.next.id),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud({prefix:!0})):Object.create(varstatement).fud({prefix:!0,implied:\"for\",ignore:!ok}),advance(nextop.value),expression(20),advance(\")\",t),\"in\"===nextop.value&&state.option.forin&&(state.forinifcheckneeded=!0,void 0===state.forinifchecks&&(state.forinifchecks=[]),state.forinifchecks.push({type:\"(none)\"})),state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,s=block(!0,!0),\"in\"===nextop.value&&state.option.forin){if(state.forinifchecks&&state.forinifchecks.length>0){var check=state.forinifchecks.pop();(s&&s.length>0&&(\"object\"!=typeof s[0]||\"if\"!==s[0].value)||\"(positive)\"===check.type&&s.length>1||\"(negative)\"===check.type)&&warning(\"W089\",this)}state.forinifcheckneeded=!1}state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}else{if(foreachtok&&error(\"E045\",foreachtok),\";\"!==state.tokens.next.id)if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud();else if(\"let\"===state.tokens.next.id)advance(\"let\"),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud();else for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();if(nolinebreak(state.tokens.curr),advance(\";\"),state.funct[\"(loopage)\"]+=1,\";\"!==state.tokens.next.id&&checkCondAssignment(expression(0)),nolinebreak(state.tokens.curr),advance(\";\"),\";\"===state.tokens.next.id&&error(\"E021\",state.tokens.next,\")\",\";\"),\")\"!==state.tokens.next.id)for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();advance(\")\",t),state.funct[\"(breakage)\"]+=1,block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}return letscope&&state.funct[\"(scope)\"].unstack(),this}).labelled=!0,stmt(\"break\",function(){var v=state.tokens.next.value;return state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line!==startLine(state.tokens.next)?0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value):(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"continue\",function(){var v=state.tokens.next.value;return 0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value),state.funct[\"(loopage)\"]||warning(\"W052\",state.tokens.next,this.value),state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line===startLine(state.tokens.next)&&(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"return\",function(){return this.line===startLine(state.tokens.next)?\";\"===state.tokens.next.id||state.tokens.next.reach||(this.first=expression(0),!this.first||\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)):\"(punctuator)\"===state.tokens.next.type&&[\"[\",\"{\",\"+\",\"-\"].indexOf(state.tokens.next.value)>-1&&nolinebreak(this),reachable(this),this}).exps=!0,function(x){x.exps=!0,x.lbp=25}(prefix(\"yield\",function(){var prev=state.tokens.prev;state.inES6(!0)&&!state.funct[\"(generator)\"]?\"(catch)\"===state.funct[\"(name)\"]&&state.funct[\"(context)\"][\"(generator)\"]||error(\"E046\",state.tokens.curr,\"yield\"):state.inES6()||warning(\"W104\",state.tokens.curr,\"yield\",\"6\"),state.funct[\"(generator)\"]=\"yielded\";var delegatingYield=!1;return\"*\"===state.tokens.next.value&&(delegatingYield=!0,advance(\"*\")),this.line!==startLine(state.tokens.next)&&state.inMoz()?state.option.asi||nolinebreak(this):((delegatingYield||\";\"!==state.tokens.next.id&&!state.option.asi&&!state.tokens.next.reach&&state.tokens.next.nud)&&(nobreaknonadjacent(state.tokens.curr,state.tokens.next),this.first=expression(10),\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)),state.inMoz()&&\")\"!==state.tokens.next.id&&(prev.lbp>30||!prev.assign&&!isEndOfExpr()||\"yield\"===prev.id)&&error(\"E050\",this)),this})),stmt(\"throw\",function(){return nolinebreak(this),this.first=expression(20),reachable(this),this}).exps=!0,stmt(\"import\",function(){if(state.inES6()||warning(\"W119\",state.tokens.curr,\"import\",\"6\"),\"(string)\"===state.tokens.next.type)return advance(\"(string)\"),this;if(state.tokens.next.identifier){if(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value)return advance(\"from\"),advance(\"(string)\"),this;advance(\",\")}if(\"*\"===state.tokens.next.id)advance(\"*\"),advance(\"as\"),state.tokens.next.identifier&&(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}));else for(advance(\"{\");;){if(\"}\"===state.tokens.next.value){advance(\"}\");break}var importName;if(\"default\"===state.tokens.next.type?(importName=\"default\",advance(\"default\")):importName=identifier(),\"as\"===state.tokens.next.value&&(advance(\"as\"),importName=identifier()),state.funct[\"(scope)\"].addlabel(importName,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return advance(\"from\"),advance(\"(string)\"),this}).exps=!0,stmt(\"export\",function(){var token,identifier,ok=!0;if(state.inES6()||(warning(\"W119\",state.tokens.curr,\"export\",\"6\"),ok=!1),state.funct[\"(scope)\"].block.isGlobal()||(error(\"E053\",state.tokens.curr),ok=!1),\"*\"===state.tokens.next.value)return advance(\"*\"),advance(\"from\"),advance(\"(string)\"),this;if(\"default\"===state.tokens.next.type){state.nameStack.set(state.tokens.next),advance(\"default\");var exportType=state.tokens.next.id;return(\"function\"===exportType||\"class\"===exportType)&&(this.block=!0),token=peek(),expression(10),identifier=token.value,this.block&&(state.funct[\"(scope)\"].addlabel(identifier,{type:exportType,token:token}),state.funct[\"(scope)\"].setExported(identifier,token)),this}if(\"{\"===state.tokens.next.value){advance(\"{\");for(var exportedTokens=[];;){if(state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance(),exportedTokens.push(state.tokens.curr),\"as\"===state.tokens.next.value&&(advance(\"as\"),state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance()),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return\"from\"===state.tokens.next.value?(advance(\"from\"),advance(\"(string)\")):ok&&exportedTokens.forEach(function(token){state.funct[\"(scope)\"].setExported(token.value,token)}),this}if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud({inexport:!0});else if(\"let\"===state.tokens.next.id)advance(\"let\"),state.tokens.curr.fud({inexport:!0});else if(\"const\"===state.tokens.next.id)advance(\"const\"),state.tokens.curr.fud({inexport:!0});else if(\"function\"===state.tokens.next.id)this.block=!0,advance(\"function\"),state.syntax[\"function\"].fud({inexport:!0});else if(\"class\"===state.tokens.next.id){this.block=!0,advance(\"class\");var classNameToken=state.tokens.next;state.syntax[\"class\"].fud(),state.funct[\"(scope)\"].setExported(classNameToken.value,classNameToken)}else error(\"E024\",state.tokens.next,state.tokens.next.value);return this}).exps=!0,FutureReservedWord(\"abstract\"),FutureReservedWord(\"boolean\"),FutureReservedWord(\"byte\"),FutureReservedWord(\"char\"),FutureReservedWord(\"class\",{es5:!0,nud:classdef}),FutureReservedWord(\"double\"),FutureReservedWord(\"enum\",{es5:!0}),FutureReservedWord(\"export\",{es5:!0}),FutureReservedWord(\"extends\",{es5:!0}),FutureReservedWord(\"final\"),FutureReservedWord(\"float\"),FutureReservedWord(\"goto\"),FutureReservedWord(\"implements\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"import\",{es5:!0}),FutureReservedWord(\"int\"),FutureReservedWord(\"interface\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"long\"),FutureReservedWord(\"native\"),FutureReservedWord(\"package\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"private\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"protected\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"public\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"short\"),FutureReservedWord(\"static\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"super\",{es5:!0}),FutureReservedWord(\"synchronized\"),FutureReservedWord(\"transient\"),FutureReservedWord(\"volatile\");var lookupBlockType=function(){var pn,pn1,prev,i=-1,bracketStack=0,ret={};checkPunctuators(state.tokens.curr,[\"[\",\"{\"])&&(bracketStack+=1);do{if(prev=-1===i?state.tokens.curr:pn,pn=-1===i?state.tokens.next:peek(i),pn1=peek(i+1),i+=1,checkPunctuators(pn,[\"[\",\"{\"])?bracketStack+=1:checkPunctuators(pn,[\"]\",\"}\"])&&(bracketStack-=1),1===bracketStack&&pn.identifier&&\"for\"===pn.value&&!checkPunctuator(prev,\".\")){ret.isCompArray=!0,ret.notJson=!0;break}if(0===bracketStack&&checkPunctuators(pn,[\"}\",\"]\"])){if(\"=\"===pn1.value){ret.isDestAssign=!0,ret.notJson=!0;break}if(\".\"===pn1.value){ret.notJson=!0;break}}checkPunctuator(pn,\";\")&&(ret.isBlock=!0,ret.notJson=!0)}while(bracketStack>0&&\"(end)\"!==pn.id);return ret},arrayComprehension=function(){function declare(v){var l=_current.variables.filter(function(elt){return elt.value===v?(elt.undef=!1,v):void 0}).length;return 0!==l}function use(v){var l=_current.variables.filter(function(elt){return elt.value!==v||elt.undef?void 0:(elt.unused===!0&&(elt.unused=!1),v)}).length;return 0===l}var _current,CompArray=function(){this.mode=\"use\",this.variables=[]},_carrays=[];return{stack:function(){_current=new CompArray,_carrays.push(_current)},unstack:function(){_current.variables.filter(function(v){v.unused&&warning(\"W098\",v.token,v.raw_text||v.value),v.undef&&state.funct[\"(scope)\"].block.use(v.value,v.token)}),_carrays.splice(-1,1),_current=_carrays[_carrays.length-1]},setState:function(s){_.contains([\"use\",\"define\",\"generate\",\"filter\"],s)&&(_current.mode=s)},check:function(v){return _current?_current&&\"use\"===_current.mode?(use(v)&&_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!0,unused:!1}),!0):_current&&\"define\"===_current.mode?(declare(v)||_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!1,unused:!0}),!0):_current&&\"generate\"===_current.mode?(state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):_current&&\"filter\"===_current.mode?(use(v)&&state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):!1:void 0}}},escapeRegex=function(str){return str.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")},itself=function(s,o,g){function each(obj,cb){obj&&(Array.isArray(obj)||\"object\"!=typeof obj||(obj=Object.keys(obj)),obj.forEach(cb))}var i,k,x,reIgnoreStr,reIgnore,optionKeys,newOptionObj={},newIgnoredObj={};o=_.clone(o),state.reset(),o&&o.scope?JSHINT.scope=o.scope:(JSHINT.errors=[],JSHINT.undefs=[],JSHINT.internals=[],JSHINT.blacklist={},JSHINT.scope=\"(main)\"),predefined=Object.create(null),combine(predefined,vars.ecmaIdentifiers[3]),combine(predefined,vars.reservedVars),combine(predefined,g||{}),declared=Object.create(null);var exported=Object.create(null);if(o)for(each(o.predef||null,function(item){var slice,prop;\"-\"===item[0]?(slice=item.slice(1),JSHINT.blacklist[slice]=slice,delete predefined[slice]):(prop=Object.getOwnPropertyDescriptor(o.predef,item),predefined[item]=prop?prop.value:!1)}),each(o.exported||null,function(item){exported[item]=!0}),delete o.predef,delete o.exported,optionKeys=Object.keys(o),x=0;optionKeys.length>x;x++)if(/^-W\\d{3}$/g.test(optionKeys[x]))newIgnoredObj[optionKeys[x].slice(1)]=!0;else{var optionKey=optionKeys[x];newOptionObj[optionKey]=o[optionKey],(\"esversion\"===optionKey&&5===o[optionKey]||\"es5\"===optionKey&&o[optionKey])&&warning(\"I003\"),\"newcap\"===optionKeys[x]&&o[optionKey]===!1&&(newOptionObj[\"(explicitNewcap)\"]=!0)}state.option=newOptionObj,state.ignored=newIgnoredObj,state.option.indent=state.option.indent||4,state.option.maxerr=state.option.maxerr||50,indent=1;var scopeManagerInst=scopeManager(state,predefined,exported,declared);if(scopeManagerInst.on(\"warning\",function(ev){warning.apply(null,[ev.code,ev.token].concat(ev.data))}),scopeManagerInst.on(\"error\",function(ev){error.apply(null,[ev.code,ev.token].concat(ev.data))}),state.funct=functor(\"(global)\",null,{\"(global)\":!0,\"(scope)\":scopeManagerInst,\"(comparray)\":arrayComprehension(),\"(metrics)\":createMetrics(state.tokens.next)}),functions=[state.funct],urls=[],stack=null,member={},membersOnly=null,inblock=!1,lookahead=[],!isString(s)&&!Array.isArray(s))return errorAt(\"E004\",0),!1;api={get isJSON(){return state.jsonMode},getOption:function(name){return state.option[name]||null},getCache:function(name){return state.cache[name]},setCache:function(name,value){state.cache[name]=value},warn:function(code,data){warningAt.apply(null,[code,data.line,data.char].concat(data.data))},on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)}.bind(this))}},emitter.removeAllListeners(),(extraModules||[]).forEach(function(func){func(api)}),state.tokens.prev=state.tokens.curr=state.tokens.next=state.syntax[\"(begin)\"],o&&o.ignoreDelimiters&&(Array.isArray(o.ignoreDelimiters)||(o.ignoreDelimiters=[o.ignoreDelimiters]),o.ignoreDelimiters.forEach(function(delimiterPair){delimiterPair.start&&delimiterPair.end&&(reIgnoreStr=escapeRegex(delimiterPair.start)+\"[\\\\s\\\\S]*?\"+escapeRegex(delimiterPair.end),reIgnore=RegExp(reIgnoreStr,\"ig\"),s=s.replace(reIgnore,function(match){return match.replace(/./g,\" \")}))})),lex=new Lexer(s),lex.on(\"warning\",function(ev){warningAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"error\",function(ev){errorAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"fatal\",function(ev){quit(\"E041\",ev.line,ev.from)}),lex.on(\"Identifier\",function(ev){emitter.emit(\"Identifier\",ev)}),lex.on(\"String\",function(ev){emitter.emit(\"String\",ev)}),lex.on(\"Number\",function(ev){emitter.emit(\"Number\",ev)}),lex.start();for(var name in o)_.has(o,name)&&checkOption(name,state.tokens.curr);assume(),combine(predefined,g||{}),comma.first=!0;try{switch(advance(),state.tokens.next.id){case\"{\":case\"[\":destructuringAssignOrJsonValue();break;default:directives(),state.directive[\"use strict\"]&&\"global\"!==state.option.strict&&warning(\"W097\",state.tokens.prev),statements()}\"(end)\"!==state.tokens.next.id&&quit(\"E041\",state.tokens.curr.line),state.funct[\"(scope)\"].unstack()}catch(err){if(!err||\"JSHintError\"!==err.name)throw err;var nt=state.tokens.next||{};JSHINT.errors.push({scope:\"(main)\",raw:err.raw,code:err.code,reason:err.message,line:err.line||nt.line,character:err.character||nt.from},null)}if(\"(main)\"===JSHINT.scope)for(o=o||{},i=0;JSHINT.internals.length>i;i+=1)k=JSHINT.internals[i],o.scope=k.elem,itself(k.value,o,g);return 0===JSHINT.errors.length};return itself.addModule=function(func){extraModules.push(func)},itself.addModule(style.register),itself.data=function(){var fu,f,i,j,n,globals,data={functions:[],options:state.option};itself.errors.length&&(data.errors=itself.errors),state.jsonMode&&(data.json=!0);var impliedGlobals=state.funct[\"(scope)\"].getImpliedGlobals();for(impliedGlobals.length>0&&(data.implieds=impliedGlobals),urls.length>0&&(data.urls=urls),globals=state.funct[\"(scope)\"].getUsedOrDefinedGlobals(),globals.length>0&&(data.globals=globals),i=1;functions.length>i;i+=1){for(f=functions[i],fu={},j=0;functionicity.length>j;j+=1)fu[functionicity[j]]=[];for(j=0;functionicity.length>j;j+=1)0===fu[functionicity[j]].length&&delete fu[functionicity[j]];fu.name=f[\"(name)\"],fu.param=f[\"(params)\"],fu.line=f[\"(line)\"],fu.character=f[\"(character)\"],fu.last=f[\"(last)\"],fu.lastcharacter=f[\"(lastcharacter)\"],fu.metrics={complexity:f[\"(metrics)\"].ComplexityCount,parameters:f[\"(metrics)\"].arity,statements:f[\"(metrics)\"].statementCount},data.functions.push(fu)}var unuseds=state.funct[\"(scope)\"].getUnuseds();unuseds.length>0&&(data.unused=unuseds);for(n in member)if(\"number\"==typeof member[n]){data.member=member;break}return data},itself.jshint=itself,itself}();\"object\"==typeof exports&&exports&&(exports.JSHINT=JSHINT)},{\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./lex.js\":\"/node_modules/jshint/src/lex.js\",\"./messages.js\":\"/node_modules/jshint/src/messages.js\",\"./options.js\":\"/node_modules/jshint/src/options.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./scope-manager.js\":\"/node_modules/jshint/src/scope-manager.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",\"./style.js\":\"/node_modules/jshint/src/style.js\",\"./vars.js\":\"/node_modules/jshint/src/vars.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/lex.js\":[function(_dereq_,module,exports){\"use strict\";function asyncTrigger(){var _checks=[];return{push:function(fn){_checks.push(fn)},check:function(){for(var check=0;_checks.length>check;++check)_checks[check]();_checks.splice(0,_checks.length)}}}function Lexer(source){var lines=source;\"string\"==typeof lines&&(lines=lines.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\").split(\"\\n\")),lines[0]&&\"#!\"===lines[0].substr(0,2)&&(-1!==lines[0].indexOf(\"node\")&&(state.option.node=!0),lines[0]=\"\"),this.emitter=new events.EventEmitter,this.source=source,this.setLines(lines),this.prereg=!0,this.line=0,this.char=1,this.from=1,this.input=\"\",this.inComment=!1,this.context=[],this.templateStarts=[];for(var i=0;state.option.indent>i;i+=1)state.tab+=\" \";this.ignoreLinterErrors=!1}var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,unicodeData=_dereq_(\"../data/ascii-identifier-data.js\"),asciiIdentifierStartTable=unicodeData.asciiIdentifierStartTable,asciiIdentifierPartTable=unicodeData.asciiIdentifierPartTable,Token={Identifier:1,Punctuator:2,NumericLiteral:3,StringLiteral:4,Comment:5,Keyword:6,NullLiteral:7,BooleanLiteral:8,RegExp:9,TemplateHead:10,TemplateMiddle:11,TemplateTail:12,NoSubstTemplate:13},Context={Block:1,Template:2};Lexer.prototype={_lines:[],inContext:function(ctxType){return this.context.length>0&&this.context[this.context.length-1].type===ctxType},pushContext:function(ctxType){this.context.push({type:ctxType})},popContext:function(){return this.context.pop()},isContext:function(context){return this.context.length>0&&this.context[this.context.length-1]===context},currentContext:function(){return this.context.length>0&&this.context[this.context.length-1]},getLines:function(){return this._lines=state.lines,this._lines},setLines:function(val){this._lines=val,state.lines=this._lines},peek:function(i){return this.input.charAt(i||0)},skip:function(i){i=i||1,this.char+=i,this.input=this.input.slice(i)},on:function(names,listener){names.split(\" \").forEach(function(name){this.emitter.on(name,listener)}.bind(this))},trigger:function(){this.emitter.emit.apply(this.emitter,Array.prototype.slice.call(arguments))},triggerAsync:function(type,args,checks,fn){checks.push(function(){fn()&&this.trigger(type,args)}.bind(this))},scanPunctuator:function(){var ch2,ch3,ch4,ch1=this.peek();switch(ch1){case\".\":if(/^[0-9]$/.test(this.peek(1)))return null;if(\".\"===this.peek(1)&&\".\"===this.peek(2))return{type:Token.Punctuator,value:\"...\"};case\"(\":case\")\":case\";\":case\",\":case\"[\":case\"]\":case\":\":case\"~\":case\"?\":return{type:Token.Punctuator,value:ch1};case\"{\":return this.pushContext(Context.Block),{type:Token.Punctuator,value:ch1};case\"}\":return this.inContext(Context.Block)&&this.popContext(),{type:Token.Punctuator,value:ch1};case\"#\":return{type:Token.Punctuator,value:ch1};case\"\":return null}return ch2=this.peek(1),ch3=this.peek(2),ch4=this.peek(3),\">\"===ch1&&\">\"===ch2&&\">\"===ch3&&\"=\"===ch4?{type:Token.Punctuator,value:\">>>=\"}:\"=\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"===\"}:\"!\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"!==\"}:\">\"===ch1&&\">\"===ch2&&\">\"===ch3?{type:Token.Punctuator,value:\">>>\"}:\"<\"===ch1&&\"<\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"<<=\"}:\">\"===ch1&&\">\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\">>=\"}:\"=\"===ch1&&\">\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:ch1===ch2&&\"+-<>&|\".indexOf(ch1)>=0?{type:Token.Punctuator,value:ch1+ch2}:\"<>=!+-*%&|^\".indexOf(ch1)>=0?\"=\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:{type:Token.Punctuator,value:ch1}:\"/\"===ch1?\"=\"===ch2?{type:Token.Punctuator,value:\"/=\"}:{type:Token.Punctuator,value:\"/\"}:null},scanComments:function(){function commentToken(label,body,opt){var special=[\"jshint\",\"jslint\",\"members\",\"member\",\"globals\",\"global\",\"exported\"],isSpecial=!1,value=label+body,commentType=\"plain\";return opt=opt||{},opt.isMultiline&&(value+=\"*/\"),body=body.replace(/\\n/g,\" \"),\"/*\"===label&&reg.fallsThrough.test(body)&&(isSpecial=!0,commentType=\"falls through\"),special.forEach(function(str){if(!isSpecial&&(\"//\"!==label||\"jshint\"===str)&&(\" \"===body.charAt(str.length)&&body.substr(0,str.length)===str&&(isSpecial=!0,label+=str,body=body.substr(str.length)),isSpecial||\" \"!==body.charAt(0)||\" \"!==body.charAt(str.length+1)||body.substr(1,str.length)!==str||(isSpecial=!0,label=label+\" \"+str,body=body.substr(str.length+1)),isSpecial))switch(str){case\"member\":commentType=\"members\";break;case\"global\":commentType=\"globals\";break;default:var options=body.split(\":\").map(function(v){return v.replace(/^\\s+/,\"\").replace(/\\s+$/,\"\")});if(2===options.length)switch(options[0]){case\"ignore\":switch(options[1]){case\"start\":self.ignoringLinterErrors=!0,isSpecial=!1;break;case\"end\":self.ignoringLinterErrors=!1,isSpecial=!1}}commentType=str}}),{type:Token.Comment,commentType:commentType,value:value,body:body,isSpecial:isSpecial,isMultiline:opt.isMultiline||!1,isMalformed:opt.isMalformed||!1}}var ch1=this.peek(),ch2=this.peek(1),rest=this.input.substr(2),startLine=this.line,startChar=this.char,self=this;if(\"*\"===ch1&&\"/\"===ch2)return this.trigger(\"error\",{code:\"E018\",line:startLine,character:startChar}),this.skip(2),null;if(\"/\"!==ch1||\"*\"!==ch2&&\"/\"!==ch2)return null;if(\"/\"===ch2)return this.skip(this.input.length),commentToken(\"//\",rest);var body=\"\";if(\"*\"===ch2){for(this.inComment=!0,this.skip(2);\"*\"!==this.peek()||\"/\"!==this.peek(1);)if(\"\"===this.peek()){if(body+=\"\\n\",!this.nextLine())return this.trigger(\"error\",{code:\"E017\",line:startLine,character:startChar}),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0,isMalformed:!0})}else body+=this.peek(),this.skip();return this.skip(2),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0})}},scanKeyword:function(){var result=/^[a-zA-Z_$][a-zA-Z0-9_$]*/.exec(this.input),keywords=[\"if\",\"in\",\"do\",\"var\",\"for\",\"new\",\"try\",\"let\",\"this\",\"else\",\"case\",\"void\",\"with\",\"enum\",\"while\",\"break\",\"catch\",\"throw\",\"const\",\"yield\",\"class\",\"super\",\"return\",\"typeof\",\"delete\",\"switch\",\"export\",\"import\",\"default\",\"finally\",\"extends\",\"function\",\"continue\",\"debugger\",\"instanceof\"];return result&&keywords.indexOf(result[0])>=0?{type:Token.Keyword,value:result[0]}:null},scanIdentifier:function(){function isNonAsciiIdentifierStart(code){return code>256}function isNonAsciiIdentifierPart(code){return code>256}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function removeEscapeSequences(id){return id.replace(/\\\\u([0-9a-fA-F]{4})/g,function(m0,codepoint){return String.fromCharCode(parseInt(codepoint,16))})}var type,char,id=\"\",index=0,readUnicodeEscapeSequence=function(){if(index+=1,\"u\"!==this.peek(index))return null;var code,ch1=this.peek(index+1),ch2=this.peek(index+2),ch3=this.peek(index+3),ch4=this.peek(index+4);return isHexDigit(ch1)&&isHexDigit(ch2)&&isHexDigit(ch3)&&isHexDigit(ch4)?(code=parseInt(ch1+ch2+ch3+ch4,16),asciiIdentifierPartTable[code]||isNonAsciiIdentifierPart(code)?(index+=5,\"\\\\u\"+ch1+ch2+ch3+ch4):null):null}.bind(this),getIdentifierStart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierStartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierStart(code)?(index+=1,chr):null}.bind(this),getIdentifierPart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierPartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierPart(code)?(index+=1,chr):null}.bind(this);if(char=getIdentifierStart(),null===char)return null;for(id=char;char=getIdentifierPart(),null!==char;)id+=char;switch(id){case\"true\":case\"false\":type=Token.BooleanLiteral;break;case\"null\":type=Token.NullLiteral;break;default:type=Token.Identifier}return{type:type,value:removeEscapeSequences(id),text:id,tokenLength:id.length}},scanNumericLiteral:function(){function isDecimalDigit(str){return/^[0-9]$/.test(str)}function isOctalDigit(str){return/^[0-7]$/.test(str)}function isBinaryDigit(str){return/^[01]$/.test(str)}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function isIdentifierStart(ch){return\"$\"===ch||\"_\"===ch||\"\\\\\"===ch||ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch}var bad,index=0,value=\"\",length=this.input.length,char=this.peek(index),isAllowedDigit=isDecimalDigit,base=10,isLegacy=!1;if(\".\"!==char&&!isDecimalDigit(char))return null;if(\".\"!==char){for(value=this.peek(index),index+=1,char=this.peek(index),\"0\"===value&&((\"x\"===char||\"X\"===char)&&(isAllowedDigit=isHexDigit,base=16,index+=1,value+=char),(\"o\"===char||\"O\"===char)&&(isAllowedDigit=isOctalDigit,base=8,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Octal integer literal\",\"6\"]}),index+=1,value+=char),(\"b\"===char||\"B\"===char)&&(isAllowedDigit=isBinaryDigit,base=2,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Binary integer literal\",\"6\"]}),index+=1,value+=char),isOctalDigit(char)&&(isAllowedDigit=isOctalDigit,base=8,isLegacy=!0,bad=!1,index+=1,value+=char),!isOctalDigit(char)&&isDecimalDigit(char)&&(index+=1,value+=char));length>index;){if(char=this.peek(index),isLegacy&&isDecimalDigit(char))bad=!0;else if(!isAllowedDigit(char))break;value+=char,index+=1}if(isAllowedDigit!==isDecimalDigit)return!isLegacy&&2>=value.length?{type:Token.NumericLiteral,value:value,isMalformed:!0}:length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isLegacy:isLegacy,isMalformed:!1}}if(\".\"===char)for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1;if(\"e\"===char||\"E\"===char){if(value+=char,index+=1,char=this.peek(index),(\"+\"===char||\"-\"===char)&&(value+=this.peek(index),index+=1),char=this.peek(index),!isDecimalDigit(char))return null;for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1}return length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isMalformed:!isFinite(value)}},scanEscapeSequence:function(checks){var allowNewLine=!1,jump=1;this.skip();var char=this.peek();switch(char){case\"'\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\'\"]},checks,function(){return state.jsonMode});break;case\"b\":char=\"\\\\b\";break;case\"f\":char=\"\\\\f\";break;case\"n\":char=\"\\\\n\";break;case\"r\":char=\"\\\\r\";break;case\"t\":char=\"\\\\t\";break;case\"0\":char=\"\\\\0\";var n=parseInt(this.peek(1),10);this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return n>=0&&7>=n&&state.isStrict()});break;case\"u\":var hexCode=this.input.substr(1,4),code=parseInt(hexCode,16);isNaN(code)&&this.trigger(\"warning\",{code:\"W052\",line:this.line,character:this.char,data:[\"u\"+hexCode]}),char=String.fromCharCode(code),jump=5;break;case\"v\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\v\"]},checks,function(){return state.jsonMode}),char=\"\u000b\";break;case\"x\":var x=parseInt(this.input.substr(1,2),16);this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\x-\"]},checks,function(){return state.jsonMode}),char=String.fromCharCode(x),jump=3;break;case\"\\\\\":char=\"\\\\\\\\\";break;case'\"':char='\\\\\"';break;case\"/\":break;case\"\":allowNewLine=!0,char=\"\"}return{\"char\":char,jump:jump,allowNewLine:allowNewLine}},scanTemplateLiteral:function(checks){var tokenType,ch,value=\"\",startLine=this.line,startChar=this.char,depth=this.templateStarts.length;if(!state.inES6(!0))return null;if(\"`\"===this.peek())tokenType=Token.TemplateHead,this.templateStarts.push({line:this.line,\"char\":this.char}),depth=this.templateStarts.length,this.skip(1),this.pushContext(Context.Template);else{if(!this.inContext(Context.Template)||\"}\"!==this.peek())return null;tokenType=Token.TemplateMiddle}for(;\"`\"!==this.peek();){for(;\"\"===(ch=this.peek());)if(value+=\"\\n\",!this.nextLine()){var startPos=this.templateStarts.pop();return this.trigger(\"error\",{code:\"E052\",line:startPos.line,character:startPos.char}),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,depth:depth,context:this.popContext()}}if(\"$\"===ch&&\"{\"===this.peek(1))return value+=\"${\",this.skip(2),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.currentContext()};\nif(\"\\\\\"===ch){var escape=this.scanEscapeSequence(checks);value+=escape.char,this.skip(escape.jump)}else\"`\"!==ch&&(value+=ch,this.skip(1))}return tokenType=tokenType===Token.TemplateHead?Token.NoSubstTemplate:Token.TemplateTail,this.skip(1),this.templateStarts.pop(),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.popContext()}},scanStringLiteral:function(checks){var quote=this.peek();if('\"'!==quote&&\"'\"!==quote)return null;this.triggerAsync(\"warning\",{code:\"W108\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&'\"'!==quote});var value=\"\",startLine=this.line,startChar=this.char,allowNewLine=!1;for(this.skip();this.peek()!==quote;)if(\"\"===this.peek()){if(allowNewLine?(allowNewLine=!1,this.triggerAsync(\"warning\",{code:\"W043\",line:this.line,character:this.char},checks,function(){return!state.option.multistr}),this.triggerAsync(\"warning\",{code:\"W042\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&state.option.multistr})):this.trigger(\"warning\",{code:\"W112\",line:this.line,character:this.char}),!this.nextLine())return this.trigger(\"error\",{code:\"E029\",line:startLine,character:startChar}),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,quote:quote}}else{allowNewLine=!1;var char=this.peek(),jump=1;if(\" \">char&&this.trigger(\"warning\",{code:\"W113\",line:this.line,character:this.char,data:[\"<non-printable>\"]}),\"\\\\\"===char){var parsed=this.scanEscapeSequence(checks);char=parsed.char,jump=parsed.jump,allowNewLine=parsed.allowNewLine}value+=char,this.skip(jump)}return this.skip(),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,quote:quote}},scanRegExp:function(){var terminated,index=0,length=this.input.length,char=this.peek(),value=char,body=\"\",flags=[],malformed=!1,isCharSet=!1,scanUnexpectedChars=function(){\" \">char&&(malformed=!0,this.trigger(\"warning\",{code:\"W048\",line:this.line,character:this.char})),\"<\"===char&&(malformed=!0,this.trigger(\"warning\",{code:\"W049\",line:this.line,character:this.char,data:[char]}))}.bind(this);if(!this.prereg||\"/\"!==char)return null;for(index+=1,terminated=!1;length>index;)if(char=this.peek(index),value+=char,body+=char,isCharSet)\"]\"===char&&(\"\\\\\"!==this.peek(index-1)||\"\\\\\"===this.peek(index-2))&&(isCharSet=!1),\"\\\\\"===char&&(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars()),index+=1;else{if(\"\\\\\"===char){if(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars(),\"/\"===char){index+=1;continue}if(\"[\"===char){index+=1;continue}}if(\"[\"!==char){if(\"/\"===char){body=body.substr(0,body.length-1),terminated=!0,index+=1;break}index+=1}else isCharSet=!0,index+=1}if(!terminated)return this.trigger(\"error\",{code:\"E015\",line:this.line,character:this.from}),void this.trigger(\"fatal\",{line:this.line,from:this.from});for(;length>index&&(char=this.peek(index),/[gim]/.test(char));)flags.push(char),value+=char,index+=1;try{RegExp(body,flags.join(\"\"))}catch(err){malformed=!0,this.trigger(\"error\",{code:\"E016\",line:this.line,character:this.char,data:[err.message]})}return{type:Token.RegExp,value:value,flags:flags,isMalformed:malformed}},scanNonBreakingSpaces:function(){return state.option.nonbsp?this.input.search(/(\\u00A0)/):-1},scanUnsafeChars:function(){return this.input.search(reg.unsafeChars)},next:function(checks){this.from=this.char;var start;if(/\\s/.test(this.peek()))for(start=this.char;/\\s/.test(this.peek());)this.from+=1,this.skip();var match=this.scanComments()||this.scanStringLiteral(checks)||this.scanTemplateLiteral(checks);return match?match:(match=this.scanRegExp()||this.scanPunctuator()||this.scanKeyword()||this.scanIdentifier()||this.scanNumericLiteral(),match?(this.skip(match.tokenLength||match.value.length),match):null)},nextLine:function(){var char;if(this.line>=this.getLines().length)return!1;this.input=this.getLines()[this.line],this.line+=1,this.char=1,this.from=1;var inputTrimmed=this.input.trim(),startsWith=function(){return _.some(arguments,function(prefix){return 0===inputTrimmed.indexOf(prefix)})},endsWith=function(){return _.some(arguments,function(suffix){return-1!==inputTrimmed.indexOf(suffix,inputTrimmed.length-suffix.length)})};if(this.ignoringLinterErrors===!0&&(startsWith(\"/*\",\"//\")||this.inComment&&endsWith(\"*/\")||(this.input=\"\")),char=this.scanNonBreakingSpaces(),char>=0&&this.trigger(\"warning\",{code:\"W125\",line:this.line,character:char+1}),this.input=this.input.replace(/\\t/g,state.tab),char=this.scanUnsafeChars(),char>=0&&this.trigger(\"warning\",{code:\"W100\",line:this.line,character:char}),!this.ignoringLinterErrors&&state.option.maxlen&&state.option.maxlen<this.input.length){var inComment=this.inComment||startsWith.call(inputTrimmed,\"//\")||startsWith.call(inputTrimmed,\"/*\"),shouldTriggerError=!inComment||!reg.maxlenException.test(inputTrimmed);shouldTriggerError&&this.trigger(\"warning\",{code:\"W101\",line:this.line,character:this.input.length})}return!0},start:function(){this.nextLine()},token:function(){function isReserved(token,isProperty){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(isProperty)return!1}return!0}for(var token,checks=asyncTrigger(),create=function(type,value,isProperty,token){var obj;if(\"(endline)\"!==type&&\"(end)\"!==type&&(this.prereg=!1),\"(punctuator)\"===type){switch(value){case\".\":case\")\":case\"~\":case\"#\":case\"]\":case\"++\":case\"--\":this.prereg=!1;break;default:this.prereg=!0}obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"])}return\"(identifier)\"===type&&((\"return\"===value||\"case\"===value||\"typeof\"===value)&&(this.prereg=!0),_.has(state.syntax,value)&&(obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"]),isReserved(obj,isProperty&&\"(identifier)\"===type)||(obj=null))),obj||(obj=Object.create(state.syntax[type])),obj.identifier=\"(identifier)\"===type,obj.type=obj.type||type,obj.value=value,obj.line=this.line,obj.character=this.char,obj.from=this.from,obj.identifier&&token&&(obj.raw_text=token.text||token.value),token&&token.startLine&&token.startLine!==this.line&&(obj.startLine=token.startLine),token&&token.context&&(obj.context=token.context),token&&token.depth&&(obj.depth=token.depth),token&&token.isUnclosed&&(obj.isUnclosed=token.isUnclosed),isProperty&&obj.identifier&&(obj.isProperty=isProperty),obj.check=checks.check,obj}.bind(this);;){if(!this.input.length)return this.nextLine()?create(\"(endline)\",\"\"):this.exhausted?null:(this.exhausted=!0,create(\"(end)\",\"\"));if(token=this.next(checks))switch(token.type){case Token.StringLiteral:return this.triggerAsync(\"String\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value,quote:token.quote},checks,function(){return!0}),create(\"(string)\",token.value,null,token);case Token.TemplateHead:return this.trigger(\"TemplateHead\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template)\",token.value,null,token);case Token.TemplateMiddle:return this.trigger(\"TemplateMiddle\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template middle)\",token.value,null,token);case Token.TemplateTail:return this.trigger(\"TemplateTail\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template tail)\",token.value,null,token);case Token.NoSubstTemplate:return this.trigger(\"NoSubstTemplate\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(no subst template)\",token.value,null,token);case Token.Identifier:this.triggerAsync(\"Identifier\",{line:this.line,\"char\":this.char,from:this.form,name:token.value,raw_name:token.text,isProperty:\".\"===state.tokens.curr.id},checks,function(){return!0});case Token.Keyword:case Token.NullLiteral:case Token.BooleanLiteral:return create(\"(identifier)\",token.value,\".\"===state.tokens.curr.id,token);case Token.NumericLiteral:return token.isMalformed&&this.trigger(\"warning\",{code:\"W045\",line:this.line,character:this.char,data:[token.value]}),this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"0x-\"]},checks,function(){return 16===token.base&&state.jsonMode}),this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return state.isStrict()&&8===token.base&&token.isLegacy}),this.trigger(\"Number\",{line:this.line,\"char\":this.char,from:this.from,value:token.value,base:token.base,isMalformed:token.malformed}),create(\"(number)\",token.value);case Token.RegExp:return create(\"(regexp)\",token.value);case Token.Comment:if(state.tokens.curr.comment=!0,token.isSpecial)return{id:\"(comment)\",value:token.value,body:token.body,type:token.commentType,isSpecial:token.isSpecial,line:this.line,character:this.char,from:this.from};break;case\"\":break;default:return create(\"(punctuator)\",token.value)}else this.input.length&&(this.trigger(\"error\",{code:\"E024\",line:this.line,character:this.char,data:[this.peek()]}),this.input=\"\")}}},exports.Lexer=Lexer,exports.Context=Context},{\"../data/ascii-identifier-data.js\":\"/node_modules/jshint/data/ascii-identifier-data.js\",\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/messages.js\":[function(_dereq_,module,exports){\"use strict\";var _=_dereq_(\"../lodash\"),errors={E001:\"Bad option: '{a}'.\",E002:\"Bad option value.\",E003:\"Expected a JSON value.\",E004:\"Input is neither a string nor an array of strings.\",E005:\"Input is empty.\",E006:\"Unexpected early end of program.\",E007:'Missing \"use strict\" statement.',E008:\"Strict violation.\",E009:\"Option 'validthis' can't be used in a global scope.\",E010:\"'with' is not allowed in strict mode.\",E011:\"'{a}' has already been declared.\",E012:\"const '{a}' is initialized to 'undefined'.\",E013:\"Attempting to override '{a}' which is a constant.\",E014:\"A regular expression literal can be confused with '/='.\",E015:\"Unclosed regular expression.\",E016:\"Invalid regular expression.\",E017:\"Unclosed comment.\",E018:\"Unbegun comment.\",E019:\"Unmatched '{a}'.\",E020:\"Expected '{a}' to match '{b}' from line {c} and instead saw '{d}'.\",E021:\"Expected '{a}' and instead saw '{b}'.\",E022:\"Line breaking error '{a}'.\",E023:\"Missing '{a}'.\",E024:\"Unexpected '{a}'.\",E025:\"Missing ':' on a case clause.\",E026:\"Missing '}' to match '{' from line {a}.\",E027:\"Missing ']' to match '[' from line {a}.\",E028:\"Illegal comma.\",E029:\"Unclosed string.\",E030:\"Expected an identifier and instead saw '{a}'.\",E031:\"Bad assignment.\",E032:\"Expected a small integer or 'false' and instead saw '{a}'.\",E033:\"Expected an operator and instead saw '{a}'.\",E034:\"get/set are ES5 features.\",E035:\"Missing property name.\",E036:\"Expected to see a statement and instead saw a block.\",E037:null,E038:null,E039:\"Function declarations are not invocable. Wrap the whole function invocation in parens.\",E040:\"Each value should have its own case label.\",E041:\"Unrecoverable syntax error.\",E042:\"Stopping.\",E043:\"Too many errors.\",E044:null,E045:\"Invalid for each loop.\",E046:\"A yield statement shall be within a generator function (with syntax: `function*`)\",E047:null,E048:\"{a} declaration not directly within block.\",E049:\"A {a} cannot be named '{b}'.\",E050:\"Mozilla acequires the yield expression to be parenthesized here.\",E051:null,E052:\"Unclosed template literal.\",E053:\"Export declaration must be in global scope.\",E054:\"Class properties must be methods. Expected '(' but instead saw '{a}'.\",E055:\"The '{a}' option cannot be set after any executable code.\",E056:\"'{a}' was used before it was declared, which is illegal for '{b}' variables.\",E057:\"Invalid meta property: '{a}.{b}'.\",E058:\"Missing semicolon.\"},warnings={W001:\"'hasOwnProperty' is a really bad name.\",W002:\"Value of '{a}' may be overwritten in IE 8 and earlier.\",W003:\"'{a}' was used before it was defined.\",W004:\"'{a}' is already defined.\",W005:\"A dot following a number can be confused with a decimal point.\",W006:\"Confusing minuses.\",W007:\"Confusing plusses.\",W008:\"A leading decimal point can be confused with a dot: '{a}'.\",W009:\"The array literal notation [] is preferable.\",W010:\"The object literal notation {} is preferable.\",W011:null,W012:null,W013:null,W014:\"Bad line breaking before '{a}'.\",W015:null,W016:\"Unexpected use of '{a}'.\",W017:\"Bad operand.\",W018:\"Confusing use of '{a}'.\",W019:\"Use the isNaN function to compare with NaN.\",W020:\"Read only.\",W021:\"Reassignment of '{a}', which is is a {b}. Use 'var' or 'let' to declare bindings that may change.\",W022:\"Do not assign to the exception parameter.\",W023:\"Expected an identifier in an assignment and instead saw a function invocation.\",W024:\"Expected an identifier and instead saw '{a}' (a reserved word).\",W025:\"Missing name in function declaration.\",W026:\"Inner functions should be listed at the top of the outer function.\",W027:\"Unreachable '{a}' after '{b}'.\",W028:\"Label '{a}' on {b} statement.\",W030:\"Expected an assignment or function call and instead saw an expression.\",W031:\"Do not use 'new' for side effects.\",W032:\"Unnecessary semicolon.\",W033:\"Missing semicolon.\",W034:'Unnecessary directive \"{a}\".',W035:\"Empty block.\",W036:\"Unexpected /*member '{a}'.\",W037:\"'{a}' is a statement label.\",W038:\"'{a}' used out of scope.\",W039:\"'{a}' is not allowed.\",W040:\"Possible strict violation.\",W041:\"Use '{a}' to compare with '{b}'.\",W042:\"Avoid EOL escaping.\",W043:\"Bad escaping of EOL. Use option multistr if needed.\",W044:\"Bad or unnecessary escaping.\",W045:\"Bad number '{a}'.\",W046:\"Don't use extra leading zeros '{a}'.\",W047:\"A trailing decimal point can be confused with a dot: '{a}'.\",W048:\"Unexpected control character in regular expression.\",W049:\"Unexpected escaped character '{a}' in regular expression.\",W050:\"JavaScript URL.\",W051:\"Variables should not be deleted.\",W052:\"Unexpected '{a}'.\",W053:\"Do not use {a} as a constructor.\",W054:\"The Function constructor is a form of eval.\",W055:\"A constructor name should start with an uppercase letter.\",W056:\"Bad constructor.\",W057:\"Weird construction. Is 'new' necessary?\",W058:\"Missing '()' invoking a constructor.\",W059:\"Avoid arguments.{a}.\",W060:\"document.write can be a form of eval.\",W061:\"eval can be harmful.\",W062:\"Wrap an immediate function invocation in parens to assist the reader in understanding that the expression is the result of a function, and not the function itself.\",W063:\"Math is not a function.\",W064:\"Missing 'new' prefix when invoking a constructor.\",W065:\"Missing radix parameter.\",W066:\"Implied eval. Consider passing a function instead of a string.\",W067:\"Bad invocation.\",W068:\"Wrapping non-IIFE function literals in parens is unnecessary.\",W069:\"['{a}'] is better written in dot notation.\",W070:\"Extra comma. (it breaks older versions of IE)\",W071:\"This function has too many statements. ({a})\",W072:\"This function has too many parameters. ({a})\",W073:\"Blocks are nested too deeply. ({a})\",W074:\"This function's cyclomatic complexity is too high. ({a})\",W075:\"Duplicate {a} '{b}'.\",W076:\"Unexpected parameter '{a}' in get {b} function.\",W077:\"Expected a single parameter in set {a} function.\",W078:\"Setter is defined without getter.\",W079:\"Redefinition of '{a}'.\",W080:\"It's not necessary to initialize '{a}' to 'undefined'.\",W081:null,W082:\"Function declarations should not be placed in blocks. Use a function expression or move the statement to the top of the outer function.\",W083:\"Don't make functions within a loop.\",W084:\"Assignment in conditional expression\",W085:\"Don't use 'with'.\",W086:\"Expected a 'break' statement before '{a}'.\",W087:\"Forgotten 'debugger' statement?\",W088:\"Creating global 'for' variable. Should be 'for (var {a} ...'.\",W089:\"The body of a for in should be wrapped in an if statement to filter unwanted properties from the prototype.\",W090:\"'{a}' is not a statement label.\",W091:null,W093:\"Did you mean to return a conditional instead of an assignment?\",W094:\"Unexpected comma.\",W095:\"Expected a string and instead saw {a}.\",W096:\"The '{a}' key may produce unexpected results.\",W097:'Use the function form of \"use strict\".',W098:\"'{a}' is defined but never used.\",W099:null,W100:\"This character may get silently deleted by one or more browsers.\",W101:\"Line is too long.\",W102:null,W103:\"The '{a}' property is deprecated.\",W104:\"'{a}' is available in ES{b} (use 'esversion: {b}') or Mozilla JS extensions (use moz).\",W105:\"Unexpected {a} in '{b}'.\",W106:\"Identifier '{a}' is not in camel case.\",W107:\"Script URL.\",W108:\"Strings must use doublequote.\",W109:\"Strings must use singlequote.\",W110:\"Mixed double and single quotes.\",W112:\"Unclosed string.\",W113:\"Control character in string: {a}.\",W114:\"Avoid {a}.\",W115:\"Octal literals are not allowed in strict mode.\",W116:\"Expected '{a}' and instead saw '{b}'.\",W117:\"'{a}' is not defined.\",W118:\"'{a}' is only available in Mozilla JavaScript extensions (use moz option).\",W119:\"'{a}' is only available in ES{b} (use 'esversion: {b}').\",W120:\"You might be leaking a variable ({a}) here.\",W121:\"Extending prototype of native object: '{a}'.\",W122:\"Invalid typeof value '{a}'\",W123:\"'{a}' is already defined in outer scope.\",W124:\"A generator function shall contain a yield statement.\",W125:\"This line contains non-breaking spaces: http://jshint.com/doc/options/#nonbsp\",W126:\"Unnecessary grouping operator.\",W127:\"Unexpected use of a comma operator.\",W128:\"Empty array elements acequire elision=true.\",W129:\"'{a}' is defined in a future version of JavaScript. Use a different variable name to avoid migration issues.\",W130:\"Invalid element after rest element.\",W131:\"Invalid parameter after rest parameter.\",W132:\"`var` declarations are forbidden. Use `let` or `const` instead.\",W133:\"Invalid for-{a} loop left-hand-side: {b}.\",W134:\"The '{a}' option is only available when linting ECMAScript {b} code.\",W135:\"{a} may not be supported by non-browser environments.\",W136:\"'{a}' must be in function scope.\",W137:\"Empty destructuring.\",W138:\"Regular parameters should not come after default parameters.\"},info={I001:\"Comma warnings can be turned off with 'laxcomma'.\",I002:null,I003:\"ES5 option is now set per default\"};exports.errors={},exports.warnings={},exports.info={},_.each(errors,function(desc,code){exports.errors[code]={code:code,desc:desc}}),_.each(warnings,function(desc,code){exports.warnings[code]={code:code,desc:desc}}),_.each(info,function(desc,code){exports.info[code]={code:code,desc:desc}})},{\"../lodash\":\"/node_modules/jshint/lodash.js\"}],\"/node_modules/jshint/src/name-stack.js\":[function(_dereq_,module){\"use strict\";function NameStack(){this._stack=[]}Object.defineProperty(NameStack.prototype,\"length\",{get:function(){return this._stack.length}}),NameStack.prototype.push=function(){this._stack.push(null)},NameStack.prototype.pop=function(){this._stack.pop()},NameStack.prototype.set=function(token){this._stack[this.length-1]=token},NameStack.prototype.infer=function(){var type,nameToken=this._stack[this.length-1],prefix=\"\";return nameToken&&\"class\"!==nameToken.type||(nameToken=this._stack[this.length-2]),nameToken?(type=nameToken.type,\"(string)\"!==type&&\"(number)\"!==type&&\"(identifier)\"!==type&&\"default\"!==type?\"(expression)\":(nameToken.accessorType&&(prefix=nameToken.accessorType+\" \"),prefix+nameToken.value)):\"(empty)\"},module.exports=NameStack},{}],\"/node_modules/jshint/src/options.js\":[function(_dereq_,module,exports){\"use strict\";exports.bool={enforcing:{bitwise:!0,freeze:!0,camelcase:!0,curly:!0,eqeqeq:!0,futurehostile:!0,notypeof:!0,es3:!0,es5:!0,forin:!0,funcscope:!0,immed:!0,iterator:!0,newcap:!0,noarg:!0,nocomma:!0,noempty:!0,nonbsp:!0,nonew:!0,undef:!0,singleGroups:!1,varstmt:!1,enforceall:!1},relaxing:{asi:!0,multistr:!0,debug:!0,boss:!0,evil:!0,globalstrict:!0,plusplus:!0,proto:!0,scripturl:!0,sub:!0,supernew:!0,laxbreak:!0,laxcomma:!0,validthis:!0,withstmt:!0,moz:!0,noyield:!0,eqnull:!0,lastsemic:!0,loopfunc:!0,expr:!0,esnext:!0,elision:!0},environments:{mootools:!0,couch:!0,jasmine:!0,jquery:!0,node:!0,qunit:!0,rhino:!0,shelljs:!0,prototypejs:!0,yui:!0,mocha:!0,module:!0,wsh:!0,worker:!0,nonstandard:!0,browser:!0,browserify:!0,devel:!0,dojo:!0,typed:!0,phantom:!0},obsolete:{onecase:!0,regexp:!0,regexdash:!0}},exports.val={maxlen:!1,indent:!1,maxerr:!1,predef:!1,globals:!1,quotmark:!1,scope:!1,maxstatements:!1,maxdepth:!1,maxparams:!1,maxcomplexity:!1,shadow:!1,strict:!0,unused:!0,latedef:!1,ignore:!1,ignoreDelimiters:!1,esversion:5},exports.inverted={bitwise:!0,forin:!0,newcap:!0,plusplus:!0,regexp:!0,undef:!0,eqeqeq:!0,strict:!0},exports.validNames=Object.keys(exports.val).concat(Object.keys(exports.bool.relaxing)).concat(Object.keys(exports.bool.enforcing)).concat(Object.keys(exports.bool.obsolete)).concat(Object.keys(exports.bool.environments)),exports.renamed={eqeq:\"eqeqeq\",windows:\"wsh\",sloppy:\"strict\"},exports.removed={nomen:!0,onevar:!0,passfail:!0,white:!0,gcl:!0,smarttabs:!0,trailing:!0},exports.noenforceall={varstmt:!0,strict:!0}},{}],\"/node_modules/jshint/src/reg.js\":[function(_dereq_,module,exports){\"use strict\";exports.unsafeString=/@cc|<\\/?|script|\\]\\s*\\]|<\\s*!|&lt/i,exports.unsafeChars=/[\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEsc=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEscGlobal=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g,exports.starSlash=/\\*\\//,exports.identifier=/^([a-zA-Z_$][a-zA-Z0-9_$]*)$/,exports.javascriptURL=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i,exports.fallsThrough=/^\\s*falls?\\sthrough\\s*$/,exports.maxlenException=/^(?:(?:\\/\\/|\\/\\*|\\*) ?)?[^ ]+$/},{}],\"/node_modules/jshint/src/scope-manager.js\":[function(_dereq_,module){\"use strict\";var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),marker={},scopeManager=function(state,predefined,exported,declared){function _newScope(type){_current={\"(labels)\":Object.create(null),\"(usages)\":Object.create(null),\"(breakLabels)\":Object.create(null),\"(parent)\":_current,\"(type)\":type,\"(params)\":\"functionparams\"===type||\"catchparams\"===type?[]:null},_scopeStack.push(_current)}function warning(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function error(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function _setupUsages(labelName){_current[\"(usages)\"][labelName]||(_current[\"(usages)\"][labelName]={\"(modified)\":[],\"(reassigned)\":[],\"(tokens)\":[]})}function _checkForUnused(){if(\"functionparams\"===_current[\"(type)\"])return _checkParams(),void 0;var curentLabels=_current[\"(labels)\"];for(var labelName in curentLabels)curentLabels[labelName]&&\"exception\"!==curentLabels[labelName][\"(type)\"]&&curentLabels[labelName][\"(unused)\"]&&_warnUnused(labelName,curentLabels[labelName][\"(token)\"],\"var\")}function _checkParams(){var params=_current[\"(params)\"];if(params)for(var unused_opt,param=params.pop();param;){var label=_current[\"(labels)\"][param];if(unused_opt=_getUnusedOption(state.funct[\"(unusedOption)\"]),\"undefined\"===param)return;if(label[\"(unused)\"])_warnUnused(param,label[\"(token)\"],\"param\",state.funct[\"(unusedOption)\"]);else if(\"last-param\"===unused_opt)return;param=params.pop()}}function _getLabel(labelName){for(var i=_scopeStack.length-1;i>=0;--i){var scopeLabels=_scopeStack[i][\"(labels)\"];if(scopeLabels[labelName])return scopeLabels}}function usedSoFarInCurrentFunction(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(usages)\"][labelName])return current[\"(usages)\"][labelName];if(current===_currentFunctBody)break}return!1}function _checkOuterShadow(labelName,token){if(\"outer\"===state.option.shadow)for(var isGlobal=\"global\"===_currentFunctBody[\"(type)\"],isNewFunction=\"functionparams\"===_current[\"(type)\"],outsideCurrentFunction=!isGlobal,i=0;_scopeStack.length>i;i++){var stackItem=_scopeStack[i];isNewFunction||_scopeStack[i+1]!==_currentFunctBody||(outsideCurrentFunction=!1),outsideCurrentFunction&&stackItem[\"(labels)\"][labelName]&&warning(\"W123\",token,labelName),stackItem[\"(breakLabels)\"][labelName]&&warning(\"W123\",token,labelName)}}function _latedefWarning(type,labelName,token){state.option.latedef&&(state.option.latedef===!0&&\"function\"===type||\"function\"!==type)&&warning(\"W003\",token,labelName)}var _current,_scopeStack=[];_newScope(\"global\"),_current[\"(predefined)\"]=predefined;var _currentFunctBody=_current,usedPredefinedAndGlobals=Object.create(null),impliedGlobals=Object.create(null),unuseds=[],emitter=new events.EventEmitter,_getUnusedOption=function(unused_opt){return void 0===unused_opt&&(unused_opt=state.option.unused),unused_opt===!0&&(unused_opt=\"last-param\"),unused_opt},_warnUnused=function(name,tkn,type,unused_opt){var line=tkn.line,chr=tkn.from,raw_name=tkn.raw_text||name;unused_opt=_getUnusedOption(unused_opt);var warnable_types={vars:[\"var\"],\"last-param\":[\"var\",\"param\"],strict:[\"var\",\"param\",\"last-param\"]};unused_opt&&warnable_types[unused_opt]&&-1!==warnable_types[unused_opt].indexOf(type)&&warning(\"W098\",{line:line,from:chr},raw_name),(unused_opt||\"var\"===type)&&unuseds.push({name:name,line:line,character:chr})},scopeManagerInst={on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)})},isPredefined:function(labelName){return!this.has(labelName)&&_.has(_scopeStack[0][\"(predefined)\"],labelName)},stack:function(type){var previousScope=_current;_newScope(type),type||\"functionparams\"!==previousScope[\"(type)\"]||(_current[\"(isFuncBody)\"]=!0,_current[\"(context)\"]=_currentFunctBody,_currentFunctBody=_current)},unstack:function(){var i,j,subScope=_scopeStack.length>1?_scopeStack[_scopeStack.length-2]:null,isUnstackingFunctionBody=_current===_currentFunctBody,isUnstackingFunctionParams=\"functionparams\"===_current[\"(type)\"],isUnstackingFunctionOuter=\"functionouter\"===_current[\"(type)\"],currentUsages=_current[\"(usages)\"],currentLabels=_current[\"(labels)\"],usedLabelNameList=Object.keys(currentUsages);for(currentUsages.__proto__&&-1===usedLabelNameList.indexOf(\"__proto__\")&&usedLabelNameList.push(\"__proto__\"),i=0;usedLabelNameList.length>i;i++){var usedLabelName=usedLabelNameList[i],usage=currentUsages[usedLabelName],usedLabel=currentLabels[usedLabelName];if(usedLabel){var usedLabelType=usedLabel[\"(type)\"];if(usedLabel[\"(useOutsideOfScope)\"]&&!state.option.funcscope){var usedTokens=usage[\"(tokens)\"];if(usedTokens)for(j=0;usedTokens.length>j;j++)usedLabel[\"(function)\"]===usedTokens[j][\"(function)\"]&&error(\"W038\",usedTokens[j],usedLabelName)}if(_current[\"(labels)\"][usedLabelName][\"(unused)\"]=!1,\"const\"===usedLabelType&&usage[\"(modified)\"])for(j=0;usage[\"(modified)\"].length>j;j++)error(\"E013\",usage[\"(modified)\"][j],usedLabelName);if((\"function\"===usedLabelType||\"class\"===usedLabelType)&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)error(\"W021\",usage[\"(reassigned)\"][j],usedLabelName,usedLabelType)}else if(isUnstackingFunctionOuter&&(state.funct[\"(isCapturing)\"]=!0),subScope)if(subScope[\"(usages)\"][usedLabelName]){var subScopeUsage=subScope[\"(usages)\"][usedLabelName];subScopeUsage[\"(modified)\"]=subScopeUsage[\"(modified)\"].concat(usage[\"(modified)\"]),subScopeUsage[\"(tokens)\"]=subScopeUsage[\"(tokens)\"].concat(usage[\"(tokens)\"]),subScopeUsage[\"(reassigned)\"]=subScopeUsage[\"(reassigned)\"].concat(usage[\"(reassigned)\"]),subScopeUsage[\"(onlyUsedSubFunction)\"]=!1}else subScope[\"(usages)\"][usedLabelName]=usage,isUnstackingFunctionBody&&(subScope[\"(usages)\"][usedLabelName][\"(onlyUsedSubFunction)\"]=!0);else if(\"boolean\"==typeof _current[\"(predefined)\"][usedLabelName]){if(delete declared[usedLabelName],usedPredefinedAndGlobals[usedLabelName]=marker,_current[\"(predefined)\"][usedLabelName]===!1&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)warning(\"W020\",usage[\"(reassigned)\"][j])}else if(usage[\"(tokens)\"])for(j=0;usage[\"(tokens)\"].length>j;j++){var undefinedToken=usage[\"(tokens)\"][j];undefinedToken.forgiveUndef||(state.option.undef&&!undefinedToken.ignoreUndef&&warning(\"W117\",undefinedToken,usedLabelName),impliedGlobals[usedLabelName]?impliedGlobals[usedLabelName].line.push(undefinedToken.line):impliedGlobals[usedLabelName]={name:usedLabelName,line:[undefinedToken.line]})}}if(subScope||Object.keys(declared).forEach(function(labelNotUsed){_warnUnused(labelNotUsed,declared[labelNotUsed],\"var\")}),subScope&&!isUnstackingFunctionBody&&!isUnstackingFunctionParams&&!isUnstackingFunctionOuter){var labelNames=Object.keys(currentLabels);for(i=0;labelNames.length>i;i++){var defLabelName=labelNames[i];currentLabels[defLabelName][\"(blockscoped)\"]||\"exception\"===currentLabels[defLabelName][\"(type)\"]||this.funct.has(defLabelName,{excludeCurrent:!0})||(subScope[\"(labels)\"][defLabelName]=currentLabels[defLabelName],\"global\"!==_currentFunctBody[\"(type)\"]&&(subScope[\"(labels)\"][defLabelName][\"(useOutsideOfScope)\"]=!0),delete currentLabels[defLabelName])}}_checkForUnused(),_scopeStack.pop(),isUnstackingFunctionBody&&(_currentFunctBody=_scopeStack[_.findLastIndex(_scopeStack,function(scope){return scope[\"(isFuncBody)\"]||\"global\"===scope[\"(type)\"]})]),_current=subScope},addParam:function(labelName,token,type){if(type=type||\"param\",\"exception\"===type){var previouslyDefinedLabelType=this.funct.labeltype(labelName);previouslyDefinedLabelType&&\"exception\"!==previouslyDefinedLabelType&&(state.option.node||warning(\"W002\",state.tokens.next,labelName))}if(_.has(_current[\"(labels)\"],labelName)?_current[\"(labels)\"][labelName].duplicated=!0:(_checkOuterShadow(labelName,token,type),_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":token,\"(unused)\":!0},_current[\"(params)\"].push(labelName)),_.has(_current[\"(usages)\"],labelName)){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}},validateParams:function(){if(\"global\"!==_currentFunctBody[\"(type)\"]){var isStrict=state.isStrict(),currentFunctParamScope=_currentFunctBody[\"(parent)\"];currentFunctParamScope[\"(params)\"]&&currentFunctParamScope[\"(params)\"].forEach(function(labelName){var label=currentFunctParamScope[\"(labels)\"][labelName];label&&label.duplicated&&(isStrict?warning(\"E011\",label[\"(token)\"],labelName):state.option.shadow!==!0&&warning(\"W004\",label[\"(token)\"],labelName))})}},getUsedOrDefinedGlobals:function(){var list=Object.keys(usedPredefinedAndGlobals);return usedPredefinedAndGlobals.__proto__===marker&&-1===list.indexOf(\"__proto__\")&&list.push(\"__proto__\"),list},getImpliedGlobals:function(){var values=_.values(impliedGlobals),hasProto=!1;return impliedGlobals.__proto__&&(hasProto=values.some(function(value){return\"__proto__\"===value.name}),hasProto||values.push(impliedGlobals.__proto__)),values},getUnuseds:function(){return unuseds},has:function(labelName){return Boolean(_getLabel(labelName))},labeltype:function(labelName){var scopeLabels=_getLabel(labelName);return scopeLabels?scopeLabels[labelName][\"(type)\"]:null},addExported:function(labelName){var globalLabels=_scopeStack[0][\"(labels)\"];if(_.has(declared,labelName))delete declared[labelName];else if(_.has(globalLabels,labelName))globalLabels[labelName][\"(unused)\"]=!1;else{for(var i=1;_scopeStack.length>i;i++){var scope=_scopeStack[i];if(scope[\"(type)\"])break;if(_.has(scope[\"(labels)\"],labelName)&&!scope[\"(labels)\"][labelName][\"(blockscoped)\"])return scope[\"(labels)\"][labelName][\"(unused)\"]=!1,void 0}exported[labelName]=!0}},setExported:function(labelName,token){this.block.use(labelName,token)\n},addlabel:function(labelName,opts){var type=opts.type,token=opts.token,isblockscoped=\"let\"===type||\"const\"===type||\"class\"===type,isexported=\"global\"===(isblockscoped?_current:_currentFunctBody)[\"(type)\"]&&_.has(exported,labelName);if(_checkOuterShadow(labelName,token,type),isblockscoped){var declaredInCurrentScope=_current[\"(labels)\"][labelName];if(declaredInCurrentScope||_current!==_currentFunctBody||\"global\"===_current[\"(type)\"]||(declaredInCurrentScope=!!_currentFunctBody[\"(parent)\"][\"(labels)\"][labelName]),!declaredInCurrentScope&&_current[\"(usages)\"][labelName]){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}declaredInCurrentScope?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&scopeManagerInst.funct.has(labelName)&&warning(\"W004\",token,labelName),scopeManagerInst.block.add(labelName,type,token,!isexported)}else{var declaredInCurrentFunctionScope=scopeManagerInst.funct.has(labelName);!declaredInCurrentFunctionScope&&usedSoFarInCurrentFunction(labelName)&&_latedefWarning(type,labelName,token),scopeManagerInst.funct.has(labelName,{onlyBlockscoped:!0})?warning(\"E011\",token,labelName):state.option.shadow!==!0&&declaredInCurrentFunctionScope&&\"__proto__\"!==labelName&&\"global\"!==_currentFunctBody[\"(type)\"]&&warning(\"W004\",token,labelName),scopeManagerInst.funct.add(labelName,type,token,!isexported),\"global\"===_currentFunctBody[\"(type)\"]&&(usedPredefinedAndGlobals[labelName]=marker)}},funct:{labeltype:function(labelName,options){for(var onlyBlockscoped=options&&options.onlyBlockscoped,excludeParams=options&&options.excludeParams,currentScopeIndex=_scopeStack.length-(options&&options.excludeCurrent?2:1),i=currentScopeIndex;i>=0;i--){var current=_scopeStack[i];if(current[\"(labels)\"][labelName]&&(!onlyBlockscoped||current[\"(labels)\"][labelName][\"(blockscoped)\"]))return current[\"(labels)\"][labelName][\"(type)\"];var scopeCheck=excludeParams?_scopeStack[i-1]:current;if(scopeCheck&&\"functionparams\"===scopeCheck[\"(type)\"])return null}return null},hasBreakLabel:function(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(breakLabels)\"][labelName])return!0;if(\"functionparams\"===current[\"(type)\"])return!1}return!1},has:function(labelName,options){return Boolean(this.labeltype(labelName,options))},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!1,\"(function)\":_currentFunctBody,\"(unused)\":unused}}},block:{isGlobal:function(){return\"global\"===_current[\"(type)\"]},use:function(labelName,token){var paramScope=_currentFunctBody[\"(parent)\"];paramScope&&paramScope[\"(labels)\"][labelName]&&\"param\"===paramScope[\"(labels)\"][labelName][\"(type)\"]&&(scopeManagerInst.funct.has(labelName,{excludeParams:!0,onlyBlockscoped:!0})||(paramScope[\"(labels)\"][labelName][\"(unused)\"]=!1)),token&&(state.ignored.W117||state.option.undef===!1)&&(token.ignoreUndef=!0),_setupUsages(labelName),token&&(token[\"(function)\"]=_currentFunctBody,_current[\"(usages)\"][labelName][\"(tokens)\"].push(token))},reassign:function(labelName,token){this.modify(labelName,token),_current[\"(usages)\"][labelName][\"(reassigned)\"].push(token)},modify:function(labelName,token){_setupUsages(labelName),_current[\"(usages)\"][labelName][\"(modified)\"].push(token)},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!0,\"(unused)\":unused}},addBreakLabel:function(labelName,opts){var token=opts.token;scopeManagerInst.funct.hasBreakLabel(labelName)?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&(scopeManagerInst.funct.has(labelName)?warning(\"W004\",token,labelName):_checkOuterShadow(labelName,token)),_current[\"(breakLabels)\"][labelName]=token}}};return scopeManagerInst};module.exports=scopeManager},{\"../lodash\":\"/node_modules/jshint/lodash.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/state.js\":[function(_dereq_,module,exports){\"use strict\";var NameStack=_dereq_(\"./name-stack.js\"),state={syntax:{},isStrict:function(){return this.directive[\"use strict\"]||this.inClassBody||this.option.module||\"implied\"===this.option.strict},inMoz:function(){return this.option.moz},inES6:function(){return this.option.moz||this.option.esversion>=6},inES5:function(strict){return strict?!(this.option.esversion&&5!==this.option.esversion||this.option.moz):!this.option.esversion||this.option.esversion>=5||this.option.moz},reset:function(){this.tokens={prev:null,next:null,curr:null},this.option={},this.funct=null,this.ignored={},this.directive={},this.jsonMode=!1,this.jsonWarnings=[],this.lines=[],this.tab=\"\",this.cache={},this.ignoredLines={},this.forinifcheckneeded=!1,this.nameStack=new NameStack,this.inClassBody=!1}};exports.state=state},{\"./name-stack.js\":\"/node_modules/jshint/src/name-stack.js\"}],\"/node_modules/jshint/src/style.js\":[function(_dereq_,module,exports){\"use strict\";exports.register=function(linter){linter.on(\"Identifier\",function(data){linter.getOption(\"proto\")||\"__proto__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name,\"6\"]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"iterator\")||\"__iterator__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"camelcase\")&&data.name.replace(/^_+|_+$/g,\"\").indexOf(\"_\")>-1&&!data.name.match(/^[A-Z0-9_]*$/)&&linter.warn(\"W106\",{line:data.line,\"char\":data.from,data:[data.name]})}),linter.on(\"String\",function(data){var code,quotmark=linter.getOption(\"quotmark\");quotmark&&(\"single\"===quotmark&&\"'\"!==data.quote&&(code=\"W109\"),\"double\"===quotmark&&'\"'!==data.quote&&(code=\"W108\"),quotmark===!0&&(linter.getCache(\"quotmark\")||linter.setCache(\"quotmark\",data.quote),linter.getCache(\"quotmark\")!==data.quote&&(code=\"W110\")),code&&linter.warn(code,{line:data.line,\"char\":data.char}))}),linter.on(\"Number\",function(data){\".\"===data.value.charAt(0)&&linter.warn(\"W008\",{line:data.line,\"char\":data.char,data:[data.value]}),\".\"===data.value.substr(data.value.length-1)&&linter.warn(\"W047\",{line:data.line,\"char\":data.char,data:[data.value]}),/^00+/.test(data.value)&&linter.warn(\"W046\",{line:data.line,\"char\":data.char,data:[data.value]})}),linter.on(\"String\",function(data){var re=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i;linter.getOption(\"scripturl\")||re.test(data.value)&&linter.warn(\"W107\",{line:data.line,\"char\":data.char})})}},{}],\"/node_modules/jshint/src/vars.js\":[function(_dereq_,module,exports){\"use strict\";exports.reservedVars={arguments:!1,NaN:!1},exports.ecmaIdentifiers={3:{Array:!1,Boolean:!1,Date:!1,decodeURI:!1,decodeURIComponent:!1,encodeURI:!1,encodeURIComponent:!1,Error:!1,eval:!1,EvalError:!1,Function:!1,hasOwnProperty:!1,isFinite:!1,isNaN:!1,Math:!1,Number:!1,Object:!1,parseInt:!1,parseFloat:!1,RangeError:!1,ReferenceError:!1,RegExp:!1,String:!1,SyntaxError:!1,TypeError:!1,URIError:!1},5:{JSON:!1},6:{Map:!1,Promise:!1,Proxy:!1,Reflect:!1,Set:!1,Symbol:!1,WeakMap:!1,WeakSet:!1}},exports.browser={Audio:!1,Blob:!1,addEventListener:!1,applicationCache:!1,atob:!1,blur:!1,btoa:!1,cancelAnimationFrame:!1,CanvasGradient:!1,CanvasPattern:!1,CanvasRenderingContext2D:!1,CSS:!1,clearInterval:!1,clearTimeout:!1,close:!1,closed:!1,Comment:!1,CustomEvent:!1,DOMParser:!1,defaultStatus:!1,Document:!1,document:!1,DocumentFragment:!1,Element:!1,ElementTimeControl:!1,Event:!1,event:!1,fetch:!1,FileReader:!1,FormData:!1,focus:!1,frames:!1,getComputedStyle:!1,HTMLElement:!1,HTMLAnchorElement:!1,HTMLBaseElement:!1,HTMLBlockquoteElement:!1,HTMLBodyElement:!1,HTMLBRElement:!1,HTMLButtonElement:!1,HTMLCanvasElement:!1,HTMLCollection:!1,HTMLDirectoryElement:!1,HTMLDivElement:!1,HTMLDListElement:!1,HTMLFieldSetElement:!1,HTMLFontElement:!1,HTMLFormElement:!1,HTMLFrameElement:!1,HTMLFrameSetElement:!1,HTMLHeadElement:!1,HTMLHeadingElement:!1,HTMLHRElement:!1,HTMLHtmlElement:!1,HTMLIFrameElement:!1,HTMLImageElement:!1,HTMLInputElement:!1,HTMLIsIndexElement:!1,HTMLLabelElement:!1,HTMLLayerElement:!1,HTMLLegendElement:!1,HTMLLIElement:!1,HTMLLinkElement:!1,HTMLMapElement:!1,HTMLMenuElement:!1,HTMLMetaElement:!1,HTMLModElement:!1,HTMLObjectElement:!1,HTMLOListElement:!1,HTMLOptGroupElement:!1,HTMLOptionElement:!1,HTMLParagraphElement:!1,HTMLParamElement:!1,HTMLPreElement:!1,HTMLQuoteElement:!1,HTMLScriptElement:!1,HTMLSelectElement:!1,HTMLStyleElement:!1,HTMLTableCaptionElement:!1,HTMLTableCellElement:!1,HTMLTableColElement:!1,HTMLTableElement:!1,HTMLTableRowElement:!1,HTMLTableSectionElement:!1,HTMLTemplateElement:!1,HTMLTextAreaElement:!1,HTMLTitleElement:!1,HTMLUListElement:!1,HTMLVideoElement:!1,history:!1,Image:!1,Intl:!1,length:!1,localStorage:!1,location:!1,matchMedia:!1,MessageChannel:!1,MessageEvent:!1,MessagePort:!1,MouseEvent:!1,moveBy:!1,moveTo:!1,MutationObserver:!1,name:!1,Node:!1,NodeFilter:!1,NodeList:!1,Notification:!1,navigator:!1,onbeforeunload:!0,onblur:!0,onerror:!0,onfocus:!0,onload:!0,onresize:!0,onunload:!0,open:!1,openDatabase:!1,opener:!1,Option:!1,parent:!1,performance:!1,print:!1,Range:!1,requestAnimationFrame:!1,removeEventListener:!1,resizeBy:!1,resizeTo:!1,screen:!1,scroll:!1,scrollBy:!1,scrollTo:!1,sessionStorage:!1,setInterval:!1,setTimeout:!1,SharedWorker:!1,status:!1,SVGAElement:!1,SVGAltGlyphDefElement:!1,SVGAltGlyphElement:!1,SVGAltGlyphItemElement:!1,SVGAngle:!1,SVGAnimateColorElement:!1,SVGAnimateElement:!1,SVGAnimateMotionElement:!1,SVGAnimateTransformElement:!1,SVGAnimatedAngle:!1,SVGAnimatedBoolean:!1,SVGAnimatedEnumeration:!1,SVGAnimatedInteger:!1,SVGAnimatedLength:!1,SVGAnimatedLengthList:!1,SVGAnimatedNumber:!1,SVGAnimatedNumberList:!1,SVGAnimatedPathData:!1,SVGAnimatedPoints:!1,SVGAnimatedPreserveAspectRatio:!1,SVGAnimatedRect:!1,SVGAnimatedString:!1,SVGAnimatedTransformList:!1,SVGAnimationElement:!1,SVGCSSRule:!1,SVGCircleElement:!1,SVGClipPathElement:!1,SVGColor:!1,SVGColorProfileElement:!1,SVGColorProfileRule:!1,SVGComponentTransferFunctionElement:!1,SVGCursorElement:!1,SVGDefsElement:!1,SVGDescElement:!1,SVGDocument:!1,SVGElement:!1,SVGElementInstance:!1,SVGElementInstanceList:!1,SVGEllipseElement:!1,SVGExternalResourcesRequired:!1,SVGFEBlendElement:!1,SVGFEColorMatrixElement:!1,SVGFEComponentTransferElement:!1,SVGFECompositeElement:!1,SVGFEConvolveMatrixElement:!1,SVGFEDiffuseLightingElement:!1,SVGFEDisplacementMapElement:!1,SVGFEDistantLightElement:!1,SVGFEFloodElement:!1,SVGFEFuncAElement:!1,SVGFEFuncBElement:!1,SVGFEFuncGElement:!1,SVGFEFuncRElement:!1,SVGFEGaussianBlurElement:!1,SVGFEImageElement:!1,SVGFEMergeElement:!1,SVGFEMergeNodeElement:!1,SVGFEMorphologyElement:!1,SVGFEOffsetElement:!1,SVGFEPointLightElement:!1,SVGFESpecularLightingElement:!1,SVGFESpotLightElement:!1,SVGFETileElement:!1,SVGFETurbulenceElement:!1,SVGFilterElement:!1,SVGFilterPrimitiveStandardAttributes:!1,SVGFitToViewBox:!1,SVGFontElement:!1,SVGFontFaceElement:!1,SVGFontFaceFormatElement:!1,SVGFontFaceNameElement:!1,SVGFontFaceSrcElement:!1,SVGFontFaceUriElement:!1,SVGForeignObjectElement:!1,SVGGElement:!1,SVGGlyphElement:!1,SVGGlyphRefElement:!1,SVGGradientElement:!1,SVGHKernElement:!1,SVGICCColor:!1,SVGImageElement:!1,SVGLangSpace:!1,SVGLength:!1,SVGLengthList:!1,SVGLineElement:!1,SVGLinearGradientElement:!1,SVGLocatable:!1,SVGMPathElement:!1,SVGMarkerElement:!1,SVGMaskElement:!1,SVGMatrix:!1,SVGMetadataElement:!1,SVGMissingGlyphElement:!1,SVGNumber:!1,SVGNumberList:!1,SVGPaint:!1,SVGPathElement:!1,SVGPathSeg:!1,SVGPathSegArcAbs:!1,SVGPathSegArcRel:!1,SVGPathSegClosePath:!1,SVGPathSegCurvetoCubicAbs:!1,SVGPathSegCurvetoCubicRel:!1,SVGPathSegCurvetoCubicSmoothAbs:!1,SVGPathSegCurvetoCubicSmoothRel:!1,SVGPathSegCurvetoQuadraticAbs:!1,SVGPathSegCurvetoQuadraticRel:!1,SVGPathSegCurvetoQuadraticSmoothAbs:!1,SVGPathSegCurvetoQuadraticSmoothRel:!1,SVGPathSegLinetoAbs:!1,SVGPathSegLinetoHorizontalAbs:!1,SVGPathSegLinetoHorizontalRel:!1,SVGPathSegLinetoRel:!1,SVGPathSegLinetoVerticalAbs:!1,SVGPathSegLinetoVerticalRel:!1,SVGPathSegList:!1,SVGPathSegMovetoAbs:!1,SVGPathSegMovetoRel:!1,SVGPatternElement:!1,SVGPoint:!1,SVGPointList:!1,SVGPolygonElement:!1,SVGPolylineElement:!1,SVGPreserveAspectRatio:!1,SVGRadialGradientElement:!1,SVGRect:!1,SVGRectElement:!1,SVGRenderingIntent:!1,SVGSVGElement:!1,SVGScriptElement:!1,SVGSetElement:!1,SVGStopElement:!1,SVGStringList:!1,SVGStylable:!1,SVGStyleElement:!1,SVGSwitchElement:!1,SVGSymbolElement:!1,SVGTRefElement:!1,SVGTSpanElement:!1,SVGTests:!1,SVGTextContentElement:!1,SVGTextElement:!1,SVGTextPathElement:!1,SVGTextPositioningElement:!1,SVGTitleElement:!1,SVGTransform:!1,SVGTransformList:!1,SVGTransformable:!1,SVGURIReference:!1,SVGUnitTypes:!1,SVGUseElement:!1,SVGVKernElement:!1,SVGViewElement:!1,SVGViewSpec:!1,SVGZoomAndPan:!1,Text:!1,TextDecoder:!1,TextEncoder:!1,TimeEvent:!1,top:!1,URL:!1,WebGLActiveInfo:!1,WebGLBuffer:!1,WebGLContextEvent:!1,WebGLFramebuffer:!1,WebGLProgram:!1,WebGLRenderbuffer:!1,WebGLRenderingContext:!1,WebGLShader:!1,WebGLShaderPrecisionFormat:!1,WebGLTexture:!1,WebGLUniformLocation:!1,WebSocket:!1,window:!1,Window:!1,Worker:!1,XDomainRequest:!1,XMLHttpRequest:!1,XMLSerializer:!1,XPathEvaluator:!1,XPathException:!1,XPathExpression:!1,XPathNamespace:!1,XPathNSResolver:!1,XPathResult:!1},exports.devel={alert:!1,confirm:!1,console:!1,Debug:!1,opera:!1,prompt:!1},exports.worker={importScripts:!0,postMessage:!0,self:!0,FileReaderSync:!0},exports.nonstandard={escape:!1,unescape:!1},exports.couch={require:!1,respond:!1,getRow:!1,emit:!1,send:!1,start:!1,sum:!1,log:!1,exports:!1,module:!1,provides:!1},exports.node={__filename:!1,__dirname:!1,GLOBAL:!1,global:!1,module:!1,acequire:!1,Buffer:!0,console:!0,exports:!0,process:!0,setTimeout:!0,clearTimeout:!0,setInterval:!0,clearInterval:!0,setImmediate:!0,clearImmediate:!0},exports.browserify={__filename:!1,__dirname:!1,global:!1,module:!1,acequire:!1,Buffer:!0,exports:!0,process:!0},exports.phantom={phantom:!0,acequire:!0,WebPage:!0,console:!0,exports:!0},exports.qunit={asyncTest:!1,deepEqual:!1,equal:!1,expect:!1,module:!1,notDeepEqual:!1,notEqual:!1,notPropEqual:!1,notStrictEqual:!1,ok:!1,propEqual:!1,QUnit:!1,raises:!1,start:!1,stop:!1,strictEqual:!1,test:!1,\"throws\":!1},exports.rhino={defineClass:!1,deserialize:!1,gc:!1,help:!1,importClass:!1,importPackage:!1,java:!1,load:!1,loadClass:!1,Packages:!1,print:!1,quit:!1,readFile:!1,readUrl:!1,runCommand:!1,seal:!1,serialize:!1,spawn:!1,sync:!1,toint32:!1,version:!1},exports.shelljs={target:!1,echo:!1,exit:!1,cd:!1,pwd:!1,ls:!1,find:!1,cp:!1,rm:!1,mv:!1,mkdir:!1,test:!1,cat:!1,sed:!1,grep:!1,which:!1,dirs:!1,pushd:!1,popd:!1,env:!1,exec:!1,chmod:!1,config:!1,error:!1,tempdir:!1},exports.typed={ArrayBuffer:!1,ArrayBufferView:!1,DataView:!1,Float32Array:!1,Float64Array:!1,Int16Array:!1,Int32Array:!1,Int8Array:!1,Uint16Array:!1,Uint32Array:!1,Uint8Array:!1,Uint8ClampedArray:!1},exports.wsh={ActiveXObject:!0,Enumerator:!0,GetObject:!0,ScriptEngine:!0,ScriptEngineBuildVersion:!0,ScriptEngineMajorVersion:!0,ScriptEngineMinorVersion:!0,VBArray:!0,WSH:!0,WScript:!0,XDomainRequest:!0},exports.dojo={dojo:!1,dijit:!1,dojox:!1,define:!1,require:!1},exports.jquery={$:!1,jQuery:!1},exports.mootools={$:!1,$$:!1,Asset:!1,Browser:!1,Chain:!1,Class:!1,Color:!1,Cookie:!1,Core:!1,Document:!1,DomReady:!1,DOMEvent:!1,DOMReady:!1,Drag:!1,Element:!1,Elements:!1,Event:!1,Events:!1,Fx:!1,Group:!1,Hash:!1,HtmlTable:!1,IFrame:!1,IframeShim:!1,InputValidator:!1,instanceOf:!1,Keyboard:!1,Locale:!1,Mask:!1,MooTools:!1,Native:!1,Options:!1,OverText:!1,Request:!1,Scroller:!1,Slick:!1,Slider:!1,Sortables:!1,Spinner:!1,Swiff:!1,Tips:!1,Type:!1,typeOf:!1,URI:!1,Window:!1},exports.prototypejs={$:!1,$$:!1,$A:!1,$F:!1,$H:!1,$R:!1,$break:!1,$continue:!1,$w:!1,Abstract:!1,Ajax:!1,Class:!1,Enumerable:!1,Element:!1,Event:!1,Field:!1,Form:!1,Hash:!1,Insertion:!1,ObjectRange:!1,PeriodicalExecuter:!1,Position:!1,Prototype:!1,Selector:!1,Template:!1,Toggle:!1,Try:!1,Autocompleter:!1,Builder:!1,Control:!1,Draggable:!1,Draggables:!1,Droppables:!1,Effect:!1,Sortable:!1,SortableObserver:!1,Sound:!1,Scriptaculous:!1},exports.yui={YUI:!1,Y:!1,YUI_config:!1},exports.mocha={mocha:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,context:!1,xcontext:!1,before:!1,after:!1,beforeEach:!1,afterEach:!1,suite:!1,test:!1,setup:!1,teardown:!1,suiteSetup:!1,suiteTeardown:!1},exports.jasmine={jasmine:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,beforeEach:!1,afterEach:!1,setFixtures:!1,loadFixtures:!1,spyOn:!1,expect:!1,runs:!1,waitsFor:!1,waits:!1,beforeAll:!1,afterAll:!1,fail:!1,fdescribe:!1,fit:!1,pending:!1}},{}]},{},[\"/node_modules/jshint/src/jshint.js\"])}),ace.define(\"ace/mode/javascript_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/javascript/jshint\"],function(acequire,exports,module){\"use strict\";function startRegex(arr){return RegExp(\"^(\"+arr.join(\"|\")+\")\")}var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,lint=acequire(\"./javascript/jshint\").JSHINT,disabledWarningsRe=startRegex([\"Bad for in variable '(.+)'.\",'Missing \"use strict\"']),errorsRe=startRegex([\"Unexpected\",\"Expected \",\"Confusing (plus|minus)\",\"\\\\{a\\\\} unterminated regular expression\",\"Unclosed \",\"Unmatched \",\"Unbegun comment\",\"Bad invocation\",\"Missing space after\",\"Missing operator at\"]),infoRe=startRegex([\"Expected an assignment\",\"Bad escapement of EOL\",\"Unexpected comma\",\"Unexpected space\",\"Missing radix parameter.\",\"A leading decimal point can\",\"\\\\['{a}'\\\\] is better written in dot notation.\",\"'{a}' used out of scope\"]),JavaScriptWorker=exports.JavaScriptWorker=function(sender){Mirror.call(this,sender),this.setTimeout(500),this.setOptions()};oop.inherits(JavaScriptWorker,Mirror),function(){this.setOptions=function(options){this.options=options||{esnext:!0,moz:!0,devel:!0,browser:!0,node:!0,laxcomma:!0,laxbreak:!0,lastsemic:!0,onevar:!1,passfail:!1,maxerr:100,expr:!0,multistr:!0,globalstrict:!0},this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.changeOptions=function(newOptions){oop.mixin(this.options,newOptions),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.isValidJS=function(str){try{eval(\"throw 0;\"+str)}catch(e){if(0===e)return!0}return!1},this.onUpdate=function(){var value=this.doc.getValue();if(value=value.replace(/^#!.*\\n/,\"\\n\"),!value)return this.sender.emit(\"annotate\",[]);var errors=[],maxErrorLevel=this.isValidJS(value)?\"warning\":\"error\";lint(value,this.options,this.options.globals);for(var results=lint.errors,errorAdded=!1,i=0;results.length>i;i++){var error=results[i];if(error){var raw=error.raw,type=\"warning\";if(\"Missing semicolon.\"==raw){var str=error.evidence.substr(error.character);str=str.charAt(str.search(/\\S/)),\"error\"==maxErrorLevel&&str&&/[\\w\\d{(['\"]/.test(str)?(error.reason='Missing \";\" before statement',type=\"error\"):type=\"info\"}else{if(disabledWarningsRe.test(raw))continue;infoRe.test(raw)?type=\"info\":errorsRe.test(raw)?(errorAdded=!0,type=maxErrorLevel):\"'{a}' is not defined.\"==raw?type=\"warning\":\"'{a}' is defined but never used.\"==raw&&(type=\"info\")}errors.push({row:error.line-1,column:error.character-1,text:error.reason,type:type,raw:raw})}}this.sender.emit(\"annotate\",errors)}}.call(JavaScriptWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),

/***/ "6da6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("51cd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4371ebe0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6e1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDatePicker_vue_vue_type_style_index_0_id_018e8802_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f8c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDatePicker_vue_vue_type_style_index_0_id_018e8802_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDatePicker_vue_vue_type_style_index_0_id_018e8802_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDatePicker_vue_vue_type_style_index_0_id_018e8802_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6e61":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e4a6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6c6be338", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "71c1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var defined = __webpack_require__("25eb");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "7514":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "75fe":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".math-node[data-v-867fe350]{display:inline;position:relative}.align-self-center[data-v-867fe350]{display:inline;line-height:2.5}.v-btn[data-v-867fe350]{text-transform:none}.inline[data-v-867fe350]{display:inline}.function-name[data-v-867fe350]{color:#1e90ff;padding:0 0 0 0;font-weight:700}.op[data-v-867fe350]{padding:1px 10px;font-size:18px}.parameter[data-v-867fe350]{margin-left:0;padding:0 8px}.parameters[data-v-867fe350]:before{content:\"(\";align-self:center!important;font-size:28px;vertical-align:middle;margin-left:8px}.parameters[data-v-867fe350]:after{content:\")\";align-self:center!important;font-size:28px;vertical-align:middle}.parameter[data-v-867fe350]:not(:last-child){padding-right:0}.parameter[data-v-867fe350]:not(:last-child):after{content:\" , \";margin-left:4px;align-self:center!important;font-size:28px;vertical-align:middle}.v-input[data-v-867fe350]{width:130px}.v-select[data-v-867fe350]{width:200px}.op .v-input[data-v-867fe350]{width:70px}.parentheses[data-v-867fe350],.parenthesis[data-v-867fe350] .v-btn__content{font-size:26px}.v-list[data-v-867fe350]{max-height:calc(100vh - 20px);overflow-y:auto}", ""]);

// exports


/***/ }),

/***/ "7614":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2db7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("11fb254c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "765d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('observable');


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "794b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("8e60") && !__webpack_require__("294c")(function () {
  return Object.defineProperty(__webpack_require__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "79aa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7a56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var dP = __webpack_require__("86cc");
var DESCRIPTORS = __webpack_require__("9e1e");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "7e90":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var anObject = __webpack_require__("e4ae");
var getKeys = __webpack_require__("c3a1");

module.exports = __webpack_require__("8e60") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "7fa4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".photoshop[data-v-22f23381]{background:#b5b5b5;height:100%;overflow:hidden;padding:0;display:flex;flex-direction:column;flex:1}.panel[data-v-22f23381]{background:#f1f1f1;padding:10px}#background[data-v-22f23381]{width:100%}#container[data-v-22f23381]{padding:0;overflow:hidden}#designer[data-v-22f23381]{margin:0 auto;box-shadow:0 0 10px rgba(0,0,0,.1)}#designer *[data-v-22f23381]{cursor:default;outline:none;overflow:visible;user-select:none;overflow:hidden;white-space:nowrap}.selector[data-v-22f23381]{border:4px solid #08f;z-index:999;cursor:move!important;box-shadow:0 0 10px #fff;overflow:visible!important}.resize-box[data-v-22f23381],.selector[data-v-22f23381]{position:absolute;box-sizing:content-box}.resize-box[data-v-22f23381]{border:1px solid #000;background:#fff;width:8px;height:8px;z-index:10000}.resize-box.left[data-v-22f23381]{left:-6px}.resize-box.right[data-v-22f23381]{right:-6px}.resize-box.top[data-v-22f23381]{top:-6px}.resize-box.bottom[data-v-22f23381]{bottom:-6px}.resize-box.top.left[data-v-22f23381]{cursor:nw-resize}.resize-box.bottom.left[data-v-22f23381]{cursor:sw-resize}.resize-box.top.right[data-v-22f23381]{cursor:ne-resize}.resize-box.bottom.right[data-v-22f23381]{cursor:se-resize!important}.v-divider[data-v-22f23381]{margin-bottom:10px}.v-input[data-v-22f23381]{margin:0 0 15px 0}", ""]);

// exports


/***/ }),

/***/ "8079":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var macrotask = __webpack_require__("1991").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("2d95")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "8380":
/***/ (function(module, exports) {

module.exports = require("vue2-ace-editor");

/***/ }),

/***/ "83a1":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "8436":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("d3f4");
var anObject = __webpack_require__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8df7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9fd7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("42cd55fc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8e60":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("294c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8f60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("a159");
var descriptor = __webpack_require__("aebd");
var setToStringTag = __webpack_require__("45f2");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("35e8")(IteratorPrototype, __webpack_require__("5168")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "8ff1":
/***/ (function(module, exports) {

module.exports = require("vue-context");

/***/ }),

/***/ "9003":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("6b4c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "9093":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("ce10");
var hiddenKeys = __webpack_require__("e11e").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "9096":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeToolbox_vue_vue_type_style_index_0_id_df63b094_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6da6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeToolbox_vue_vue_type_style_index_0_id_df63b094_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeToolbox_vue_vue_type_style_index_0_id_df63b094_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeToolbox_vue_vue_type_style_index_0_id_df63b094_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9138":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("35e8");


/***/ }),

/***/ "92ad":
/***/ (function(module, exports) {

module.exports = require("brace");

/***/ }),

/***/ "95b8":
/***/ (function(module, exports) {

ace.define("ace/theme/chrome",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {

exports.isDark = false;
exports.cssClass = "ace-chrome";
exports.cssText = ".ace-chrome .ace_gutter {\
background: #ebebeb;\
color: #333;\
overflow : hidden;\
}\
.ace-chrome .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-chrome {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-chrome .ace_cursor {\
color: black;\
}\
.ace-chrome .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-chrome .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-chrome .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-chrome .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-chrome .ace_invalid {\
background-color: rgb(153, 0, 0);\
color: white;\
}\
.ace-chrome .ace_fold {\
}\
.ace-chrome .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-chrome .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-chrome .ace_support.ace_type,\
.ace-chrome .ace_support.ace_class\
.ace-chrome .ace_support.ace_other {\
color: rgb(109, 121, 222);\
}\
.ace-chrome .ace_variable.ace_parameter {\
font-style:italic;\
color:#FD971F;\
}\
.ace-chrome .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-chrome .ace_comment {\
color: #236e24;\
}\
.ace-chrome .ace_comment.ace_doc {\
color: #236e24;\
}\
.ace-chrome .ace_comment.ace_doc.ace_tag {\
color: #236e24;\
}\
.ace-chrome .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-chrome .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-chrome .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-chrome .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-chrome .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-chrome .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-chrome .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-chrome .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-chrome .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-chrome .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-chrome .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-chrome .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-chrome .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-chrome .ace_storage,\
.ace-chrome .ace_keyword,\
.ace-chrome .ace_meta.ace_tag {\
color: rgb(147, 15, 128);\
}\
.ace-chrome .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-chrome .ace_string {\
color: #1A1AA6;\
}\
.ace-chrome .ace_entity.ace_other.ace_attribute-name {\
color: #994409;\
}\
.ace-chrome .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});


/***/ }),

/***/ "96b3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-divider[data-v-6f1cd0e6]{margin-bottom:10px}.v-input[data-v-6f1cd0e6]{margin:0 0 15px 0}", ""]);

// exports


/***/ }),

/***/ "980a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardImageProperties_vue_vue_type_style_index_0_id_6f1cd0e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("13a1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardImageProperties_vue_vue_type_style_index_0_id_6f1cd0e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardImageProperties_vue_vue_type_style_index_0_id_6f1cd0e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardImageProperties_vue_vue_type_style_index_0_id_6f1cd0e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9aa9":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9c80":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "9fd7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-card__text[data-v-430cfa9f]{padding:10px!important}", ""]);

// exports


/***/ }),

/***/ "a038":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3389");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("173608bd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a159":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("e4ae");
var dPs = __webpack_require__("7e90");
var enumBugKeys = __webpack_require__("1691");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("1ec9")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("32fc").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "a25f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "a5b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("d8e8");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "a7b5":
/***/ (function(module, exports) {

module.exports = require("vue-the-mask");

/***/ }),

/***/ "aa77":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("5ca1");
var defined = __webpack_require__("be13");
var fails = __webpack_require__("79e5");
var spaces = __webpack_require__("fdef");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "ad57":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-card[data-v-36c8de00]{margin-top:10px;margin-bottom:30px}.v-dialog .v-card[data-v-36c8de00]{margin-top:0;margin-bottom:0}.v-card__title[data-v-36c8de00]{padding:0!important;position:relative;display:block}.v-card-icon[data-v-36c8de00]{border-radius:3px;padding:20px;top:-14px;max-width:64px;left:15px;box-shadow:0 12px 20px -10px rgba(76,175,80,.28),0 4px 20px 0 rgba(0,0,0,.12),0 7px 8px -5px rgba(76,175,80,.2);position:absolute}.v-card__title h4[data-v-36c8de00]{color:#3c4858;font-weight:300;font-size:1.125rem;padding:12px 5px 10px 10px;padding-left:90px;display:block}.v-application .mx-3[data-v-36c8de00]{margin-left:0!important;margin-right:0!important}.material-card[data-v-36c8de00] .v-card__text{padding:16px!important}", ""]);

// exports


/***/ }),

/***/ "aebd":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "aef6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "b034":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ad57");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("450f62aa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "b447":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("3a38");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "b49e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LogicalExpressions_vue_vue_type_style_index_0_id_47da686d_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("49d9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LogicalExpressions_vue_vue_type_style_index_0_id_47da686d_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LogicalExpressions_vue_vue_type_style_index_0_id_47da686d_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LogicalExpressions_vue_vue_type_style_index_0_id_47da686d_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b4d8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-dialog--scrollable{overflow:visible!important}", ""]);

// exports


/***/ }),

/***/ "b88c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_0_id_9e5fd4a8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bc7b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_0_id_9e5fd4a8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_0_id_9e5fd4a8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasDataTable_vue_vue_type_style_index_0_id_9e5fd4a8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b8e3":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "ba92":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("4bf8");
var toAbsoluteIndex = __webpack_require__("77f1");
var toLength = __webpack_require__("9def");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "bb36":
/***/ (function(module, exports, __webpack_require__) {

ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var DocCommentHighlightRules = function() {
    this.$rules = {
        "start" : [ {
            token : "comment.doc.tag",
            regex : "@[\\w\\d_]+" // TODO: fix email addresses
        }, 
        DocCommentHighlightRules.getTagRule(),
        {
            defaultToken : "comment.doc",
            caseInsensitive: true
        }]
    };
};

oop.inherits(DocCommentHighlightRules, TextHighlightRules);

DocCommentHighlightRules.getTagRule = function(start) {
    return {
        token : "comment.doc.tag.storage.type",
        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
    };
};

DocCommentHighlightRules.getStartRule = function(start) {
    return {
        token : "comment.doc", // doc comment
        regex : "\\/\\*(?=\\*)",
        next  : start
    };
};

DocCommentHighlightRules.getEndRule = function (start) {
    return {
        token : "comment.doc", // closing comment
        regex : "\\*\\/",
        next  : start
    };
};


exports.DocCommentHighlightRules = DocCommentHighlightRules;

});

ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";

var JavaScriptHighlightRules = function(options) {
    var keywordMapper = this.createKeywordMapper({
        "variable.language":
            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
            "Namespace|QName|XML|XMLList|"                                             + // E4X
            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
            "SyntaxError|TypeError|URIError|"                                          +
            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
            "isNaN|parseFloat|parseInt|"                                               +
            "JSON|Math|"                                                               + // Other
            "this|arguments|prototype|window|document"                                 , // Pseudo
        "keyword":
            "const|yield|import|get|set|async|await|" +
            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
            "__parent__|__count__|escape|unescape|with|__proto__|" +
            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
        "storage.type":
            "const|let|var|function",
        "constant.language":
            "null|Infinity|NaN|undefined",
        "support.function":
            "alert",
        "constant.language.boolean": "true|false"
    }, "identifier");
    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";

    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
        "u[0-9a-fA-F]{4}|" + // unicode
        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
        "[0-2][0-7]{0,2}|" + // oct
        "3[0-7][0-7]?|" + // oct
        "[4-7][0-7]?|" + //oct
        ".)";

    this.$rules = {
        "no_regex" : [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("no_regex"),
            {
                token : "string",
                regex : "'(?=.)",
                next  : "qstring"
            }, {
                token : "string",
                regex : '"(?=.)',
                next  : "qqstring"
            }, {
                token : "constant.numeric", // hexadecimal, octal and binary
                regex : /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
            }, {
                token : "constant.numeric", // decimal integers and floats
                regex : /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
            }, {
                token : [
                    "storage.type", "punctuation.operator", "support.function",
                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
                ],
                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
                    "text", "paren.lparen"
                ],
                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "punctuation.operator",
                    "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "text", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "keyword",
                regex : "from(?=\\s*('|\"))"
            }, {
                token : "keyword",
                regex : "(?:" + kwBeforeRe + ")\\b",
                next : "start"
            }, {
                token : ["support.constant"],
                regex : /that\b/
            }, {
                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
            }, {
                token : keywordMapper,
                regex : identifierRe
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/,
                next  : "property"
            }, {
                token : "storage.type",
                regex : /=>/
            }, {
                token : "keyword.operator",
                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                next  : "start"
            }, {
                token : "punctuation.operator",
                regex : /[?:,;.]/,
                next  : "start"
            }, {
                token : "paren.lparen",
                regex : /[\[({]/,
                next  : "start"
            }, {
                token : "paren.rparen",
                regex : /[\])}]/
            }, {
                token: "comment",
                regex: /^#!.*$/
            }
        ],
        property: [{
                token : "text",
                regex : "\\s+"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/
            }, {
                token : "support.function",
                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
            }, {
                token : "support.function.dom",
                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
            }, {
                token :  "support.constant",
                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
            }, {
                token : "identifier",
                regex : identifierRe
            }, {
                regex: "",
                token: "empty",
                next: "no_regex"
            }
        ],
        "start": [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("start"),
            {
                token: "string.regexp",
                regex: "\\/",
                next: "regex"
            }, {
                token : "text",
                regex : "\\s+|^$",
                next : "start"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "regex": [
            {
                token: "regexp.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "string.regexp",
                regex: "/[sxngimy]*",
                next: "no_regex"
            }, {
                token : "invalid",
                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
            }, {
                token : "constant.language.escape",
                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
            }, {
                token : "constant.language.delimiter",
                regex: /\|/
            }, {
                token: "constant.language.escape",
                regex: /\[\^?/,
                next: "regex_character_class"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp"
            }
        ],
        "regex_character_class": [
            {
                token: "regexp.charclass.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "constant.language.escape",
                regex: "]",
                next: "regex"
            }, {
                token: "constant.language.escape",
                regex: "-"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp.charachterclass"
            }
        ],
        "function_arguments": [
            {
                token: "variable.parameter",
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: "[, ]+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "qqstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                consumeLineEnd  : true
            }, {
                token : "string",
                regex : '"|$',
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ],
        "qstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                consumeLineEnd  : true
            }, {
                token : "string",
                regex : "'|$",
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ]
    };


    if (!options || !options.noES6) {
        this.$rules.no_regex.unshift({
            regex: "[{}]", onMatch: function(val, state, stack) {
                this.next = val == "{" ? this.nextState : "";
                if (val == "{" && stack.length) {
                    stack.unshift("start", state);
                }
                else if (val == "}" && stack.length) {
                    stack.shift();
                    this.next = stack.shift();
                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
                        return "paren.quasi.end";
                }
                return val == "{" ? "paren.lparen" : "paren.rparen";
            },
            nextState: "start"
        }, {
            token : "string.quasi.start",
            regex : /`/,
            push  : [{
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "paren.quasi.start",
                regex : /\${/,
                push  : "start"
            }, {
                token : "string.quasi.end",
                regex : /`/,
                next  : "pop"
            }, {
                defaultToken: "string.quasi"
            }]
        });

        if (!options || options.jsx != false)
            JSX.call(this);
    }

    this.embedRules(DocCommentHighlightRules, "doc-",
        [ DocCommentHighlightRules.getEndRule("no_regex") ]);

    this.normalizeRules();
};

oop.inherits(JavaScriptHighlightRules, TextHighlightRules);

function JSX() {
    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
    var jsxTag = {
        onMatch : function(val, state, stack) {
            var offset = val.charAt(1) == "/" ? 2 : 1;
            if (offset == 1) {
                if (state != this.nextState)
                    stack.unshift(this.next, this.nextState, 0);
                else
                    stack.unshift(this.next);
                stack[2]++;
            } else if (offset == 2) {
                if (state == this.nextState) {
                    stack[1]--;
                    if (!stack[1] || stack[1] < 0) {
                        stack.shift();
                        stack.shift();
                    }
                }
            }
            return [{
                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                value: val.slice(0, offset)
            }, {
                type: "meta.tag.tag-name.xml",
                value: val.substr(offset)
            }];
        },
        regex : "</?" + tagRegex + "",
        next: "jsxAttributes",
        nextState: "jsx"
    };
    this.$rules.start.unshift(jsxTag);
    var jsxJsRule = {
        regex: "{",
        token: "paren.quasi.start",
        push: "start"
    };
    this.$rules.jsx = [
        jsxJsRule,
        jsxTag,
        {include : "reference"},
        {defaultToken: "string"}
    ];
    this.$rules.jsxAttributes = [{
        token : "meta.tag.punctuation.tag-close.xml",
        regex : "/?>",
        onMatch : function(value, currentState, stack) {
            if (currentState == stack[0])
                stack.shift();
            if (value.length == 2) {
                if (stack[0] == this.nextState)
                    stack[1]--;
                if (!stack[1] || stack[1] < 0) {
                    stack.splice(0, 2);
                }
            }
            this.next = stack[0] || "start";
            return [{type: this.token, value: value}];
        },
        nextState: "jsx"
    },
    jsxJsRule,
    comments("jsxAttributes"),
    {
        token : "entity.other.attribute-name.xml",
        regex : tagRegex
    }, {
        token : "keyword.operator.attribute-equals.xml",
        regex : "="
    }, {
        token : "text.tag-whitespace.xml",
        regex : "\\s+"
    }, {
        token : "string.attribute-value.xml",
        regex : "'",
        stateName : "jsx_attr_q",
        push : [
            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    }, {
        token : "string.attribute-value.xml",
        regex : '"',
        stateName : "jsx_attr_qq",
        push : [
            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    },
    jsxTag
    ];
    this.$rules.reference = [{
        token : "constant.language.escape.reference.xml",
        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
    }];
}

function comments(next) {
    return [
        {
            token : "comment", // multi line comment
            regex : /\/\*/,
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "\\*\\/", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }, {
            token : "comment",
            regex : "\\/\\/",
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "$|^", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }
    ];
}
exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});

ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;

var MatchingBraceOutdent = function() {};

(function() {

    this.checkOutdent = function(line, input) {
        if (! /^\s+$/.test(line))
            return false;

        return /^\s*\}/.test(input);
    };

    this.autoOutdent = function(doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);

        if (!match) return 0;

        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({row: row, column: column});

        if (!openBracePos || openBracePos.row == row) return 0;

        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column-1), indent);
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

}).call(MatchingBraceOutdent.prototype);

exports.MatchingBraceOutdent = MatchingBraceOutdent;
});

ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(
            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
        );
        this.foldingStopMarker = new RegExp(
            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
        );
    }
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
    
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
    
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
    
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
    
        return fw;
    };

    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;

            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
                
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                } else if (foldStyle != "all")
                    range = null;
            }
            
            return range;
        }

        if (foldStyle === "markbegin")
            return;

        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;

            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);

            return session.getCommentFoldRange(row, i, -1);
        }
    };
    
    this.getSectionRange = function(session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if  (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                } else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                } else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function(session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth--;
            else depth++;

            if (!depth) break;
        }

        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;

var Mode = function() {
    this.HighlightRules = JavaScriptHighlightRules;
    
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "//";
    this.blockComment = {start: "/*", end: "*/"};
    this.$quotes = {'"': '"', "'": "'", "`": "`"};

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
        var tokens = tokenizedLine.tokens;
        var endState = tokenizedLine.state;

        if (tokens.length && tokens[tokens.length-1].type == "comment") {
            return indent;
        }

        if (state == "start" || state == "no_regex") {
            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
            if (match) {
                indent += tab;
            }
        } else if (state == "doc-start") {
            if (endState == "start" || endState == "no_regex") {
                return "";
            }
            var match = line.match(/^\s*(\/?)\*/);
            if (match) {
                if (match[1]) {
                    indent += " ";
                }
                indent += "* ";
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__("6d68"), "JavaScriptWorker");
        worker.attachToDocument(session.getDocument());

        worker.on("annotate", function(results) {
            session.setAnnotations(results.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };

    this.$id = "ace/mode/javascript";
}).call(Mode.prototype);

exports.Mode = Mode;
});


/***/ }),

/***/ "bc7b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4603");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("508db748", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bcaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var newPromiseCapability = __webpack_require__("a5b8");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "be67":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".formula-editor[data-v-318081f3]{background:#fff;height:100%;overflow:hidden}[data-v-318081f3] .v-tabs-items{height:calc(100% - 48px)}[data-v-318081f3] .v-window-item,[data-v-318081f3] .v-window__container{height:100%}", ""]);

// exports


/***/ }),

/***/ "bf0b":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("355d");
var createDesc = __webpack_require__("aebd");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var has = __webpack_require__("07e3");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("8e60") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "c141":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasColumnFilters_vue_vue_type_style_index_0_id_201afedd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c17c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasColumnFilters_vue_vue_type_style_index_0_id_201afedd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasColumnFilters_vue_vue_type_style_index_0_id_201afedd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasColumnFilters_vue_vue_type_style_index_0_id_201afedd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c17c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ca9e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("49b4587e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c207":
/***/ (function(module, exports) {



/***/ }),

/***/ "c26b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("86cc").f;
var create = __webpack_require__("2aeb");
var redefineAll = __webpack_require__("dcbc");
var ctx = __webpack_require__("9b43");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var $iterDefine = __webpack_require__("01f9");
var step = __webpack_require__("d53b");
var setSpecies = __webpack_require__("7a56");
var DESCRIPTORS = __webpack_require__("9e1e");
var fastKey = __webpack_require__("67ab").fastKey;
var validate = __webpack_require__("b39a");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c367":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("8436");
var step = __webpack_require__("50ed");
var Iterators = __webpack_require__("481b");
var toIObject = __webpack_require__("36c3");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("30f1")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "c3a1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("e6f3");
var enumBugKeys = __webpack_require__("1691");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "c5f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var has = __webpack_require__("69a8");
var cof = __webpack_require__("2d95");
var inheritIfRequired = __webpack_require__("5dbc");
var toPrimitive = __webpack_require__("6a99");
var fails = __webpack_require__("79e5");
var gOPN = __webpack_require__("9093").f;
var gOPD = __webpack_require__("11e9").f;
var dP = __webpack_require__("86cc").f;
var $trim = __webpack_require__("aa77").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("2aeb")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("9e1e") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("2aba")(global, NUMBER, $Number);
}


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8b2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-divider[data-v-3273e1a5]{margin-bottom:10px}.v-input[data-v-3273e1a5]{margin:0 0 15px 0}", ""]);

// exports


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "ca9e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".col[data-v-201afedd]{padding:3px}", ""]);

// exports


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb73":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("be67");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("62c4b6e4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ccb9":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("5168");


/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d146":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7fa4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4cac0a37", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d241":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b4d8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4897cb22", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d720":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardDesigner_vue_vue_type_style_index_0_id_22f23381_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d146");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardDesigner_vue_vue_type_style_index_0_id_22f23381_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardDesigner_vue_vue_type_style_index_0_id_22f23381_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardDesigner_vue_vue_type_style_index_0_id_22f23381_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d864":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("79aa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "d8d6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1654");
__webpack_require__("6c1c");
module.exports = __webpack_require__("ccb9").f('iterator');


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "d9f6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var toPrimitive = __webpack_require__("1bc3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "da64":
/***/ (function(module, exports) {



/***/ }),

/***/ "dadb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("497d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("df6993c8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "daf1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c8b2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("93869926", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "dbdb":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("b8e3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "dcbc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("2aba");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "de7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AceEditor_vue_vue_type_style_index_0_id_0639c179_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f181");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AceEditor_vue_vue_type_style_index_0_id_0639c179_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AceEditor_vue_vue_type_style_index_0_id_0639c179_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AceEditor_vue_vue_type_style_index_0_id_0639c179_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e0b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var redefineAll = __webpack_require__("dcbc");
var meta = __webpack_require__("67ab");
var forOf = __webpack_require__("4a59");
var anInstance = __webpack_require__("f605");
var isObject = __webpack_require__("d3f4");
var fails = __webpack_require__("79e5");
var $iterDetect = __webpack_require__("5cc5");
var setToStringTag = __webpack_require__("7f20");
var inheritIfRequired = __webpack_require__("5dbc");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e4a6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".v-input--selection-controls[data-v-313c9c82]{margin:0!important;padding:0!important}.v-input[data-v-313c9c82] .v-input__slot{margin:0!important;padding:0!important}.v-input[data-v-313c9c82] .v-messages{min-height:0!important}", ""]);

// exports


/***/ }),

/***/ "e4ae":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "e53d":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "e6f3":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("07e3");
var toIObject = __webpack_require__("36c3");
var arrayIndexOf = __webpack_require__("5b4e")(false);
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var isArray = __webpack_require__("1169");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "ebd6":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("cb7c");
var aFunction = __webpack_require__("d8e8");
var SPECIES = __webpack_require__("2b4c")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "ebfd":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("62a0")('meta');
var isObject = __webpack_require__("f772");
var has = __webpack_require__("07e3");
var setDesc = __webpack_require__("d9f6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("294c")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "ec30":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("9e1e")) {
  var LIBRARY = __webpack_require__("2d00");
  var global = __webpack_require__("7726");
  var fails = __webpack_require__("79e5");
  var $export = __webpack_require__("5ca1");
  var $typed = __webpack_require__("0f88");
  var $buffer = __webpack_require__("ed0b");
  var ctx = __webpack_require__("9b43");
  var anInstance = __webpack_require__("f605");
  var propertyDesc = __webpack_require__("4630");
  var hide = __webpack_require__("32e9");
  var redefineAll = __webpack_require__("dcbc");
  var toInteger = __webpack_require__("4588");
  var toLength = __webpack_require__("9def");
  var toIndex = __webpack_require__("09fa");
  var toAbsoluteIndex = __webpack_require__("77f1");
  var toPrimitive = __webpack_require__("6a99");
  var has = __webpack_require__("69a8");
  var classof = __webpack_require__("23c6");
  var isObject = __webpack_require__("d3f4");
  var toObject = __webpack_require__("4bf8");
  var isArrayIter = __webpack_require__("33a4");
  var create = __webpack_require__("2aeb");
  var getPrototypeOf = __webpack_require__("38fd");
  var gOPN = __webpack_require__("9093").f;
  var getIterFn = __webpack_require__("27ee");
  var uid = __webpack_require__("ca5a");
  var wks = __webpack_require__("2b4c");
  var createArrayMethod = __webpack_require__("0a49");
  var createArrayIncludes = __webpack_require__("c366");
  var speciesConstructor = __webpack_require__("ebd6");
  var ArrayIterators = __webpack_require__("cadf");
  var Iterators = __webpack_require__("84f2");
  var $iterDetect = __webpack_require__("5cc5");
  var setSpecies = __webpack_require__("7a56");
  var arrayFill = __webpack_require__("36bd");
  var arrayCopyWithin = __webpack_require__("ba92");
  var $DP = __webpack_require__("86cc");
  var $GOPD = __webpack_require__("11e9");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "ed0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var DESCRIPTORS = __webpack_require__("9e1e");
var LIBRARY = __webpack_require__("2d00");
var $typed = __webpack_require__("0f88");
var hide = __webpack_require__("32e9");
var redefineAll = __webpack_require__("dcbc");
var fails = __webpack_require__("79e5");
var anInstance = __webpack_require__("f605");
var toInteger = __webpack_require__("4588");
var toLength = __webpack_require__("9def");
var toIndex = __webpack_require__("09fa");
var gOPN = __webpack_require__("9093").f;
var dP = __webpack_require__("86cc").f;
var arrayFill = __webpack_require__("36bd");
var setToStringTag = __webpack_require__("7f20");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "f181":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("544f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("205a8860", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f1ae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "f2ad":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("75fe");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7fd04a8c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f400":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("c26b");
var validate = __webpack_require__("b39a");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("e0b8")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "f4da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialStatsCard_vue_vue_type_style_index_0_id_430cfa9f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8df7");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialStatsCard_vue_vue_type_style_index_0_id_430cfa9f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialStatsCard_vue_vue_type_style_index_0_id_430cfa9f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaterialStatsCard_vue_vue_type_style_index_0_id_430cfa9f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f605":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "f639":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeComponent_vue_vue_type_style_index_0_id_867fe350_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f2ad");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeComponent_vue_vue_type_style_index_0_id_867fe350_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeComponent_vue_vue_type_style_index_0_id_867fe350_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeComponent_vue_vue_type_style_index_0_id_867fe350_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "f7bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardLabelProperties_vue_vue_type_style_index_0_id_4f42e0ac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a038");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardLabelProperties_vue_vue_type_style_index_0_id_4f42e0ac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardLabelProperties_vue_vue_type_style_index_0_id_4f42e0ac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardLabelProperties_vue_vue_type_style_index_0_id_4f42e0ac_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f921":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("014b");
__webpack_require__("c207");
__webpack_require__("69d3");
__webpack_require__("765d");
module.exports = __webpack_require__("584a").Symbol;


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b64toBlob", function() { return /* reexport */ b64toBlob; });
__webpack_require__.d(__webpack_exports__, "readFileAsDataUrlAsync", function() { return /* reexport */ readFileAsDataUrlAsync; });
__webpack_require__.d(__webpack_exports__, "readFileAsTextAsync", function() { return /* reexport */ readFileAsTextAsync; });
__webpack_require__.d(__webpack_exports__, "createReader", function() { return /* reexport */ createReader; });
__webpack_require__.d(__webpack_exports__, "DataProvider", function() { return /* reexport */ lib_DataProvider; });
__webpack_require__.d(__webpack_exports__, "FetchResult", function() { return /* reexport */ lib_FetchResult; });
__webpack_require__.d(__webpack_exports__, "SortOption", function() { return /* reexport */ lib_SortOption; });
__webpack_require__.d(__webpack_exports__, "DataType", function() { return /* reexport */ lib_DataType; });
__webpack_require__.d(__webpack_exports__, "SortDirection", function() { return /* reexport */ lib_SortDirection; });
__webpack_require__.d(__webpack_exports__, "Header", function() { return /* reexport */ lib_Header; });
__webpack_require__.d(__webpack_exports__, "HeaderAlignment", function() { return /* reexport */ lib_HeaderAlignment; });
__webpack_require__.d(__webpack_exports__, "IHttpService", function() { return /* reexport */ lib_IHttpService; });
__webpack_require__.d(__webpack_exports__, "ODataType", function() { return /* reexport */ odata_ODataType; });
__webpack_require__.d(__webpack_exports__, "ODataProvider", function() { return /* reexport */ odata_ODataProvider; });
__webpack_require__.d(__webpack_exports__, "ODataHeader", function() { return /* reexport */ odata_ODataHeader; });
__webpack_require__.d(__webpack_exports__, "ODataOperator", function() { return /* reexport */ odata_ODataOperator; });
__webpack_require__.d(__webpack_exports__, "ODataBoolean", function() { return /* reexport */ datatypes_ODataBoolean; });
__webpack_require__.d(__webpack_exports__, "ODataDate", function() { return /* reexport */ datatypes_ODataDate; });
__webpack_require__.d(__webpack_exports__, "ODataDateTime", function() { return /* reexport */ datatypes_ODataDateTime; });
__webpack_require__.d(__webpack_exports__, "ODataDecimal", function() { return /* reexport */ datatypes_ODataDecimal; });
__webpack_require__.d(__webpack_exports__, "ODataInteger", function() { return /* reexport */ datatypes_ODataInteger; });
__webpack_require__.d(__webpack_exports__, "ODataString", function() { return /* reexport */ datatypes_ODataString; });
__webpack_require__.d(__webpack_exports__, "ODataEnum", function() { return /* reexport */ datatypes_ODataEnum; });
__webpack_require__.d(__webpack_exports__, "ODataCustom", function() { return /* reexport */ datatypes_ODataCustom; });
__webpack_require__.d(__webpack_exports__, "ODataBooleanIs", function() { return /* reexport */ operators_ODataBooleanIs; });
__webpack_require__.d(__webpack_exports__, "ODataEquals", function() { return /* reexport */ operators_ODataEquals; });
__webpack_require__.d(__webpack_exports__, "ODataGreaterThan", function() { return /* reexport */ operators_ODataGreaterThan; });
__webpack_require__.d(__webpack_exports__, "ODataGreaterThanOrEquals", function() { return /* reexport */ operators_ODataGreaterThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "ODataLowerThan", function() { return /* reexport */ operators_ODataLowerThan; });
__webpack_require__.d(__webpack_exports__, "ODataLowerThanOrEquals", function() { return /* reexport */ operators_ODataLowerThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "ODataStringContains", function() { return /* reexport */ operators_ODataStringContains; });
__webpack_require__.d(__webpack_exports__, "ODataStringEquals", function() { return /* reexport */ ODataStringEquals; });
__webpack_require__.d(__webpack_exports__, "ODataStringNotContains", function() { return /* reexport */ operators_ODataStringNotContains; });
__webpack_require__.d(__webpack_exports__, "ODataStringNotEquals", function() { return /* reexport */ operators_ODataStringNotEquals; });
__webpack_require__.d(__webpack_exports__, "ODataStringStartsWith", function() { return /* reexport */ operators_ODataStringStartsWith; });
__webpack_require__.d(__webpack_exports__, "ODataStringEndsWith", function() { return /* reexport */ operators_ODataStringEndsWith; });
__webpack_require__.d(__webpack_exports__, "InMemoryType", function() { return /* reexport */ inmemory_InMemoryType; });
__webpack_require__.d(__webpack_exports__, "InMemoryProvider", function() { return /* reexport */ inmemory_InMemoryProvider; });
__webpack_require__.d(__webpack_exports__, "InMemoryHeader", function() { return /* reexport */ inmemory_InMemoryHeader; });
__webpack_require__.d(__webpack_exports__, "InMemoryOperator", function() { return /* reexport */ inmemory_InMemoryOperator; });
__webpack_require__.d(__webpack_exports__, "InMemoryBoolean", function() { return /* reexport */ datatypes_InMemoryBoolean; });
__webpack_require__.d(__webpack_exports__, "InMemoryDate", function() { return /* reexport */ datatypes_InMemoryDate; });
__webpack_require__.d(__webpack_exports__, "InMemoryDateTime", function() { return /* reexport */ datatypes_InMemoryDateTime; });
__webpack_require__.d(__webpack_exports__, "InMemoryDecimal", function() { return /* reexport */ datatypes_InMemoryDecimal; });
__webpack_require__.d(__webpack_exports__, "InMemoryInteger", function() { return /* reexport */ datatypes_InMemoryInteger; });
__webpack_require__.d(__webpack_exports__, "InMemoryString", function() { return /* reexport */ datatypes_InMemoryString; });
__webpack_require__.d(__webpack_exports__, "InMemoryBooleanIs", function() { return /* reexport */ operators_InMemoryBooleanIs; });
__webpack_require__.d(__webpack_exports__, "InMemoryEquals", function() { return /* reexport */ operators_InMemoryEquals; });
__webpack_require__.d(__webpack_exports__, "InMemoryGreaterThan", function() { return /* reexport */ operators_InMemoryGreaterThan; });
__webpack_require__.d(__webpack_exports__, "InMemoryGreaterThanOrEquals", function() { return /* reexport */ operators_InMemoryGreaterThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "InMemoryLowerThan", function() { return /* reexport */ operators_InMemoryLowerThan; });
__webpack_require__.d(__webpack_exports__, "InMemoryLowerThanOrEquals", function() { return /* reexport */ operators_InMemoryLowerThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "InMemoryStringContains", function() { return /* reexport */ operators_InMemoryStringContains; });
__webpack_require__.d(__webpack_exports__, "InMemoryStringNotContains", function() { return /* reexport */ operators_InMemoryStringNotContains; });
__webpack_require__.d(__webpack_exports__, "InMemoryStringStartsWith", function() { return /* reexport */ operators_InMemoryStringStartsWith; });
__webpack_require__.d(__webpack_exports__, "InMemoryStringEndsWith", function() { return /* reexport */ operators_InMemoryStringEndsWith; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsType", function() { return /* reexport */ logicalExpressions_LogicalExpressionsType; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsHeader", function() { return /* reexport */ logicalExpressions_LogicalExpressionsHeader; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsOperator", function() { return /* reexport */ logicalExpressions_LogicalExpressionsOperator; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsColumnFilter", function() { return /* reexport */ logicalExpressions_LogicalExpressionsColumnFilter; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsBoolean", function() { return /* reexport */ datatypes_LogicalExpressionsBoolean; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsNumber", function() { return /* reexport */ datatypes_LogicalExpressionsNumber; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsString", function() { return /* reexport */ datatypes_LogicalExpressionsString; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsEnum", function() { return /* reexport */ datatypes_LogicalExpressionsEnum; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDate", function() { return /* reexport */ datatypes_LogicalExpressionsDate; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsBooleanIs", function() { return /* reexport */ operators_LogicalExpressionsBooleanIs; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsEnumEquals", function() { return /* reexport */ operators_LogicalExpressionsEnumEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsEnumNotEquals", function() { return /* reexport */ operators_LogicalExpressionsEnumNotEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionEquals", function() { return /* reexport */ operators_LogicalExpressionsEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsEquals", function() { return /* reexport */ operators_LogicalExpressionsEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsNotEquals", function() { return /* reexport */ operators_LogicalExpressionsNotEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsStringEquals", function() { return /* reexport */ LogicalExpressionsStringEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsStringNotEquals", function() { return /* reexport */ LogicalExpressionsStringNotEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsGreaterThan", function() { return /* reexport */ operators_LogicalExpressionsGreaterThan; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsGreaterThanOrEquals", function() { return /* reexport */ operators_LogicalExpressionsGreaterThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsLowerThan", function() { return /* reexport */ operators_LogicalExpressionsLowerThan; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsLowerThanOrEquals", function() { return /* reexport */ operators_LogicalExpressionsLowerThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateGreaterThan", function() { return /* reexport */ operators_LogicalExpressionsDateGreaterThan; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateGreaterThanOrEquals", function() { return /* reexport */ operators_LogicalExpressionsDateGreaterThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateLowerThan", function() { return /* reexport */ operators_LogicalExpressionsDateLowerThan; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateLowerThanOrEquals", function() { return /* reexport */ operators_LogicalExpressionsLowerThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateExists", function() { return /* reexport */ operators_LogicalExpressionsDateExists; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateNotExists", function() { return /* reexport */ operators_LogicalExpressionsDateNotExists; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateEquals", function() { return /* reexport */ operators_LogicalExpressionsDateEquals; });
__webpack_require__.d(__webpack_exports__, "LogicalExpressionsDateNotEquals", function() { return /* reexport */ operators_LogicalExpressionsDateNotEquals; });
__webpack_require__.d(__webpack_exports__, "RedmineType", function() { return /* reexport */ redmine_RedmineType; });
__webpack_require__.d(__webpack_exports__, "RedmineProvider", function() { return /* reexport */ redmine_RedmineProvider; });
__webpack_require__.d(__webpack_exports__, "RedmineHeader", function() { return /* reexport */ redmine_RedmineHeader; });
__webpack_require__.d(__webpack_exports__, "RedmineOperator", function() { return /* reexport */ redmine_RedmineOperator; });
__webpack_require__.d(__webpack_exports__, "RedmineBoolean", function() { return /* reexport */ datatypes_RedmineBoolean; });
__webpack_require__.d(__webpack_exports__, "RedmineDate", function() { return /* reexport */ datatypes_RedmineDate; });
__webpack_require__.d(__webpack_exports__, "RedmineDateTime", function() { return /* reexport */ datatypes_RedmineDateTime; });
__webpack_require__.d(__webpack_exports__, "RedmineDecimal", function() { return /* reexport */ datatypes_RedmineDecimal; });
__webpack_require__.d(__webpack_exports__, "RedmineInteger", function() { return /* reexport */ datatypes_RedmineInteger; });
__webpack_require__.d(__webpack_exports__, "RedmineString", function() { return /* reexport */ datatypes_RedmineString; });
__webpack_require__.d(__webpack_exports__, "RedmineEnum", function() { return /* reexport */ datatypes_RedmineEnum; });
__webpack_require__.d(__webpack_exports__, "RedmineBooleanIs", function() { return /* reexport */ operators_RedmineBooleanIs; });
__webpack_require__.d(__webpack_exports__, "RedmineEquals", function() { return /* reexport */ RedmineEquals; });
__webpack_require__.d(__webpack_exports__, "RedmineGreaterThan", function() { return /* reexport */ RedmineGreaterThan; });
__webpack_require__.d(__webpack_exports__, "RedmineGreaterThanOrEquals", function() { return /* reexport */ RedmineGreaterThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "RedmineLowerThan", function() { return /* reexport */ RedmineLowerThan; });
__webpack_require__.d(__webpack_exports__, "RedmineLowerThanOrEquals", function() { return /* reexport */ RedmineLowerThanOrEquals; });
__webpack_require__.d(__webpack_exports__, "RedmineStringContains", function() { return /* reexport */ operators_RedmineStringContains; });
__webpack_require__.d(__webpack_exports__, "RedmineStringNotContains", function() { return /* reexport */ operators_RedmineStringNotContains; });
__webpack_require__.d(__webpack_exports__, "IDataExporter", function() { return /* reexport */ IDataExporter_default.a; });
__webpack_require__.d(__webpack_exports__, "Downloader", function() { return /* reexport */ lib_Downloader; });
__webpack_require__.d(__webpack_exports__, "CsvExporter", function() { return /* reexport */ exporters_CsvExporter; });
__webpack_require__.d(__webpack_exports__, "CsvWithHistoryExporter", function() { return /* reexport */ exporters_CsvWithHistoryExporter; });
__webpack_require__.d(__webpack_exports__, "DataToExcelConverter", function() { return /* reexport */ exporters_DataToExcelConverter; });
__webpack_require__.d(__webpack_exports__, "ExcelExporter", function() { return /* reexport */ exporters_ExcelExporter; });
__webpack_require__.d(__webpack_exports__, "ExcelWithHistoryExporter", function() { return /* reexport */ exporters_ExcelWithHistoryExporter; });
__webpack_require__.d(__webpack_exports__, "DirectExcelExporter", function() { return /* reexport */ exporters_DirectExcelExporter; });
__webpack_require__.d(__webpack_exports__, "DirectExcelWithHistoryExporter", function() { return /* reexport */ DirectExcelWithHistoryExporter; });
__webpack_require__.d(__webpack_exports__, "CodeFunction", function() { return /* reexport */ CodeFunction; });
__webpack_require__.d(__webpack_exports__, "CodeArgument", function() { return /* reexport */ CodeArgument; });
__webpack_require__.d(__webpack_exports__, "CardTemplate", function() { return /* reexport */ CardTemplate_CardTemplate; });
__webpack_require__.d(__webpack_exports__, "CardLabel", function() { return /* reexport */ CardTemplate_CardLabel; });
__webpack_require__.d(__webpack_exports__, "CardImage", function() { return /* reexport */ CardTemplate_CardImage; });
__webpack_require__.d(__webpack_exports__, "Rect", function() { return /* reexport */ Rect; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasDataTable.vue?vue&type=template&id=9e5fd4a8&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataProvider !== null && _vm.dataProvider !== undefined)?_c('div',{ref:"container",staticClass:"pbas-data-table-container",style:({
    '--max-height': _vm.maxHeight !== undefined ? _vm.maxHeight + 'px' : 'auto',
  })},[(_vm.exporters.length > 0)?_c('v-dialog',{ref:"exportDialog",attrs:{"persistent":"","max-width":"360"},model:{value:(_vm.exportDialog),callback:function ($$v) {_vm.exportDialog=$$v},expression:"exportDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.export_options"))+"\n      ")]),_c('v-card-text',[_c('p',[_vm._v("\n          "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.please_choose_export_format"))+"\n        ")]),_c('v-radio-group',{model:{value:(_vm.selectedExporter),callback:function ($$v) {_vm.selectedExporter=$$v},expression:"selectedExporter"}},_vm._l((_vm.exporters),function(exporter){return _c('v-radio',{key:exporter.label,attrs:{"label":exporter.label,"value":exporter},on:{"change":function($event){return _vm.onExporterChange(exporter)}}})}),1),(_vm.selectedExporter)?_c('div',[_c('p',[_vm._v("\n            "+_vm._s(_vm.trans(
                "pbascomponents.pbasdatatable.please_choose_what_to_export"
              ))+"\n          ")]),_c('v-radio-group',{attrs:{"disabled":_vm.exporting},model:{value:(_vm.selectedExporterFunction),callback:function ($$v) {_vm.selectedExporterFunction=$$v},expression:"selectedExporterFunction"}},_vm._l((this.exporterOperations),function(func){return _c('v-radio',{key:func,attrs:{"label":_vm.trans(func),"value":func}})}),1)],1):_vm._e()],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.exportDialog = false}}},[_vm._v("\n          "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.cancel"))+"\n        ")]),_c('v-btn',{ref:"exportButton",attrs:{"text":"","color":"primary","loading":_vm.exporting,"disabled":_vm.selectedExporter == null || _vm.selectedExporterFunction === ''},on:{"click":_vm.exportData}},[_vm._v("\n          "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.download"))+"\n        ")])],1)],1)],1):_vm._e(),_c('v-dialog',{attrs:{"scrollable":"","max-width":"800"},model:{value:(_vm.showFiltersDialog),callback:function ($$v) {_vm.showFiltersDialog=$$v},expression:"showFiltersDialog"}},[_c('pbas-column-filters',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFiltersDialog),expression:"showFiltersDialog"}],ref:"filtersControl",attrs:{"dataProvider":_vm.dataProvider,"settingsFilters":_vm.settingsFilters},on:{"apply":function($event){return _vm.onFiltersChanged($event)},"close":function($event){_vm.showFiltersDialog = false}}})],1),(_vm.dataProvider !== undefined && _vm.canCustomize)?_c('pbas-customize-columns',{attrs:{"show":_vm.showCustomizeColumns,"headers":_vm.dataProvider.headers},on:{"save":function($event){return _vm.updateHeaders($event)},"close":function($event){_vm.showCustomizeColumns = false}}}):_vm._e(),_c('vue-context',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.rowActions != null &&
        _vm.rowActions.length > 0 &&
        _vm.visibleRowActions.length > 0
    ),expression:"\n      rowActions != null &&\n        rowActions.length > 0 &&\n        visibleRowActions.length > 0\n    "}],ref:"menu"},_vm._l((_vm.getActionsFor(_vm.contextMenuSelectedItem)),function(action){return _c('li',{key:action.name},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();action.handler(_vm.contextMenuSelectedItem);
          _vm.contextMenuOpened = false;}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n        "+_vm._s(_vm.trans(action.title))+"\n      ")],1)])}),0),(_vm.dataProvider && _vm.optionsValue)?_c('v-data-table',{attrs:{"mobile-breakpoint":"0","headers":_vm.dataProvider !== undefined
        ? _vm.dataProvider.headers.filter(function (h) { return h.visible; })
        : [],"loading":_vm.loading,"items":_vm.fetchResult.items,"footer-props":_vm.footerProps,"server-items-length":_vm.fetchResult.count,"options":_vm.optionsValue,"fixed-header":false,"search":_vm.search,"show-expand":_vm.showExpand,"show-select":_vm.showSelect,"sort-by":_vm.sortByInternal,"sort-desc":_vm.sortDescendingLoc,"item-key":_vm.dataProvider.headers.some(function (h) { return h.isIdentifier; })
        ? _vm.dataProvider.headers.find(function (h) { return h.isIdentifier; }).type.key
        : ''},on:{"update:options":function($event){_vm.optionsValue=$event},"update:sortBy":function($event){_vm.sortByInternal=$event},"update:sort-by":function($event){_vm.sortByInternal=$event},"update:sortDesc":function($event){_vm.sortDescendingLoc=$event},"update:sort-desc":function($event){_vm.sortDescendingLoc=$event}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"justify-center align-self-center text-center",attrs:{"cols":"12","xs":"12","md":"auto"}},[_vm._t("top"),(_vm.exporters.length > 0 && _vm.floatExport)?_c('v-btn',{staticStyle:{"margin-right":"5px"},attrs:{"dark":"","color":"#00a8d7"},on:{"click":_vm.showExportDialog}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("file_download")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.download"))+"\n            ")],1):_vm._e(),_vm._l((_vm.visibleFloatActions),function(action){return [(
                  action.actions !== null &&
                    action.actions !== undefined &&
                    action.actions.length > 0
                )?_c('v-menu',{key:action.name,scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":action.color,"dark":""}},on),[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n                    "+_vm._s(_vm.trans(action.text))+"\n                  ")],1)]}}],null,true)},[_c('v-list',_vm._l((action.actions),function(subAction){return _c('v-list-item',{key:subAction.name,on:{"click":function($event){return subAction.handler(_vm.selected)}}},[_c('v-list-item-title',[_vm._v("\n                      "+_vm._s(_vm.trans(subAction.text))+"\n                    ")])],1)}),1)],1):_c('v-btn',{key:action.name,ref:("floatAction" + (action.name)),refInFor:true,staticStyle:{"margin-right":"5px"},attrs:{"dark":"","color":action.color},on:{"click":action.handler}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n                "+_vm._s(_vm.trans(action.text))+"\n              ")],1)]})],2),(
              _vm.selected.length > 0 &&
                (_vm.selectActions.length > 0 || _vm.selectActionsList.length > 0)
            )?_c('v-col',{staticClass:"justify-center align-self-center",attrs:{"cols":"12","xs":"12","md":"auto"}},[_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"#a8a2a2","dark":""}},on),[_c('v-icon',{attrs:{"x-small":""}},[_vm._v("check")]),_vm._v("\n                  "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.selection"))+"\n                ")],1)]}}],null,false,622691564)},[_c('v-list',_vm._l((_vm.selectActions.concat(_vm.selectActionsList)),function(action){return _c('v-list-item',{key:action.name,on:{"click":function($event){return action.handler(_vm.selected)}}},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n                    "+_vm._s(_vm.trans(action.title))+"\n                  ")],1)],1)}),1)],1)],1):_vm._e(),_c('v-col',{staticStyle:{"padding-top":"0px","padding-bottom":"0px"}}),(_vm.noSearch !== true)?_c('v-col',{staticClass:"justify-center align-self-center",attrs:{"cols":"6","xs":"6","md":"auto"}},[(
                _vm.searchable ||
                  (_vm.dataProvider !== undefined &&
                    _vm.dataProvider.headers.any(function (h) { return h.visible && _vm.searchable; }))
              )?_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.trans('pbascomponents.pbasdatatable.search'),"single-line":"","hide-details":""},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}):_vm._e()],1):_vm._e(),(_vm.noActions !== true && _vm.noFilters !== true)?_c('v-col',{staticClass:"justify-center align-self-center",attrs:{"cols":"auto","xs":"auto","md":"auto"}},[_c('v-btn',{on:{"click":function($event){_vm.showFiltersDialog = true}}},[_c('v-icon',[_vm._v("layers")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.add_filters"))+"\n            ")],1)],1):_vm._e(),(_vm.filtersApplied)?_c('v-col',{staticClass:"justify-center align-self-center",attrs:{"cols":"auto","xs":"auto","md":"auto"}},[_c('v-btn',{attrs:{"color":"#F44336","dark":""},on:{"click":_vm.deactivateFilters}},[_c('v-icon',[_vm._v("layers_clear")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.clear_filters"))+"\n            ")],1)],1):_vm._e(),(
              _vm.noActions !== true ||
                (_vm.noActions === true && _vm.exportDataSwitch === true)
            )?_c('v-col',{staticClass:"justify-center align-self-center text-center",attrs:{"cols":"auto","xs":"auto","md":"auto"}},[(
                (((_vm.exporters.length > 0 && !_vm.floatExport) ||
                  _vm.tableActions.length > 0) &&
                  _vm.canCustomize !== false) ||
                  (_vm.canCustomize === false &&
                    _vm.tableActions.length > 0 &&
                    (_vm.exporters.length > 0 && !_vm.floatExport))
              )?_c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":_vm.actionsColor,"dark":""}},on),[_c('v-icon',[_vm._v("more_vert")]),_vm._v("\n                  "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.actions"))+"\n                ")],1)]}}],null,false,960087156)},[_c('v-list',[(_vm.canCustomize !== false)?_c('v-list-item',{on:{"click":function($event){_vm.showCustomizeColumns = true}}},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("view_column")]),_vm._v("\n                    "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.customize_columns"))+"\n                  ")],1)],1):_vm._e(),(_vm.exporters.length > 0 && !_vm.floatExport)?_c('v-list-item',{on:{"click":_vm.showExportDialog}},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("file_download")]),_vm._v("\n                    "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.download"))+"\n                  ")],1)],1):_vm._e(),_vm._l((_vm.tableActions),function(action){return _c('v-list-item',{key:action.name,on:{"click":function($event){return action.handler()}}},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("\n                      "+_vm._s(action.icon)+"\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.trans(action.title))+"\n                  ")],1)],1)})],2)],1):(
                _vm.canCustomize !== false &&
                  _vm.tableActions.length === 0 &&
                  (_vm.exporters.length === 0 || _vm.floatExport)
              )?_c('v-btn',{attrs:{"color":_vm.actionsColor,"dark":""},on:{"click":function($event){_vm.showCustomizeColumns = true}}},[_c('v-icon',[_vm._v("view_column")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.customize_columns"))+"\n            ")],1):(
                _vm.canCustomize === false &&
                  _vm.tableActions.length === 0 &&
                  (_vm.exporters.length > 0 && !_vm.floatExport)
              )?_c('v-btn',{attrs:{"color":_vm.actionsColor,"dark":""},on:{"click":function($event){_vm.showCustomizeColumns = true}}},[_c('v-icon',[_vm._v("file_download")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbasdatatable.download"))+"\n            ")],1):_vm._e()],1):_vm._e()],1)],1),_c('div',{ref:"horizontalScroll",staticStyle:{"overflow-x":"auto"}},[_c('div',{ref:"horizontalScrollContent",staticStyle:{"width":"1px","height":"1px"}})])]},proxy:true},_vm._l((_vm.dataProvider.headers),function(header){return {key:_vm.headerSlotFunc(header),fn:function(ref){
              var header = ref.header;
return [_c('div',{key:header.value,staticStyle:{"display":"inline-block"}},[_c('span',[_vm._v(_vm._s(_vm.trans(header.title)))])])]}}}),_vm._l((_vm.dataProvider.headers.filter(function (h) { return h.visible; })),function(header,index){return {key:_vm.itemSlotFunc(header),fn:function(ref){
              var header = ref.header;
              var item = ref.item;
return [_c('div',{key:header.type.key,style:('justify-content: ' +
            (header.align != 'center' ? 'flex-' + header.align : 'center')),on:{"contextmenu":function($event){$event.preventDefault();_vm.contextMenuSelectedItem = item;
          _vm.contextMenuOpened = true;
          if (_vm.$refs.menu != null) { _vm.$refs.menu.open($event); }}}},[(
            index === 0 && _vm.getActionsFor(item).length === 1 && !_vm.showActionsBtn
          )?_c('v-btn',{attrs:{"small":"","text":""},on:{"click":function($event){$event.preventDefault();_vm.getActionsFor(item)[0].handler(item)}}},[_c('v-icon',[_vm._v("\n            "+_vm._s(_vm.getActionsFor(item)[0].icon)+"\n          ")]),_vm._v("\n          "+_vm._s(_vm.trans(_vm.getActionsFor(item)[0].title))+"\n        ")],1):(
            (index === 0 && _vm.getActionsFor(item).length > 0) ||
              (index === 0 &&
                _vm.getActionsFor(item).length === 1 &&
                _vm.showActionsBtn)
          )?_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticStyle:{"margin-right":"10px"},attrs:{"small":"","text":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("\n                list\n              ")])],1)]}}],null,true)},[_c('v-list',_vm._l((_vm.getActionsFor(item)),function(action){return _c('v-list-item',{key:action.name,on:{"click":function($event){$event.preventDefault();return action.handler(item)}}},[_c('v-list-item-icon',{staticStyle:{"margin-right":"10px"}},[_c('v-icon',[_vm._v(_vm._s(action.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.trans(action.title)))])],1)}),1)],1):_vm._e(),(header.type.getHtml !== undefined)?_c('div',{domProps:{"innerHTML":_vm._s(header.type.getHtml(item, header.type))}}):(header.type.getComponent !== undefined)?_c('div',[_c(header.type.getComponent(item, header),{tag:"component",attrs:{"data":{ item: item, header: header }}})],1):_c('span',[_vm._v(_vm._s(header.type.getString(item, header.type)))])],1)]}}}),{key:"item.data-table-expand",fn:function(ref){
          var item = ref.item;
          var isExpanded = ref.isExpanded;
          var expand = ref.expand;
return [(_vm.canExpand !== undefined && _vm.canExpand(item))?_c('v-icon',{class:[
          isExpanded
            ? 'v-data-table__expand-icon--active'
            : 'v-data-table__expand-icon' ],staticStyle:{"margin-left":"10px"},attrs:{"role":"button"},on:{"click":function($event){return expand(!isExpanded)}}},[_vm._v("\n        arrow_drop_down\n      ")]):_vm._e()]}},{key:"expanded-item",fn:function(ref){
        var item = ref.item;
        var headers = ref.headers;
return [_c('td',{attrs:{"colspan":_vm.dataProvider.headers.length + 2}},[_c('pbas-data-table',{ref:"inlineTable",staticClass:"hide-selects",attrs:{"canCustomize":false,"identifier":'inline' + _vm.identifier,"headersZIndex":2,"dataProvider":_vm.generateProviderForExpanded(item),"showSelect":_vm.showSelect,"matchColumns":true,"showExpand":true,"sortBy":_vm.expandedSortBy,"sortDescending":_vm.expandedSortDescending,"rowActions":_vm.expandedRowActions,"floatActions":_vm.expandedFloatActions(item)},on:{"error":function($event){return _vm.$emit('error', $event)},"itemsChanged":function($event){return _vm.onExpandedItemsChanged({ items: $event, parent: item })}}})],1)]}},_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(scope){return [_vm._t(name,null,null,scope)]}}})],null,true),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[(_vm.visibleBodyActionsFunc().length > 0)?_c('template',{slot:"body.append"},[_c('tr',[_c('th',{staticClass:"text-left",attrs:{"colspan":12}},_vm._l((_vm.visibleBodyActionsFunc()),function(action){return _c('v-btn',{key:action.name,staticStyle:{"margin-right":"5px"},attrs:{"dark":"","color":action.color},on:{"click":action.handler}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n            "+_vm._s(_vm.trans(action.text))+"\n          ")],1)}),1)])]):_vm._e()],2):_vm._e(),_c('div',{ref:"headersContainer",style:({
      position: 'fixed',
      top: '0',
      background: 'white',
      width: '100%',
      visibility: 'hidden',
      'overflow-x': 'auto',
      'z-index': _vm.headersZIndex,
    })},[_c('table',{ref:"headers",staticClass:"v-data-table",staticStyle:{"border-spacing":"0"}})])],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/PbasDataTable.vue?vue&type=template&id=9e5fd4a8&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__("386d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("551c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasColumnFilters.vue?vue&type=template&id=201afedd&scoped=true&
var PbasColumnFiltersvue_type_template_id_201afedd_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataProvider)?_c('material-card',{attrs:{"icon":"layers","title":_vm.trans('pbascomponents.pbascolumnfilters.title')}},[_c('v-card-text',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},_vm._l((_vm.filters),function(filter,index){return _c('v-row',{key:index},[_c('v-col',{staticClass:"col-lg-3 col-12 justify-center align-self-center"},[_c('v-checkbox',{attrs:{"label":_vm.trans(_vm.filterHeaders.get(filter).title)},model:{value:(filter.active),callback:function ($$v) {_vm.$set(filter, "active", $$v)},expression:"filter.active"}})],1),_c('v-col',{staticClass:"col-lg-2 col-12 justify-center align-self-center"},[_c('v-select',{attrs:{"items":filter.type.operators,"hint":("" + (filter.operator ? _vm.trans(filter.operator.text) : '')),"return-object":true,"required":"","item-text":"symbol","rules":filter.operator.operatorRules},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.symbol)+" "+_vm._s(_vm.trans(data.item.text))+"\n              ")]}}],null,true),model:{value:(filter.operator),callback:function ($$v) {_vm.$set(filter, "operator", $$v)},expression:"filter.operator"}})],1),_c('v-col',{staticClass:"col-lg-4 col-12 justify-center align-self-center"},[(filter.operator && filter.operator.values.length > 0)?_c('v-select',{attrs:{"items":filter.operator.values,"rules":filter.operator.valueRules,"label":"Value"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                "+_vm._s(_vm.trans(data.item))+"\n              ")]}},{key:"item",fn:function(data){return [_vm._v("\n                "+_vm._s(_vm.trans(data.item))+"\n              ")]}}],null,true),model:{value:(filter.value),callback:function ($$v) {_vm.$set(filter, "value", $$v)},expression:"filter.value"}}):_c('keep-alive',[_c(filter.type.getEditableComponent(filter, filter.type),{tag:"component",attrs:{"data":filter}})],1)],1),_c('v-col',{staticClass:"col-auto justify-center align-self-center"},[_c('v-btn',{attrs:{"color":"#6b6a75","depressed":"","small":"","dark":""},on:{"click":function($event){return _vm.remove(filter)}}},[_c('v-icon',[_vm._v("clear")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.remove"))+"\n            ")],1)],1)],1)}),1),_c('v-icon',[_vm._v("add")]),_c('v-select',{ref:"selectedCombo",staticStyle:{"margin-left":"10px","margin-right":"10px","display":"inline-block","min-width":"120px"},attrs:{"items":_vm.selectedColumns(),"return-object":true,"label":_vm.trans('pbascomponents.pbascolumnfilters.add_filter'),"item-value":"title"},on:{"input":_vm.onSelectedColumnChanged},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(_vm.trans(data.item.title))+"\n        ")]}},{key:"item",fn:function(data){return [_c('v-list-item-content',{domProps:{"textContent":_vm._s(_vm.trans(data.item.title))}})]}}],null,false,817074428),model:{value:(_vm.selectedColumn),callback:function ($$v) {_vm.selectedColumn=$$v},expression:"selectedColumn"}})],1)],1),_c('v-card-actions',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v("\n      "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.close"))+"\n    ")]),(this.filters.length > 0)?_c('v-btn',{attrs:{"color":"","text":""},on:{"click":_vm.clear}},[_vm._v("\n      "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.clear"))+"\n    ")]):_vm._e(),(_vm.isValid())?_c('v-btn',{attrs:{"color":"primary","text":"","loading":_vm.loading},on:{"click":_vm.apply}},[_vm._v("\n      "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.apply"))+"\n    ")]):_vm._e()],1)],1):_vm._e()}
var PbasColumnFiltersvue_type_template_id_201afedd_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/PbasColumnFilters.vue?vue&type=template&id=201afedd&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__("f400");

// EXTERNAL MODULE: ./node_modules/vue-class-component/dist/vue-class-component.common.js
var vue_class_component_common = __webpack_require__("65d9");
var vue_class_component_common_default = /*#__PURE__*/__webpack_require__.n(vue_class_component_common);

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.1.0 MIT LICENSE copyright 2018 kaorun343 */
/// <reference types='reflect-metadata'/>




/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return Object(vue_class_component_common["createDecorator"])(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return Object(vue_class_component_common["createDecorator"])(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) && typeof options !== 'function' && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component_common["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        Object(vue_class_component_common["createDecorator"])(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return Object(vue_class_component_common["createDecorator"])(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasDatePicker.vue?vue&type=template&id=018e8802&scoped=true&
var PbasDatePickervue_type_template_id_018e8802_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","min-width":"290px","max-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('####-##-##'),expression:"'####-##-##'"}],ref:"textfield",attrs:{"dense":_vm.dense,"autocomplete":"off","label":_vm.label,"rules":_vm.rules,"disabled":_vm.disabled,"append-icon":"calendar_today"},on:{"blur":function($event){return _vm.blur()}},nativeOn:{"keyup":function($event){return _vm.save($event.target.value)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('div',{staticStyle:{"cursor":"pointer"},attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.menu = !_vm.menu}}},[_c('v-icon',[_vm._v("calendar_today")])],1),(_vm.clearable)?_c('div',{staticClass:"date-picker-clear-btn",on:{"click":_vm.clear}},[_vm._v("\n            X\n          ")]):_vm._e()]},proxy:true}],null,true),model:{value:(_vm.inputVModel),callback:function ($$v) {_vm.inputVModel=$$v},expression:"inputVModel"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","allowed-dates":_vm.allowedDates},model:{value:(_vm.pickerDate),callback:function ($$v) {_vm.pickerDate=$$v},expression:"pickerDate"}},[_c('div',{staticClass:"flex-grow-1"}),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.pbasdatepicker.cancel"))+"\n      ")])],1)],1)],1)}
var PbasDatePickervue_type_template_id_018e8802_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/PbasDatePicker.vue?vue&type=template&id=018e8802&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.constructor.js
var es6_regexp_constructor = __webpack_require__("3b2b");

// EXTERNAL MODULE: external "vuetify/lib"
var lib_ = __webpack_require__("4875");

// EXTERNAL MODULE: external "vue-the-mask"
var external_vue_the_mask_ = __webpack_require__("a7b5");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasDatePicker.vue?vue&type=script&lang=ts&







var PbasDatePickervue_type_script_lang_ts_PbasDatePicker =
/** @class */
function (_super) {
  __extends(PbasDatePicker, _super);

  function PbasDatePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.pickerDate = "";
    _this.menu = false;
    _this.inputVModel = "";
    return _this;
  }

  PbasDatePicker.prototype.created = function () {
    // console.log("created");
    this.updateValue();
  };

  PbasDatePicker.prototype.updateValue = function () {
    // console.log("updateValue: ", this.value);
    this.formattedValue = this.formatValue(this.value);
    this.$emit("update-date", this.formattedValue);
    this.$emit("update:value", this.formattedValue);
    var displ = this.displayValue(this.value);

    if (displ !== "") {
      this.inputVModel = this.pickerDate = this.displayValue(this.value);
    } else {
      this.inputVModel = "";
      this.pickerDate = "";
    }
  };

  PbasDatePicker.prototype.onPickerDateChanged = function () {
    // console.log("onPickerDateChanged");
    this.save(this.pickerDate);
  };

  PbasDatePicker.prototype.onValueChanged = function () {
    // console.log("value: ", this.value);
    this.updateValue();
  };

  PbasDatePicker.prototype.formatValue = function (dateString) {
    // console.log("formatValue: ", dateString);
    if (dateString === undefined || dateString === null || dateString === "") {
      return undefined;
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day + "T00:00:00.000Z";
  };

  PbasDatePicker.prototype.displayValue = function (dateString) {
    // console.log("displayValue: ", dateString);
    if (dateString === undefined || dateString === null || dateString === "") {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  PbasDatePicker.prototype.blur = function () {
    // console.log("blur");
    this.inputVModel = this.pickerDate = this.displayValue(this.formattedValue);
  };

  PbasDatePicker.prototype.isDate = function (val) {
    // console.log("isDate: ", val);
    if (new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(val)) {
      return !isNaN(Date.parse(val));
    }

    return false;
  };

  PbasDatePicker.prototype.save = function (dateString) {
    // console.log("save: ", dateString);
    if (!this.isDate(dateString)) {
      // console.log("not date string");
      blur();
      return;
    }

    if (this.allowedDates !== undefined && !this.allowedDates(this.displayValue(dateString))) {
      // console.log("not allowed date");
      blur();
      return;
    }

    this.formattedValue = this.formatValue(dateString);
    this.inputVModel = this.pickerDate = this.displayValue(dateString); // console.log("inputVModel: ", this.inputVModel);

    this.$emit("update-date", this.formattedValue);
    this.$emit("update:value", this.formattedValue);
    this.menu = false;
    var textfield = this.$refs.textfield;

    if (textfield !== null && textfield !== undefined) {
      textfield.focus();
    }
  };

  PbasDatePicker.prototype.clear = function () {
    // console.log("clear");
    this.formattedValue = "";
    this.inputVModel = this.pickerDate = "";
    this.$emit("update-date", this.formattedValue);
    this.$emit("update:value", this.formattedValue);
  };

  PbasDatePicker.prototype.trans = function (key) {
    // console.log("trans: ", key);
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  var _a;

  __decorate([Prop(), __metadata("design:type", Boolean)], PbasDatePicker.prototype, "dense", void 0);

  __decorate([Prop(), __metadata("design:type", String)], PbasDatePicker.prototype, "value", void 0);

  __decorate([Prop(), __metadata("design:type", String)], PbasDatePicker.prototype, "label", void 0);

  __decorate([Prop(), __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)], PbasDatePicker.prototype, "rules", void 0);

  __decorate([Prop(), __metadata("design:type", Boolean)], PbasDatePicker.prototype, "disabled", void 0);

  __decorate([Prop(), __metadata("design:type", Function)], PbasDatePicker.prototype, "allowedDates", void 0);

  __decorate([Prop(), __metadata("design:type", Boolean)], PbasDatePicker.prototype, "clearable", void 0);

  __decorate([Watch("pickerDate"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasDatePicker.prototype, "onPickerDateChanged", null);

  __decorate([Watch("value"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasDatePicker.prototype, "onValueChanged", null);

  PbasDatePicker = __decorate([vue_class_component_common_default()({
    components: {
      VDatePicker: lib_["VDatePicker"],
      VTextField: lib_["VTextField"],
      VBtn: lib_["VBtn"],
      VMenu: lib_["VMenu"]
    },
    directives: {
      mask: external_vue_the_mask_["mask"]
    }
  })], PbasDatePicker);
  return PbasDatePicker;
}(external_vue_default.a);

/* harmony default export */ var PbasDatePickervue_type_script_lang_ts_ = (PbasDatePickervue_type_script_lang_ts_PbasDatePicker);
// CONCATENATED MODULE: ./src/lib/components/PbasDatePicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PbasDatePickervue_type_script_lang_ts_ = (PbasDatePickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/PbasDatePicker.vue?vue&type=style&index=0&id=018e8802&scoped=true&lang=css&
var PbasDatePickervue_type_style_index_0_id_018e8802_scoped_true_lang_css_ = __webpack_require__("6e1d");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/lib/components/PbasDatePicker.vue






/* normalize component */

var component = normalizeComponent(
  components_PbasDatePickervue_type_script_lang_ts_,
  PbasDatePickervue_type_template_id_018e8802_scoped_true_render,
  PbasDatePickervue_type_template_id_018e8802_scoped_true_staticRenderFns,
  false,
  null,
  "018e8802",
  null
  
)

/* harmony default export */ var components_PbasDatePicker = (component.exports);
// CONCATENATED MODULE: ./src/lib/DataProvider.ts
var DataProvider =
/** @class */
function () {
  function DataProvider() {}

  return DataProvider;
}();

/* harmony default export */ var lib_DataProvider = (DataProvider);
// CONCATENATED MODULE: ./src/lib/HeaderAlignment.ts
var HeaderAlignment;

(function (HeaderAlignment) {
  HeaderAlignment["Auto"] = "AUTO";
  HeaderAlignment["Left"] = "LEFT";
  HeaderAlignment["Right"] = "RIGHT";
  HeaderAlignment["Center"] = "CENTER";
})(HeaderAlignment || (HeaderAlignment = {}));

/* harmony default export */ var lib_HeaderAlignment = (HeaderAlignment);
// CONCATENATED MODULE: ./src/lib/ColumnFilter.ts



var ColumnFilter =
/** @class */
function () {
  function ColumnFilter(type) {
    this.type = type;
    this.active = true;
    this.operator = this.type.operators[0];

    if (this.operator.values.length > 0) {
      this.value = this.operator.values[0];
    } else {
      this.value = "";
    }
  }

  return ColumnFilter;
}();

/* harmony default export */ var lib_ColumnFilter = (ColumnFilter);
// CONCATENATED MODULE: ./src/lib/Header.ts



var Header_Header =
/** @class */
function () {
  function Header(args) {
    this.isIdentifier = false;
    this.visible = true;
    this.allowVisibilityChange = true;
    this.sortable = true;
    this.searchable = true;
    this.title = args.title;
    this.type = args.type;
    this.isIdentifier = args.isIdentifier;
    this.allowVisibilityChange = args.allowVisibilityChange === undefined ? true : args.allowVisibilityChange;
    this.visible = args.visible === undefined ? true : args.visible;
    this.sortable = args.sortable === undefined ? true : args.sortable;
    this.searchable = args.searchable === undefined ? true : args.searchable;
    this.version = args.version;
  }

  Object.defineProperty(Header.prototype, "value", {
    get: function get() {
      return this.type.key;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Header.prototype, "text", {
    get: function get() {
      return this.title;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Header.prototype, "align", {
    get: function get() {
      switch (this.type.alignment) {
        case lib_HeaderAlignment.Left:
          return "start";

        case lib_HeaderAlignment.Center:
          return "center";

        default:
          return "end";
      }
    },
    enumerable: true,
    configurable: true
  });

  Header.prototype.createColumnFilter = function () {
    return new lib_ColumnFilter(this.type);
  };

  return Header;
}();

/* harmony default export */ var lib_Header = (Header_Header);
// CONCATENATED MODULE: ./src/lib/odata/ODataHeader.ts



var ODataHeader_ODataHeader =
/** @class */
function (_super) {
  __extends(ODataHeader, _super);

  function ODataHeader(args) {
    var _this = _super.call(this, {
      title: args.title,
      type: args.type,
      isIdentifier: args.isIdentifier !== undefined ? args.isIdentifier : false,
      allowVisibilityChange: args.allowVisibilityChange !== undefined ? args.allowVisibilityChange : true,
      visible: args.visible,
      sortable: args.sortable,
      searchable: args.searchable,
      version: args.version
    }) || this;

    _this.alwaysInclude = false;
    _this.orderByKey = undefined;
    _this.alwaysInclude = args.alwaysInclude === true;
    _this.subHeaders = args.subHeaders !== undefined ? args.subHeaders : [];
    _this.type = args.type;
    _this.orderByKey = args.orderByKey;
    return _this;
  }

  return ODataHeader;
}(lib_Header);

/* harmony default export */ var odata_ODataHeader = (ODataHeader_ODataHeader);
// CONCATENATED MODULE: ./src/lib/inmemory/InMemoryHeader.ts



var InMemoryHeader_InMemoryHeader =
/** @class */
function (_super) {
  __extends(InMemoryHeader, _super);

  function InMemoryHeader(args) {
    var _this = _super.call(this, {
      title: args.title,
      type: args.type,
      isIdentifier: args.isIdentifier !== undefined ? args.isIdentifier : false,
      allowVisibilityChange: args.allowVisibilityChange !== undefined ? args.allowVisibilityChange : true,
      visible: args.visible,
      sortable: args.sortable,
      searchable: args.searchable
    }) || this;

    _this.subHeaders = args.subHeaders !== undefined ? args.subHeaders : [];
    _this.type = args.type;
    return _this;
  }

  return InMemoryHeader;
}(lib_Header);

/* harmony default export */ var inmemory_InMemoryHeader = (InMemoryHeader_InMemoryHeader);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/LogicalExpressionsHeader.ts



var LogicalExpressionsHeader_LogicalExpressionsHeader =
/** @class */
function (_super) {
  __extends(LogicalExpressionsHeader, _super);

  function LogicalExpressionsHeader(args) {
    var _this = _super.call(this, {
      title: args.title,
      type: args.type,
      isIdentifier: false,
      allowVisibilityChange: true,
      visible: true,
      sortable: true,
      searchable: true
    }) || this;

    _this.type = args.type;
    return _this;
  }

  return LogicalExpressionsHeader;
}(lib_Header);

/* harmony default export */ var logicalExpressions_LogicalExpressionsHeader = (LogicalExpressionsHeader_LogicalExpressionsHeader);
// CONCATENATED MODULE: ./src/lib/redmine/RedmineHeader.ts



var RedmineHeader_RedmineHeader =
/** @class */
function (_super) {
  __extends(RedmineHeader, _super);

  function RedmineHeader(args) {
    var _this = _super.call(this, {
      title: args.title,
      type: args.type,
      isIdentifier: args.isIdentifier !== undefined ? args.isIdentifier : false,
      allowVisibilityChange: args.allowVisibilityChange !== undefined ? args.allowVisibilityChange : true,
      visible: args.visible,
      sortable: args.sortable,
      searchable: args.searchable,
      version: args.version
    }) || this;

    _this.alwaysInclude = false;
    _this.orderByKey = undefined;
    _this.alwaysInclude = args.alwaysInclude === true;
    _this.subHeaders = args.subHeaders !== undefined ? args.subHeaders : [];
    _this.type = args.type;
    _this.orderByKey = args.orderByKey;
    return _this;
  }

  return RedmineHeader;
}(lib_Header);

/* harmony default export */ var redmine_RedmineHeader = (RedmineHeader_RedmineHeader);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasColumnFilters.vue?vue&type=script&lang=ts&















var PbasColumnFiltersvue_type_script_lang_ts_PbasColumnFilter =
/** @class */
function (_super) {
  __extends(PbasColumnFilter, _super);

  function PbasColumnFilter() {
    var _this = _super.call(this) || this;

    _this.valid = false;
    _this.filters = [];
    _this.filterHeaders = new Map();
    _this.hasChanges = false;
    _this.selectedColumn = null;
    _this.columns = [];
    return _this;
  }

  PbasColumnFilter.prototype.onHeadersChanged = function (val, oldVal) {
    if (val === undefined || val.headers === undefined) {
      return;
    }

    this.columns = val.headers.filter(function (h) {
      return h.visible;
    }).map(function (h) {
      return h.title;
    });
  };

  PbasColumnFilter.prototype.onSettingsChanged = function (val, oldVal) {
    return __awaiter(this, void 0, void 0, function () {
      var columns, _loop_1, this_1, _i, columns_1, col;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (val === undefined) {
              return [2
              /*return*/
              ];
            }

            this.filters = val;
            columns = this.selectedColumns();

            _loop_1 = function _loop_1(col) {
              var filterColumn = val.filter(function (o) {
                return o.type.key === col.type.key;
              });

              if (filterColumn.length > 0) {
                this_1.filterHeaders.set(filterColumn[0], col);
              }
            };

            this_1 = this;

            for (_i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
              col = columns_1[_i];

              _loop_1(col);
            }

            this.hasChanges = true;
            return [4
            /*yield*/
            , this.delay(20)];

          case 1:
            _a.sent();

            this.selectedColumn = undefined;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasColumnFilter.prototype.mounted = function () {
    this.onSettingsChanged(this.settingsFilters, []);
  };

  PbasColumnFilter.prototype.onSelectedColumnChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var filter;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.selectedColumn === null || this.selectedColumn === undefined) {
              return [2
              /*return*/
              ];
            }

            console.log("onSelectedColumnChange", this.selectedColumn);
            filter = this.selectedColumn.type.createNewFilter(this.selectedColumn);
            console.log("onSelectedColumnChange filter:", filter);
            this.filterHeaders.set(filter, this.selectedColumn);
            this.filters.push(filter);
            this.hasChanges = true;
            return [4
            /*yield*/
            , this.delay(20)];

          case 1:
            _a.sent();

            this.selectedColumn = undefined;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasColumnFilter.prototype.clear = function () {
    this.filters.splice(0, this.filters.length);
    this.filterHeaders.clear();
    this.hasChanges = false;
    return [];
  };

  PbasColumnFilter.prototype.delay = function (ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  PbasColumnFilter.prototype.remove = function (filter) {
    this.hasChanges = true;
    this.filterHeaders.delete(filter);
    var index = this.filters.indexOf(filter);
    this.filters.splice(index, 1);
  };

  PbasColumnFilter.prototype.apply = function () {
    this.hasChanges = false;
    return this.filters.filter(function (f) {
      return f.active;
    });
  };

  PbasColumnFilter.prototype.close = function () {
    return;
  };

  PbasColumnFilter.prototype.isValid = function () {
    return this.filters.length > 0 && !this.filters.some(function (f) {
      return f.value === "" || f.value === undefined;
    }) || this.hasChanges && this.filters.length === 0;
  };

  PbasColumnFilter.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  PbasColumnFilter.prototype.selectedColumns = function () {
    var headers = [];

    for (var _i = 0, _a = this.dataProvider.headers.filter(function (h) {
      return h.searchable && h.allowVisibilityChange;
    }); _i < _a.length; _i++) {
      var header = _a[_i];

      if (header instanceof odata_ODataHeader) {
        var subs = header.subHeaders;

        if (subs.length > 0) {
          var searchableSubs = subs.filter(function (s) {
            return s.searchable;
          });
          headers = headers.concat(searchableSubs);
        } else {
          headers.push(header);
        }
      } else if (header instanceof inmemory_InMemoryHeader) {
        var subs = header.subHeaders;

        if (subs.length > 0) {
          var searchableSubs = subs.filter(function (s) {
            return s.searchable;
          });
          headers = headers.concat(searchableSubs);
        } else {
          headers.push(header);
        }
      } else if (header instanceof logicalExpressions_LogicalExpressionsHeader) {
        headers.push(header);
      } else if (header instanceof redmine_RedmineHeader) {
        headers.push(header);
      }
    } // console.log(headers);


    return headers;
  };

  var _a, _b, _c;

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", typeof (_a = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _a : Object)], PbasColumnFilter.prototype, "dataProvider", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasColumnFilter.prototype, "loading", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", Array)], PbasColumnFilter.prototype, "settingsFilters", void 0);

  __decorate([Watch("dataProvider", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [typeof (_b = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _b : Object, typeof (_c = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _c : Object]), __metadata("design:returntype", void 0)], PbasColumnFilter.prototype, "onHeadersChanged", null);

  __decorate([Watch("settingsFilters", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", Promise)], PbasColumnFilter.prototype, "onSettingsChanged", null);

  __decorate([Emit("apply"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasColumnFilter.prototype, "clear", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasColumnFilter.prototype, "apply", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasColumnFilter.prototype, "close", null);

  PbasColumnFilter = __decorate([vue_class_component_common_default()({
    components: {
      VDialog: lib_["VDialog"],
      VCardText: lib_["VCardText"],
      VDataTable: lib_["VDataTable"],
      VIcon: lib_["VIcon"],
      VBtn: lib_["VBtn"],
      VList: lib_["VList"],
      VListItem: lib_["VListItem"],
      VListItemTitle: lib_["VListItemTitle"],
      VListItemContent: lib_["VListItemContent"],
      VContainer: lib_["VContainer"],
      VRow: lib_["VRow"],
      VCol: lib_["VCol"],
      VMenu: lib_["VMenu"],
      VTextField: lib_["VTextField"],
      VCheckbox: lib_["VCheckbox"],
      VCard: lib_["VCard"],
      VCardActions: lib_["VCardActions"],
      VForm: lib_["VForm"],
      VSelect: lib_["VSelect"],
      PbasDatePicker: components_PbasDatePicker,
      VCardTitle: lib_["VCardTitle"]
    }
  }), __metadata("design:paramtypes", [])], PbasColumnFilter);
  return PbasColumnFilter;
}(external_vue_default.a);

/* harmony default export */ var PbasColumnFiltersvue_type_script_lang_ts_ = (PbasColumnFiltersvue_type_script_lang_ts_PbasColumnFilter);
// CONCATENATED MODULE: ./src/lib/components/PbasColumnFilters.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PbasColumnFiltersvue_type_script_lang_ts_ = (PbasColumnFiltersvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/PbasColumnFilters.vue?vue&type=style&index=0&id=201afedd&scoped=true&lang=css&
var PbasColumnFiltersvue_type_style_index_0_id_201afedd_scoped_true_lang_css_ = __webpack_require__("c141");

// CONCATENATED MODULE: ./src/lib/components/PbasColumnFilters.vue






/* normalize component */

var PbasColumnFilters_component = normalizeComponent(
  components_PbasColumnFiltersvue_type_script_lang_ts_,
  PbasColumnFiltersvue_type_template_id_201afedd_scoped_true_render,
  PbasColumnFiltersvue_type_template_id_201afedd_scoped_true_staticRenderFns,
  false,
  null,
  "201afedd",
  null
  
)

/* harmony default export */ var PbasColumnFilters = (PbasColumnFilters_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasCustomizeColumns.vue?vue&type=template&id=313c9c82&scoped=true&
var PbasCustomizeColumnsvue_type_template_id_313c9c82_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.trans('pbascomponents.pbascustomizecolumns.select_columns')))]),_c('v-card-text',_vm._l((_vm.options.filter(function (o) { return o.header.allowVisibilityChange; })),function(opt){return _c('div',{key:opt.header.type.key},[_c('v-checkbox',{attrs:{"label":_vm.trans(opt.header.title)},model:{value:(opt.visible),callback:function ($$v) {_vm.$set(opt, "visible", $$v)},expression:"opt.visible"}})],1)}),0),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.trans('pbascomponents.pbascustomizecolumns.cancel')))]),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.trans('pbascomponents.pbascustomizecolumns.save')))])],1)],1)],1)}
var PbasCustomizeColumnsvue_type_template_id_313c9c82_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/PbasCustomizeColumns.vue?vue&type=template&id=313c9c82&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasCustomizeColumns.vue?vue&type=script&lang=ts&




var PbasCustomizeColumnsvue_type_script_lang_ts_PbasCustomizeColumns =
/** @class */
function (_super) {
  __extends(PbasCustomizeColumns, _super);

  function PbasCustomizeColumns() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.options = [];
    return _this;
  }

  PbasCustomizeColumns.prototype.mounted = function () {
    this.onHeadersChanged(this.headers, []);
  };

  PbasCustomizeColumns.prototype.onHeadersChanged = function (val, oldVal) {
    this.options = [];

    for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
      var h = val_1[_i];
      this.options.push({
        header: h,
        visible: h.visible
      });
    }
  };

  PbasCustomizeColumns.prototype.save = function () {
    return this.options;
  };

  PbasCustomizeColumns.prototype.close = function () {
    return undefined;
  };

  PbasCustomizeColumns.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasCustomizeColumns.prototype, "show", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasCustomizeColumns.prototype, "headers", void 0);

  __decorate([Watch("headers"), __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", void 0)], PbasCustomizeColumns.prototype, "onHeadersChanged", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasCustomizeColumns.prototype, "save", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasCustomizeColumns.prototype, "close", null);

  PbasCustomizeColumns = __decorate([vue_class_component_common_default()({
    components: {
      VDialog: lib_["VDialog"],
      VCardText: lib_["VCardText"],
      VDataTable: lib_["VDataTable"],
      VIcon: lib_["VIcon"],
      VBtn: lib_["VBtn"],
      VList: lib_["VList"],
      VListItem: lib_["VListItem"],
      VListItemTitle: lib_["VListItemTitle"],
      VContainer: lib_["VContainer"],
      VRow: lib_["VRow"],
      VCol: lib_["VCol"],
      VMenu: lib_["VMenu"],
      VTextField: lib_["VTextField"],
      VCheckbox: lib_["VCheckbox"],
      VCard: lib_["VCard"],
      VSpacer: lib_["VSpacer"],
      VCardActions: lib_["VCardActions"],
      VCardTitle: lib_["VCardTitle"]
    }
  })], PbasCustomizeColumns);
  return PbasCustomizeColumns;
}(external_vue_default.a);

/* harmony default export */ var PbasCustomizeColumnsvue_type_script_lang_ts_ = (PbasCustomizeColumnsvue_type_script_lang_ts_PbasCustomizeColumns);
// CONCATENATED MODULE: ./src/lib/components/PbasCustomizeColumns.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PbasCustomizeColumnsvue_type_script_lang_ts_ = (PbasCustomizeColumnsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/PbasCustomizeColumns.vue?vue&type=style&index=0&id=313c9c82&scoped=true&lang=css&
var PbasCustomizeColumnsvue_type_style_index_0_id_313c9c82_scoped_true_lang_css_ = __webpack_require__("fe1c");

// CONCATENATED MODULE: ./src/lib/components/PbasCustomizeColumns.vue






/* normalize component */

var PbasCustomizeColumns_component = normalizeComponent(
  components_PbasCustomizeColumnsvue_type_script_lang_ts_,
  PbasCustomizeColumnsvue_type_template_id_313c9c82_scoped_true_render,
  PbasCustomizeColumnsvue_type_template_id_313c9c82_scoped_true_staticRenderFns,
  false,
  null,
  "313c9c82",
  null
  
)

/* harmony default export */ var components_PbasCustomizeColumns = (PbasCustomizeColumns_component.exports);
// CONCATENATED MODULE: ./src/lib/FetchResult.ts
var FetchResult =
/** @class */
function () {
  function FetchResult(count, items) {
    this.count = count;
    this.items = items;
  }

  return FetchResult;
}();

/* harmony default export */ var lib_FetchResult = (FetchResult);
// CONCATENATED MODULE: ./src/lib/SortOption.ts
var SortOption =
/** @class */
function () {
  function SortOption(header, direction) {
    this.header = header;
    this.direction = direction;
  }

  return SortOption;
}();

/* harmony default export */ var lib_SortOption = (SortOption);
// CONCATENATED MODULE: ./src/lib/SortDirection.ts
var SortDirection;

(function (SortDirection) {
  SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
  SortDirection[SortDirection["Descending"] = 1] = "Descending";
})(SortDirection || (SortDirection = {}));

/* harmony default export */ var lib_SortDirection = (SortDirection);
// CONCATENATED MODULE: ./src/lib/Downloader.ts




var Downloader =
/** @class */
function () {
  function Downloader() {}

  Downloader.prototype.download = function (filename, blob) {
    var isIe = Object.keys(document).some(function (k) {
      return k === "documentMode";
    });

    if (!isIe) {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      window.navigator.msSaveBlob(blob, filename);
    }
  };

  return Downloader;
}();

/* harmony default export */ var lib_Downloader = (Downloader);
// EXTERNAL MODULE: external "vue-context"
var external_vue_context_ = __webpack_require__("8ff1");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasDataTable.vue?vue&type=script&lang=ts&
























var PbasDataTablevue_type_script_lang_ts_PbasDataTable =
/** @class */
function (_super) {
  __extends(PbasDataTable, _super);

  function PbasDataTable() {
    var _this = _super.call(this) || this;

    _this.$refs = {
      horizontalScrollContent: HTMLElement,
      horizontalScroll: HTMLElement,
      container: HTMLElement,
      headers: HTMLElement,
      headersContainer: HTMLElement,
      filtersControl: PbasColumnFilters
    };
    _this.matchColumns = true; // internal merge with selectActions

    _this.selectActionsList = [];
    _this.exportDialog = false;
    _this.exporting = false;
    _this.sortDescendingLoc = false;
    _this.showFiltersDialog = false;
    _this.selected = [];
    _this.contextMenuSelectedItem = null;
    _this.search = "";
    _this.searchValue = "";
    _this.loading = false;
    _this.options = {};
    _this.optionsValue = {
      page: 1,
      itemsPerPage: 20,
      sortBy: [],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false
    };
    _this.showCustomizeColumns = false;
    _this.visibleFloatActions = [];
    _this.filters = [];
    _this.settingsFilters = [];
    _this.contextMenuOpened = false;
    _this.downloader = new lib_Downloader();
    _this.sortByInternal = "";
    _this.selectedExporter = null;
    _this.selectedExporterFunction = "";
    _this.addedEvents = false;
    _this.filtersApplied = false;
    _this.exporterOperations = [];
    _this.visibleRowActions = [];
    _this.activeSearchWarning = false;
    _this.fetchResult = new lib_FetchResult(0, []);
    return _this;
  }

  PbasDataTable.prototype.onFloatActionsChanged = function (newVal) {
    this.visibleFloatActions = this.visibleFloatActionsFunc(); // console.log("visible float actions: ", this.visibleFloatActions);

    this.$forceUpdate();
  };

  PbasDataTable.prototype.destroy = function () {
    window.removeEventListener("resize", this.onWindowSizeChanged);
    window.removeEventListener("scroll", this.onScroll);
  };

  PbasDataTable.prototype.mounted = function () {
    console.log("mounted"); // this.sortDescendingLoc = this.sortDescending;
    // this.sortByInternal = this.sortBy;

    console.log(this.sortByInternal, this.sortBy); // this.loadPreferences();

    if (this.showSelect && this.dataProvider !== undefined) {
      var res = this.dataProvider.headers.find(function (h) {
        return h.isIdentifier;
      });

      if (res === undefined) {
        throw new Error("You allow selections but the provider does not have any Header with isIdentifier: true. Add isIdentifier to one Header.");
      }
    }

    window.addEventListener("resize", this.onWindowSizeChanged);
    window.addEventListener("scroll", this.onScroll);
  };

  PbasDataTable.prototype.created = function () {
    console.log("created");
    this.sortDescendingLoc = this.sortDescending;
    this.sortByInternal = this.sortBy;
    console.log(this.sortByInternal, this.sortBy);
  };

  PbasDataTable.prototype.updated = function () {
    if (this.$el !== undefined && this.$el !== null && this.$el.querySelector !== undefined) {
      this.addScrollEvents();
      this.onScroll();
      this.resizeScrollbar();
    }
  };

  PbasDataTable.prototype.getDataAsync = function () {
    return __awaiter(this, void 0, Promise, function () {
      var οpts, start, count, sortOptions, headerObj, localPromise, result, error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.selected = [];

            if (this.dataProvider === undefined) {
              return [2
              /*return*/
              ];
            }

            οpts = this.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;

            if (isNaN(start) || isNaN(count)) {
              return [2
              /*return*/
              ];
            }

            this.loading = true;
            sortOptions = [];

            if (οpts.sortBy !== null && οpts.sortBy !== undefined && οpts.sortBy.length > 0) {
              sortOptions = οpts.sortBy.map(function (header, index) {
                if (_this.dataProvider !== undefined) {
                  var headerObj = _this.dataProvider.headers.filter(function (h) {
                    return h.type.key === header;
                  })[0];

                  return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
                }
              });
            } else if (this.sortByInternal !== null && this.sortByInternal !== undefined && this.sortByInternal !== "") {
              headerObj = this.dataProvider.headers.filter(function (h) {
                return h.type.key === _this.sortByInternal;
              })[0];
              sortOptions = [new lib_SortOption(headerObj, this.sortDescendingLoc ? lib_SortDirection.Descending : lib_SortDirection.Ascending)];
            }

            console.log("make call", sortOptions);
            sortOptions = sortOptions.filter(function (o) {
              return o.header !== undefined;
            });
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            this.fetchingPromise = this.dataProvider.fetchAsync(start, count, sortOptions.length > 0 ? sortOptions : undefined, this.search, this.filters, undefined, this.apply);
            localPromise = this.fetchingPromise;
            this.fetchResult = new lib_FetchResult(0, []);
            return [4
            /*yield*/
            , localPromise];

          case 2:
            result = _a.sent();

            if (localPromise === this.fetchingPromise) {
              this.fetchResult = result;
              this.onItemsChanged();
              this.loading = false;
            }

            console.log(this.fetchResult);
            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            this.$emit("error", error_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.itemsChangeWarningNo = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      var keys;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            keys = Object.keys(options);

            if (keys.indexOf("search") > -1) {
              // console.log("search: ", options.search.old);
              this.searchValue = options.search.old;
            }

            if (keys.indexOf("options") > -1) {
              // console.log("options: ", options.options.old);
              this.optionsValue = options.options.old;
            }

            if (keys.indexOf("filters") > -1) {
              // console.log("filters: ", options.filters.old);
              this.filtersChanged(options.filters.old);
            }

            return [4
            /*yield*/
            , this.delay(1000)];

          case 1:
            _a.sent();

            this.activeSearchWarning = false;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.itemsChangeWarningYes = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      var keys;
      return __generator(this, function (_a) {
        keys = Object.keys(options);

        if (keys.indexOf("search") > -1) {
          // console.log("search: ", options.search.new);
          this.search = options.search.new;
        }

        if (keys.indexOf("options") > -1) {
          // console.log("options: ", options.options.new);
          this.options = options.options.new;
        }

        if (keys.indexOf("filters") > -1) {
          // console.log("filters: ", options.filters.new);
          this.filtersChanged(options.filters.new);
        }

        this.activeSearchWarning = false;
        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.evalDisabled = function (action) {
    if (action.disabled === null || action.disabled === undefined) {
      return false;
    }

    var disabled = action.disabled();
    return disabled;
  };

  PbasDataTable.prototype.visibleFloatActionsFunc = function () {
    /*if (this.contextMenuOpened === false) {
      return [];
    }*/
    if (this.floatActions == null) {
      return [];
    }

    var visibleActions = this.floatActions.filter(function (a) {
      if (a.visible === undefined) {
        return true;
      }

      return a.visible() !== false;
    });
    return visibleActions;
  };

  PbasDataTable.prototype.onExpandedItemsChanged = function (data) {
    return data;
  };

  PbasDataTable.prototype.addScrollEvents = function () {
    var _this = this;

    if (this.addedEvents || this.$el.querySelector === undefined) {
      return;
    }

    var wrapper = this.$el.querySelector(".v-data-table__wrapper");

    if (wrapper !== null) {
      wrapper.addEventListener("scroll", function (event) {
        _this.$refs.horizontalScroll.scrollLeft = wrapper.scrollLeft;
        _this.$refs.headersContainer.scrollLeft = wrapper.scrollLeft;
      });
      this.$refs.headersContainer.addEventListener("scroll", function (event) {
        wrapper.scrollLeft = _this.$refs.headersContainer.scrollLeft;
      });
      this.$refs.horizontalScroll.addEventListener("scroll", function (event) {
        wrapper.scrollLeft = _this.$refs.horizontalScroll.scrollLeft;
      });
      this.addedEvents = true;
      setTimeout(this.setupFixedHeader, 100);
    }
  };

  PbasDataTable.prototype.onSortByChange = function (newVal) {
    this.sortByInternal = newVal;
    console.log(newVal);
  };

  PbasDataTable.prototype.onContextMenuSelectedItemChange = function (newVal) {
    if (newVal !== null && newVal !== undefined) {
      this.visibleRowActions = this.visibleRowActionsFunc(newVal);

      if (this.visibleRowActions.length === 0) {
        if (this.$refs.menu !== undefined) {
          this.$refs.menu.show = false;
        }
      }
    } else {
      if (this.$refs.menu !== undefined) {
        this.$refs.menu.show = false;
      }
    }
  };

  PbasDataTable.prototype.onWindowSizeChanged = function () {
    this.resizeScrollbar();
    this.onScroll();
  };

  PbasDataTable.prototype.setupFixedHeader = function () {
    if (this.$refs.container !== undefined && this.$el.querySelector !== undefined) {
      var header = this.$el.querySelector(".v-data-table-header");

      if (header !== undefined) {
        this.$refs.headersContainer.style.width = this.$refs.container.querySelector(".v-data-table__wrapper").offsetWidth + "px";
        var cln = header.cloneNode(true);
        this.$refs.headers.innerHTML = "";
        this.$refs.headers.append(cln);
        var thead2 = this.$refs.headers.querySelector(".v-data-table-header").children[0];
        this.$refs.headers.style.width = header.scrollWidth + "px";

        if (this.showSelect) {
          var index = this.showExpand ? 1 : 0;
          thead2.children[index].innerHTML = "";
        }

        for (var _i = 0, _a = Object.keys(header.children[0].children); _i < _a.length; _i++) {
          var c = _a[_i];
          var source = header.children[0].children[c];

          if (source === undefined) {
            continue;
          }

          if (thead2.children[c].style !== undefined) {
            thead2.children[c].style.width = header.children[0].children[c].offsetWidth + "px";
          }
        }
      }
    }
  };

  PbasDataTable.prototype.onScroll = function () {
    var _this = this;

    clearTimeout(this.timeoutResult);
    this.timeoutResult = setTimeout(function () {
      _this.setupFixedHeader();

      if (_this.$refs.container === undefined || _this.$el.querySelector === undefined) {
        return;
      }

      var header = _this.$el.querySelector(".v-data-table-header");

      if (header === undefined) {
        return;
      }

      var tablevisible = _this.checkVisible(_this.$refs.container.querySelector(".v-data-table__wrapper"));

      if (!tablevisible) {
        _this.$refs.headersContainer.style.visibility = "hidden";
        return;
      }

      var isVisible = _this.checkVisible(header);

      _this.$refs.headersContainer.style.visibility = isVisible ? "hidden" : "visible";
    }, 100);
  };

  PbasDataTable.prototype.checkVisible = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  PbasDataTable.prototype.savePreferences = function () {
    if (this.identifier === undefined) {
      return;
    }

    window.localStorage["pbasdatatable__" + this.identifier] = JSON.stringify({
      // options: this.options,
      filters: this.settingsFromFilters(this.filters),
      visibleHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : [],
      hiddenHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return !h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : []
    });
    var inlineOptions = this.$refs.inlineTable ? this.$refs.inlineTable.options : undefined;

    if (inlineOptions === undefined) {
      var settingsJson = window.localStorage["pbasdatatable__inline" + this.identifier];

      if (settingsJson !== undefined) {
        var settings = JSON.parse(settingsJson);

        if (settings.options !== undefined) {
          inlineOptions = settings.options;
        }
      }
    }

    window.localStorage["pbasdatatable__inline" + this.identifier] = JSON.stringify({
      // options: inlineOptions,
      visibleHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : [],
      hiddenHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return !h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : []
    });
  };

  PbasDataTable.prototype.loadPreferences = function () {
    if (this.identifier === undefined || this.dataProvider === undefined) {
      return;
    }

    var settingsJson = window.localStorage["pbasdatatable__" + this.identifier];

    if (settingsJson === undefined) {
      return;
    }

    var settings = JSON.parse(settingsJson);
    console.log(settingsJson);

    var _loop_1 = function _loop_1(i) {
      var f = this_1.dataProvider.headers.find(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "") === i;
      });

      if (f !== undefined) {
        f.visible = true;
      }
    };

    var this_1 = this;

    for (var _i = 0, _a = settings.visibleHeaders; _i < _a.length; _i++) {
      var i = _a[_i];

      _loop_1(i);
    }

    var _loop_2 = function _loop_2(i) {
      var f = this_2.dataProvider.headers.find(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "") === i;
      });

      if (f !== undefined) {
        f.visible = false;
      }
    };

    var this_2 = this;

    for (var _b = 0, _c = settings.hiddenHeaders; _b < _c.length; _b++) {
      var i = _c[_b];

      _loop_2(i);
    }

    if (settings.options !== undefined) {
      if (settings.filters !== undefined) {
        this.filters = this.filtersFromSettings(settings.filters);
        this.settingsFilters = this.filters;

        if (this.filters.length > 0) {
          this.filtersApplied = true;
        }
      } // this.$nextTick(() => {


      this.optionsValue = settings.options; // });

      console.log(this.optionsValue);
    }
  };

  PbasDataTable.prototype.filtersFromSettings = function (settingsFilters) {
    var columns = this.selectedColumns();
    var filters = [];

    var _loop_3 = function _loop_3(col) {
      var filterColumn = settingsFilters.filter(function (o) {
        return o.header === col.type.key;
      });

      if (filterColumn.length > 0) {
        // console.log(filterColumn[0], col);
        var filter = col.type.createNewFilter(col);
        var operator = col.type.operators.filter(function (o) {
          // console.log(o.constructor.name);
          return o.constructor.name === filterColumn[0].operator;
        }); // console.log(operator, filter);

        if (operator.length > 0) {
          filter.operator = operator[0];
        }

        filter.value = filterColumn[0].value;
        filters.push(filter); // this.filterHeaders.set(filter, col);
      }
    };

    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
      var col = columns_1[_i];

      _loop_3(col);
    }

    return filters;
  };

  PbasDataTable.prototype.selectedColumns = function () {
    var headers = [];

    if (this.dataProvider === undefined) {
      return headers;
    }

    for (var _i = 0, _a = this.dataProvider.headers.filter(function (h) {
      return h.searchable && h.allowVisibilityChange;
    }); _i < _a.length; _i++) {
      var header = _a[_i];

      if (header instanceof odata_ODataHeader) {
        var subs = header.subHeaders;

        if (subs.length > 0) {
          var searchableSubs = subs.filter(function (s) {
            return s.searchable;
          });
          headers = headers.concat(searchableSubs);
        } else {
          headers.push(header);
        }
      } else if (header instanceof inmemory_InMemoryHeader) {
        var subs = header.subHeaders;

        if (subs.length > 0) {
          var searchableSubs = subs.filter(function (s) {
            return s.searchable;
          });
          headers = headers.concat(searchableSubs);
        } else {
          headers.push(header);
        }
      }
    } // console.log(headers);


    return headers;
  };

  PbasDataTable.prototype.settingsFromFilters = function (filters) {
    var settingsFilters = [];

    for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
      var filter = filters_1[_i];
      settingsFilters.push({
        operator: filter.operator ? filter.operator.constructor.name : undefined,
        value: filter.value,
        header: filter.type.key
      });
    }

    return settingsFilters;
  };

  PbasDataTable.prototype.onSearchValueChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var obj;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log("on-search-value-changed", this.searchValue, this.itemsChangeWarning, this.activeSearchWarning);

            if (this.dataProvider == null) {
              return [2
              /*return*/
              ];
            }

            obj = {};
            this.searchMonitor = obj;
            return [4
            /*yield*/
            , this.delay(800)];

          case 1:
            _a.sent();

            if (this.searchMonitor !== obj) {
              return [2
              /*return*/
              ];
            }

            if (this.itemsChangeWarning) {
              if (!this.activeSearchWarning) {
                this.activeSearchWarning = true;
                this.$emit("items-change-warning", {
                  search: {
                    old: this.search,
                    new: this.searchValue
                  }
                });
              }
            } else {
              this.search = this.searchValue;
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.onOptionsValueChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        console.log("on-options-value-changed", JSON.stringify(this.optionsValue));

        if (this.dataProvider === null || this.dataProvider === undefined) {
          return [2
          /*return*/
          ];
        }

        if (this.itemsChangeWarning) {
          if (!this.activeSearchWarning) {
            this.activeSearchWarning = true;
            this.$emit("items-change-warning", {
              options: {
                old: this.options,
                new: this.optionsValue
              }
            });
          }
        } else {
          this.options = this.optionsValue;
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.getActionsFor = function (item) {
    if (!item) {
      return [];
    }

    return this.visibleRowActionsFunc(item);
  };

  PbasDataTable.prototype.onDataProviderChanged = function (value, oldValue) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        console.log("provider", value, oldValue);

        if (value === undefined || value === null) {
          return [2
          /*return*/
          ];
        }

        this.loadPreferences();
        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.delay = function (ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  PbasDataTable.prototype.onSearchChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var obj;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log("on-search-changed", this.search);

            if (this.dataProvider === null || this.dataProvider === undefined) {
              return [2
              /*return*/
              ];
            }

            obj = {};
            this.searchMonitor = obj;
            return [4
            /*yield*/
            , this.delay(800)];

          case 1:
            _a.sent();

            if (this.searchMonitor !== obj) {
              return [2
              /*return*/
              ];
            }

            this.getDataAsync();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.onSelectedChanged = function () {
    return this.selected;
  };

  PbasDataTable.prototype.getAll = function (keys) {
    return __awaiter(this, void 0, Promise, function () {
      var οpts, sortOptions, headerObj, res;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.dataProvider === undefined) {
              throw new Error("Called getAll() without a provider");
            }

            οpts = this.options;
            sortOptions = [];

            if (οpts.sortBy !== null && οpts.sortBy !== undefined && οpts.sortBy.length > 0) {
              sortOptions = οpts.sortBy.map(function (header, index) {
                if (_this.dataProvider !== undefined) {
                  var headerObj = _this.dataProvider.headers.filter(function (h) {
                    return h.type.key === header;
                  })[0];

                  return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
                }
              });
            } else if (this.sortByInternal !== null && this.sortByInternal !== undefined && this.sortByInternal !== "") {
              headerObj = this.dataProvider.headers.filter(function (h) {
                return h.type.key === _this.sortByInternal;
              })[0];
              sortOptions = [new lib_SortOption(headerObj, this.sortDescendingLoc ? lib_SortDirection.Descending : lib_SortDirection.Ascending)];
            }

            sortOptions = sortOptions.filter(function (o) {
              return o.header !== undefined;
            });
            console.log("fetch all");
            return [4
            /*yield*/
            , this.dataProvider.fetchAsync(undefined, undefined, sortOptions.length > 0 ? sortOptions : undefined, this.search, this.filters, keys)];

          case 1:
            res = _a.sent();
            return [2
            /*return*/
            , res.items];
        }
      });
    });
  };

  PbasDataTable.prototype.onOptionsChanged = function () {
    return __awaiter(this, void 0, Promise, function () {
      var obj;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log("options-changed", JSON.stringify(this.options));

            if (this.dataProvider === undefined) {
              return [2
              /*return*/
              ];
            }

            obj = {};
            this.searchMonitor = obj;
            return [4
            /*yield*/
            , this.delay(200)];

          case 1:
            _a.sent();

            if (this.searchMonitor !== obj) {
              return [2
              /*return*/
              ];
            } // const { sortBy, sortDesc, page, itemsPerPage } = this.options


            this.savePreferences();
            return [4
            /*yield*/
            , this.getDataAsync()];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.resizeScrollbar = function () {
    if (this.$el.querySelector !== undefined) {
      var wrapper = this.$el.querySelector(".v-data-table__wrapper");

      if (wrapper !== null && wrapper.children.length > 0) {
        var el = wrapper.children[0];

        if (el !== null && this.$refs.horizontalScrollContent !== undefined) {
          this.$refs.horizontalScrollContent.style.width = el.offsetWidth + "px";
        }
      }
    }
  };

  PbasDataTable.prototype.onItemsChanged = function () {
    return this.fetchResult.items;
  };

  PbasDataTable.prototype.itemSlotFunc = function (header) {
    return "item." + header.type.key;
  };

  PbasDataTable.prototype.headerSlotFunc = function (header) {
    return "header." + header.type.key;
  };

  PbasDataTable.prototype.updateHeaders = function (options) {
    this.showCustomizeColumns = false;

    if (this.dataProvider === undefined) {
      return;
    }

    var _loop_4 = function _loop_4(o) {
      var found = this_3.dataProvider.headers.find(function (h) {
        return h === o.header;
      });

      if (found !== undefined) {
        found.visible = o.visible;
      }
    };

    var this_3 = this;

    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
      var o = options_1[_i];

      _loop_4(o);
    }

    this.savePreferences();
  };

  PbasDataTable.prototype.deactivateFilters = function () {
    if (this.dataProvider === undefined) {
      return;
    }

    this.filtersApplied = false;

    if (this.$refs.filtersControl !== undefined && this.$refs.filtersControl.clear) {
      this.$refs.filtersControl.clear();
    } else {
      this.onFiltersChanged([]);
      this.settingsFilters = [];
    }
  };

  PbasDataTable.prototype.showExportDialog = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.selectedExporter === null) {
          this.selectedExporter = this.exporters[0];
        }

        this.exporterOperations = this.selectedExporter.getSupportedOperations(this);
        this.selectedExporterFunction = this.exporterOperations[0];
        this.exportDialog = true;
        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.exportData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var blob;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 2, 3]);

            this.exporting = true;

            if (this.selectedExporter === null || this.selectedExporterFunction === "") {
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.selectedExporter.export(this, this.selectedExporterFunction)];

          case 1:
            blob = _a.sent();
            this.downloader.download(this.getFileName() + "." + this.selectedExporter.extension, blob);
            this.exportDialog = false;
            return [3
            /*break*/
            , 3];

          case 2:
            this.exporting = false;
            return [7
            /*endfinally*/
            ];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasDataTable.prototype.getFileName = function () {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    return this.fileNamePrefix + "_" + new Date().toLocaleString("en-US", options).split(".").join("-");
  };

  PbasDataTable.prototype.exportCurrentPage = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.dataProvider === undefined) {
          return [2
          /*return*/
          ];
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.filtersChanged = function (filters) {
    console.log("on-filters-changed", filters);

    if (this.dataProvider === undefined) {
      return;
    }

    this.filters = filters;
    this.filtersApplied = this.filters.length > 0;
    this.showFiltersDialog = false;
    this.options.page = 1;
    this.getDataAsync();
    this.savePreferences();
  };

  PbasDataTable.prototype.onFiltersChanged = function (filters) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // console.log("on-filters-changed", filters);
        if (this.dataProvider === null || this.dataProvider === undefined) {
          return [2
          /*return*/
          ];
        }

        if (this.itemsChangeWarning) {
          if (!this.activeSearchWarning) {
            this.activeSearchWarning = true;
            this.$emit("items-change-warning", {
              filters: {
                old: this.filters,
                new: filters
              }
            });
          }
        } else {
          this.filtersChanged(filters);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PbasDataTable.prototype.visibleRowActionsFunc = function (item) {
    /*if (this.contextMenuOpened === false) {
      return [];
    }*/
    if (this.rowActions == null) {
      return [];
    }

    return this.rowActions.filter(function (a) {
      if (a.visible === undefined) {
        return true;
      }

      return a.visible(item) !== false;
    });
  };

  PbasDataTable.prototype.visibleBodyActionsFunc = function () {
    /*if (this.contextMenuOpened === false) {
      return [];
    }*/
    if (this.bodyActions == null) {
      return [];
    }

    return this.bodyActions.filter(function (a) {
      if (a.visible === undefined) {
        return true;
      }

      return a.visible() !== false;
    });
  };

  PbasDataTable.prototype.onExporterChange = function (exporter) {
    if (exporter === null) {
      return;
    }

    this.exporterOperations = exporter.getSupportedOperations(this);
    this.selectedExporterFunction = this.exporterOperations[0];
  };

  PbasDataTable.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  var _a, _b, _c, _d;

  __decorate([Prop({
    default: false
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "itemsChangeWarning", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "tableActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return 1;
    }
  }), __metadata("design:type", Number)], PbasDataTable.prototype, "headersZIndex", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", Object)], PbasDataTable.prototype, "dataProvider", void 0);

  __decorate([Prop({
    default: true
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "canCustomize", void 0);

  __decorate([Prop({
    default: "#007cb5"
  }), __metadata("design:type", String)], PbasDataTable.prototype, "actionsColor", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "selectActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return function (item) {
        return null;
      };
    }
  }), __metadata("design:type", Function)], PbasDataTable.prototype, "generateProviderForExpanded", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Function)], PbasDataTable.prototype, "canExpand", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "sortDescending", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasDataTable.prototype, "sortBy", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "expandedSortDescending", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasDataTable.prototype, "expandedSortBy", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasDataTable.prototype, "maxHeight", void 0);

  __decorate([Prop({
    default: function _default() {
      return {
        itemsPerPageOptions: [20, 50, 100, 200, 500]
      };
    }
  }), __metadata("design:type", Object)], PbasDataTable.prototype, "footerProps", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "rowActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "expandedRowActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return function (item) {
        return null;
      };
    }
  }), __metadata("design:type", Function)], PbasDataTable.prototype, "expandedFloatActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "showExpand", void 0);

  __decorate([Prop({
    default: function _default() {
      return true;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "showSelect", void 0);

  __decorate([Prop({
    default: function _default() {
      return true;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "searchable", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "exporters", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "noSearch", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "noActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "noFilters", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "exportDataSwitch", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "showActionsBtn", void 0);

  __decorate([Prop(), __metadata("design:type", String)], PbasDataTable.prototype, "apply", void 0);

  __decorate([Prop({
    default: function _default() {
      return "data";
    }
  }), __metadata("design:type", String)], PbasDataTable.prototype, "fileNamePrefix", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "floatActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasDataTable.prototype, "bodyActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasDataTable.prototype, "identifier", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasDataTable.prototype, "floatExport", void 0);

  __decorate([Watch("floatActions", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onFloatActionsChanged", null);

  __decorate([Emit("expanded-changed"), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onExpandedItemsChanged", null);

  __decorate([Watch("sortBy", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onSortByChange", null);

  __decorate([Watch("contextMenuSelectedItem", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onContextMenuSelectedItemChange", null);

  __decorate([Watch("searchValue"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PbasDataTable.prototype, "onSearchValueChanged", null);

  __decorate([Watch("optionsValue"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PbasDataTable.prototype, "onOptionsValueChanged", null);

  __decorate([Watch("dataProvider", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [typeof (_b = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _b : Object, typeof (_c = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _c : Object]), __metadata("design:returntype", Promise)], PbasDataTable.prototype, "onDataProviderChanged", null);

  __decorate([Watch("search"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PbasDataTable.prototype, "onSearchChanged", null);

  __decorate([Watch("selected"), Emit("selected-changed"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onSelectedChanged", null);

  __decorate([Watch("options", {
    deep: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)], PbasDataTable.prototype, "onOptionsChanged", null);

  __decorate([Emit("itemsChanged"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasDataTable.prototype, "onItemsChanged", null);

  PbasDataTable = __decorate([vue_class_component_common_default()({
    components: {
      VDialog: lib_["VDialog"],
      VCardText: lib_["VCardText"],
      VDataTable: lib_["VDataTable"],
      VIcon: lib_["VIcon"],
      VBtn: lib_["VBtn"],
      VList: lib_["VList"],
      VListItem: lib_["VListItem"],
      VListItemTitle: lib_["VListItemTitle"],
      VContainer: lib_["VContainer"],
      VRow: lib_["VRow"],
      VCol: lib_["VCol"],
      VMenu: lib_["VMenu"],
      VTextField: lib_["VTextField"],
      VCheckbox: lib_["VCheckbox"],
      VCard: lib_["VCard"],
      VueContext: external_vue_context_["VueContext"],
      PbasColumnFilters: PbasColumnFilters,
      PbasCustomizeColumns: components_PbasCustomizeColumns,
      NestedPbasComponent: components_PbasDataTable,
      VRadioGroup: lib_["VRadioGroup"],
      VRadio: lib_["VRadio"],
      VCardActions: lib_["VCardActions"],
      VSpacer: lib_["VSpacer"],
      VCardTitle: lib_["VCardTitle"]
    }
  }), __metadata("design:paramtypes", [])], PbasDataTable);
  return PbasDataTable;
}(external_vue_default.a);

/* harmony default export */ var PbasDataTablevue_type_script_lang_ts_ = (PbasDataTablevue_type_script_lang_ts_PbasDataTable);
// CONCATENATED MODULE: ./src/lib/components/PbasDataTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PbasDataTablevue_type_script_lang_ts_ = (PbasDataTablevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/PbasDataTable.vue?vue&type=style&index=0&id=9e5fd4a8&scoped=true&lang=css&
var PbasDataTablevue_type_style_index_0_id_9e5fd4a8_scoped_true_lang_css_ = __webpack_require__("b88c");

// EXTERNAL MODULE: ./src/lib/components/PbasDataTable.vue?vue&type=style&index=1&lang=css&
var PbasDataTablevue_type_style_index_1_lang_css_ = __webpack_require__("25ab");

// CONCATENATED MODULE: ./src/lib/components/PbasDataTable.vue







/* normalize component */

var PbasDataTable_component = normalizeComponent(
  components_PbasDataTablevue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "9e5fd4a8",
  null
  
)

/* harmony default export */ var components_PbasDataTable = (PbasDataTable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/LogicalExpressions.vue?vue&type=template&id=47da686d&scoped=true&
var LogicalExpressionsvue_type_template_id_47da686d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headers)?_c('div',[(_vm.materialCard)?_c('material-card',{attrs:{"icon":"layers","title":_vm.trans('pbascomponents.pbascolumnfilters.title')}},[_c('v-card-text',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},_vm._l((_vm.filters),function(filter,index){return _c('v-row',{key:index},[_c('v-col',{staticClass:"col-lg-3 col-12 justify-center align-self-center"},[_c('v-checkbox',{attrs:{"label":_vm.trans(_vm.filterHeaders.get(filter).title)},model:{value:(filter.active),callback:function ($$v) {_vm.$set(filter, "active", $$v)},expression:"filter.active"}})],1),_c('v-col',{staticClass:"col-lg-2 col-12 justify-center align-self-center"},[_c('v-select',{attrs:{"items":_vm.getFilterOperators(filter, index),"hint":("" + (filter.operator ? _vm.trans(filter.operator.text) : '')),"return-object":true,"required":"","item-text":"symbol","rules":filter.operator.operatorRules},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.symbol)+" "+_vm._s(_vm.trans(data.item.text))+"\n                ")]}}],null,true),model:{value:(filter.operator),callback:function ($$v) {_vm.$set(filter, "operator", $$v)},expression:"filter.operator"}})],1),_c('v-col',{staticClass:"col-lg-4 col-12 justify-center align-self-center"},[(filter.operator && filter.operator.values.length > 0)?_c('v-select',{attrs:{"items":filter.operator.values,"rules":filter.operator.valueRules,"label":"Value"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(_vm.trans(data.item))+"\n                ")]}},{key:"item",fn:function(data){return [_vm._v("\n                  "+_vm._s(_vm.trans(data.item))+"\n                ")]}}],null,true),model:{value:(filter.value),callback:function ($$v) {_vm.$set(filter, "value", $$v)},expression:"filter.value"}}):(_vm.isDateOperator(filter))?_c('pbas-date-picker',{attrs:{"value":filter.value,"rules":filter.operator.valueRules,"label":"Value"},on:{"update-date":function($event){filter.value = $event}}}):_c('keep-alive',[_c(filter.type.getEditableComponent(filter, filter.type),{tag:"component",attrs:{"data":filter}})],1)],1),_c('v-col',{staticClass:"col-auto justify-center align-self-center"},[_c('v-btn',{attrs:{"color":"#6b6a75","depressed":"","small":"","dark":""},on:{"click":function($event){return _vm.remove(filter)}}},[_c('v-icon',[_vm._v("clear")]),_vm._v("\n                "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.remove"))+"\n              ")],1)],1)],1)}),1),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedColumns().length > 0),expression:"selectedColumns().length > 0"}]},[_vm._v("add")]),_c('v-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedColumns().length > 0),expression:"selectedColumns().length > 0"}],ref:"selectedCombo",staticStyle:{"margin-left":"10px","margin-right":"10px","display":"inline-block","min-width":"120px"},attrs:{"items":_vm.selectedColumns(),"return-object":true,"label":_vm.trans('pbascomponents.pbascolumnfilters.add_filter'),"item-value":"title"},on:{"input":_vm.onSelectedColumnChanged},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(_vm.trans(data.item.title))+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-item-content',{domProps:{"textContent":_vm._s(_vm.trans(data.item.title))}})]}}],null,false,4201501436),model:{value:(_vm.selectedColumn),callback:function ($$v) {_vm.selectedColumn=$$v},expression:"selectedColumn"}})],1)],1),_c('v-card-actions',[(_vm.isDialog)?_c('v-btn',{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.close"))+"\n      ")]):_vm._e(),(_vm.filters.length > 0)?_c('v-btn',{attrs:{"color":"","text":""},on:{"click":_vm.clear}},[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.clear"))+"\n      ")]):_vm._e(),(_vm.isValid())?_c('v-btn',{attrs:{"color":"primary","text":"","loading":_vm.loading},on:{"click":_vm.apply}},[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.apply"))+"\n      ")]):_vm._e()],1)],1):[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},_vm._l((_vm.filters),function(filter,index){return _c('v-row',{key:index},[_c('v-col',{staticClass:"col-lg-3 col-12 justify-center align-self-center"},[_c('v-checkbox',{attrs:{"label":_vm.transLabel(filter)},model:{value:(filter.active),callback:function ($$v) {_vm.$set(filter, "active", $$v)},expression:"filter.active"}})],1),_c('v-col',{staticClass:"col-lg-2 col-12 justify-center align-self-center"},[_c('v-select',{attrs:{"items":_vm.getFilterOperators(filter, index),"hint":("" + (filter.operator ? _vm.trans(filter.operator.text) : '')),"return-object":true,"required":"","item-text":"symbol","rules":filter.operator.operatorRules},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.symbol)+" "+_vm._s(_vm.trans(data.item.text))+"\n              ")]}}],null,true),model:{value:(filter.operator),callback:function ($$v) {_vm.$set(filter, "operator", $$v)},expression:"filter.operator"}})],1),_c('v-col',{staticClass:"col-lg-4 col-12 justify-center align-self-center"},[(filter.operator && filter.operator.values.length > 0)?[(
                  filter.operator && filter.operator.values[0] === 'noValues'
                )?_c('div'):_c('v-select',{attrs:{"items":filter.operator.values,"rules":filter.operator.valueRules,"label":"Value"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(_vm.trans(data.item))+"\n                ")]}},{key:"item",fn:function(data){return [_vm._v("\n                  "+_vm._s(_vm.trans(data.item))+"\n                ")]}}],null,true),model:{value:(filter.value),callback:function ($$v) {_vm.$set(filter, "value", $$v)},expression:"filter.value"}})]:(_vm.isDateOperator(filter))?_c('pbas-date-picker',{attrs:{"value":filter.value,"rules":filter.operator.valueRules,"label":"Value"},on:{"update-date":function($event){filter.value = $event}}}):_c('keep-alive',[_c(filter.type.getEditableComponent(filter, filter.type),{tag:"component",attrs:{"data":filter}})],1)],2),_c('v-col',{staticClass:"col-auto justify-center align-self-center"},[_c('v-btn',{attrs:{"color":"#6b6a75","depressed":"","small":"","dark":""},on:{"click":function($event){return _vm.remove(filter)}}},[_c('v-icon',[_vm._v("clear")]),_vm._v("\n              "+_vm._s(_vm.trans("pbascomponents.pbascolumnfilters.remove"))+"\n            ")],1)],1)],1)}),1),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedColumns().length > 0),expression:"selectedColumns().length > 0"}]},[_vm._v("add")]),_c('v-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedColumns().length > 0),expression:"selectedColumns().length > 0"}],ref:"selectedCombo",staticStyle:{"margin-left":"10px","margin-right":"10px","display":"inline-block","min-width":"120px"},attrs:{"items":_vm.selectedColumns(),"return-object":true,"label":_vm.trans('pbascomponents.pbascolumnfilters.add_filter'),"item-value":"title"},on:{"input":_vm.onSelectedColumnChanged},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(_vm.trans(data.item.title))+"\n        ")]}},{key:"item",fn:function(data){return [_c('v-list-item-content',{domProps:{"textContent":_vm._s(_vm.trans(data.item.title))}})]}}],null,false,817074428),model:{value:(_vm.selectedColumn),callback:function ($$v) {_vm.selectedColumn=$$v},expression:"selectedColumn"}})],1)]],2):_vm._e()}
var LogicalExpressionsvue_type_template_id_47da686d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/LogicalExpressions.vue?vue&type=template&id=47da686d&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/symbol/iterator.js
var iterator = __webpack_require__("5d58");
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/symbol.js
var symbol = __webpack_require__("67bb");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js



function typeof_typeof2(obj) { if (typeof symbol_default.a === "function" && typeof iterator_default.a === "symbol") { typeof_typeof2 = function _typeof2(obj) { return typeof obj; }; } else { typeof_typeof2 = function _typeof2(obj) { return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof obj; }; } return typeof_typeof2(obj); }

function typeof_typeof(obj) {
  if (typeof symbol_default.a === "function" && typeof_typeof2(iterator_default.a) === "symbol") {
    typeof_typeof = function _typeof(obj) {
      return typeof_typeof2(obj);
    };
  } else {
    typeof_typeof = function _typeof(obj) {
      return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof_typeof2(obj);
    };
  }

  return typeof_typeof(obj);
}
// CONCATENATED MODULE: ./src/lib/logicalExpressions/LogicalExpressionsColumnFilter.ts



var LogicalExpressionsColumnFilter_LogicalExpressionsColumnFilter =
/** @class */
function (_super) {
  __extends(LogicalExpressionsColumnFilter, _super);

  function LogicalExpressionsColumnFilter(type) {
    return _super.call(this, type) || this;
  }

  return LogicalExpressionsColumnFilter;
}(lib_ColumnFilter);

/* harmony default export */ var logicalExpressions_LogicalExpressionsColumnFilter = (LogicalExpressionsColumnFilter_LogicalExpressionsColumnFilter);
// CONCATENATED MODULE: ./src/lib/Operator.ts
var Operator =
/** @class */
function () {
  function Operator(symbol, text, values, valueRules, operatorRules) {
    if (valueRules === void 0) {
      valueRules = [function (v) {
        if (v === null || v === undefined || v === "") {
          return "Value is required";
        }

        return true;
      }];
    }

    if (operatorRules === void 0) {
      operatorRules = [function (v) {
        if (v === null || v === undefined) {
          return "Operator is required";
        }

        return true;
      }];
    }

    this.symbol = symbol;
    this.text = text;
    this.values = values;
    this.valueRules = valueRules;
    this.operatorRules = operatorRules;
  }

  return Operator;
}();

/* harmony default export */ var lib_Operator = (Operator);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/LogicalExpressionsOperator.ts



var LogicalExpressionsOperator_LogicalExpressionsOperator =
/** @class */
function (_super) {
  __extends(LogicalExpressionsOperator, _super);

  function LogicalExpressionsOperator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return LogicalExpressionsOperator;
}(lib_Operator);

/* harmony default export */ var logicalExpressions_LogicalExpressionsOperator = (LogicalExpressionsOperator_LogicalExpressionsOperator);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/LogicalExpressionsOperatorResult.ts
var LogicalExpressionsOperatorResult =
/** @class */
function () {
  function LogicalExpressionsOperatorResult(parameter) {
    this.expression = "";
    this.parameter = "";
    this.translatedExpression = "";
    this.parameter = parameter;
  }

  return LogicalExpressionsOperatorResult;
}();

/* harmony default export */ var logicalExpressions_LogicalExpressionsOperatorResult = (LogicalExpressionsOperatorResult);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsEquals.ts




var LogicalExpressionsEquals_LogicalExpressionsEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsEquals, _super);

  function LogicalExpressionsEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  LogicalExpressionsEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] == " + variable;
    return result;
  };

  return LogicalExpressionsEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsEquals = (LogicalExpressionsEquals_LogicalExpressionsEquals);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/StringEditableComponent.vue?vue&type=template&id=03104722&
var StringEditableComponentvue_type_template_id_03104722_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data !== undefined)?_c('v-text-field',{attrs:{"label":"Value","rules":_vm.data.operator.valueRules},model:{value:(_vm.data.value),callback:function ($$v) {_vm.$set(_vm.data, "value", $$v)},expression:"data.value"}}):_vm._e()],1)}
var StringEditableComponentvue_type_template_id_03104722_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/StringEditableComponent.vue?vue&type=template&id=03104722&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/StringEditableComponent.vue?vue&type=script&lang=ts&





var StringEditableComponentvue_type_script_lang_ts_StringEditableComponent =
/** @class */
function (_super) {
  __extends(StringEditableComponent, _super);

  function StringEditableComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  var _a;

  __decorate([Prop(), __metadata("design:type", typeof (_a = typeof lib_ColumnFilter !== "undefined" && lib_ColumnFilter) === "function" ? _a : Object)], StringEditableComponent.prototype, "data", void 0);

  StringEditableComponent = __decorate([vue_class_component_common_default()({
    name: "StringEditableComponent",
    components: {
      VTextField: lib_["VTextField"]
    }
  })], StringEditableComponent);
  return StringEditableComponent;
}(external_vue_default.a);

/* harmony default export */ var StringEditableComponentvue_type_script_lang_ts_ = (StringEditableComponentvue_type_script_lang_ts_StringEditableComponent);
// CONCATENATED MODULE: ./src/lib/StringEditableComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var lib_StringEditableComponentvue_type_script_lang_ts_ = (StringEditableComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/StringEditableComponent.vue





/* normalize component */

var StringEditableComponent_component = normalizeComponent(
  lib_StringEditableComponentvue_type_script_lang_ts_,
  StringEditableComponentvue_type_template_id_03104722_render,
  StringEditableComponentvue_type_template_id_03104722_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var lib_StringEditableComponent = (StringEditableComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/DataType.ts




var DataType_DataType =
/** @class */
function () {
  function DataType(key, alignment, operators, getValue, getString, getHtml, getComponent, getEditableComponent, defaultFilters, additionalKeys) {
    var _this = this;

    if (alignment === void 0) {
      alignment = lib_HeaderAlignment.Left;
    }

    if (operators === void 0) {
      operators = [];
    }

    if (defaultFilters === void 0) {
      defaultFilters = [];
    }

    if (additionalKeys === void 0) {
      additionalKeys = [];
    }

    this.key = key;
    this.alignment = alignment;
    this.operators = operators;
    this.getHtml = getHtml;
    this.getComponent = getComponent;
    this.getEditableComponent = getEditableComponent;
    this.defaultFilters = defaultFilters;
    this.additionalKeys = additionalKeys;

    if (getValue === undefined) {
      this.getValue = function (item, type) {
        return item[_this.key];
      };
    } else {
      this.getValue = getValue;
    }

    if (getString === undefined) {
      this.getString = function (item, type) {
        var val = _this.getValue(item, type);

        if (val instanceof Array) {
          return val.join(", ");
        }

        if (val !== undefined && val !== null) {
          return val.toString();
        }

        return "";
      };
    } else {
      this.getString = getString;
    }

    if (getEditableComponent === undefined) {
      this.getEditableComponent = function (filter, type) {
        return lib_StringEditableComponent;
      };
    }
  }

  DataType.prototype.typeString = function () {
    return "String";
  };

  return DataType;
}();

/* harmony default export */ var lib_DataType = (DataType_DataType);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/LogicalExpressionsType.ts







var LogicalExpressionsType_LogicalExpressionsType =
/** @class */
function (_super) {
  __extends(LogicalExpressionsType, _super);

  function LogicalExpressionsType(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, lib_HeaderAlignment.Left, args.operators || [], args.getValue || function (item, type) {
      var parts = _this.key.split('/');

      var obj = item;

      var _loop_1 = function _loop_1() {
        var partKey = _this.removeAnnotation(parts.shift());

        if (partKey !== undefined) {
          if (obj instanceof Array) {
            obj = obj.map(function (o) {
              return o[partKey];
            });

            if (obj.some(function (o) {
              return o instanceof Array;
            })) {
              obj = obj.reduce(function (a, b) {
                return a.concat(b);
              });
            }
          } else {
            if (obj !== null && obj !== undefined) {
              obj = obj[partKey];
            } else {
              obj = null;
            }
          }
        }
      };

      while (parts.length > 0) {
        _loop_1();
      }

      return obj;
    }, args.getString, args.getHtml, args.getComponent, args.getEditableComponent, args.defaultFilters) || this;
    _this.filters = [];
    _this.defaultFilters = [];
    return _this;
  }

  LogicalExpressionsType.prototype.createNewFilter = function () {
    return new logicalExpressions_LogicalExpressionsColumnFilter(this);
  };

  LogicalExpressionsType.prototype.stringToOperator = function (operator) {
    throw new Error("not implemented");
  };

  LogicalExpressionsType.prototype.stringToValue = function (valueStr) {
    throw new Error("not implemented");
  };

  LogicalExpressionsType.prototype.copy = function () {
    throw new Error("not implemented");
  }; // protected escapeValue(value: any): string {
  //     if (value instanceof Date) {
  //         return value.toISOString();
  //     }
  //     return encodeURI(value.replace(/\'/g, "''"));
  // }


  LogicalExpressionsType.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  return LogicalExpressionsType;
}(lib_DataType);

/* harmony default export */ var logicalExpressions_LogicalExpressionsType = (LogicalExpressionsType_LogicalExpressionsType);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsEnumEquals.ts




var LogicalExpressionsEnumEquals_LogicalExpressionsEnumEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsEnumEquals, _super);

  function LogicalExpressionsEnumEquals(dropdownItems, language) {
    var _this = _super.call(this, "=", "pbascomponents.operators.equals", []) || this;

    _this.dropdownItems = dropdownItems;
    _this.language = language;
    return _this;
  }

  LogicalExpressionsEnumEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.translatedExpression = "[" + source + "] == '" + this.translate(variable) + "'";
    result.expression = "[" + source + "] == '" + variable + "'";
    console.log(result);
    return result;
  };

  LogicalExpressionsEnumEquals.prototype.translate = function (v) {
    var _this = this; // console.log(v, this.dropdownItems.filter((o) => {
    //   console.log(v, o.Id);
    //   return o.Id === v;
    // }).length);


    return this.dropdownItems.filter(function (o) {
      return o.Id === v;
    })[0].Translations.filter(function (o) {
      return o.LanguageCode === _this.language;
    })[0].DisplayValue;
  };

  return LogicalExpressionsEnumEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsEnumEquals = (LogicalExpressionsEnumEquals_LogicalExpressionsEnumEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsEnumNotEquals.ts




var LogicalExpressionsEnumNotEquals_LogicalExpressionsEnumNotEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsEnumNotEquals, _super);

  function LogicalExpressionsEnumNotEquals(dropdownItems, language) {
    var _this = _super.call(this, "≠", "pbascomponents.operators.not_equals", []) || this;

    _this.dropdownItems = dropdownItems;
    _this.language = language;
    return _this;
  }

  LogicalExpressionsEnumNotEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.translatedExpression = "[" + source + "] != '" + this.translate(variable) + "'";
    result.expression = "[" + source + "] != '" + variable + "'";
    return result;
  };

  LogicalExpressionsEnumNotEquals.prototype.translate = function (v) {
    var _this = this;

    return this.dropdownItems.filter(function (o) {
      return o.Id === v;
    })[0].Translations.filter(function (o) {
      return o.LanguageCode === _this.language;
    })[0].DisplayValue;
  };

  return LogicalExpressionsEnumNotEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsEnumNotEquals = (LogicalExpressionsEnumNotEquals_LogicalExpressionsEnumNotEquals);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/logicalExpressions/components/EnumModelComponent.vue?vue&type=template&id=0dd9fd44&
var EnumModelComponentvue_type_template_id_0dd9fd44_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Value","items":_vm.data.operator.dropdownItems,"rules":_vm.data.operator.valueRules,"item-value":"Id","item-text":function (item){ return _vm.translate(item); }},model:{value:(_vm.data.value),callback:function ($$v) {_vm.$set(_vm.data, "value", $$v)},expression:"data.value"}})}
var EnumModelComponentvue_type_template_id_0dd9fd44_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/logicalExpressions/components/EnumModelComponent.vue?vue&type=template&id=0dd9fd44&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/logicalExpressions/components/EnumModelComponent.vue?vue&type=script&lang=ts&







var EnumModelComponentvue_type_script_lang_ts_EnumModelComponent =
/** @class */
function (_super) {
  __extends(EnumModelComponent, _super);

  function EnumModelComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EnumModelComponent.prototype.translate = function (item) {
    if (item === null || item === undefined) {
      return "";
    }

    if (item.Translations === null || item.Translations === undefined) {
      return item.Name || "";
    }

    var lang = this.data.operator.language;

    if (lang === null || lang === undefined) {
      lang = "en";
    }

    var trans = item.Translations.filter(function (o) {
      return o.LanguageCode === lang;
    });

    if (trans.length > 0) {
      if (Object.keys(trans[0]).indexOf("DisplayValue") > -1) {
        return trans[0].DisplayValue || item.Name || "";
      }
    }

    return item.Name || "";
  };

  __decorate([Prop(), __metadata("design:type", Object)], EnumModelComponent.prototype, "data", void 0);

  EnumModelComponent = __decorate([vue_class_component_common_default()({
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"],
      VSelect: lib_["VSelect"]
    }
  })], EnumModelComponent);
  return EnumModelComponent;
}(external_vue_default.a);

/* harmony default export */ var EnumModelComponentvue_type_script_lang_ts_ = (EnumModelComponentvue_type_script_lang_ts_EnumModelComponent);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/components/EnumModelComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_EnumModelComponentvue_type_script_lang_ts_ = (EnumModelComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/logicalExpressions/components/EnumModelComponent.vue





/* normalize component */

var EnumModelComponent_component = normalizeComponent(
  components_EnumModelComponentvue_type_script_lang_ts_,
  EnumModelComponentvue_type_template_id_0dd9fd44_render,
  EnumModelComponentvue_type_template_id_0dd9fd44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_EnumModelComponent = (EnumModelComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/LogicalExpressionsEnum.ts







var LogicalExpressionsEnum_LogicalExpressionsEnum =
/** @class */
function (_super) {
  __extends(LogicalExpressionsEnum, _super);

  function LogicalExpressionsEnum(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      operators: args.operators === undefined ? [new operators_LogicalExpressionsEnumEquals(args.dropdownItems ? args.dropdownItems : [], args.language ? args.language : 'en'), new operators_LogicalExpressionsEnumNotEquals(args.dropdownItems ? args.dropdownItems : [], args.language ? args.language : 'en')] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        var lang = 'en';

        if (args && args.language) {
          lang = args.language;
        }

        return components_EnumModelComponent;
      }
    }) || this;
    return _this;
  }

  LogicalExpressionsEnum.prototype.stringToOperator = function (operator) {
    var dropdownItems = this.operators[0].dropdownItems;
    var languageCode = this.operators[0].language;

    if (operator === "==") {
      return new operators_LogicalExpressionsEnumEquals(dropdownItems, languageCode);
    } else if (operator === "!=") {
      return new operators_LogicalExpressionsEnumNotEquals(dropdownItems, languageCode);
    }

    return undefined;
  };

  LogicalExpressionsEnum.prototype.stringToValue = function (valueStr) {
    console.log(valueStr);
    return valueStr.replace("'", "").replace("'", "");
  };

  LogicalExpressionsEnum.prototype.copy = function () {
    return new LogicalExpressionsEnum(this.key);
  };

  return LogicalExpressionsEnum;
}(logicalExpressions_LogicalExpressionsType);

/* harmony default export */ var datatypes_LogicalExpressionsEnum = (LogicalExpressionsEnum_LogicalExpressionsEnum);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsNotEquals.ts




var LogicalExpressionsNotEquals_LogicalExpressionsNotEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsNotEquals, _super);

  function LogicalExpressionsNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  LogicalExpressionsNotEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] != " + variable;
    return result;
  };

  return LogicalExpressionsNotEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsNotEquals = (LogicalExpressionsNotEquals_LogicalExpressionsNotEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsGreaterThan.ts




var LogicalExpressionsGreaterThan_LogicalExpressionsGreaterThan =
/** @class */
function (_super) {
  __extends(LogicalExpressionsGreaterThan, _super);

  function LogicalExpressionsGreaterThan() {
    return _super.call(this, ">", "Greater", []) || this;
  }

  LogicalExpressionsGreaterThan.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] > " + variable;
    return result;
  };

  return LogicalExpressionsGreaterThan;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsGreaterThan = (LogicalExpressionsGreaterThan_LogicalExpressionsGreaterThan);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsGreaterThanOrEquals.ts




var LogicalExpressionsGreaterThanOrEquals_LogicalExpressionsGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsGreaterThanOrEquals, _super);

  function LogicalExpressionsGreaterThanOrEquals() {
    return _super.call(this, ">=", "Greater or Equals", []) || this;
  }

  LogicalExpressionsGreaterThanOrEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] >= " + variable;
    return result;
  };

  return LogicalExpressionsGreaterThanOrEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsGreaterThanOrEquals = (LogicalExpressionsGreaterThanOrEquals_LogicalExpressionsGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsLowerThan.ts




var LogicalExpressionsLowerThan_LogicalExpressionsLowerThan =
/** @class */
function (_super) {
  __extends(LogicalExpressionsLowerThan, _super);

  function LogicalExpressionsLowerThan() {
    return _super.call(this, "<", "Lower", []) || this;
  }

  LogicalExpressionsLowerThan.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] < " + variable;
    return result;
  };

  return LogicalExpressionsLowerThan;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsLowerThan = (LogicalExpressionsLowerThan_LogicalExpressionsLowerThan);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsLowerThanOrEquals.ts




var LogicalExpressionsLowerThanOrEquals_LogicalExpressionsLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsLowerThanOrEquals, _super);

  function LogicalExpressionsLowerThanOrEquals() {
    return _super.call(this, "<=", "Lower or Equals", []) || this;
  }

  LogicalExpressionsLowerThanOrEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] <= " + variable;
    return result;
  };

  return LogicalExpressionsLowerThanOrEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsLowerThanOrEquals = (LogicalExpressionsLowerThanOrEquals_LogicalExpressionsLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/LogicalExpressionsNumber.ts









var LogicalExpressionsNumber_LogicalExpressionsNumber =
/** @class */
function (_super) {
  __extends(LogicalExpressionsNumber, _super);

  function LogicalExpressionsNumber(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      operators: args.operators || [new operators_LogicalExpressionsEquals(), new operators_LogicalExpressionsNotEquals(), new operators_LogicalExpressionsGreaterThan(), new operators_LogicalExpressionsGreaterThanOrEquals(), new operators_LogicalExpressionsLowerThan(), new operators_LogicalExpressionsLowerThanOrEquals()],
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  LogicalExpressionsNumber.prototype.stringToOperator = function (operator) {
    if (operator === "==") {
      return new operators_LogicalExpressionsEquals();
    } else if (operator === "!=") {
      return new operators_LogicalExpressionsNotEquals();
    } else if (operator === "<") {
      return new operators_LogicalExpressionsLowerThan();
    } else if (operator === "<=") {
      return new operators_LogicalExpressionsLowerThanOrEquals();
    } else if (operator === ">") {
      return new operators_LogicalExpressionsGreaterThan();
    } else if (operator === ">=") {
      return new operators_LogicalExpressionsGreaterThanOrEquals();
    } else {
      return undefined;
    }
  };

  LogicalExpressionsNumber.prototype.stringToValue = function (valueStr) {
    var num = parseFloat(valueStr);
    return isNaN(num) ? undefined : num;
  };

  LogicalExpressionsNumber.prototype.copy = function () {
    return new LogicalExpressionsNumber(this.key);
  };

  return LogicalExpressionsNumber;
}(logicalExpressions_LogicalExpressionsType);

/* harmony default export */ var datatypes_LogicalExpressionsNumber = (LogicalExpressionsNumber_LogicalExpressionsNumber);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateGreaterThan.ts




var LogicalExpressionsDateGreaterThan_LogicalExpressionsDateGreaterThan =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateGreaterThan, _super);

  function LogicalExpressionsDateGreaterThan() {
    return _super.call(this, ">", "Greater", []) || this;
  }

  LogicalExpressionsDateGreaterThan.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] > '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateGreaterThan;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateGreaterThan = (LogicalExpressionsDateGreaterThan_LogicalExpressionsDateGreaterThan);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateGreaterThanOrEquals.ts




var LogicalExpressionsDateGreaterThanOrEquals_LogicalExpressionsDateGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateGreaterThanOrEquals, _super);

  function LogicalExpressionsDateGreaterThanOrEquals() {
    return _super.call(this, ">=", "Greater or Equals", []) || this;
  }

  LogicalExpressionsDateGreaterThanOrEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] >= '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateGreaterThanOrEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateGreaterThanOrEquals = (LogicalExpressionsDateGreaterThanOrEquals_LogicalExpressionsDateGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateLowerThan.ts




var LogicalExpressionsDateLowerThan_LogicalExpressionsDateLowerThan =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateLowerThan, _super);

  function LogicalExpressionsDateLowerThan() {
    return _super.call(this, "<", "Lower", []) || this;
  }

  LogicalExpressionsDateLowerThan.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] < '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateLowerThan;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateLowerThan = (LogicalExpressionsDateLowerThan_LogicalExpressionsDateLowerThan);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateLowerThanOrEquals.ts




var LogicalExpressionsDateLowerThanOrEquals_LogicalExpressionsDateLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateLowerThanOrEquals, _super);

  function LogicalExpressionsDateLowerThanOrEquals() {
    return _super.call(this, "<=", "Lower or Equals", []) || this;
  }

  LogicalExpressionsDateLowerThanOrEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] <= '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateLowerThanOrEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateLowerThanOrEquals = (LogicalExpressionsDateLowerThanOrEquals_LogicalExpressionsDateLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateEquals.ts




var LogicalExpressionsDateEquals_LogicalExpressionsDateEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateEquals, _super);

  function LogicalExpressionsDateEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  LogicalExpressionsDateEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] == '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateEquals = (LogicalExpressionsDateEquals_LogicalExpressionsDateEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateNotEquals.ts




var LogicalExpressionsDateNotEquals_LogicalExpressionsDateNotEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateNotEquals, _super);

  function LogicalExpressionsDateNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  LogicalExpressionsDateNotEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] != '" + variable + "'";
    return result;
  };

  return LogicalExpressionsDateNotEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateNotEquals = (LogicalExpressionsDateNotEquals_LogicalExpressionsDateNotEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateExists.ts




var LogicalExpressionsDateExists_LogicalExpressionsDateExists =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateExists, _super);

  function LogicalExpressionsDateExists() {
    return _super.call(this, "\u2203", "Exists", ["noValues"]) || this;
  }

  LogicalExpressionsDateExists.prototype.applyFilter = function (source) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] != '0001-01-01T00:00:00.000Z'";
    return result;
  };

  return LogicalExpressionsDateExists;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateExists = (LogicalExpressionsDateExists_LogicalExpressionsDateExists);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsDateNotExists.ts




var LogicalExpressionsDateNotExists_LogicalExpressionsDateNotExists =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDateNotExists, _super);

  function LogicalExpressionsDateNotExists() {
    return _super.call(this, "\u2204", "Not Exists", ["noValues"]) || this;
  }

  LogicalExpressionsDateNotExists.prototype.applyFilter = function (source) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] == '0001-01-01T00:00:00.000Z'";
    return result;
  };

  return LogicalExpressionsDateNotExists;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsDateNotExists = (LogicalExpressionsDateNotExists_LogicalExpressionsDateNotExists);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/LogicalExpressionsDate.ts













var LogicalExpressionsDate_LogicalExpressionsDate =
/** @class */
function (_super) {
  __extends(LogicalExpressionsDate, _super);

  function LogicalExpressionsDate(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      operators: args.operators === undefined ? [new operators_LogicalExpressionsDateEquals(), new operators_LogicalExpressionsDateNotEquals(), new operators_LogicalExpressionsDateGreaterThan(), new operators_LogicalExpressionsDateGreaterThanOrEquals(), new operators_LogicalExpressionsDateLowerThan(), new operators_LogicalExpressionsDateLowerThanOrEquals(), new operators_LogicalExpressionsDateExists(), new operators_LogicalExpressionsDateNotExists()] : undefined,
      getValue: args.getValue,
      getString: args.getString || function (item) {
        var parsed = _this.parseValue(_this.getValue(item, _this));

        return parsed; // return new Date(Date.parse(parsed)).toLocaleDateString();
      },
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  LogicalExpressionsDate.prototype.stringToOperator = function (operator) {
    if (operator === "==") {
      return new operators_LogicalExpressionsDateEquals();
    } else if (operator === "!=") {
      return new operators_LogicalExpressionsDateNotEquals();
    } else if (operator === "<") {
      return new operators_LogicalExpressionsDateLowerThan();
    } else if (operator === "<=") {
      return new operators_LogicalExpressionsDateLowerThanOrEquals();
    } else if (operator === ">") {
      return new operators_LogicalExpressionsDateGreaterThan();
    } else if (operator === ">=") {
      return new operators_LogicalExpressionsDateGreaterThanOrEquals();
    } else if (operator === "\u2203") {
      return new operators_LogicalExpressionsDateExists();
    } else if (operator === "\u2204") {
      return new operators_LogicalExpressionsDateNotExists();
    } else {
      return undefined;
    }
  };

  LogicalExpressionsDate.prototype.stringToValue = function (valueStr) {
    // return valueStr.replace(/'/g, "");
    return this.parseValue(valueStr.replace(/'/g, ""));
  };

  LogicalExpressionsDate.prototype.copy = function () {
    return new LogicalExpressionsDate(this.key);
  };

  LogicalExpressionsDate.prototype.toDateString = function (variable) {
    var timestamp = Date.parse(variable);

    if (isNaN(timestamp)) {
      return "";
    }

    var _a = variable.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    var dateFormatted = year + "-" + month + "-" + day;
    return dateFormatted;
  };

  LogicalExpressionsDate.prototype.parseValue = function (dateString) {
    if (dateString === undefined || dateString === null) {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return LogicalExpressionsDate;
}(logicalExpressions_LogicalExpressionsType);

/* harmony default export */ var datatypes_LogicalExpressionsDate = (LogicalExpressionsDate_LogicalExpressionsDate);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/LogicalExpressions.vue?vue&type=script&lang=ts&



























var LogicalExpressionsvue_type_script_lang_ts_LogicalExpressions =
/** @class */
function (_super) {
  __extends(LogicalExpressions, _super); // private columns: LogicalExpressionsHeader[] = [];


  function LogicalExpressions() {
    var _this = _super.call(this) || this;

    _this.valid = false;
    _this.filters = [];
    _this.filterHeaders = new Map();
    _this.hasChanges = false;
    _this.selectedColumn = null;
    return _this;
  }

  LogicalExpressions.prototype.onFiltersChanged = function (val, oldVal) {
    console.log("filters: ", val, oldVal);
    this.apply();
  };

  LogicalExpressions.prototype.onExternalFiltersChanged = function (val, oldVal) {
    var _this = this; // console.log("external filters: ", val, oldVal);


    if (val === undefined) {
      return;
    }

    var old = this.applyFilters(this.filters.filter(function (f) {
      return f.active;
    })).expressions;

    if (this.isSame(old, val)) {
      return;
    }

    var filters = val.map(function (o) {
      return _this.stringToFilter(o);
    });
    this.filters = [];

    for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
      var f = filters_1[_i];

      if (f !== undefined) {
        this.filters.push(f.filter);
        this.filterHeaders.set(f.filter, f.header);
      }
    }
  }; // @Watch("headers", { deep: true, immediate: true })
  // public onHeadersChanged(
  //   val: LogicalExpressionsHeader[],
  //   oldVal: LogicalExpressionsHeader[]
  // ) {
  //   if (val === undefined) {
  //     return;
  //   }
  //   console.log("$$$$$$$$$$$$$$$$$$$$$$", val);
  //   this.columns = val.filter((h) => h.visible);//.map((h) => h.title);
  // }


  LogicalExpressions.prototype.onValidChanged = function (val) {
    this.emitValid(); // this.apply();
  };

  LogicalExpressions.prototype.isDateOperator = function (filter) {
    // console.log(filter);
    if (filter.operator) {
      console.log(filter.operator instanceof operators_LogicalExpressionsDateGreaterThan);
    }

    return filter.operator && (filter.operator instanceof operators_LogicalExpressionsDateGreaterThan || filter.operator instanceof operators_LogicalExpressionsDateGreaterThanOrEquals || filter.operator instanceof operators_LogicalExpressionsDateLowerThan || filter.operator instanceof operators_LogicalExpressionsDateLowerThanOrEquals || filter.operator instanceof operators_LogicalExpressionsDateEquals || filter.operator instanceof operators_LogicalExpressionsDateNotEquals);
  };

  LogicalExpressions.prototype.onSelectedColumnChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var filter;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.selectedColumn === null || this.selectedColumn === undefined) {
              return [2
              /*return*/
              ];
            }

            filter = this.selectedColumn.type.createNewFilter(this.selectedColumn);
            this.filterHeaders.set(filter, this.selectedColumn);
            this.filters.push(filter);
            this.hasChanges = true;
            return [4
            /*yield*/
            , this.delay(20)];

          case 1:
            _a.sent();

            this.selectedColumn = undefined;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  LogicalExpressions.prototype.clear = function () {
    this.filters.splice(0, this.filters.length);
    this.filterHeaders.clear();
    this.hasChanges = false;
    return {
      expressions: [],
      usedParameters: []
    };
  };

  LogicalExpressions.prototype.transLabel = function (filter) {
    if (this.filterHeaders !== undefined && filter !== undefined) {
      var key = this.filterHeaders.get(filter);

      if (key !== undefined) {
        return this.trans(key.title);
      }
    }

    return "";
  };

  LogicalExpressions.prototype.getFilterOperators = function (filter, index) {
    if (filter.type instanceof datatypes_LogicalExpressionsNumber) {
      var existingFilters = this.filters.filter(function (f) {
        return f.type.key === filter.type.key;
      });
      var firstIndex = this.filters.indexOf(existingFilters[0]);

      if (existingFilters.length === 2) {
        if (existingFilters[0].operator.symbol === ">" || existingFilters[0].operator.symbol === ">=") {
          if (index === firstIndex) {
            return existingFilters[0].type.operators.filter(function (o) {
              return o.symbol !== "=" && o.symbol !== "≠" && o.symbol !== "<" && o.symbol !== "<=";
            });
          } else {
            return existingFilters[0].type.operators.filter(function (o) {
              return o.symbol !== "=" && o.symbol !== "≠" && o.symbol !== ">" && o.symbol !== ">=";
            });
          }
        } else {
          if (index === firstIndex) {
            return existingFilters[0].type.operators.filter(function (o) {
              return o.symbol !== "=" && o.symbol !== "≠" && o.symbol !== ">" && o.symbol !== ">=";
            });
          } else {
            return existingFilters[0].type.operators.filter(function (o) {
              return o.symbol !== "=" && o.symbol !== "≠" && o.symbol !== "<" && o.symbol !== "<=";
            });
          }
        }
      }
    }

    return filter.type.operators;
  };

  LogicalExpressions.prototype.isSame = function (old, val) {
    // console.log(old, val);
    var isSame = true;

    var _loop_1 = function _loop_1(v) {
      var found = old.filter(function (o) {
        return o === v;
      });
      isSame = found.length > 0;

      if (!isSame) {
        return {
          value: false
        };
      }
    };

    for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
      var v = val_1[_i];

      var state_1 = _loop_1(v);

      if (typeof_typeof(state_1) === "object") return state_1.value;
    }

    var _loop_2 = function _loop_2(v) {
      var found = val.filter(function (o) {
        return o === v;
      });
      isSame = found.length > 0;

      if (!isSame) {
        return {
          value: false
        };
      }
    };

    for (var _a = 0, old_1 = old; _a < old_1.length; _a++) {
      var v = old_1[_a];

      var state_2 = _loop_2(v);

      if (typeof_typeof(state_2) === "object") return state_2.value;
    }

    return true;
  };

  LogicalExpressions.prototype.remove = function (filter) {
    this.hasChanges = true;
    this.filterHeaders.delete(filter);
    var index = this.filters.indexOf(filter);
    this.filters.splice(index, 1);
    this.apply();
  };

  LogicalExpressions.prototype.delay = function (ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  LogicalExpressions.prototype.stringToFilter = function (condition) {
    // const [field, operatorStr, valueStr] = condition.split(" ");
    var parts = condition.split(" ");
    var field = parts[0];
    var operatorStr = parts[1];
    var valueStr = parts.slice(2).join(" ");
    var header = this.headers.filter(function (o) {
      return o.type.key === field.replace("]", "").replace("[", "");
    });
    console.log(parts);

    if (header.length === 0) {
      return undefined;
    }

    var h = header[0];
    var f = new logicalExpressions_LogicalExpressionsColumnFilter(h.type);
    var operator = this.stringToOperator(h.type, operatorStr, valueStr);

    if (operator === undefined) {
      return undefined;
    }

    f.operator = operator;
    f.value = this.stringToValue(h.type, valueStr);
    return {
      header: h,
      filter: f
    };
  };

  LogicalExpressions.prototype.stringToOperator = function (type, operatorStr, valueStr) {
    if (type instanceof datatypes_LogicalExpressionsDate) {
      if (valueStr === "'0001-01-01T00:00:00.000Z'") {
        if (operatorStr === "!=") {
          return new operators_LogicalExpressionsDateExists();
        } else {
          return new operators_LogicalExpressionsDateNotExists();
        }
      }
    }

    return type.stringToOperator(operatorStr);
  };

  LogicalExpressions.prototype.stringToValue = function (type, valueStr) {
    return type.stringToValue(valueStr);
  };

  LogicalExpressions.prototype.emitValid = function () {
    return this.valid;
  };

  LogicalExpressions.prototype.apply = function () {
    if (this.headers === undefined) {
      return;
    }

    this.hasChanges = false;
    return this.applyFilters(this.filters.filter(function (f) {
      return f.active;
    }));
  };

  LogicalExpressions.prototype.applyFilters = function (filters) {
    if (filters === undefined || filters.length === 0) {
      return {
        expressions: [],
        usedParameters: []
      };
    }

    var expressions = [];
    var usedParameters = [];
    var translatedExpressions = [];

    var _loop_3 = function _loop_3(f) {
      var header = this_1.headers.filter(function (o) {
        return o.type.key === f.type.key;
      })[0];
      var result = f.operator.applyFilter(header.type.key, f.value);
      f.type instanceof datatypes_LogicalExpressionsEnum ? translatedExpressions.push(result.translatedExpression) : translatedExpressions.push(result.expression);
      expressions.push(result.expression);
      usedParameters.push(result.parameter);
    };

    var this_1 = this;

    for (var _i = 0, filters_2 = filters; _i < filters_2.length; _i++) {
      var f = filters_2[_i];

      _loop_3(f);
    }

    return {
      translatedExpressions: translatedExpressions,
      expressions: expressions,
      usedParameters: usedParameters
    };
  };

  LogicalExpressions.prototype.close = function () {
    return;
  };

  LogicalExpressions.prototype.isValid = function () {
    return this.filters.length > 0 && !this.filters.some(function (f) {
      return f.value === "" || f.value === undefined;
    }) || this.hasChanges && this.filters.length === 0;
  };

  LogicalExpressions.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  LogicalExpressions.prototype.selectedColumns = function () {
    var _this = this;

    var headers = [];

    var _loop_4 = function _loop_4(header) {
      if (header instanceof logicalExpressions_LogicalExpressionsHeader) {
        // console.log(header);
        var hCopy_1;

        if (header.type instanceof datatypes_LogicalExpressionsNumber) {
          hCopy_1 = new logicalExpressions_LogicalExpressionsHeader({
            title: header.title,
            type: header.type.copy()
          });
        } else {
          hCopy_1 = new logicalExpressions_LogicalExpressionsHeader({
            title: header.title,
            type: header.type
          });
        } // console.log(hCopy)


        if (hCopy_1.type instanceof datatypes_LogicalExpressionsNumber) {
          var existingFilters_1 = this_2.filters.filter(function (f) {
            return f.type.key === hCopy_1.type.key;
          });

          if (existingFilters_1.length > 0) {
            var operators = hCopy_1.type.operators.filter(function (o) {
              return o.symbol !== existingFilters_1[0].operator.symbol && o.symbol !== "=" && o.symbol !== "≠";
            });
            hCopy_1.type.operators = operators;
          }
        }

        headers.push(hCopy_1);
      }
    };

    var this_2 = this;

    for (var _i = 0, _a = this.headers.filter(function (h) {
      var existsInFilters = false;

      if (h.type instanceof datatypes_LogicalExpressionsNumber) {
        var existingFilters = _this.filters.filter(function (f) {
          return f.type.key === h.type.key;
        });

        if (existingFilters.length === 1) {
          var existingOperator = existingFilters[0].operator;

          if (existingOperator instanceof operators_LogicalExpressionsEquals) {
            existsInFilters = true;
          } else {
            existsInFilters = false;
          }
        } else if (existingFilters.length === 0) {
          existsInFilters = false;
        } else {
          existsInFilters = true;
        }
      } else {
        existsInFilters = _this.filters.filter(function (f) {
          return f.type.key === h.type.key;
        }).length > 0;
      }

      return h.searchable && h.allowVisibilityChange && !existsInFilters;
    }); _i < _a.length; _i++) {
      var header = _a[_i];

      _loop_4(header);
    }

    return headers;
  };

  __decorate([Prop({
    default: function _default() {}
  }), __metadata("design:type", Object)], LogicalExpressions.prototype, "dropdownItems", void 0);

  __decorate([Prop({
    default: function _default() {
      return "en";
    }
  }), __metadata("design:type", String)], LogicalExpressions.prototype, "languageCode", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], LogicalExpressions.prototype, "materialCard", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", Array)], LogicalExpressions.prototype, "headers", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], LogicalExpressions.prototype, "loading", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], LogicalExpressions.prototype, "isDialog", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], LogicalExpressions.prototype, "externalFilters", void 0);

  __decorate([Watch("filters", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "onFiltersChanged", null);

  __decorate([Watch("externalFilters", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "onExternalFiltersChanged", null);

  __decorate([Watch("valid"), __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "onValidChanged", null);

  __decorate([Emit("apply"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "clear", null);

  __decorate([Emit("valid"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "emitValid", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "apply", null);

  __decorate([Emit(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], LogicalExpressions.prototype, "close", null);

  LogicalExpressions = __decorate([vue_class_component_common_default()({
    components: {
      VDialog: lib_["VDialog"],
      VCardText: lib_["VCardText"],
      VDataTable: lib_["VDataTable"],
      VIcon: lib_["VIcon"],
      VBtn: lib_["VBtn"],
      VList: lib_["VList"],
      VListItem: lib_["VListItem"],
      VListItemTitle: lib_["VListItemTitle"],
      VListItemContent: lib_["VListItemContent"],
      VContainer: lib_["VContainer"],
      VRow: lib_["VRow"],
      VCol: lib_["VCol"],
      VMenu: lib_["VMenu"],
      VTextField: lib_["VTextField"],
      VCheckbox: lib_["VCheckbox"],
      VCard: lib_["VCard"],
      VCardActions: lib_["VCardActions"],
      VForm: lib_["VForm"],
      VSelect: lib_["VSelect"],
      PbasDatePicker: components_PbasDatePicker,
      VCardTitle: lib_["VCardTitle"]
    }
  }), __metadata("design:paramtypes", [])], LogicalExpressions);
  return LogicalExpressions;
}(external_vue_default.a);

/* harmony default export */ var LogicalExpressionsvue_type_script_lang_ts_ = (LogicalExpressionsvue_type_script_lang_ts_LogicalExpressions);
// CONCATENATED MODULE: ./src/lib/components/LogicalExpressions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_LogicalExpressionsvue_type_script_lang_ts_ = (LogicalExpressionsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/LogicalExpressions.vue?vue&type=style&index=0&id=47da686d&scoped=true&lang=css&
var LogicalExpressionsvue_type_style_index_0_id_47da686d_scoped_true_lang_css_ = __webpack_require__("b49e");

// CONCATENATED MODULE: ./src/lib/components/LogicalExpressions.vue






/* normalize component */

var LogicalExpressions_component = normalizeComponent(
  components_LogicalExpressionsvue_type_script_lang_ts_,
  LogicalExpressionsvue_type_template_id_47da686d_scoped_true_render,
  LogicalExpressionsvue_type_template_id_47da686d_scoped_true_staticRenderFns,
  false,
  null,
  "47da686d",
  null
  
)

/* harmony default export */ var components_LogicalExpressions = (LogicalExpressions_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasSimpleTable.vue?vue&type=template&id=4beddfd7&scoped=true&
var PbasSimpleTablevue_type_template_id_4beddfd7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataProvider !== null && _vm.dataProvider !== undefined)?_c('div',{ref:"container",staticClass:"pbas-data-table-container",style:({
    '--max-height': _vm.maxHeight !== undefined ? _vm.maxHeight + 'px' : 'auto',
  })},[(_vm.dataProvider)?_c('v-data-table',{attrs:{"mobile-breakpoint":"0","headers":this.dataProvider !== undefined
        ? this.dataProvider.headers.filter(function (h) { return h.visible; })
        : [],"loading":_vm.loading,"items":_vm.fetchResult.items,"server-items-length":_vm.fetchResult.count,"options":_vm.optionsValue,"fixed-header":false,"show-expand":false,"show-select":false,"sort-by":_vm.sortByInternal,"sort-desc":_vm.sortDescendingLoc,"item-key":_vm.dataProvider.headers.some(function (h) { return h.isIdentifier; })
        ? _vm.dataProvider.headers.find(function (h) { return h.isIdentifier; }).type.key
        : '',"hide-default-footer":true},on:{"update:options":function($event){_vm.optionsValue=$event},"update:sortBy":function($event){_vm.sortByInternal=$event},"update:sort-by":function($event){_vm.sortByInternal=$event},"update:sortDesc":function($event){_vm.sortDescendingLoc=$event},"update:sort-desc":function($event){_vm.sortDescendingLoc=$event}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('div',{ref:"horizontalScroll",staticStyle:{"overflow-x":"auto"}},[_c('div',{ref:"horizontalScrollContent",staticStyle:{"width":"1px","height":"1px"}})])]},proxy:true},_vm._l((_vm.dataProvider.headers),function(header){return {key:_vm.headerSlotFunc(header),fn:function(ref){
        var header = ref.header;
return [_c('div',{key:header.value,staticStyle:{"display":"inline-block"}},[_c('span',[_vm._v(_vm._s(_vm.trans(header.title)))])])]}}}),_vm._l((_vm.dataProvider.headers.filter(function (h) { return h.visible; })),function(header,index){return {key:_vm.itemSlotFunc(header),fn:function(ref){
        var header = ref.header;
        var item = ref.item;
return [_c('div',{key:header.type.key,style:('justify-content: ' +
            (header.align != 'center' ? 'flex-' + header.align : 'center')),on:{"contextmenu":function($event){$event.preventDefault();_vm.contextMenuSelectedItem = item;
          _vm.contextMenuOpened = true;
          if (_vm.$refs.menu != null) { _vm.$refs.menu.open($event); }}}},[(header.type.getHtml !== undefined)?_c('div',{domProps:{"innerHTML":_vm._s(header.type.getHtml(item, header.type))}}):(header.type.getComponent !== undefined)?_c('div',[_c(header.type.getComponent(item, header),{tag:"component",attrs:{"data":{ item: item, header: header }}})],1):_c('span',[_vm._v(_vm._s(header.type.getString(item, header.type)))])])]}}}),_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(scope){return [_vm._t(name,null,null,scope)]}}})],null,true)}):_vm._e(),_c('div',{ref:"headersContainer",style:({
      position: 'fixed',
      top: '0',
      background: 'white',
      width: '100%',
      visibility: 'hidden',
      'overflow-x': 'auto',
      'z-index': _vm.headersZIndex,
    })},[_c('table',{ref:"headers",staticClass:"v-data-table",staticStyle:{"border-spacing":"0"}})])],1):_vm._e()}
var PbasSimpleTablevue_type_template_id_4beddfd7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/PbasSimpleTable.vue?vue&type=template&id=4beddfd7&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/PbasSimpleTable.vue?vue&type=script&lang=ts&














var PbasSimpleTablevue_type_script_lang_ts_PbasSimpleTable =
/** @class */
function (_super) {
  __extends(PbasSimpleTable, _super);

  function PbasSimpleTable() {
    var _this = _super.call(this) || this;

    _this.$refs = {
      horizontalScrollContent: HTMLElement,
      horizontalScroll: HTMLElement,
      container: HTMLElement,
      headers: HTMLElement,
      headersContainer: HTMLElement
    };
    _this.matchColumns = true;
    _this.sortDescendingLoc = false;
    _this.loading = false;
    _this.options = {};
    _this.optionsValue = {};
    _this.showCustomizeColumns = false;
    _this.sortByInternal = "";
    _this.addedEvents = false;
    _this.fetchResult = new lib_FetchResult(0, []);
    return _this;
  }

  PbasSimpleTable.prototype.destroy = function () {
    window.removeEventListener("resize", this.onWindowSizeChanged);
    window.removeEventListener("scroll", this.onScroll);
  };

  PbasSimpleTable.prototype.mounted = function () {
    this.sortDescendingLoc = this.sortDescending;
    this.loadPreferences();
    window.addEventListener("resize", this.onWindowSizeChanged);
    window.addEventListener("scroll", this.onScroll);
  };

  PbasSimpleTable.prototype.updated = function () {
    if (this.$el !== undefined && this.$el !== null && this.$el.querySelector !== undefined) {
      this.addScrollEvents();
      this.onScroll();
      this.resizeScrollbar();
    }
  };

  PbasSimpleTable.prototype.getDataAsync = function () {
    return __awaiter(this, void 0, Promise, function () {
      var οpts, sortOptions, localPromise, result, error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.dataProvider === undefined) {
              return [2
              /*return*/
              ];
            }

            this.loading = true;
            οpts = this.options;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (_this.dataProvider !== undefined) {
                var headerObj = _this.dataProvider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];

                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            this.fetchingPromise = this.dataProvider.fetchAsync(undefined, undefined, sortOptions);
            localPromise = this.fetchingPromise;
            this.fetchResult = new lib_FetchResult(0, []);
            return [4
            /*yield*/
            , localPromise];

          case 2:
            result = _a.sent();

            if (localPromise === this.fetchingPromise) {
              this.fetchResult = result;
              this.onItemsChanged();
              this.loading = false;
            }

            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            this.$emit("error", error_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasSimpleTable.prototype.addScrollEvents = function () {
    var _this = this;

    if (this.addedEvents || this.$el.querySelector === undefined) {
      return;
    }

    var wrapper = this.$el.querySelector(".v-data-table__wrapper");

    if (wrapper !== null) {
      wrapper.addEventListener("scroll", function (event) {
        _this.$refs.horizontalScroll.scrollLeft = wrapper.scrollLeft;
        _this.$refs.headersContainer.scrollLeft = wrapper.scrollLeft;
      });
      this.$refs.headersContainer.addEventListener("scroll", function (event) {
        wrapper.scrollLeft = _this.$refs.headersContainer.scrollLeft;
      });
      this.$refs.horizontalScroll.addEventListener("scroll", function (event) {
        wrapper.scrollLeft = _this.$refs.horizontalScroll.scrollLeft;
      });
      this.addedEvents = true;
      setTimeout(this.setupFixedHeader, 100);
    }
  };

  PbasSimpleTable.prototype.onSortByChange = function (newVal) {
    this.sortByInternal = newVal;
  };

  PbasSimpleTable.prototype.onWindowSizeChanged = function () {
    this.resizeScrollbar();
    this.onScroll();
  };

  PbasSimpleTable.prototype.setupFixedHeader = function () {
    if (this.$refs.container !== undefined && this.$el.querySelector !== undefined) {
      var header = this.$el.querySelector(".v-data-table-header");

      if (header !== undefined) {
        this.$refs.headersContainer.style.width = this.$refs.container.querySelector(".v-data-table__wrapper").offsetWidth + "px";
        var cln = header.cloneNode(true);
        this.$refs.headers.innerHTML = "";
        this.$refs.headers.append(cln);
        var thead2 = this.$refs.headers.querySelector(".v-data-table-header").children[0];
        this.$refs.headers.style.width = header.scrollWidth + "px";

        for (var _i = 0, _a = Object.keys(header.children[0].children); _i < _a.length; _i++) {
          var c = _a[_i];
          var source = header.children[0].children[c];

          if (source === undefined) {
            continue;
          }

          if (thead2.children[c].style !== undefined) {
            thead2.children[c].style.width = header.children[0].children[c].offsetWidth + "px";
          }
        }
      }
    }
  };

  PbasSimpleTable.prototype.onScroll = function () {
    var _this = this;

    clearTimeout(this.timeoutResult);
    this.timeoutResult = setTimeout(function () {
      _this.setupFixedHeader();

      if (_this.$refs.container === undefined || _this.$el.querySelector === undefined) {
        return;
      }

      var header = _this.$el.querySelector(".v-data-table-header");

      if (header === undefined) {
        return;
      }

      var tablevisible = _this.checkVisible(_this.$refs.container.querySelector(".v-data-table__wrapper"));

      if (!tablevisible) {
        _this.$refs.headersContainer.style.visibility = "hidden";
        return;
      }

      var isVisible = _this.checkVisible(header);

      _this.$refs.headersContainer.style.visibility = isVisible ? "hidden" : "visible";
    }, 100);
  };

  PbasSimpleTable.prototype.checkVisible = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  PbasSimpleTable.prototype.savePreferences = function () {
    if (this.identifier === undefined) {
      return;
    }

    window.localStorage["pbassimpletable__" + this.identifier] = JSON.stringify({
      options: this.options,
      visibleHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : [],
      hiddenHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return !h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : []
    });
    var inlineOptions = this.$refs.inlineTable ? this.$refs.inlineTable.options : undefined;

    if (inlineOptions === undefined) {
      var settingsJson = window.localStorage["pbassimpletable__inline" + this.identifier];

      if (settingsJson !== undefined) {
        var settings = JSON.parse(settingsJson);

        if (settings.options !== undefined) {
          inlineOptions = settings.options;
        }
      }
    }

    window.localStorage["pbassimpletable__inline" + this.identifier] = JSON.stringify({
      options: inlineOptions,
      visibleHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : [],
      hiddenHeaders: this.dataProvider !== undefined ? this.dataProvider.headers.filter(function (h) {
        return !h.visible;
      }).map(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "");
      }) : []
    });
  };

  PbasSimpleTable.prototype.loadPreferences = function () {
    if (this.identifier === undefined || this.dataProvider === undefined) {
      return;
    }

    var settingsJson = window.localStorage["pbassimpletable__" + this.identifier];

    if (settingsJson === undefined) {
      return;
    }

    var settings = JSON.parse(settingsJson);

    if (settings.options !== undefined) {
      this.options.itemsPerPage = settings.options.itemsPerPage;
    }

    var _loop_1 = function _loop_1(i) {
      var f = this_1.dataProvider.headers.find(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "") === i;
      });

      if (f !== undefined) {
        f.visible = true;
      }
    };

    var this_1 = this;

    for (var _i = 0, _a = settings.visibleHeaders; _i < _a.length; _i++) {
      var i = _a[_i];

      _loop_1(i);
    }

    var _loop_2 = function _loop_2(i) {
      var f = this_2.dataProvider.headers.find(function (h) {
        return "" + h.type.key + (h.version !== undefined ? ":" + h.version : "") === i;
      });

      if (f !== undefined) {
        f.visible = false;
      }
    };

    var this_2 = this;

    for (var _b = 0, _c = settings.hiddenHeaders; _b < _c.length; _b++) {
      var i = _c[_b];

      _loop_2(i);
    }
  };

  PbasSimpleTable.prototype.onOptionsValueChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // console.log("on-options-value-changed", this.optionsValue);
        if (this.dataProvider === null || this.dataProvider === undefined) {
          return [2
          /*return*/
          ];
        }

        this.options = this.optionsValue;
        return [2
        /*return*/
        ];
      });
    });
  };

  PbasSimpleTable.prototype.onDataProviderChanged = function (value, oldValue) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (value === undefined || value === null) {
          return [2
          /*return*/
          ];
        }

        this.loadPreferences();
        return [2
        /*return*/
        ];
      });
    });
  };

  PbasSimpleTable.prototype.delay = function (ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  PbasSimpleTable.prototype.onOptionsChanged = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.dataProvider === undefined) {
              return [2
              /*return*/
              ];
            } // const { sortBy, sortDesc, page, itemsPerPage } = this.options


            this.savePreferences();
            return [4
            /*yield*/
            , this.getDataAsync()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PbasSimpleTable.prototype.resizeScrollbar = function () {
    if (this.$el.querySelector !== undefined) {
      var wrapper = this.$el.querySelector(".v-data-table__wrapper");

      if (wrapper !== null && wrapper.children.length > 0) {
        var el = wrapper.children[0];

        if (el !== null && this.$refs.horizontalScrollContent !== undefined) {
          this.$refs.horizontalScrollContent.style.width = el.offsetWidth + "px";
        }
      }
    }
  };

  PbasSimpleTable.prototype.onItemsChanged = function () {
    return this.fetchResult.items;
  };

  PbasSimpleTable.prototype.itemSlotFunc = function (header) {
    return "item." + header.type.key;
  };

  PbasSimpleTable.prototype.headerSlotFunc = function (header) {
    return "header." + header.type.key;
  };

  PbasSimpleTable.prototype.updateHeaders = function (options) {
    this.showCustomizeColumns = false;

    if (this.dataProvider === undefined) {
      return;
    }

    var _loop_3 = function _loop_3(o) {
      var found = this_3.dataProvider.headers.find(function (h) {
        return h === o.header;
      });

      if (found !== undefined) {
        found.visible = o.visible;
      }
    };

    var this_3 = this;

    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
      var o = options_1[_i];

      _loop_3(o);
    }

    this.savePreferences();
  };

  PbasSimpleTable.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  var _a, _b, _c, _d;

  __decorate([Prop({
    default: false
  }), __metadata("design:type", Boolean)], PbasSimpleTable.prototype, "itemsChangeWarning", void 0);

  __decorate([Prop({
    default: function _default() {
      return 1;
    }
  }), __metadata("design:type", Number)], PbasSimpleTable.prototype, "headersZIndex", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", Object)], PbasSimpleTable.prototype, "dataProvider", void 0);

  __decorate([Prop({
    default: true
  }), __metadata("design:type", Boolean)], PbasSimpleTable.prototype, "canCustomize", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], PbasSimpleTable.prototype, "sortDescending", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasSimpleTable.prototype, "sortBy", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasSimpleTable.prototype, "maxHeight", void 0);

  __decorate([Prop({
    default: function _default() {
      return "data";
    }
  }), __metadata("design:type", String)], PbasSimpleTable.prototype, "fileNamePrefix", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], PbasSimpleTable.prototype, "floatActions", void 0);

  __decorate([Prop({
    default: function _default() {
      return undefined;
    }
  }), __metadata("design:type", String)], PbasSimpleTable.prototype, "identifier", void 0);

  __decorate([Watch("sortBy", {
    deep: true,
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], PbasSimpleTable.prototype, "onSortByChange", null);

  __decorate([Watch("optionsValue"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PbasSimpleTable.prototype, "onOptionsValueChanged", null);

  __decorate([Watch("dataProvider", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [typeof (_b = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _b : Object, typeof (_c = typeof lib_DataProvider !== "undefined" && lib_DataProvider) === "function" ? _c : Object]), __metadata("design:returntype", Promise)], PbasSimpleTable.prototype, "onDataProviderChanged", null);

  __decorate([Watch("options", {
    deep: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)], PbasSimpleTable.prototype, "onOptionsChanged", null);

  __decorate([Emit("itemsChanged"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], PbasSimpleTable.prototype, "onItemsChanged", null);

  PbasSimpleTable = __decorate([vue_class_component_common_default()({
    components: {
      VDialog: lib_["VDialog"],
      VCardText: lib_["VCardText"],
      VDataTable: lib_["VDataTable"],
      VIcon: lib_["VIcon"],
      VBtn: lib_["VBtn"],
      VList: lib_["VList"],
      VListItem: lib_["VListItem"],
      VListItemTitle: lib_["VListItemTitle"],
      VContainer: lib_["VContainer"],
      VRow: lib_["VRow"],
      VCol: lib_["VCol"],
      VMenu: lib_["VMenu"],
      VTextField: lib_["VTextField"],
      VCheckbox: lib_["VCheckbox"],
      VCard: lib_["VCard"],
      VRadioGroup: lib_["VRadioGroup"],
      VRadio: lib_["VRadio"],
      VCardActions: lib_["VCardActions"],
      VSpacer: lib_["VSpacer"],
      VCardTitle: lib_["VCardTitle"]
    }
  }), __metadata("design:paramtypes", [])], PbasSimpleTable);
  return PbasSimpleTable;
}(external_vue_default.a);

/* harmony default export */ var PbasSimpleTablevue_type_script_lang_ts_ = (PbasSimpleTablevue_type_script_lang_ts_PbasSimpleTable);
// CONCATENATED MODULE: ./src/lib/components/PbasSimpleTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PbasSimpleTablevue_type_script_lang_ts_ = (PbasSimpleTablevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/PbasSimpleTable.vue?vue&type=style&index=0&id=4beddfd7&scoped=true&lang=css&
var PbasSimpleTablevue_type_style_index_0_id_4beddfd7_scoped_true_lang_css_ = __webpack_require__("6cd1");

// EXTERNAL MODULE: ./src/lib/components/PbasSimpleTable.vue?vue&type=style&index=1&lang=css&
var PbasSimpleTablevue_type_style_index_1_lang_css_ = __webpack_require__("4f2e");

// CONCATENATED MODULE: ./src/lib/components/PbasSimpleTable.vue







/* normalize component */

var PbasSimpleTable_component = normalizeComponent(
  components_PbasSimpleTablevue_type_script_lang_ts_,
  PbasSimpleTablevue_type_template_id_4beddfd7_scoped_true_render,
  PbasSimpleTablevue_type_template_id_4beddfd7_scoped_true_staticRenderFns,
  false,
  null,
  "4beddfd7",
  null
  
)

/* harmony default export */ var components_PbasSimpleTable = (PbasSimpleTable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/MaterialCard.vue?vue&type=template&id=36c8de00&scoped=true&
var MaterialCardvue_type_template_id_36c8de00_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._g(_vm._b({staticClass:"material-card"},'v-card',_vm.$attrs,false),_vm.$listeners),[(_vm.icon || _vm.title)?_c('v-card-title',[(_vm.icon)?_c('v-icon',{staticClass:"v-card-icon",style:({
        'background-color':
          _vm.color !== '' ? _vm.color : _vm.$vuetify.theme.currentTheme.primary,
      }),attrs:{"dark":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col"},[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"col-auto"},[_vm._t("actions")],2)]),(_vm.$slots.title)?_c('div',{staticStyle:{"margin-left":"80px"}},[_vm._t("title")],2):_vm._e(),(_vm.title)?_c('v-divider',{staticClass:"mx-3"}):_vm._e()],1):_vm._e(),_vm._t("default"),(_vm.$slots.actions)?_c('v-divider',{staticClass:"mx-3"}):_vm._e()],2)}
var MaterialCardvue_type_template_id_36c8de00_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/MaterialCard.vue?vue&type=template&id=36c8de00&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/MaterialCard.vue?vue&type=script&lang=ts&




var MaterialCardvue_type_script_lang_ts_MaterialCard =
/** @class */
function (_super) {
  __extends(MaterialCard, _super);

  function MaterialCard() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialCard.prototype, "color", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], MaterialCard.prototype, "inline", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialCard.prototype, "icon", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialCard.prototype, "title", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialCard.prototype, "text", void 0);

  MaterialCard = __decorate([vue_class_component_common_default()({
    components: {
      VIcon: lib_["VIcon"],
      VDivider: lib_["VDivider"],
      VCardTitle: lib_["VCardTitle"],
      VCard: lib_["VCard"]
    }
  })], MaterialCard);
  return MaterialCard;
}(external_vue_default.a);

/* harmony default export */ var MaterialCardvue_type_script_lang_ts_ = (MaterialCardvue_type_script_lang_ts_MaterialCard);
// CONCATENATED MODULE: ./src/lib/components/MaterialCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_MaterialCardvue_type_script_lang_ts_ = (MaterialCardvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/MaterialCard.vue?vue&type=style&index=0&id=36c8de00&scoped=true&lang=css&
var MaterialCardvue_type_style_index_0_id_36c8de00_scoped_true_lang_css_ = __webpack_require__("4051");

// EXTERNAL MODULE: ./src/lib/components/MaterialCard.vue?vue&type=style&index=1&lang=css&
var MaterialCardvue_type_style_index_1_lang_css_ = __webpack_require__("08a9");

// CONCATENATED MODULE: ./src/lib/components/MaterialCard.vue







/* normalize component */

var MaterialCard_component = normalizeComponent(
  components_MaterialCardvue_type_script_lang_ts_,
  MaterialCardvue_type_template_id_36c8de00_scoped_true_render,
  MaterialCardvue_type_template_id_36c8de00_scoped_true_staticRenderFns,
  false,
  null,
  "36c8de00",
  null
  
)

/* harmony default export */ var components_MaterialCard = (MaterialCard_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/MaterialStatsCard.vue?vue&type=template&id=430cfa9f&scoped=true&
var MaterialStatsCardvue_type_template_id_430cfa9f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._g(_vm._b({staticClass:"v-card--material-stats",staticStyle:{"margin":"5px","min-width":"220px"},attrs:{"icon":_vm.icon}},'v-card',_vm.$attrs,false),_vm.$listeners),[_c('v-card-text',{attrs:{"title":_vm.value}},[_c('div',[_c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"headline font-weight-light text--primary",staticStyle:{"margin":"0 0 5px 0","font-size":"1.1rem !important","font-weight":"500 !important","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.value))])])]),_c('div',{style:({'background-color' : _vm.color, 'margin' : '0 auto', 'display':'table', 'padding': '20px', 'border-radius': '3px', 'box-shadow': '2px 2px 5px 1px rgba(0,0,0,.1)'})},[_c('v-icon',{attrs:{"size":"40","color":"white"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._t("actions")],2)])],1)}
var MaterialStatsCardvue_type_template_id_430cfa9f_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/MaterialStatsCard.vue?vue&type=template&id=430cfa9f&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/MaterialStatsCard.vue?vue&type=script&lang=ts&




var MaterialStatsCardvue_type_script_lang_ts_MaterialStatsCard =
/** @class */
function (_super) {
  __extends(MaterialStatsCard, _super);

  function MaterialStatsCard() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialStatsCard.prototype, "color", void 0);

  __decorate([Prop({
    default: function _default() {
      return false;
    }
  }), __metadata("design:type", Boolean)], MaterialStatsCard.prototype, "inline", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialStatsCard.prototype, "icon", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialStatsCard.prototype, "value", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], MaterialStatsCard.prototype, "text", void 0);

  MaterialStatsCard = __decorate([vue_class_component_common_default()({
    components: {
      VIcon: lib_["VIcon"],
      VCardText: lib_["VCardText"],
      VCard: lib_["VCard"]
    }
  })], MaterialStatsCard);
  return MaterialStatsCard;
}(external_vue_default.a);

/* harmony default export */ var MaterialStatsCardvue_type_script_lang_ts_ = (MaterialStatsCardvue_type_script_lang_ts_MaterialStatsCard);
// CONCATENATED MODULE: ./src/lib/components/MaterialStatsCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_MaterialStatsCardvue_type_script_lang_ts_ = (MaterialStatsCardvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/MaterialStatsCard.vue?vue&type=style&index=0&id=430cfa9f&scoped=true&lang=css&
var MaterialStatsCardvue_type_style_index_0_id_430cfa9f_scoped_true_lang_css_ = __webpack_require__("f4da");

// CONCATENATED MODULE: ./src/lib/components/MaterialStatsCard.vue






/* normalize component */

var MaterialStatsCard_component = normalizeComponent(
  components_MaterialStatsCardvue_type_script_lang_ts_,
  MaterialStatsCardvue_type_template_id_430cfa9f_scoped_true_render,
  MaterialStatsCardvue_type_template_id_430cfa9f_scoped_true_staticRenderFns,
  false,
  null,
  "430cfa9f",
  null
  
)

/* harmony default export */ var components_MaterialStatsCard = (MaterialStatsCard_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CodeEditor.vue?vue&type=template&id=318081f3&scoped=true&
var CodeEditorvue_type_template_id_318081f3_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formula-editor"},[_c('v-row',{staticStyle:{"height":"100%"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"max-height":"100%"},attrs:{"cols":"12"}},[_c('v-tabs',{staticStyle:{"height":"100%"},attrs:{"background-color":"primary","dark":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tabs-slider'),_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("Code Mode")]),_c('v-tab-item',{attrs:{"value":'tab-1'}},[_c('v-row',{staticStyle:{"height":"100%","overflow":"auto"},attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"order-sm-1 order-2",staticStyle:{"max-height":"100%"},attrs:{"cols":"12","sm":"4","lg":"3"}},[_c('code-toolbox',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters},on:{"variable":function($event){return _vm.addVariable($event)},"function":function($event){return _vm.addFunction($event)},"parameter":function($event){return _vm.addParameter($event)}}})],1),_c('v-col',{staticClass:"order-sm-2 order-1",staticStyle:{"max-height":"100%","display":"flex","flex-direction":"column"},attrs:{"cols":"12","sm":"8","lg":"9"}},[_c('v-row',{staticStyle:{"flex":"1"},attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('ace-editor',{ref:"editor",attrs:{"code":_vm.code,"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters},on:{"update:code":function($event){_vm.code=$event}}})],1)],1),_c('v-row',{staticStyle:{"flex":"0"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"height":"80px","background":"#ebebeb"},attrs:{"cols":"12"}},[_c('div',{staticStyle:{"padding":"10px","font-family":"Consolas, sans-serif"}},[_vm._v("\n                    "+_vm._s(_vm.actualCode)+"\n                  ")])])],1),_c('v-row',{staticStyle:{"background":"#ebebeb","flex":"0"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"background":"#ebebeb"},attrs:{"cols":"12"}},[_c('v-banner',{attrs:{"value":_vm.failedToParse,"single-line":"","color":"error","dark":"","sticky":true}},[_vm._v("\n                    "+_vm._s(_vm.codeError)+"\n                  ")]),_c('v-banner',{attrs:{"value":_vm.parseSuccess,"single-line":"","color":"success","dark":"","sticky":true}},[_c('v-layout',{attrs:{"no-gutters":""}},[_c('v-col',[_c('v-icon',[_vm._v("check")])],1),_c('v-col',[_vm._t("actions")],2)],1)],1)],1)],1)],1)],1)],1),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("Visual Mode")]),_c('v-tab-item',{attrs:{"value":'tab-2'}},[_c('div',{staticStyle:{"overflow":"auto","display":"flex","flex-direction":"column","height":"100%"}},[_c('div',{staticStyle:{"padding":"20px","flex":"1"}},[_c('node-component',{attrs:{"node":_vm.rootNode,"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters},on:{"update:node":function($event){_vm.rootNode=$event},"update":function($event){return _vm.onNodeChanged()}}})],1)])]),_vm._t("tabs")],2)],1)],1),_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"500"},model:{value:(_vm.showErrorDialog),callback:function ($$v) {_vm.showErrorDialog=$$v},expression:"showErrorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n        "+_vm._s(_vm.trans("pbascomponents.codeeditor.error"))+"\n      ")]),_c('v-card-text',[_c('p',[_vm._v("The variables below do not exist.")]),_vm._l((_vm.nonExistantVariables),function(opt){return _c('div',{key:opt},[_c('div',[_vm._v(_vm._s(opt))])])})],2),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"","text":""},on:{"click":function($event){_vm.showErrorDialog = false}}},[_vm._v("\n          "+_vm._s(_vm.trans("pbascomponents.pbascustomizecolumns.cancel"))+"\n        ")]),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("\n          "+_vm._s(_vm.trans("pbascomponents.pbascustomizecolumns.save"))+"\n        ")])],1)],1)],1)],1)}
var CodeEditorvue_type_template_id_318081f3_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CodeEditor.vue?vue&type=template&id=318081f3&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/AceEditor.vue?vue&type=template&id=0639c179&scoped=true&
var AceEditorvue_type_template_id_0639c179_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{ref:"editor",attrs:{"lang":"javascript","theme":"chrome","value":_vm.code},on:{"init":_vm.editorInit,"input":function($event){return _vm.$emit('update:code', $event)}}})}
var AceEditorvue_type_template_id_0639c179_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/AceEditor.vue?vue&type=template&id=0639c179&scoped=true&

// EXTERNAL MODULE: external "vue2-ace-editor"
var external_vue2_ace_editor_ = __webpack_require__("8380");
var external_vue2_ace_editor_default = /*#__PURE__*/__webpack_require__.n(external_vue2_ace_editor_);

// EXTERNAL MODULE: external "brace"
var external_brace_ = __webpack_require__("92ad");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/AceEditor.vue?vue&type=script&lang=ts&






var Range = external_brace_["acequire"]("ace/range").Range;

var AceEditorvue_type_script_lang_ts_AceEditor =
/** @class */
function (_super) {
  __extends(AceEditor, _super);

  function AceEditor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AceEditor.prototype.focus = function () {
    var editor = this.getEditor();
    editor.focus();
  };

  AceEditor.prototype.addFunction = function (func) {
    return __awaiter(this, void 0, void 0, function () {
      var editor, str, pos, range, emptyValues, emptyValue, index;
      return __generator(this, function (_a) {
        if (!this.$refs.editor || !func) {
          return [2
          /*return*/
          ];
        }

        editor = this.getEditor();
        str = func.name + "(" + func.args.map(function (a) {
          return a.defaultValue || "<" + a.name + ">";
        }).join(", ") + ")";
        pos = editor.getCursorPosition();
        range = editor.getSelectionRange();
        editor.session.replace(range, str);
        emptyValues = func.args.filter(function (a) {
          return a.defaultValue === undefined;
        });

        if (emptyValues.length > 0) {
          emptyValue = emptyValues[0];
          index = func.args.indexOf(emptyValue);
          range.start.column += 1 + func.name.length + index * 2;
          range.end.column = range.start.column + emptyValue.name.length + 2;
          editor.selection.setSelectionRange(range);
        }

        editor.focus();
        return [2
        /*return*/
        ];
      });
    });
  };

  AceEditor.prototype.addParameter = function (parameter) {
    var editor = this.getEditor();
    var pos = editor.getCursorPosition();
    var range = editor.getSelectionRange();
    editor.session.replace(range, "[" + parameter.name + "]");
    this.selectNextVariable();
  };

  AceEditor.prototype.addVariable = function (variable) {
    // console.log("-------------------------------var--------------: ", variable);
    var editor = this.getEditor();
    var pos = editor.getCursorPosition();
    var range = editor.getSelectionRange();
    editor.session.replace(range, "[" + variable.name + "]");
    this.selectNextVariable();
  };

  AceEditor.prototype.isFocused = function () {
    return this.getEditor().textInput.getElement() === document.activeElement;
  };

  AceEditor.prototype.onCodeChanged = function () {
    this.$emit("update:code", this.code);
  };

  AceEditor.prototype.editorInit = function () {
    __webpack_require__("2099");

    __webpack_require__("bb36");

    __webpack_require__("95b8");
  };

  AceEditor.prototype.selectNextVariable = function () {
    var editorComponent = this.$refs.editor;
    var editor = editorComponent.editor;
    var pos = editor.getCursorPosition();
    var content = editor.session.getLine(pos.row);
    var index = -1;
    var re = /<[a-zA-Z0-9]*>/g;
    var match;
    var text = "";
    match = re.exec(content);

    while (match !== null) {
      if (index === -1) {
        index = match.index;
        text = match[0];

        if (pos.column < match.index) {
          break;
        }
      } else if (pos.column < match.index) {
        index = match.index;
        text = match[0];
        break;
      }

      match = re.exec(content);
    }

    if (index !== -1) {
      editor.selection.setSelectionRange(new Range(pos.row, index, pos.row, index + text.length));
      editor.focus();
      return true;
    }

    editor.focus();
    return false;
  };

  AceEditor.prototype.getEditor = function () {
    var editorComponent = this.$refs.editor;
    return editorComponent.editor;
  };

  AceEditor.prototype.mounted = function () {
    return __awaiter(this, void 0, void 0, function () {
      var editorComponent, editor, $this, functionCompleter, variableCompleter, parameterCompleter, constantCompleter;
      return __generator(this, function (_a) {
        editorComponent = this.$refs.editor;

        if (!editorComponent) {
          return [2
          /*return*/
          ];
        }

        editor = editorComponent.editor;
        editor.getSession().setUseWorker(false);
        editor.getSession().setUseWrapMode(true);
        $this = this;
        editor.commands.addCommand({
          name: "commas",
          exec: function exec() {
            var pos = editor.getCursorPosition();
            var next = editor.getSession().doc.getTextRange(new Range(pos.row, pos.column, pos.row, pos.column + 1));

            if (next === ",") {
              editor.selection.setSelectionRange(new Range(pos.row, pos.column + 1, pos.row, pos.column + 1));
              return true;
            }

            return false;
          },
          bindKey: {
            mac: ",",
            win: ","
          }
        });
        editor.commands.addCommand({
          name: "brackets",
          exec: function exec() {
            var pos = editor.getCursorPosition();
            var next = editor.getSession().doc.getTextRange(new Range(pos.row, pos.column, pos.row, pos.column + 1));

            if (next === "]") {
              editor.selection.setSelectionRange(new Range(pos.row, pos.column + 1, pos.row, pos.column + 1));
              return true;
            }

            return false;
          },
          bindKey: {
            mac: "]",
            win: "]"
          }
        });
        editor.commands.addCommand({
          name: "tab",
          exec: function exec() {
            return $this.selectNextVariable();
          },
          bindKey: {
            mac: "Tab",
            win: "Tab"
          }
        });
        editor.commands.addCommand({
          name: "enterKey",
          exec: function exec() {
            return;
          },
          bindKey: {
            mac: "Enter",
            win: "Enter"
          }
        });
        editor.setFontSize("16px");
        functionCompleter = {
          getCompletions: function getCompletions(neditor, session, pos, prefix, callback) {
            callback(null, $this.functions.filter(function (f) {
              return f.name.toLowerCase().indexOf(prefix.toLowerCase()) >= 0;
            }).map(function (f) {
              return {
                caption: f.name,
                value: f.name + "(" + f.args.map(function (a) {
                  return a.defaultValue || "<" + a.name + ">";
                }).join(", ") + ")",
                meta: "function",
                completer: functionCompleter,
                pos: pos,
                doc: f.description
              };
            }));
          },
          insertMatch: function insertMatch(neditor, data) {
            editor.forEachSelection(function () {
              editor.completer.insertMatch(data.value);
              var pos = data.pos;
              editor.selection.setSelectionRange(new Range(pos.row, pos.column - 1, pos.row, pos.column - 1));
              $this.selectNextVariable();
            });
          },
          getDocTooltip: function getDocTooltip(item) {
            return item.doc;
          }
        };
        variableCompleter = {
          getCompletions: function getCompletions(neditor, session, pos, prefix, callback) {
            callback(null, $this.variables.map(function (word) {
              return {
                caption: word.name,
                value: "[" + word.name + "]",
                meta: "variable",
                completer: variableCompleter
              };
            }));
          }
        };
        parameterCompleter = {
          getCompletions: function getCompletions(neditor, session, pos, prefix, callback) {
            callback(null, $this.parameters.map(function (word) {
              return {
                caption: word.name,
                value: "[" + word.name + "]",
                meta: "parameter"
              };
            }));
          }
        };
        constantCompleter = {
          getCompletions: function getCompletions(neditor, session, pos, prefix, callback) {
            callback(null, ["true", "false"].map(function (word) {
              return {
                caption: word,
                value: word,
                meta: "constant"
              };
            }));
          }
        };
        editor.completers = [functionCompleter, variableCompleter, parameterCompleter, constantCompleter];
        editor.setOptions({
          enableLiveAutocompletion: true
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], AceEditor.prototype, "functions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], AceEditor.prototype, "variables", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], AceEditor.prototype, "code", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], AceEditor.prototype, "parameters", void 0);

  __decorate([Watch("code"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], AceEditor.prototype, "onCodeChanged", null);

  AceEditor = __decorate([vue_class_component_common_default()({
    components: {
      Editor: external_vue2_ace_editor_default.a
    }
  })], AceEditor);
  return AceEditor;
}(external_vue_default.a);

/* harmony default export */ var AceEditorvue_type_script_lang_ts_ = (AceEditorvue_type_script_lang_ts_AceEditor);
// CONCATENATED MODULE: ./src/lib/components/AceEditor.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_AceEditorvue_type_script_lang_ts_ = (AceEditorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/AceEditor.vue?vue&type=style&index=0&id=0639c179&scoped=true&lang=css&
var AceEditorvue_type_style_index_0_id_0639c179_scoped_true_lang_css_ = __webpack_require__("de7a");

// CONCATENATED MODULE: ./src/lib/components/AceEditor.vue






/* normalize component */

var AceEditor_component = normalizeComponent(
  components_AceEditorvue_type_script_lang_ts_,
  AceEditorvue_type_template_id_0639c179_scoped_true_render,
  AceEditorvue_type_template_id_0639c179_scoped_true_staticRenderFns,
  false,
  null,
  "0639c179",
  null
  
)

/* harmony default export */ var components_AceEditor = (AceEditor_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/NodeComponent.vue?vue&type=template&id=867fe350&scoped=true&
var NodeComponentvue_type_template_id_867fe350_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"math-node align-self-center"},[(
      _vm.node !== null &&
        _vm.getClassName(_vm.node) !== 'Node' &&
        !(_vm.getClassName(_vm.node) === 'ConstantNode' && _vm.node.value == undefined)
    )?_c('div',{staticClass:"align-self-center"},[(_vm.getClassName(_vm.node) == 'SymbolNode')?_c('div'):_vm._e(),(_vm.getClassName(_vm.node) == 'ArrayNode')?_c('div',{staticClass:"inline align-self-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"align-self-center"},'v-btn',attrs,false),on),[_vm._v(_vm._s(_vm.node.items[0].name))])]}}],null,false,966094099)},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.updateNode(null)}}},[_vm._v("Remove")]),_c('v-divider'),_c('v-list-item',{on:{"click":function($event){return _vm.convertToConstant()}}},[_vm._v("Convert to constant")]),_c('v-divider'),_vm._l((_vm.variables),function(item){return _c('v-list-item',{key:item.name,on:{"click":function($event){return _vm.addVariable(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("move_to_inbox")])],1),_c('v-list-item-content',[_vm._v(_vm._s(item.name))])],1)}),_c('v-divider'),_vm._l((_vm.parameters),function(item){return _c('v-list-item',{key:item.name,on:{"click":function($event){return _vm.addParameter(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("settings_applications")])],1),_c('v-list-item-content',[_vm._v(_vm._s(item.name))])],1)})],2)],1)],1):(_vm.getClassName(_vm.node) == 'ConstantNode')?_c('div',{staticClass:"inline align-self-center"},[_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"align-self-center"},'v-btn',attrs,false),on),[_vm._v(_vm._s(_vm.node.value))])]}}],null,false,2389156225),model:{value:(_vm.showEdit),callback:function ($$v) {_vm.showEdit=$$v},expression:"showEdit"}},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.updateNode(null)}}},[_vm._v("Remove")]),_c('v-divider'),(_vm.node.value !== false && _vm.node.value !== true)?_c('v-list-item',[_c('v-text-field',{attrs:{"outlined":"","dense":"","value":_vm.node.value,"hide-details":""},on:{"input":function($event){_vm.node.value =
                  $event === '' || isNaN($event)
                    ? $event
                    : parseFloat($event);
                _vm.updateNode(_vm.node);}}})],1):_vm._e(),(_vm.node.value === false || _vm.node.value === true)?_c('v-list-item',{on:{"click":function($event){_vm.addBoolean(true);
              _vm.showEdit = false;}}},[_vm._v("True")]):_vm._e(),(_vm.node.value === false || _vm.node.value === true)?_c('v-list-item',{on:{"click":function($event){_vm.addBoolean(false);
              _vm.showEdit = false;}}},[_vm._v("False")]):_vm._e(),_c('v-divider'),_vm._l((_vm.variables),function(item){return _c('v-list-item',{key:item.name,on:{"click":function($event){return _vm.addVariable(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("move_to_inbox")])],1),_c('v-list-item-content',[_vm._v(_vm._s(item.name))])],1)}),_c('v-divider'),_vm._l((_vm.parameters),function(item){return _c('v-list-item',{key:item.name,on:{"click":function($event){return _vm.addParameter(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("settings_applications")])],1),_c('v-list-item-content',[_vm._v(_vm._s(item.name))])],1)})],2)],1)],1):(_vm.getClassName(_vm.node) == 'FunctionNode')?_c('div',{staticClass:"function align-self-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"align-self-center"},'v-btn',attrs,false),on),[_c('div',{staticClass:"function-name"},[_vm._v(_vm._s(_vm.node.name))])])]}}],null,false,1793710895)},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.updateNode(null)}}},[_vm._v("Remove")]),_c('v-list-item',{on:{"click":function($event){return _vm.copy(_vm.node)}}},[_vm._v("Copy")]),_c('v-list-item',{on:{"click":function($event){return _vm.cut(_vm.node)}}},[_vm._v("Cut")])],1)],1),_c('div',{staticClass:"parameters align-self-center"},_vm._l((_vm.node.args),function(a,index){return _c('div',{key:index,staticClass:"parameter align-self-center"},[_c('node-component',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"node":_vm.node.args[index],"parent":_vm.node,"argumentIndex":index},on:{"update:node":function($event){return _vm.$set(_vm.node.args, index, $event)},"update":function($event){return _vm.updateNode(_vm.node)}}})],1)}),0)],1):(_vm.getClassName(_vm.node) == 'OperatorNode')?_c('div',{staticClass:"function align-self-center"},[_c('div',{staticClass:"inline align-self-center"},[(_vm.node.fn !== 'unaryMinus')?_c('node-component',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"node":_vm.node.args[0]},on:{"update:node":function($event){return _vm.$set(_vm.node.args, 0, $event)},"update":function($event){return _vm.updateNode(_vm.node)}}}):_vm._e(),_c('div',{staticClass:"inline op align-self-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"inline align-self-center",attrs:{"color":"#f3ffc4"}},'v-btn',attrs,false),on),[_vm._v(_vm._s(_vm.node.op))])]}}],null,false,815844074)},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.updateNode(null)}}},[_vm._v("Remove")]),_c('v-list-item',{on:{"click":function($event){return _vm.copy(_vm.node)}}},[_vm._v("Copy")]),_c('v-list-item',{on:{"click":function($event){return _vm.cut(_vm.node)}}},[_vm._v("Cut")]),_c('v-divider'),_vm._l(([
                  ['+', 'add'],
                  ['-', 'substract'],
                  ['*', 'multiply'],
                  ['/', 'divide'],
                  ['%', 'modulo'],
                  ['==', 'equal'],
                  ['!=', 'not equal'],
                  ['and', 'logical and'],
                  ['or', 'logical or'],
                  ['<', 'lower than'],
                  ['<=', 'lower than or equal'],
                  ['>', 'greater than'],
                  ['>=', 'greater than or equal'] ]),function(item,i){return _c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){_vm.node.op = item;
                  _vm.updateNode(_vm.node);}}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item[0])}}),_c('v-list-item-subtitle',{domProps:{"textContent":_vm._s(item[1])}})],1)],1)})],2)],1)],1),_c('div',{staticClass:"inline align-self-center"},[(_vm.node.fn !== 'unaryMinus')?_c('node-component',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"node":_vm.node.args[1]},on:{"update:node":function($event){return _vm.$set(_vm.node.args, 1, $event)},"update":function($event){return _vm.updateNode(_vm.node)}}}):_vm._e(),(_vm.node.fn === 'unaryMinus')?_c('node-component',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"node":_vm.node.args[0]},on:{"update:node":function($event){return _vm.$set(_vm.node.args, 0, $event)},"update":function($event){return _vm.updateNode(_vm.node)}}}):_vm._e()],1)],1)]):(_vm.getClassName(_vm.node) == 'ParenthesisNode')?_c('div',{staticClass:"inline align-self-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('div',{staticClass:"inline align-self-center"},[_c('div',{staticClass:"inline align-self-center"},[_c('v-btn',_vm._g(_vm._b({staticClass:"inline align-self-center parenthesis"},'v-btn',attrs,false),on),[_vm._v("(")])],1),_c('div',{staticClass:"inline align-self-center",staticStyle:{"padding":"0px 10px"}},[_c('node-component',{attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"node":_vm.node.content},on:{"update:node":function($event){return _vm.$set(_vm.node, "content", $event)},"update":function($event){if (_vm.node.content !== null) { _vm.updateNode(_vm.node); }
                  else { _vm.updateNode(null); }}}})],1),_c('div',{staticClass:"inline align-self-center"},[_c('v-btn',_vm._g(_vm._b({staticClass:"inline align-self-center parenthesis"},'v-btn',attrs,false),on),[_vm._v(")")])],1)])]}}],null,false,390860446)},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.updateNode(null)}}},[_vm._v("Remove")]),_c('v-list-item',{on:{"click":function($event){return _vm.copy(_vm.node)}}},[_vm._v("Copy")]),_c('v-list-item',{on:{"click":function($event){return _vm.cut(_vm.node)}}},[_vm._v("Cut")])],1)],1)],1):_vm._e()]):_c('div',{staticClass:"align-self-center"},[_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [(_vm.parent !== null && _vm.getClassName(_vm.parent) === 'FunctionNode')?_c('div',{staticClass:"align-self-center"},[_c('v-btn',_vm._g(_vm._b({staticClass:"align-self-center",attrs:{"color":"primary","dark":""}},'v-btn',attrs,false),on),[_vm._v("Add ("+_vm._s(_vm.getHint())+")")])],1):_c('div',{staticClass:"inline align-self-center"},[_c('v-btn',_vm._g(_vm._b({staticClass:"align-self-center",attrs:{"color":"primary","dark":""}},'v-btn',attrs,false),on),[_vm._v("Add")])],1)]}}]),model:{value:(_vm.showAdd),callback:function ($$v) {_vm.showAdd=$$v},expression:"showAdd"}},[_c('code-toolbox',{staticStyle:{"width":"400px","height":"400px"},attrs:{"functions":_vm.functions,"variables":_vm.variables,"parameters":_vm.parameters,"custom":[
          { name: 'Constant', action: 'constant', icon: 'filter_1' },
          { name: 'Operation', action: 'operation', icon: 'add' },
          { name: 'Parentheses', action: 'parentheses', icon: 'code' },
          { name: 'True', action: 'instrue', icon: 'check' },
          {
            name: 'False',
            action: 'insfalse',
            icon: 'radio_button_unchecked',
          },
          {
            name: 'Paste',
            action: 'paste',
            icon: 'content_paste',
          } ]},on:{"constant":function($event){_vm.addConstant();
          _vm.showAdd = false;},"parentheses":function($event){_vm.addParentheses();
          _vm.showAdd = false;},"operation":function($event){_vm.addOperation();
          _vm.showAdd = false;},"function":function($event){_vm.addFunction($event);
          _vm.showAdd = false;},"variable":function($event){_vm.addVariable($event);
          _vm.showAdd = false;},"parameter":function($event){_vm.addParameter($event);
          _vm.showAdd = false;},"instrue":function($event){_vm.addBoolean(true);
          _vm.showAdd = false;},"insfalse":function($event){_vm.addBoolean(false);
          _vm.showAdd = false;},"paste":function($event){_vm.paste();
          _vm.showAdd = false;}},model:{value:(_vm.showAdd),callback:function ($$v) {_vm.showAdd=$$v},expression:"showAdd"}})],1)],1)])}
var NodeComponentvue_type_template_id_867fe350_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/NodeComponent.vue?vue&type=template&id=867fe350&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CodeToolbox.vue?vue&type=template&id=df63b094&scoped=true&
var CodeToolboxvue_type_template_id_df63b094_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100%","display":"flex","flex-direction":"column"}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"","flat":""}},[_c('v-text-field',{attrs:{"clearable":"","placeholder":"Search","append-icon":"search","type":"text","aria-autocomplete":"off","dense":"","hide-details":true},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('v-list',{staticClass:"overflow-y-auto"},[(_vm.getFunctions().length > 0)?_c('v-list-group',{attrs:{"prepend-icon":"functions"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("Functions")])]},proxy:true}],null,false,1068206934)},_vm._l((_vm.getFunctions()),function(item,i){return _c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){return _vm.$emit('function', item)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_c('v-chip',{attrs:{"small":"","label":""}},[_vm._v(_vm._s(item.name)+" ")]),_vm._v("\n            "+_vm._s(item.example)+"\n          ")],1),_c('v-list-item-subtitle',{staticClass:"wrap-text",domProps:{"textContent":_vm._s(item.description)}})],1)],1)}),1):_vm._e(),(_vm.getVariables().length > 0)?_c('v-list-group',{attrs:{"prepend-icon":"move_to_inbox"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("Variables")])]},proxy:true}],null,false,377133138)},_vm._l((_vm.getVariables()),function(item,i){return _c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){return _vm.$emit('variable', item)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_c('v-chip',{attrs:{"small":"","label":""}},[_vm._v(_vm._s(item.name))]),(item.label)?_c('span',[_vm._v(" "+_vm._s(item.label))]):_vm._e()],1),_c('v-list-item-subtitle',{staticClass:"wrap-text",domProps:{"textContent":_vm._s(item.description)}})],1)],1)}),1):_vm._e(),(_vm.getParameters().length > 0)?_c('v-list-group',{attrs:{"prepend-icon":"settings_applications"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("Parameters")])]},proxy:true}],null,false,4135970045)},_vm._l((_vm.getParameters()),function(item,i){return _c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){return _vm.$emit('parameter', item)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_c('v-chip',{attrs:{"small":"","label":""}},[_vm._v(_vm._s(item.name))]),(item.label)?_c('span',[_vm._v(" "+_vm._s(item.label))]):_vm._e()],1),_c('v-list-item-subtitle',{staticClass:"wrap-text",domProps:{"textContent":_vm._s(item.description)}})],1)],1)}),1):_vm._e(),_vm._l((_vm.custom),function(item,i){return _c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){return _vm.$emit(item.action, item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])],1)],1)})],2)],1)}
var CodeToolboxvue_type_template_id_df63b094_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CodeToolbox.vue?vue&type=template&id=df63b094&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CodeToolbox.vue?vue&type=script&lang=ts&





var CodeToolboxvue_type_script_lang_ts_CodeToolbox =
/** @class */
function (_super) {
  __extends(CodeToolbox, _super);

  function CodeToolbox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.search = "";
    return _this;
  }

  CodeToolbox.prototype.getFunctions = function () {
    var _this = this;

    return this.search === null ? this.functions : this.functions.filter(function (f) {
      return f.name.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
    });
  };

  CodeToolbox.prototype.getVariables = function () {
    var _this = this;

    return this.search === null ? this.variables : this.variables.filter(function (f) {
      return f.name.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1 || f.label && f.label.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
    });
  };

  CodeToolbox.prototype.getParameters = function () {
    var _this = this;

    return this.search === null ? this.parameters : this.parameters.filter(function (f) {
      return f.name.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1 || f.label && f.label.toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
    });
  };

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeToolbox.prototype, "functions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeToolbox.prototype, "variables", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeToolbox.prototype, "parameters", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeToolbox.prototype, "custom", void 0);

  CodeToolbox = __decorate([vue_class_component_common_default.a], CodeToolbox);
  return CodeToolbox;
}(external_vue_default.a);

/* harmony default export */ var CodeToolboxvue_type_script_lang_ts_ = (CodeToolboxvue_type_script_lang_ts_CodeToolbox);
// CONCATENATED MODULE: ./src/lib/components/CodeToolbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CodeToolboxvue_type_script_lang_ts_ = (CodeToolboxvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CodeToolbox.vue?vue&type=style&index=0&id=df63b094&scoped=true&lang=css&
var CodeToolboxvue_type_style_index_0_id_df63b094_scoped_true_lang_css_ = __webpack_require__("9096");

// CONCATENATED MODULE: ./src/lib/components/CodeToolbox.vue






/* normalize component */

var CodeToolbox_component = normalizeComponent(
  components_CodeToolboxvue_type_script_lang_ts_,
  CodeToolboxvue_type_template_id_df63b094_scoped_true_render,
  CodeToolboxvue_type_template_id_df63b094_scoped_true_staticRenderFns,
  false,
  null,
  "df63b094",
  null
  
)

/* harmony default export */ var components_CodeToolbox = (CodeToolbox_component.exports);
// EXTERNAL MODULE: external "mathjs-expression-parser"
var external_mathjs_expression_parser_ = __webpack_require__("03e6");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/NodeComponent.vue?vue&type=script&lang=ts&







var NodeComponentvue_type_script_lang_ts_NodeComponent =
/** @class */
function (_super) {
  __extends(NodeComponent, _super);

  function NodeComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.showAdd = false;
    _this.showEdit = false;
    return _this;
  }

  NodeComponent_1 = NodeComponent;

  NodeComponent.prototype.getClassName = function (obj) {
    if (external_mathjs_expression_parser_["type"].isSymbolNode(obj)) {
      return "SymbolNode";
    }

    if (external_mathjs_expression_parser_["type"].isFunctionNode(obj)) {
      return "FunctionNode";
    }

    if (external_mathjs_expression_parser_["type"].isArrayNode(obj)) {
      return "ArrayNode";
    }

    if (external_mathjs_expression_parser_["type"].isConstantNode(obj)) {
      return "ConstantNode";
    }

    if (external_mathjs_expression_parser_["type"].isOperatorNode(obj)) {
      return "OperatorNode";
    }

    if (external_mathjs_expression_parser_["type"].isParenthesisNode(obj)) {
      return "ParenthesisNode";
    }

    if (external_mathjs_expression_parser_["type"].isAssignmentNode(obj)) {
      return "AssignmentNode";
    }

    return "";
  };

  NodeComponent.prototype.getHint = function () {
    var _this = this;

    var f = this.functions.filter(function (ff) {
      return ff.name === _this.parent.name;
    })[0];
    return f.args[this.argumentIndex].label || f.args[this.argumentIndex].name;
  };

  NodeComponent.prototype.addFunction = function (f) {
    var newNode = external_mathjs_expression_parser_["parse"](f.name + "(" + __spreadArrays(f.args.map(function (a) {
      return "0";
    })).join(",") + ")");
    newNode.args = newNode.args.map(function (a) {
      return null;
    });
    this.updateNode(newNode);
  };

  NodeComponent.prototype.addConstant = function () {
    var newNode = external_mathjs_expression_parser_["parse"](0);
    this.updateNode(newNode);
  };

  NodeComponent.prototype.addParentheses = function () {
    var newNode = external_mathjs_expression_parser_["parse"]("(0)");
    newNode.content = null;
    this.updateNode(newNode);
  };

  NodeComponent.prototype.addOperation = function () {
    var newNode = external_mathjs_expression_parser_["parse"]("1 + 1");
    newNode.args[0] = null;
    newNode.args[1] = null;
    this.updateNode(newNode);
  };

  NodeComponent.prototype.addBoolean = function (b) {
    this.updateNode(external_mathjs_expression_parser_["parse"](b ? "true" : "false"));
    this.showEdit = false;
  };

  NodeComponent.prototype.addVariable = function (f) {
    this.updateNode(external_mathjs_expression_parser_["parse"]("[" + f.name + "]"));
  };

  NodeComponent.prototype.addParameter = function (f) {
    this.updateNode(external_mathjs_expression_parser_["parse"]("[" + f.name + "]"));
  };

  NodeComponent.prototype.convertToConstant = function () {
    this.updateNode(external_mathjs_expression_parser_["parse"]("0"));
  };

  NodeComponent.prototype.updateNode = function (node) {
    this.$emit("update:node", node);
    this.$emit("update");
  };

  NodeComponent.prototype.copy = function (node) {
    NodeComponent_1.copiedNode = node.clone();
  };

  NodeComponent.prototype.cut = function (node) {
    NodeComponent_1.copiedNode = node.clone();
    this.updateNode(null);
  };

  NodeComponent.prototype.paste = function () {
    this.updateNode(NodeComponent_1.copiedNode.clone());
  };

  var NodeComponent_1, _a, _b;

  NodeComponent.copiedNode = null;

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", typeof (_a = typeof external_mathjs_expression_parser_ !== "undefined" && external_mathjs_expression_parser_["Node"]) === "function" ? _a : Object)], NodeComponent.prototype, "node", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], NodeComponent.prototype, "functions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], NodeComponent.prototype, "variables", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], NodeComponent.prototype, "parameters", void 0);

  __decorate([Prop({
    default: function _default() {
      return 0;
    }
  }), __metadata("design:type", Number)], NodeComponent.prototype, "argumentIndex", void 0);

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", typeof (_b = typeof external_mathjs_expression_parser_ !== "undefined" && external_mathjs_expression_parser_["Node"]) === "function" ? _b : Object)], NodeComponent.prototype, "parent", void 0);

  NodeComponent = NodeComponent_1 = __decorate([vue_class_component_common_default()({
    components: {
      CodeToolbox: components_CodeToolbox
    }
  })], NodeComponent);
  return NodeComponent;
}(external_vue_default.a);

/* harmony default export */ var NodeComponentvue_type_script_lang_ts_ = (NodeComponentvue_type_script_lang_ts_NodeComponent);
// CONCATENATED MODULE: ./src/lib/components/NodeComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_NodeComponentvue_type_script_lang_ts_ = (NodeComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/NodeComponent.vue?vue&type=style&index=0&id=867fe350&scoped=true&lang=css&
var NodeComponentvue_type_style_index_0_id_867fe350_scoped_true_lang_css_ = __webpack_require__("f639");

// CONCATENATED MODULE: ./src/lib/components/NodeComponent.vue






/* normalize component */

var NodeComponent_component = normalizeComponent(
  components_NodeComponentvue_type_script_lang_ts_,
  NodeComponentvue_type_template_id_867fe350_scoped_true_render,
  NodeComponentvue_type_template_id_867fe350_scoped_true_staticRenderFns,
  false,
  null,
  "867fe350",
  null
  
)

/* harmony default export */ var components_NodeComponent = (NodeComponent_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CodeEditor.vue?vue&type=script&lang=ts&














var CodeEditorvue_type_script_lang_ts_CodeEditor =
/** @class */
function (_super) {
  __extends(CodeEditor, _super);

  function CodeEditor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.nonExistantVariables = [];
    _this.code = "";
    _this.showErrorDialog = false;
    _this.rootNode = 0;
    _this.activeTab = "tab-1";
    _this.failedToParse = false;
    _this.usedParameters = {};
    _this.typeObject = null;
    _this.codeError = "";
    _this.parseSuccess = false;
    _this.codeEditing = false;
    return _this;
  }

  Object.defineProperty(CodeEditor.prototype, "allArguments", {
    get: function get() {
      var res = __spreadArrays(this.parameters.map(function (p) {
        return p.name;
      }), this.variables);

      return res;
    },
    enumerable: true,
    configurable: true
  });

  CodeEditor.prototype.mounted = function () {// empty
  };

  CodeEditor.prototype.addParameter = function (parameter) {
    if (!this.$refs.editor || !parameter) {
      return;
    }

    this.$refs.editor.addParameter(parameter);
  };

  CodeEditor.prototype.addVariable = function (variable) {
    if (!this.$refs.editor || !variable) {
      return;
    }

    this.$refs.editor.addVariable(variable);
  };

  CodeEditor.prototype.addFunction = function (func) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!this.$refs.editor || !func) {
          return [2
          /*return*/
          ];
        }

        this.$refs.editor.addFunction(func);
        return [2
        /*return*/
        ];
      });
    });
  };

  CodeEditor.prototype.sleep = function (ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  CodeEditor.prototype.getUsedParameters = function () {
    var res = [];
    var content = this.code;
    var exp = /\[[a-zA-Z0-9\.]*\]/g;
    var match;
    match = exp.exec(content);

    while (match !== null) {
      res.push(match[0]);
      match = exp.exec(content);
    }

    return res;
  };

  CodeEditor.prototype.onActualCodeChanged = function () {
    if (!this.$refs.editor || !this.$refs.editor.isFocused()) {
      this.code = this.actualCode;
    }
  };

  CodeEditor.prototype.onActiveTabchanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var c;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.activeTab !== "tab-1") {
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.sleep(50)];

          case 1:
            _a.sent();

            if (!this.$refs.editor) return [3
            /*break*/
            , 3];
            c = this.code;
            this.code = "";
            return [4
            /*yield*/
            , this.sleep(50)];

          case 2:
            _a.sent();

            this.$refs.editor.focus();
            this.$refs.editor.$forceUpdate();
            this.code = c;
            _a.label = 3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  CodeEditor.prototype.onNodeChanged = function () {
    if (this.rootNode === 0) {
      return;
    }

    this.onUpdate();

    if (external_mathjs_expression_parser_["type"].isConstantNode(this.rootNode) && this.rootNode.value === undefined) {
      if (this.code !== "") {
        this.code = "";
      }

      return;
    }

    if (this.rootNode) {
      try {
        if (this.containsSymbols(this.rootNode)) {
          throw new Error("symbols not allowed");
        }

        this.onUpdateActualCode(this.rootNode.toString({
          implicit: "hide",
          handler: function callback(node, options) {
            // console.log(node);
            if (external_mathjs_expression_parser_["type"].isConstantNode(node)) {
              // console.log(typeof node.value);
              // if (isNaN(node.value)) {//giati?
              if (typeof node.value === "string") {
                return "'" + node.value + "'";
              }

              return "" + node.value;
            }

            if (external_mathjs_expression_parser_["type"].isArrayNode(node)) {
              if (node.items.length === 1 && external_mathjs_expression_parser_["type"].isOperatorNode(node.items[0])) {
                if (external_mathjs_expression_parser_["type"].isConstantNode(node.items[0].args[0]) && external_mathjs_expression_parser_["type"].isSymbolNode(node.items[0].args[1]) && node.items[0].fn === "multiply" && node.items[0].implicit) {
                  return "[" + node.items[0].args[0] + node.items[0].args[1] + "]";
                }
              }
            }
          }
        }));

        if (!this.codeEditing) {
          this.code = this.actualCode;
        }

        this.$emit("valid", true);
      } catch (e) {
        console.warn(e);
        this.$emit("valid", false);
      }
    } else {
      this.$emit("valid", false);
      this.onUpdateActualCode("");
      this.code = "";
    }

    this.$forceUpdate();
  };

  CodeEditor.prototype.onCodeChanged = function (val) {
    return __awaiter(this, void 0, void 0, function () {
      var local, parameters, _loop_1, this_1, _i, parameters_1, p, _loop_2, this_2, _a, _b, key, node, res;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.$emit("update");
            this.codeEditing = true;
            this.failedToParse = this.parseSuccess = false;
            this.codeError = "";
            local = new Object();
            this.typeObject = local;
            return [4
            /*yield*/
            , this.sleep(800)];

          case 1:
            _c.sent();

            if (this.typeObject !== local) {
              return [2
              /*return*/
              ];
            }

            parameters = this.getUsedParameters();
            console.log(JSON.stringify(parameters), JSON.stringify(this.usedParameters), JSON.stringify(this.variables));
            this.nonExistantVariables = [];

            _loop_1 = function _loop_1(p) {
              if (!this_1.usedParameters[p] !== undefined) {
                if (!this_1.parameters.some(function (par) {
                  return "[" + par.name + "]" === p;
                }) && !this_1.variables.some(function (v) {
                  return "[" + v.name + "]" === p;
                })) {
                  this_1.nonExistantVariables.push(p);
                } else {
                  var params = this_1.parameters.filter(function (par) {
                    return "[" + par.name + "]" === p;
                  });
                  var vars = this_1.variables.filter(function (par) {
                    return "[" + par.name + "]" === p;
                  });

                  if (params.length > 0) {
                    if (this_1.usedParameters[p] === undefined) {
                      this_1.usedParameters[p] = {
                        value: params[0].defaultValue,
                        type: params[0].type,
                        parameterType: params[0].parameterType
                      };
                    }
                  } else {
                    if (this_1.usedParameters[p] === undefined) {
                      this_1.usedParameters[p] = {
                        value: vars[0].defaultValue,
                        type: vars[0].type
                      };
                    }
                  }
                }
              }
            };

            this_1 = this;

            for (_i = 0, parameters_1 = parameters; _i < parameters_1.length; _i++) {
              p = parameters_1[_i];

              _loop_1(p);
            }

            _loop_2 = function _loop_2(key) {
              var isParam = parameters.some(function (p) {
                return p === key;
              });

              if (!isParam) {
                delete this_2.usedParameters[key];
              }
            };

            this_2 = this;

            for (_a = 0, _b = Object.keys(this.usedParameters); _a < _b.length; _a++) {
              key = _b[_a];

              _loop_2(key);
            }

            try {
              console.log(this.code);
              node = external_mathjs_expression_parser_["parse"](this.code);
              console.log(node);
              res = this.containsSymbols(node);

              if (res) {
                throw new Error("Symbol '" + res + "' not found. Did you mean [" + res + "]");
              }

              res = this.containsAssignments(node);

              if (res) {
                throw new Error("Assignments are not allowed: '" + res + "'.");
              }

              res = this.containsAccessor(node);

              if (res) {
                throw new Error("Invalid symbol '" + res + "'.");
              }

              res = this.containsInexistantFunction(node);

              if (res) {
                throw new Error("Function '" + res + "' does not exist.");
              }

              res = this.getFunctionsWithInvalidNumberOfArguments(node);

              if (res) {
                throw new Error("Function '" + res + "' has invalid number of arguments.");
              }

              if (this.nonExistantVariables.length > 0) {
                throw new Error("Variables " + this.nonExistantVariables.join(", ") + " do not exist.");
              }

              this.rootNode = node;
              this.parseSuccess = this.code !== "" && true;
            } catch (e) {
              console.warn(e);
              this.codeError = e;
              this.failedToParse = true;
              this.$emit("valid", false);
            }

            this.$forceUpdate();
            return [4
            /*yield*/
            , this.sleep(10)];

          case 2:
            _c.sent();

            this.codeEditing = false;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  CodeEditor.prototype.containsAssignments = function (node) {
    var _this = this;

    if (!node) {
      return false;
    }

    if (external_mathjs_expression_parser_["type"].isAssignmentNode(node)) {
      return node.name;
    }

    if (node.args) {
      var res = node.args.map(function (s) {
        return _this.containsAssignments(s);
      }).filter(function (s) {
        return s;
      });

      if (res.length > 0) {
        return res;
      }
    }

    if (node.content) {
      var res = this.containsAssignments(node.content);

      if (res) {
        return res;
      }
    }

    return false;
  };

  CodeEditor.prototype.containsAccessor = function (node) {
    var _this = this;

    if (!node) {
      return false;
    }

    if (external_mathjs_expression_parser_["type"].isAccessorNode(node) || external_mathjs_expression_parser_["type"].isObjectNode(node)) {
      return node.toString();
    }

    if (node.args) {
      var res = node.args.map(function (s) {
        return _this.containsAccessor(s);
      }).filter(function (s) {
        return s;
      });

      if (res.length > 0) {
        return res;
      }
    }

    if (node.content) {
      var res = this.containsAccessor(node.content);

      if (res) {
        return res;
      }
    }

    return false;
  };

  CodeEditor.prototype.containsSymbols = function (node) {
    var _this = this;

    if (!node) {
      return false;
    }

    if (external_mathjs_expression_parser_["type"].isSymbolNode(node)) {
      return node.name;
    }

    if (node.args) {
      var res = node.args.map(function (s) {
        return _this.containsSymbols(s);
      }).filter(function (s) {
        return s;
      });

      if (res.length > 0) {
        return res;
      }
    }

    if (node.content) {
      var res = this.containsSymbols(node.content);

      if (res) {
        return res;
      }
    }

    return false;
  };

  CodeEditor.prototype.onUpdateActualCode = function (val) {
    this.$emit("update:actualCode", val);
  };

  CodeEditor.prototype.onUpdate = function () {
    this.$emit("update");
  };

  CodeEditor.prototype.getFunctionsWithInvalidNumberOfArguments = function (node) {
    var _this = this;

    if (!node) {
      return false;
    }

    if (external_mathjs_expression_parser_["type"].isFunctionNode(node)) {
      var res = this.functions.filter(function (f) {
        return f.name.toLocaleLowerCase() === node.name.toLocaleLowerCase() && f.name !== "SerialIf";
      });

      if (res.length === 1) {
        if (res[0].args.length !== node.args.length) {
          return node.name;
        }
      }
    }

    if (node.args) {
      var res = node.args.map(function (s) {
        return _this.containsInexistantFunction(s);
      }).filter(function (s) {
        return s;
      });

      if (res.length > 0) {
        return res;
      }
    }
  };

  CodeEditor.prototype.containsInexistantFunction = function (node) {
    var _this = this;

    if (!node) {
      return false;
    }

    if (external_mathjs_expression_parser_["type"].isFunctionNode(node)) {
      var res = this.functions.filter(function (f) {
        return f.name.toLocaleLowerCase() === node.name.toLocaleLowerCase();
      });

      if (res.length === 0) {
        return node.name;
      }
    }

    if (node.args) {
      var res = node.args.map(function (s) {
        return _this.containsInexistantFunction(s);
      }).filter(function (s) {
        return s;
      });

      if (res.length > 0) {
        return res;
      }
    }

    if (node.content) {
      var res = this.containsAccessor(node.content);

      if (res) {
        return res;
      }
    }

    return false;
  };

  CodeEditor.prototype.trans = function (key) {
    if (this.$t !== undefined) {
      return this.$t(key);
    }

    return key;
  };

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeEditor.prototype, "functions", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeEditor.prototype, "variables", void 0);

  __decorate([Prop({
    default: function _default() {
      return [];
    }
  }), __metadata("design:type", Array)], CodeEditor.prototype, "parameters", void 0);

  __decorate([Prop({
    default: function _default() {
      return "";
    }
  }), __metadata("design:type", String)], CodeEditor.prototype, "actualCode", void 0);

  __decorate([Watch("actualCode", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], CodeEditor.prototype, "onActualCodeChanged", null);

  __decorate([Watch("activeTab", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CodeEditor.prototype, "onActiveTabchanged", null);

  __decorate([Watch("rootNode", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], CodeEditor.prototype, "onNodeChanged", null);

  __decorate([Watch("code", {
    immediate: true
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], CodeEditor.prototype, "onCodeChanged", null);

  CodeEditor = __decorate([vue_class_component_common_default()({
    components: {
      AceEditor: components_AceEditor,
      NodeComponent: components_NodeComponent,
      CodeToolbox: components_CodeToolbox,
      VTextField: lib_["VTextField"]
    }
  })], CodeEditor);
  return CodeEditor;
}(external_vue_default.a);

/* harmony default export */ var CodeEditorvue_type_script_lang_ts_ = (CodeEditorvue_type_script_lang_ts_CodeEditor);
// CONCATENATED MODULE: ./src/lib/components/CodeEditor.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CodeEditorvue_type_script_lang_ts_ = (CodeEditorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CodeEditor.vue?vue&type=style&index=0&id=318081f3&scoped=true&lang=css&
var CodeEditorvue_type_style_index_0_id_318081f3_scoped_true_lang_css_ = __webpack_require__("63ca");

// CONCATENATED MODULE: ./src/lib/components/CodeEditor.vue






/* normalize component */

var CodeEditor_component = normalizeComponent(
  components_CodeEditorvue_type_script_lang_ts_,
  CodeEditorvue_type_template_id_318081f3_scoped_true_render,
  CodeEditorvue_type_template_id_318081f3_scoped_true_staticRenderFns,
  false,
  null,
  "318081f3",
  null
  
)

/* harmony default export */ var components_CodeEditor = (CodeEditor_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardDesigner.vue?vue&type=template&id=22f23381&scoped=true&
var CardDesignervue_type_template_id_22f23381_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photoshop"},[_c('v-row',{staticStyle:{"height":"100%","flex":"1"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"max-height":"100%","overflow-y":"auto"},attrs:{"cols":"12","md":"8","sm":"7","lg":"9","no-gutters":""}},[_c('v-row',{staticStyle:{"display":"flex","flex-direction":"column","height":"100%"},attrs:{"id":"container","ondragstart":"return false;","no-gutters":""}},[_c('v-col',{ref:"canvas",staticStyle:{"flex":"1 1 0%","position":"relative","overflow":"hidden","box-shadow":"inset 0 0 10px rgba(0,0,0,.1)","outline":"none"},attrs:{"cols":"12","tabindex":"-1"},on:{"wheel":function($event){_vm.onDesignerScroll($event);
            $event.preventDefault();
            $event.stopPropagation();
            return false;},"mousedown":function($event){_vm.mouseDown($event, null);
            $event.stopPropagation();
            $event.preventDefault();
            return false;},"click":function($event){_vm.mouseClick($event, null);
            $event.stopPropagation();
            $event.preventDefault();
            return false;}}},[(_vm.template !== null)?_c('div',{ref:"designer",class:{
              selected: _vm.template === _vm.selectedItem,
            },style:({
              position: 'absolute',
              width: _vm.template.WidthInPixels + 'px',
              height: _vm.template.HeightInPixels + 'px',
              'background-color': _vm.template.BackgroundColor,
              color: _vm.template.Color,
              transform: 'scale(' + _vm.zoom / 100 + ',' + _vm.zoom / 100 + ')',
              left: _vm.template.X + 'px',
              top: _vm.template.Y + 'px',
              'font-family': _vm.template.FontFamily,
            }),attrs:{"id":"designer","tabindex":"-1"},on:{"mousedown":function($event){_vm.mouseDown($event, _vm.template);
              $event.stopPropagation();
              $event.preventDefault();
              return false;},"click":function($event){_vm.mouseClick($event, _vm.template);
              $event.stopPropagation();
              $event.preventDefault();
              return false;}}},[(_vm.template.BackgroundImage)?_c('img',{staticStyle:{"position":"relative","display":"block","width":"100%","height":"100%"},attrs:{"ondragstart":"return false;","id":"background","src":'data:image/png;base64,' + _vm.template.BackgroundImage}}):_vm._e(),_vm._l((_vm.template.Labels.concat( _vm.template.Images )),function(label,index){return _c('div',{key:index,staticClass:"label",style:({
                overflow: 'hidden',
                position: 'absolute',
                top: (label.Y / 100) * _vm.template.HeightInPixels + 'px',
                left: (label.X / 100) * _vm.template.WidthInPixels + 'px',
                width: (label.Width / 100) * _vm.template.WidthInPixels + 'px',
                height: (label.Height / 100) * _vm.template.HeightInPixels + 'px',
              }),attrs:{"tabindex":"-1"},on:{"mousedown":function($event){_vm.mouseDown($event, label);
                $event.stopPropagation();
                $event.preventDefault();
                return false;},"click":function($event){_vm.mouseClick($event, label);
                $event.stopPropagation();
                $event.preventDefault();
                return false;}}},[(_vm.getSelectedItemClass(label) === 'CardLabel')?_c('div',{staticStyle:{"display":"table","width":"100%","height":"100%"}},[_c('div',{style:({
                    display: 'table-cell',
                    'vertical-align':
                      label.VerticalAlign === 'Center'
                        ? 'middle'
                        : label.VerticalAlign === 'Top'
                        ? 'top'
                        : 'bottom',
                    'text-align':
                      label.Align === 'Center'
                        ? 'center'
                        : label.Align === 'Right'
                        ? 'right'
                        : 'left',
                    color: label.Color,
                    'font-size': label.FontSize + 'px',
                    '-webkit-text-stroke-color': label.OutlineColor,
                    '-webkit-text-stroke-width': '1px',
                    'font-family': label.FontFamily,
                    'font-weight': label.Bold ? 'bold' : 'normal',
                    'font-style': label.Italic ? 'italic' : 'normal',
                  })},[_vm._v("\n                  "+_vm._s(label.Text)+"\n                ")])]):(_vm.getSelectedItemClass(label) === 'CardImage')?_c('div',{staticStyle:{"width":"100%","height":"100%"},style:({})},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":'data:image/png;base64,' + label.Source}})]):_vm._e()])}),(
                _vm.selectedItem !== null &&
                  _vm.$refs.designer !== undefined &&
                  _vm.selectedItem.X !== undefined &&
                  !isNaN(_vm.selectedItem.X) &&
                  _vm.selectedItem !== _vm.template
              )?_c('div',{staticClass:"selector",style:({
                top:
                  (_vm.selectedItem.Y / 100) * _vm.template.HeightInPixels - 5 + 'px',
                left:
                  (_vm.selectedItem.X * _vm.template.WidthInPixels) / 100 - 5 + 'px',
                width:
                  (_vm.selectedItem.Width / 100) * _vm.template.WidthInPixels + 'px',
                height:
                  (_vm.selectedItem.Height / 100) * _vm.template.HeightInPixels +
                  'px',
                'border-width': (4 * 100) / _vm.zoom + 'px',
              }),on:{"mousedown":function($event){_vm.mouseDown($event, _vm.selectedItem);
                $event.stopPropagation();
                $event.preventDefault();
                return false;},"click":function($event){_vm.mouseClick($event, _vm.selectedItem);
                $event.stopPropagation();
                $event.preventDefault();
                return false;}}},[_c('div',{staticClass:"resize-box bottom right",style:({
                  transform: 'scale(' + 100 / _vm.zoom + ',' + 100 / _vm.zoom + ')',
                }),on:{"mousedown":function($event){_vm.mouseDownResize($event, _vm.selectedItem);
                  $event.stopPropagation();
                  $event.preventDefault();
                  return false;}}})]):_vm._e()],2):_vm._e()]),_c('v-col',{staticClass:"panel",staticStyle:{"flex":"0 1 0%","padding":"0"},attrs:{"cols":"12"}})],1)],1),_c('v-col',{staticClass:"panel",staticStyle:{"overflow-y":"auto","max-height":"100%"},attrs:{"cols":"12","md":"4","sm":"5","lg":"3"}},[(_vm.getSelectedItemClass(_vm.selectedItem) === '')?_c('div',[(_vm.template)?_c('v-select',{attrs:{"hide-details":"","value":_vm.selectedItem,"dense":"","outlined":"","items":_vm.template.Labels,"label":"Items","item-text":"Text","background-color":"white","return-object":"","prepend-icon":"find_in_page"},on:{"change":function($event){_vm.selectedItem = $event}}}):_vm._e(),_c('v-divider'),_c('div',{staticStyle:{"padding":"10px 10px 0px 10px"}},[_c('v-slider',{attrs:{"max":"200","min":"5","thumb-label":"","hide-details":"","dense":""},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1),_c('v-divider'),_c('div',{staticClass:"pb-2"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"},on:{"click":_vm.addLabel}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  text_fields\n                ")])],1)]}}],null,false,1920990579)},[_c('span',[_vm._v("Add Label")])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"},on:{"click":_vm.addImage}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  insert_photo\n                ")])],1)]}}],null,false,3438591653)},[_c('span',[_vm._v("Add Image")])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  timeline\n                ")])],1)]}}],null,false,3225418457)},[_c('span',[_vm._v("Add Line")])])],1),_c('v-divider')],1):(_vm.getSelectedItemClass(_vm.selectedItem) === 'CardTemplate')?_c('div',[_c('card-template-properties',{attrs:{"template":_vm.template}}),_c('v-divider'),_c('div',{staticStyle:{"padding":"10px 10px 0px 10px"}},[_c('v-slider',{attrs:{"max":"200","min":"5","thumb-label":"","hide-details":"","dense":""},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1),_c('v-divider'),_c('div',{staticClass:"pb-2"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"},on:{"click":_vm.addLabel}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  text_fields\n                ")])],1)]}}])},[_c('span',[_vm._v("Add Label")])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"},on:{"click":_vm.addImage}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  insert_photo\n                ")])],1)]}}])},[_c('span',[_vm._v("Add Image")])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
                  var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",attrs:{"dark":"","color":"indigo"}},on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  timeline\n                ")])],1)]}}])},[_c('span',[_vm._v("Add Line")])])],1)],1):_vm._e(),(_vm.getSelectedItemClass(_vm.selectedItem) === 'CardLabel')?_c('div',[_c('card-label-properties',{attrs:{"label":_vm.selectedItem},on:{"delete":function($event){_vm.template.Labels.splice(_vm.template.Labels.indexOf($event), 1);
            _vm.selectedItem = null;}}})],1):_vm._e(),(_vm.getSelectedItemClass(_vm.selectedItem) === 'CardImage')?_c('div',[_c('card-image-properties',{attrs:{"image":_vm.selectedItem},on:{"delete":function($event){_vm.template.Images.splice(_vm.template.Images.indexOf($event), 1);
            _vm.selectedItem = null;},"source-updated":_vm.onSourceUpdated}})],1):_vm._e()])],1)],1)}
var CardDesignervue_type_template_id_22f23381_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CardDesigner.vue?vue&type=template&id=22f23381&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.bold.js
var es6_string_bold = __webpack_require__("48c0");

// CONCATENATED MODULE: ./src/lib/components/CardTemplate.ts



var Rect =
/** @class */
function () {
  function Rect() {
    this.X = 0;
    this.Y = 0;
  }

  return Rect;
}();

var CardTemplate_CardTemplate =
/** @class */
function (_super) {
  __extends(CardTemplate, _super);

  function CardTemplate(BackgroundImage, BackgroundColor, Color, OutlineColor, FontFamily, FontSize, Labels, Images) {
    if (BackgroundImage === void 0) {
      BackgroundImage = "";
    }

    if (BackgroundColor === void 0) {
      BackgroundColor = "#ffffff";
    }

    if (Color === void 0) {
      Color = "#000000";
    }

    if (OutlineColor === void 0) {
      OutlineColor = "";
    }

    if (FontFamily === void 0) {
      FontFamily = "";
    }

    if (FontSize === void 0) {
      FontSize = null;
    }

    if (Labels === void 0) {
      Labels = [];
    }

    if (Images === void 0) {
      Images = [];
    }

    var _this = _super.call(this) || this;

    _this.BackgroundImage = BackgroundImage;
    _this.BackgroundColor = BackgroundColor;
    _this.Color = Color;
    _this.OutlineColor = OutlineColor;
    _this.FontFamily = FontFamily;
    _this.FontSize = FontSize;
    _this.Labels = Labels;
    _this.Images = Images;
    return _this;
  }

  Object.defineProperty(CardTemplate.prototype, "WidthInPixels", {
    get: function get() {
      return this.Width * 300;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CardTemplate.prototype, "HeightInPixels", {
    get: function get() {
      return this.Height * 300;
    },
    enumerable: true,
    configurable: true
  });
  return CardTemplate;
}(Rect);

var CardTemplate_CardLabel =
/** @class */
function (_super) {
  __extends(CardLabel, _super);

  function CardLabel(args) {
    var _this = _super.call(this) || this;

    _this.Align = "Left";
    _this.VerticalAlign = "Center";

    if (args) {
      _this.Text = args.text || "";
      _this.X = args.X || 0;
      _this.Y = args.Y || 0;
      _this.Color = args.color || "";
      _this.FontSize = args.fontSize || 12;
      _this.Width = args.width || 30;
      _this.Height = args.height || 10;
      _this.OutlineColor = args.outlineColor || "#ffffff00";
      _this.Align = args.alignment || "Left";
      _this.Bold = args.bold === true;
      _this.Italic = args.italic === true;
    }

    return _this;
  }

  return CardLabel;
}(Rect);

var CardTemplate_CardImage =
/** @class */
function (_super) {
  __extends(CardImage, _super);

  function CardImage(args) {
    var _this = _super.call(this) || this;

    if (args) {
      _this.Source = args.source || "";
      _this.X = args.X || 0;
      _this.Y = args.Y || 0;
      _this.Width = args.width;
      _this.Height = args.height;
    }

    return _this;
  }

  return CardImage;
}(Rect);


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardLabelProperties.vue?vue&type=template&id=4f42e0ac&scoped=true&
var CardLabelPropertiesvue_type_template_id_4f42e0ac_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label !== null)?_c('div',[_c('v-text-field',{attrs:{"hide-details":"","label":"Text","prepend-icon":"text_format","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.Text),callback:function ($$v) {_vm.$set(_vm.label, "Text", $$v)},expression:"label.Text"}}),_c('v-select',{attrs:{"hide-details":"","label":"Font Family","prepend-icon":"title","outlined":"","dense":"","items":['' ].concat( _vm.fonts),"background-color":"white"},model:{value:(_vm.label.FontFamily),callback:function ($$v) {_vm.$set(_vm.label, "FontFamily", $$v)},expression:"label.FontFamily"}}),_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Font Size","prepend-icon":"format_size","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.FontSize),callback:function ($$v) {_vm.$set(_vm.label, "FontSize", $$v)},expression:"label.FontSize"}}),_c('div',{staticClass:"pb-3",staticStyle:{"justify-content":"center","display":"flex","flex-wrap":"wrap"}},[_c('v-btn-toggle',{attrs:{"mandatory":"","dense":""},model:{value:(_vm.label.Align),callback:function ($$v) {_vm.$set(_vm.label, "Align", $$v)},expression:"label.Align"}},[_c('v-btn',{attrs:{"value":"Left"}},[_c('v-icon',[_vm._v("format_align_left")])],1),_c('v-btn',{attrs:{"value":"Center"}},[_c('v-icon',[_vm._v("format_align_center")])],1),_c('v-btn',{attrs:{"value":"Right"}},[_c('v-icon',[_vm._v("format_align_right")])],1)],1)],1),_c('div',{staticClass:"pb-3",staticStyle:{"justify-content":"center","display":"flex","flex-wrap":"wrap"}},[_c('v-btn-toggle',{attrs:{"mandatory":"","dense":""},model:{value:(_vm.label.VerticalAlign),callback:function ($$v) {_vm.$set(_vm.label, "VerticalAlign", $$v)},expression:"label.VerticalAlign"}},[_c('v-btn',{attrs:{"value":"Top"}},[_c('v-icon',[_vm._v("vertical_align_top")])],1),_c('v-btn',{attrs:{"value":"Center"}},[_c('v-icon',[_vm._v("vertical_align_center")])],1),_c('v-btn',{attrs:{"value":"Bottom"}},[_c('v-icon',[_vm._v("vertical_align_bottom")])],1)],1)],1),_c('div',{staticClass:"pb-3",staticStyle:{"justify-content":"center","display":"flex","flex-wrap":"wrap"}},[_c('v-btn-toggle',{attrs:{"dense":""},model:{value:(_vm.label.Bold),callback:function ($$v) {_vm.$set(_vm.label, "Bold", $$v)},expression:"label.Bold"}},[_c('v-btn',{attrs:{"value":true}},[_c('v-icon',[_vm._v("format_bold")])],1)],1),_c('v-btn-toggle',{attrs:{"dense":""},model:{value:(_vm.label.Italic),callback:function ($$v) {_vm.$set(_vm.label, "Italic", $$v)},expression:"label.Italic"}},[_c('v-btn',{attrs:{"value":true}},[_c('v-icon',[_vm._v("format_italic")])],1)],1)],1),_c('v-divider'),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"hide-details":"","dense":"","outlined":"","label":"Color","prepend-icon":"palette","background-color":"white"},model:{value:(_vm.label.Color),callback:function ($$v) {_vm.$set(_vm.label, "Color", $$v)},expression:"label.Color"}},on))]}}],null,false,2454233819)},[_c('v-color-picker',{attrs:{"dot-size":"20","mode":"hexa"},model:{value:(_vm.label.Color),callback:function ($$v) {_vm.$set(_vm.label, "Color", $$v)},expression:"label.Color"}})],1)],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"hide-details":"","dense":"","outlined":"","label":"Outline Color","prepend-icon":"palette","background-color":"white"},model:{value:(_vm.label.OutlineColor),callback:function ($$v) {_vm.$set(_vm.label, "OutlineColor", $$v)},expression:"label.OutlineColor"}},on))]}}],null,false,2459002587)},[_c('v-color-picker',{attrs:{"dot-size":"20","mode":"hexa"},model:{value:(_vm.label.OutlineColor),callback:function ($$v) {_vm.$set(_vm.label, "OutlineColor", $$v)},expression:"label.OutlineColor"}})],1)],1)],1),_c('v-divider'),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"X location","prepend-icon":"swap_horiz","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.X),callback:function ($$v) {_vm.$set(_vm.label, "X", $$v)},expression:"label.X"}})],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Y location","prepend-icon":"swap_vert","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.Y),callback:function ($$v) {_vm.$set(_vm.label, "Y", $$v)},expression:"label.Y"}})],1)],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Width (percentage)","prepend-icon":"crop_16_9","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.Width),callback:function ($$v) {_vm.$set(_vm.label, "Width", $$v)},expression:"label.Width"}})],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Height (percentage)","prepend-icon":"crop_portrait","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.label.Height),callback:function ($$v) {_vm.$set(_vm.label, "Height", $$v)},expression:"label.Height"}})],1)],1),_c('v-divider'),_c('v-col',{staticClass:"pa-0",staticStyle:{"text-align":"center"},attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){return _vm.$emit('delete', _vm.label)}}},[_vm._v("Delete")])],1)],1):_vm._e()}
var CardLabelPropertiesvue_type_template_id_4f42e0ac_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CardLabelProperties.vue?vue&type=template&id=4f42e0ac&scoped=true&

// CONCATENATED MODULE: ./src/lib/components/FontFamilies.ts
/* harmony default export */ var FontFamilies = (["Arial", "Barlow", "Comic Sans MS", "Consolas", "Courier New", "Impact", "Lucida Sans", "Montserrat", "Tahoma", "Trebuchet MS", "Verdana"]);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardLabelProperties.vue?vue&type=script&lang=ts&





var CardLabelPropertiesvue_type_script_lang_ts_CardLabelProperties =
/** @class */
function (_super) {
  __extends(CardLabelProperties, _super);

  function CardLabelProperties() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fonts = FontFamilies;
    return _this;
  }

  var _a;

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", typeof (_a = typeof CardTemplate_CardLabel !== "undefined" && CardTemplate_CardLabel) === "function" ? _a : Object)], CardLabelProperties.prototype, "label", void 0);

  CardLabelProperties = __decorate([vue_class_component_common_default.a], CardLabelProperties);
  return CardLabelProperties;
}(external_vue_default.a);

/* harmony default export */ var CardLabelPropertiesvue_type_script_lang_ts_ = (CardLabelPropertiesvue_type_script_lang_ts_CardLabelProperties);
// CONCATENATED MODULE: ./src/lib/components/CardLabelProperties.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CardLabelPropertiesvue_type_script_lang_ts_ = (CardLabelPropertiesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CardLabelProperties.vue?vue&type=style&index=0&id=4f42e0ac&scoped=true&lang=css&
var CardLabelPropertiesvue_type_style_index_0_id_4f42e0ac_scoped_true_lang_css_ = __webpack_require__("f7bf");

// CONCATENATED MODULE: ./src/lib/components/CardLabelProperties.vue






/* normalize component */

var CardLabelProperties_component = normalizeComponent(
  components_CardLabelPropertiesvue_type_script_lang_ts_,
  CardLabelPropertiesvue_type_template_id_4f42e0ac_scoped_true_render,
  CardLabelPropertiesvue_type_template_id_4f42e0ac_scoped_true_staticRenderFns,
  false,
  null,
  "4f42e0ac",
  null
  
)

/* harmony default export */ var components_CardLabelProperties = (CardLabelProperties_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardTemplateProperties.vue?vue&type=template&id=3273e1a5&scoped=true&
var CardTemplatePropertiesvue_type_template_id_3273e1a5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"dense":"","outlined":"","label":"Name","prepend-icon":"folder","background-color":"white","hide-details":""}}),_c('v-file-input',{attrs:{"label":"Background Image","truncate-length":"15","prepend-icon":"insert_photo","accept":"image/*","dense":"","outlined":"","hide-details":"","background-color":"white","append-outer-icon":"delete","clearable":false},on:{"change":_vm.onBackgroundChange,"click:append-outer":function($event){_vm.template.BackgroundImage = '';
      _vm.file = null;}},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_c('v-select',{attrs:{"hide-details":"","label":"Font Family","prepend-icon":"title","outlined":"","dense":"","items":['' ].concat( _vm.fonts),"background-color":"white"},model:{value:(_vm.template.FontFamily),callback:function ($$v) {_vm.$set(_vm.template, "FontFamily", $$v)},expression:"template.FontFamily"}}),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"hide-details":"","dense":"","outlined":"","label":"Color","prepend-icon":"palette","background-color":"white"},model:{value:(_vm.template.Color),callback:function ($$v) {_vm.$set(_vm.template, "Color", $$v)},expression:"template.Color"}},on))]}}])},[_c('v-color-picker',{attrs:{"dot-size":"20","mode":"hexa"},model:{value:(_vm.template.Color),callback:function ($$v) {_vm.$set(_vm.template, "Color", $$v)},expression:"template.Color"}})],1)],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"hide-details":"","dense":"","outlined":"","label":"Background Color","prepend-icon":"palette","background-color":"white"},model:{value:(_vm.template.BackgroundColor),callback:function ($$v) {_vm.$set(_vm.template, "BackgroundColor", $$v)},expression:"template.BackgroundColor"}},on))]}}])},[_c('v-color-picker',{attrs:{"dot-size":"20","mode":"hexa"},model:{value:(_vm.template.BackgroundColor),callback:function ($$v) {_vm.$set(_vm.template, "BackgroundColor", $$v)},expression:"template.BackgroundColor"}})],1)],1)],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Width (inches)","prepend-icon":"crop_16_9","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.template.Width),callback:function ($$v) {_vm.$set(_vm.template, "Width", $$v)},expression:"template.Width"}})],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Height (inches)","prepend-icon":"crop_portrait","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.template.Height),callback:function ($$v) {_vm.$set(_vm.template, "Height", $$v)},expression:"template.Height"}})],1)],1)],1)}
var CardTemplatePropertiesvue_type_template_id_3273e1a5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CardTemplateProperties.vue?vue&type=template&id=3273e1a5&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardTemplateProperties.vue?vue&type=script&lang=ts&







var CardTemplatePropertiesvue_type_script_lang_ts_CardTemplateProperties =
/** @class */
function (_super) {
  __extends(CardTemplateProperties, _super);

  function CardTemplateProperties() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.file = null;
    _this.fonts = FontFamilies;
    return _this;
  }

  CardTemplateProperties.prototype.onBackgroundChange = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var reader, contents;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!e) {
              return [2
              /*return*/
              ];
            }

            reader = new FileReader();
            reader.readAsDataURL(e);
            return [4
            /*yield*/
            , new Promise(function (resolve, reject) {
              reader.onload = function (event) {
                resolve(reader.result);
              };
            })];

          case 1:
            contents = _a.sent();

            if (this.template) {
              this.template.BackgroundImage = contents.split(",")[1];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var _a;

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", typeof (_a = typeof CardTemplate_CardTemplate !== "undefined" && CardTemplate_CardTemplate) === "function" ? _a : Object)], CardTemplateProperties.prototype, "template", void 0);

  CardTemplateProperties = __decorate([vue_class_component_common_default.a], CardTemplateProperties);
  return CardTemplateProperties;
}(external_vue_default.a);

/* harmony default export */ var CardTemplatePropertiesvue_type_script_lang_ts_ = (CardTemplatePropertiesvue_type_script_lang_ts_CardTemplateProperties);
// CONCATENATED MODULE: ./src/lib/components/CardTemplateProperties.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CardTemplatePropertiesvue_type_script_lang_ts_ = (CardTemplatePropertiesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CardTemplateProperties.vue?vue&type=style&index=0&id=3273e1a5&scoped=true&lang=css&
var CardTemplatePropertiesvue_type_style_index_0_id_3273e1a5_scoped_true_lang_css_ = __webpack_require__("36f6");

// CONCATENATED MODULE: ./src/lib/components/CardTemplateProperties.vue






/* normalize component */

var CardTemplateProperties_component = normalizeComponent(
  components_CardTemplatePropertiesvue_type_script_lang_ts_,
  CardTemplatePropertiesvue_type_template_id_3273e1a5_scoped_true_render,
  CardTemplatePropertiesvue_type_template_id_3273e1a5_scoped_true_staticRenderFns,
  false,
  null,
  "3273e1a5",
  null
  
)

/* harmony default export */ var components_CardTemplateProperties = (CardTemplateProperties_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardImageProperties.vue?vue&type=template&id=6f1cd0e6&scoped=true&
var CardImagePropertiesvue_type_template_id_6f1cd0e6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"label":"Background Image","truncate-length":"15","prepend-icon":"insert_photo","accept":"image/*","dense":"","outlined":"","hide-details":"","background-color":"white","clearable":false},on:{"change":_vm.onBackgroundChange},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"X location","prepend-icon":"swap_horiz","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.image.X),callback:function ($$v) {_vm.$set(_vm.image, "X", $$v)},expression:"image.X"}})],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Y location","prepend-icon":"swap_vert","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.image.Y),callback:function ($$v) {_vm.$set(_vm.image, "Y", $$v)},expression:"image.Y"}})],1)],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0 pr-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Width","prepend-icon":"crop_16_9","outlined":"","dense":"","background-color":"white"},model:{value:(_vm.image.Width),callback:function ($$v) {_vm.$set(_vm.image, "Width", $$v)},expression:"image.Width"}})],1),_c('v-col',{staticClass:"py-0 pl-1",attrs:{"cols":"12","md":"6"}},[_c('v-text-field',{attrs:{"type":"number","hide-details":"","label":"Height","prepend-icon":"crop_portrait","outlined":"","dense":"","value":_vm.image.Height,"background-color":"white","disabled":""}})],1)],1),_c('v-divider'),_c('v-col',{staticClass:"pa-0",staticStyle:{"text-align":"center"},attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){return _vm.$emit('delete', _vm.image)}}},[_vm._v("Delete")])],1)],1)}
var CardImagePropertiesvue_type_template_id_6f1cd0e6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/CardImageProperties.vue?vue&type=template&id=6f1cd0e6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardImageProperties.vue?vue&type=script&lang=ts&






var CardImagePropertiesvue_type_script_lang_ts_CardImageProperties =
/** @class */
function (_super) {
  __extends(CardImageProperties, _super);

  function CardImageProperties() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.file = null;
    return _this;
  }

  CardImageProperties.prototype.onBackgroundChange = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var reader, contents, img_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            reader = new FileReader();
            reader.readAsDataURL(e);
            return [4
            /*yield*/
            , new Promise(function (resolve, reject) {
              reader.onload = function (event) {
                resolve(reader.result);
              };
            })];

          case 1:
            contents = _a.sent();

            if (this.image) {
              this.image.Source = contents.split(",")[1];
              img_1 = new Image();

              img_1.onload = function () {
                _this.$emit("source-updated", {
                  width: img_1.width,
                  height: img_1.height
                });
              };

              img_1.src = "data:image/png;base64," + this.image.Source;
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var _a;

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", typeof (_a = typeof CardTemplate_CardImage !== "undefined" && CardTemplate_CardImage) === "function" ? _a : Object)], CardImageProperties.prototype, "image", void 0);

  CardImageProperties = __decorate([vue_class_component_common_default.a], CardImageProperties);
  return CardImageProperties;
}(external_vue_default.a);

/* harmony default export */ var CardImagePropertiesvue_type_script_lang_ts_ = (CardImagePropertiesvue_type_script_lang_ts_CardImageProperties);
// CONCATENATED MODULE: ./src/lib/components/CardImageProperties.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CardImagePropertiesvue_type_script_lang_ts_ = (CardImagePropertiesvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CardImageProperties.vue?vue&type=style&index=0&id=6f1cd0e6&scoped=true&lang=css&
var CardImagePropertiesvue_type_style_index_0_id_6f1cd0e6_scoped_true_lang_css_ = __webpack_require__("980a");

// CONCATENATED MODULE: ./src/lib/components/CardImageProperties.vue






/* normalize component */

var CardImageProperties_component = normalizeComponent(
  components_CardImagePropertiesvue_type_script_lang_ts_,
  CardImagePropertiesvue_type_template_id_6f1cd0e6_scoped_true_render,
  CardImagePropertiesvue_type_template_id_6f1cd0e6_scoped_true_staticRenderFns,
  false,
  null,
  "6f1cd0e6",
  null
  
)

/* harmony default export */ var components_CardImageProperties = (CardImageProperties_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/CardDesigner.vue?vue&type=script&lang=ts&







var CardDesignervue_type_script_lang_ts_CardDesigner =
/** @class */
function (_super) {
  __extends(CardDesigner, _super);

  function CardDesigner() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.selectedItem = null;
    _this.movingItem = null;
    _this.initialX = 0;
    _this.initialY = 0;
    _this.zoom = 100;
    return _this;
  }

  CardDesigner.prototype.mounted = function () {
    this.onTemplateChanged();
  };

  CardDesigner.prototype.onTemplateChanged = function () {
    this.selectedItem = null;

    if (this.$refs.canvas && this.template) {
      this.template.X = this.$refs.canvas.offsetWidth / 2 - this.template.WidthInPixels / 2;
      this.template.Y = this.$refs.canvas.offsetHeight / 2 - this.template.HeightInPixels / 2;
      var z1 = this.$refs.canvas.offsetHeight / this.template.HeightInPixels * 100 - 3;
      var z2 = this.$refs.canvas.offsetWidth / this.template.WidthInPixels * 100 - 3;
      this.zoom = z1 > z2 ? z2 : z1;
    }
  };

  CardDesigner.prototype.mouseClick = function (e, item) {
    // console.log("mouse click");
    if (this.movingItem) {
      if (this.initialX === this.movingItem.X && this.initialY === this.movingItem.Y) {
        this.selectedItem = item;
        this.movingItem = item;
      }
    } else {
      this.selectedItem = null;
    }
  };

  CardDesigner.prototype.mouseDown = function (e, item) {
    // console.log("mouse down");
    this.movingItem = item;
    this.mouseDownEvent = e;

    if (this.movingItem) {
      this.initialX = this.movingItem.X;
      this.initialY = this.movingItem.Y;
      window.addEventListener("mousemove", this.mouseMoveForMove);
      window.addEventListener("mouseup", this.mouseUp);
    }
  };

  CardDesigner.prototype.mouseDownResize = function (e, item) {
    // console.log("mouse down resize");
    this.movingItem = item;
    this.mouseDownEvent = e;
    this.initialX = this.movingItem.Width;
    this.initialY = this.movingItem.Height;
    window.addEventListener("mousemove", this.mouseMoveForResize);
    window.addEventListener("mouseup", this.mouseUp);
  };

  CardDesigner.prototype.mouseUp = function (e) {
    // console.log("mouse up");
    window.removeEventListener("mousemove", this.mouseMoveForMove);
    window.removeEventListener("mousemove", this.mouseMoveForResize);
    window.removeEventListener("mouseup", this.mouseUp);
  };

  CardDesigner.prototype.mouseMoveForMove = function (e) {
    if (this.movingItem !== null) {
      if (this.movingItem === this.template || this.movingItem === this.selectedItem) {
        var label = this.movingItem;

        if (label instanceof CardTemplate_CardTemplate) {
          var x = this.initialX - (this.mouseDownEvent.clientX - e.clientX);
          label.X = x;
          var y = this.initialY - (this.mouseDownEvent.clientY - e.clientY);
          label.Y = y;
        } else {
          var x = this.initialX - (this.mouseDownEvent.clientX - e.clientX) / this.template.WidthInPixels * (100 / this.zoom) * 100;

          if (x >= 0 && x < 100 - label.Width) {
            label.X = x;
          } else if (x < 0) {
            label.X = 0;
          } else {
            label.X = 100 - label.Width;
          }

          var y = this.initialY - (this.mouseDownEvent.clientY - e.clientY) / this.template.HeightInPixels * (100 / this.zoom) * 100;

          if (y >= 0 && y < 100 - label.Height) {
            label.Y = y;
          } else if (y < 0) {
            label.Y = 0;
          } else {
            label.Y = 100 - label.Height;
          }
        }
      }
    }
  };

  CardDesigner.prototype.mouseMoveForResize = function (e) {
    // console.log("mouse move for resize", e);
    if (this.movingItem) {
      var label = this.movingItem;

      if (label) {
        var height = this.initialY - (this.mouseDownEvent.clientY - e.clientY) / this.template.HeightInPixels * (100 / this.zoom) * 100;

        if (height <= 100 - label.Y) {
          label.Height = height;
        } else if (height < 4) {
          label.Height = 4;
        } else {
          label.Height = 100 - label.Y;
        }

        if (label instanceof CardTemplate_CardImage) {
          label.Width = label.Height / (this.initialY / this.initialX);
        } else {
          var width = this.initialX - (this.mouseDownEvent.clientX - e.clientX) / this.template.WidthInPixels * (100 / this.zoom) * 100;

          if (width <= 100 - label.X) {
            label.Width = width;
          } else if (width < 4) {
            label.Width = 4;
          } else {
            label.Width = 100 - label.X;
          }
        }
      }
    }
  };

  CardDesigner.prototype.getSelectedItemClass = function (item) {
    if (item instanceof CardTemplate_CardTemplate) {
      return "CardTemplate";
    } else if (item instanceof CardTemplate_CardLabel) {
      return "CardLabel";
    } else if (item instanceof CardTemplate_CardImage) {
      return "CardImage";
    }

    return "";
  };

  CardDesigner.prototype.onDesignerScroll = function (e) {
    e.preventDefault();
    e.stopPropagation();
    var nz = this.zoom - e.deltaY / 100 * 2;

    if (nz >= 5 && nz <= 200) {
      this.zoom = nz;
    } // window.Template = this.template;

  };

  CardDesigner.prototype.addLabel = function () {
    var label = new CardTemplate_CardLabel({
      text: "New Label",
      fontSize: this.template.WidthInPixels / 30,
      width: 20,
      height: 8
    });
    this.template.Labels.push(label);
    this.selectedItem = label;
  };

  CardDesigner.prototype.addImage = function () {
    var label = new CardTemplate_CardImage({
      source: "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"
    });
    this.template.Images.push(label);
    this.selectedItem = label;
  };

  CardDesigner.prototype.onSourceUpdated = function (size) {
    if (this.selectedItem !== null && this.selectedItem !== undefined) {
      this.selectedItem.Width = size.width * 100 / this.template.WidthInPixels;
      this.selectedItem.Height = size.height * 100 / this.template.HeightInPixels;
    }
  };

  var _a;

  __decorate([Prop({
    default: function _default() {
      return null;
    }
  }), __metadata("design:type", Object)], CardDesigner.prototype, "template", void 0);

  __decorate([Watch("template"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], CardDesigner.prototype, "onTemplateChanged", null);

  CardDesigner = __decorate([vue_class_component_common_default()({
    components: {
      CardLabelProperties: components_CardLabelProperties,
      CardTemplateProperties: components_CardTemplateProperties,
      CardImageProperties: components_CardImageProperties
    }
  })], CardDesigner);
  return CardDesigner;
}(external_vue_default.a);

/* harmony default export */ var CardDesignervue_type_script_lang_ts_ = (CardDesignervue_type_script_lang_ts_CardDesigner);
// CONCATENATED MODULE: ./src/lib/components/CardDesigner.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CardDesignervue_type_script_lang_ts_ = (CardDesignervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/lib/components/CardDesigner.vue?vue&type=style&index=0&id=22f23381&scoped=true&lang=css&
var CardDesignervue_type_style_index_0_id_22f23381_scoped_true_lang_css_ = __webpack_require__("d720");

// CONCATENATED MODULE: ./src/lib/components/CardDesigner.vue






/* normalize component */

var CardDesigner_component = normalizeComponent(
  components_CardDesignervue_type_script_lang_ts_,
  CardDesignervue_type_template_id_22f23381_scoped_true_render,
  CardDesignervue_type_template_id_22f23381_scoped_true_staticRenderFns,
  false,
  null,
  "22f23381",
  null
  
)

/* harmony default export */ var components_CardDesigner = (CardDesigner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/Shared/ToolTipButton.vue?vue&type=template&id=29380e84&
var ToolTipButtonvue_type_template_id_29380e84_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.position === 'right')?_c('v-tooltip',{attrs:{"color":_vm.tooltipBackgroundColor ? _vm.tooltipBackgroundColor : 'blue-grey lighten-2',"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"rounded-0",attrs:{"small":"","fab":"","disabled":_vm.disabled,"icon":true},on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.btnColor ? _vm.btnColor : 'grey darken-2'}},[_vm._v("\n          "+_vm._s(_vm.btnIcon ? _vm.btnIcon : "mdi-radiobox-blank")+"\n        ")])],1)]}}],null,false,1670075427)},[_c('span',{style:(_vm.tooltipTextHexColor
          ? ("color: " + _vm.tooltipTextHexColor + ";")
          : 'color: white;')},[_vm._v("\n      "+_vm._s(_vm.btnLabel)+"\n    ")])]):(_vm.position === 'bottom')?_c('v-tooltip',{attrs:{"color":_vm.tooltipBackgroundColor ? _vm.tooltipBackgroundColor : 'blue-grey lighten-2',"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"rounded-0",attrs:{"small":"","fab":"","disabled":_vm.disabled,"icon":true},on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.btnColor ? _vm.btnColor : 'grey darken-2'}},[_vm._v("\n          "+_vm._s(_vm.btnIcon ? _vm.btnIcon : "mdi-radiobox-blank")+"\n        ")])],1)]}}])},[_c('span',{style:(_vm.tooltipTextHexColor
          ? ("color: " + _vm.tooltipTextHexColor + ";")
          : 'color: white;')},[_vm._v("\n      "+_vm._s(_vm.btnLabel)+"\n    ")])]):(_vm.position === 'left')?_c('v-tooltip',{attrs:{"color":_vm.tooltipBackgroundColor ? _vm.tooltipBackgroundColor : 'blue-grey lighten-2',"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"rounded-0",attrs:{"small":"","fab":"","disabled":_vm.disabled,"icon":true},on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.btnColor ? _vm.btnColor : 'grey darken-2'}},[_vm._v("\n          "+_vm._s(_vm.btnIcon ? _vm.btnIcon : "mdi-radiobox-blank")+"\n        ")])],1)]}}])},[_c('span',{style:(_vm.tooltipTextHexColor
          ? ("color: " + _vm.tooltipTextHexColor + ";")
          : 'color: white;')},[_vm._v("\n      "+_vm._s(_vm.btnLabel)+"\n    ")])]):_c('v-tooltip',{attrs:{"color":_vm.tooltipBackgroundColor ? _vm.tooltipBackgroundColor : 'blue-grey lighten-2',"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"rounded-0",attrs:{"small":"","fab":"","disabled":_vm.disabled,"icon":true},on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.btnColor ? _vm.btnColor : 'grey darken-2'}},[_vm._v("\n          "+_vm._s(_vm.btnIcon ? _vm.btnIcon : "mdi-radiobox-blank")+"\n        ")])],1)]}}])},[_c('span',{style:(_vm.tooltipTextHexColor
          ? ("color: " + _vm.tooltipTextHexColor + ";")
          : 'color: white;')},[_vm._v("\n      "+_vm._s(_vm.btnLabel)+"\n    ")])])],1)}
var ToolTipButtonvue_type_template_id_29380e84_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/components/Shared/ToolTipButton.vue?vue&type=template&id=29380e84&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/components/Shared/ToolTipButton.vue?vue&type=script&lang=ts&




var ToolTipButtonvue_type_script_lang_ts_MembersDownloadCenter =
/** @class */
function (_super) {
  __extends(MembersDownloadCenter, _super);

  function MembersDownloadCenter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "tooltipTextHexColor", void 0);

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "tooltipBackgroundColor", void 0);

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "btnColor", void 0);

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "btnIcon", void 0);

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "btnLabel", void 0);

  __decorate([Prop(), __metadata("design:type", String)], MembersDownloadCenter.prototype, "position", void 0);

  __decorate([Prop(), __metadata("design:type", Boolean)], MembersDownloadCenter.prototype, "disabled", void 0);

  MembersDownloadCenter = __decorate([vue_class_component_common_default()({
    components: {
      VBtn: lib_["VBtn"],
      VTooltip: lib_["VTooltip"]
    }
  })], MembersDownloadCenter);
  return MembersDownloadCenter;
}(external_vue_default.a);

/* harmony default export */ var ToolTipButtonvue_type_script_lang_ts_ = (ToolTipButtonvue_type_script_lang_ts_MembersDownloadCenter);
// CONCATENATED MODULE: ./src/lib/components/Shared/ToolTipButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Shared_ToolTipButtonvue_type_script_lang_ts_ = (ToolTipButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/components/Shared/ToolTipButton.vue





/* normalize component */

var ToolTipButton_component = normalizeComponent(
  Shared_ToolTipButtonvue_type_script_lang_ts_,
  ToolTipButtonvue_type_template_id_29380e84_render,
  ToolTipButtonvue_type_template_id_29380e84_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ToolTipButton = (ToolTipButton_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__("34ef");

// CONCATENATED MODULE: ./src/lib/components/File/ReadFile.ts





function readFileAsDataUrlAsync(file) {
  return new Promise(function (resolve, reject) {
    var reader = createReader(resolve, reject);
    reader.readAsDataURL(file);
  });
}

function readFileAsTextAsync(file) {
  return new Promise(function (resolve, reject) {
    var reader = createReader(resolve, reject);
    reader.readAsText(file);
  });
}

function b64toBlob(b64Data, contentType, sliceSize) {
  if (contentType === void 0) {
    contentType = "";
  }

  if (sliceSize === void 0) {
    sliceSize = 512;
  }

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}

function createReader(resolve, reject) {
  var reader = new FileReader();

  reader.onload = function () {
    resolve(reader.result ? reader.result.toString() : "");
  };

  reader.onerror = reject;
  return reader;
}
// CONCATENATED MODULE: ./src/lib/IHttpService.ts
var IHttpService =
/** @class */
function () {
  function IHttpService() {}

  return IHttpService;
}();

/* harmony default export */ var lib_IHttpService = (IHttpService);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__("aef6");

// CONCATENATED MODULE: ./src/lib/odata/ODataColumnFilter.ts



var ODataColumnFilter_ODataColumnFilter =
/** @class */
function (_super) {
  __extends(ODataColumnFilter, _super);

  function ODataColumnFilter(type) {
    var _this = _super.call(this, type) || this;

    _this.type = type;
    return _this;
  }

  ODataColumnFilter.prototype.toODataString = function (convertName) {
    var _this = this;

    return this.type.buildExpression(function (name) {
      return _this.operator.getFilter(convertName !== undefined ? convertName(name) : name, _this.value);
    });
  };

  return ODataColumnFilter;
}(lib_ColumnFilter);

/* harmony default export */ var odata_ODataColumnFilter = (ODataColumnFilter_ODataColumnFilter);
// CONCATENATED MODULE: ./src/lib/odata/ODataOperator.ts





var ODataOperator_ODataOperator =
/** @class */
function (_super) {
  __extends(ODataOperator, _super);

  function ODataOperator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ODataOperator.prototype.escapeValue = function (value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return value.toString().replace(/\'/g, "''");
  };

  return ODataOperator;
}(lib_Operator);

/* harmony default export */ var odata_ODataOperator = (ODataOperator_ODataOperator);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringContains.ts



var ODataStringContains_ODataStringContains =
/** @class */
function (_super) {
  __extends(ODataStringContains, _super);

  function ODataStringContains() {
    return _super.call(this, "⊆", "pbascomponents.operators.contains", []) || this;
  }

  ODataStringContains.prototype.getFilter = function (name, variable) {
    return "contains(tolower(" + name + "), '" + this.escapeValue(variable.toLowerCase()) + "')";
  };

  return ODataStringContains;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataStringContains = (ODataStringContains_ODataStringContains);
// CONCATENATED MODULE: ./src/lib/odata/ODataType.ts









var ODataType_ODataType =
/** @class */
function (_super) {
  __extends(ODataType, _super);

  function ODataType(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, args.alignment || lib_HeaderAlignment.Left, args.operators || [], args.getValue || function (item, type) {
      var parts = _this.key.split("/");

      var obj = item;
      var tobreak = false;

      var _loop_1 = function _loop_1() {
        if (tobreak) {
          return "break";
        }

        var partKey = _this.removeAnnotation(parts.shift());

        if (partKey !== undefined) {
          if (obj instanceof Array) {
            obj = obj.map(function (o) {
              if (o[partKey] !== undefined) {
                return o[partKey];
              } else {
                tobreak = true;
                return o.Id;
              }
            });

            if (obj.some(function (o) {
              return o instanceof Array;
            })) {
              obj = obj.reduce(function (a, b) {
                return a.concat(b);
              });
            }
          } else {
            if (obj !== null && obj !== undefined) {
              obj = obj[partKey];
            } else {
              obj = null;
            }
          }
        }
      };

      while (parts.length > 0) {
        var state_1 = _loop_1();

        if (state_1 === "break") break;
      }

      return obj;
    }, args.getString, args.getHtml, args.getComponent, args.getEditableComponent, args.defaultFilters, args.additionalKeys) || this;
    _this.defaultFilters = [];
    return _this;
  }

  ODataType.prototype.getFilters = function () {
    return undefined;
  };

  ODataType.prototype.createNewFilter = function () {
    return new odata_ODataColumnFilter(this);
  };

  ODataType.prototype.getFiltersODataString = function (filters) {
    return filters.map(function (f) {
      return f.toODataString();
    }).filter(function (r) {
      return r !== undefined;
    }).join(" and ");
  };

  ODataType.prototype.getWildcardFilter = function (variable) {
    var filter = new odata_ODataColumnFilter(this);
    filter.operator = new operators_ODataStringContains();
    filter.value = variable;
    var basic = [filter.toODataString()];

    for (var _i = 0, _a = this.additionalKeys; _i < _a.length; _i++) {
      var key = _a[_i];
      basic.push(key.getWildcardFilter(variable));
    }

    return "(" + basic.join(" or ") + ")";
  };

  ODataType.prototype.getSelect = function () {
    return this.removeAnnotation(this.key);
  };

  ODataType.prototype.getExpand = function () {
    var split = this.key.split("/");
    return "" + this.removeAnnotation(split.shift()) + this.recursiveBuildExpand(split);
  };

  ODataType.prototype.buildExpression = function (callback) {
    var split = this.key.split("/");
    var res = this.recursiveGetFilter(split, "", callback);

    if (res === undefined) {
      return undefined;
    }

    var arr = [res];

    for (var _i = 0, _a = this.additionalKeys; _i < _a.length; _i++) {
      var sub = _a[_i];
      var ret = sub.buildExpression(callback);

      if (ret !== undefined) {
        arr.push(ret);
      }
    }

    return "(" + arr.join(" or ") + ")";
  };

  ODataType.prototype.escapeValue = function (value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return encodeURIComponent(value.replace(/\'/g, "''"));
  };

  ODataType.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  ODataType.prototype.recursiveGetFilter = function (parts, alias, callback) {
    if (parts.length === 0) {
      return callback("" + alias);
    }

    var next = parts[0];
    parts.shift();
    var prefix = alias !== "" ? "/" : "";

    if (next.endsWith("[]")) {
      if (parts.length === 0) {
        return undefined;
      }

      var newNext = this.removeAnnotation(next);
      var newAlias = alias.split('/').map(function (a) {
        return a[0];
      }).join("_") + "_" + newNext[0].toLowerCase();
      return "" + alias + prefix + newNext + "/any(" + newAlias + ": " + (this.recursiveGetFilter(parts, newAlias, callback) + ")");
    }

    return this.recursiveGetFilter(parts, "" + alias + (alias !== "" ? "/" : "") + next, callback);
  };

  ODataType.prototype.recursiveBuildExpand = function (parts) {
    if (parts.length === 0) {
      return "";
    }

    if (parts.length === 1) {
      if (parts[0] !== "") {
        return "($select=" + this.removeAnnotation(parts[0]) + ")";
      }

      return "";
    } else {
      return "($expand=" + this.removeAnnotation(parts.shift()) + this.recursiveBuildExpand(parts) + ")";
    }
  };

  return ODataType;
}(lib_DataType);

/* harmony default export */ var odata_ODataType = (ODataType_ODataType);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("1c4c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// EXTERNAL MODULE: external "url-parse"
var external_url_parse_ = __webpack_require__("6456");
var external_url_parse_default = /*#__PURE__*/__webpack_require__.n(external_url_parse_);

// CONCATENATED MODULE: ./src/lib/odata/ODataProvider.ts
















var ODataProvider_ODataProvider =
/** @class */
function (_super) {
  __extends(ODataProvider, _super);

  function ODataProvider(http, uri, headers, options) {
    var _this = _super.call(this) || this;

    _this.http = http;
    _this.uri = uri;
    _this.headers = headers;
    _this.options = options || {
      useSelect: true
    };
    return _this;
  }

  ODataProvider.prototype.fetchAsync = function (startIndex, count, sortOptions, wildcard, columnFilters, keys, apply) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.getResultAsync(this.getODataQueryString(startIndex, count, sortOptions, wildcard, columnFilters, keys, apply), apply)];
      });
    });
  };

  ODataProvider.prototype.getExpandAsString = function () {
    var _this = this;

    var map = this.getExpandAsMap();
    var res = [];
    map.forEach(function (value, key) {
      if (value === "") {
        res.push("" + key);
      } else {
        var recursive = "" + _this.recursiveGetExpandAsString(value);

        if (recursive) {
          res.push(key + "(" + recursive + ")");
        } else {
          res.push("" + key);
        }
      }
    });
    return res.join(",");
  };

  ODataProvider.prototype.getExpandAsMap = function () {
    var _this = this;

    var map = new Map();
    this.headers.filter(function (s) {
      return s.type.key.indexOf("/") > 0 || s.type.key.indexOf("[]") > 0;
    }).forEach(function (h) {
      // console.log("getExpandAsMap 1: ", h.type.key);
      var split = h.type.key.split("/");

      var key = _this.removeAnnotation(split.shift());

      if (split.length > 0) {
        var newMap = new Map();

        if (map.has(key)) {
          newMap = map.get(key);
        } // console.log("getExpandAsMap 2: ", h.type.key);


        _this.recursiveBuildExpand(split, newMap);

        map.set(key, newMap);
      } else {
        map.set(key, "");
      }

      h.subHeaders.filter(function (s) {
        return s.type.key.indexOf("/") > 0;
      }).forEach(function (sh) {
        split = sh.type.key.split("/");
        key = _this.removeAnnotation(split.shift());

        if (split.length > 0) {
          var newMap = new Map();

          if (map.has(key)) {
            newMap = map.get(key);
          } // console.log("getExpandAsMap 3: ", h.type.key, sh.type.key);


          _this.recursiveBuildExpand(split, newMap);

          map.set(key, newMap);
        } else {
          map.set(key, "");
        }
      });
    });
    return map;
  };

  ODataProvider.prototype.getODataQueryString = function (startIndex, count, sortOptions, wildcard, columnFilters, keys, apply) {
    var _this = this;

    if (apply !== undefined) {
      return this.uri + "?" + apply;
    }

    var map = new Map();
    map.set("$count", "true");

    if (startIndex !== undefined) {
      map.set("$skip", startIndex.toString());
    }

    if (count !== undefined) {
      map.set("$top", count.toString());
    }

    var headers = this.headers;

    if (keys !== undefined) {
      headers = headers.filter(function (h) {
        return keys.some(function (k) {
          return k === h.type.key;
        });
      });
    }

    var expandString = this.getExpandAsString();

    if (expandString !== undefined && expandString !== "") {
      var customKeys = keys !== undefined ? keys.filter(function (k) {
        return k.indexOf("(") >= 0;
      }) : [];
      map.set("$expand", expandString + (customKeys !== undefined && customKeys.length > 0 ? "," + customKeys.join(",") : ""));
    }

    var select = headers.filter(function (h) {
      return h.type.key.indexOf("/") === -1 && h.type.key.indexOf("[]") === -1;
    }).map(function (h) {
      var mine = h.type.getSelect();
      var subs = h.subHeaders.filter(function (s) {
        return s.type.key.indexOf("/") === -1;
      }).map(function (s) {
        return s.type.getSelect();
      });
      return [mine].concat(subs).join(",");
    }).concat(keys === undefined ? [] : keys.filter(function (k) {
      return !_this.headers.some(function (h) {
        return h.type.key === k;
      });
    })).filter(function (m) {
      return m.indexOf("(") < 0;
    });
    var uniq = new Set(select);

    if (select.length > 0 && this.options.useSelect) {
      map.set("$select", Array.from(uniq.values()).join(","));
    }

    if (sortOptions !== undefined && sortOptions.length > 0) {
      map.set("$orderby", sortOptions.filter(function (o) {
        return o.header !== undefined;
      }).map(function (o) {
        var mine = (o.header.orderByKey !== undefined ? o.header.orderByKey : o.header.type.key) + " " + (o.direction === lib_SortDirection.Ascending ? "asc" : "desc");
        var subs = o.header.subHeaders.filter(function (h) {
          return h.sortable !== false;
        }).map(function (s) {
          return (s.orderByKey !== undefined ? s.orderByKey : s.type.key) + " " + (o.direction === lib_SortDirection.Ascending ? "asc" : "desc");
        });

        if (subs.length === 0) {
          return mine;
        } else {
          return [mine].concat(subs.join(", "));
        }
      }).join(","));
    } // default filter


    var filters = [];

    if (this.filter !== undefined) {
      filters.push(this.filter);
    } // wildcard


    var filter = this.getWildcardFilter(wildcard);

    if (filter !== undefined) {
      filters.push(filter);
    } // advanced


    if (columnFilters !== undefined) {
      var newFilters = columnFilters.map(function (f) {
        return f.toODataString();
      }).filter(function (f) {
        return f !== undefined;
      }); // console.log("new filters: ", newFilters);

      if (newFilters.length > 0) {
        filters.push(newFilters.join(" and "));
      }
    }

    if (filters.length > 0) {
      map.set("$filter", filters.map(function (f) {
        return "(" + encodeURIComponent(f) + ")";
      }).join(" and "));
    }

    return this.uri + "?" + Array.from(map.keys()).map(function (key) {
      return key + "=" + map.get(key);
    }).join("&");
  };

  ODataProvider.prototype.getResultAsync = function (url, apply) {
    return __awaiter(this, void 0, Promise, function () {
      var headers, res, length, items, next, url2, subitems;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            headers = {
              Accept: "application/json"
            };
            return [4
            /*yield*/
            , this.http.get(url, headers)];

          case 1:
            res = _a.sent();
            if (!(apply === undefined)) return [3
            /*break*/
            , 5];
            length = res["@odata.count"];
            items = res.value;
            next = res["@odata.nextLink"];
            _a.label = 2;

          case 2:
            if (!(next !== undefined)) return [3
            /*break*/
            , 4];
            url2 = external_url_parse_default()(next);
            next = this.uri + url2.query;
            return [4
            /*yield*/
            , this.http.get(next, headers)];

          case 3:
            res = _a.sent();
            next = res["@odata.nextLink"];
            subitems = res.value;
            items = items.concat(subitems);
            return [3
            /*break*/
            , 2];

          case 4:
            return [3
            /*break*/
            , 6];

          case 5:
            items = res;
            length = items.count;
            _a.label = 6;

          case 6:
            return [2
            /*return*/
            , new lib_FetchResult(length, items)];
        }
      });
    });
  };

  ODataProvider.prototype.getWildcardFilter = function (filter) {
    if (filter !== undefined && filter !== "") {
      return this.headers.filter(function (h) {
        return h.searchable;
      }).map(function (h) {
        var mine = h.type.getWildcardFilter(filter);

        if (mine === undefined) {
          return mine;
        }

        var subs = h.subHeaders.filter(function (s) {
          return s.searchable;
        }).map(function (s) {
          return s.type.getWildcardFilter(filter);
        }).filter(function (s) {
          return s !== undefined;
        });
        return [mine].concat(subs).join(" or ");
      }).filter(function (r) {
        return r !== undefined;
      }).join(" or ");
    }
  };

  ODataProvider.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  ODataProvider.prototype.recursiveBuildExpand = function (parts, map) {
    // console.log("recursiveBuildExpand: ", parts, map);
    if (parts.length === 0) {
      throw new Error("Called recursive build expand with not parts");
    }

    if (parts.length === 1) {
      var key = this.removeAnnotation(parts[0]); // console.log("recursiveBuildExpand 2: ", parts[0], key, map);

      if (parts[0] !== "" && !map.has(key)) {
        map.set(key, "");
        return;
      }

      return;
    } else {
      var key = this.removeAnnotation(parts.shift());
      var newMap = new Map();

      if (map.has(key)) {
        newMap = map.get(key);
      }

      this.recursiveBuildExpand(parts, newMap);
      map.set(key, newMap);
    }
  };

  ODataProvider.prototype.recursiveGetExpandAsString = function (map) {
    var _this = this;

    var selects = [];
    var expands = [];
    map.forEach(function (value, key) {
      if (value === "") {
        selects.push(key);
      } else {
        var val = _this.recursiveGetExpandAsString(value);

        if (val) {
          expands.push(key + "(" + val + ")");
        } else {
          expands.push("" + key);
        }
      }
    });
    var res = [];

    if (selects.length > 0 && this.options.useSelect) {
      res.push("$select=" + selects.join(","));
    }

    if (expands.length > 0) {
      res.push("$expand=" + expands.join(","));
    }

    return res.join(";");
  };

  return ODataProvider;
}(lib_DataProvider);

/* harmony default export */ var odata_ODataProvider = (ODataProvider_ODataProvider);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataBooleanIs.ts



var ODataBooleanIs_ODataBooleanIs =
/** @class */
function (_super) {
  __extends(ODataBooleanIs, _super);

  function ODataBooleanIs() {
    return _super.call(this, "=", "pbascomponents.operators.is", ["pbascomponents.operators.true", "pbascomponents.operators.false"]) || this;
  }

  ODataBooleanIs.prototype.getFilter = function (name, variable) {
    return variable === "pbascomponents.operators.true" || variable.toLowerCase() === "true" ? name + " eq true" : name + " eq false";
  };

  return ODataBooleanIs;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataBooleanIs = (ODataBooleanIs_ODataBooleanIs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/odata/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=2eaf6980&
var BooleanInjectableComponentvue_type_template_id_2eaf6980_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"input-value":_vm.data.header.type.getValue(_vm.data.item, _vm.data.header.type),"readonly":true}})],1)}
var BooleanInjectableComponentvue_type_template_id_2eaf6980_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/odata/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=2eaf6980&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/odata/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&




var BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent =
/** @class */
function (_super) {
  __extends(BooleanInjectableComponent, _super);

  function BooleanInjectableComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], BooleanInjectableComponent.prototype, "data", void 0);

  BooleanInjectableComponent = __decorate([vue_class_component_common_default()({
    name: "BooleanInjectableComponent",
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"]
    }
  })], BooleanInjectableComponent);
  return BooleanInjectableComponent;
}(external_vue_default.a);

/* harmony default export */ var BooleanInjectableComponentvue_type_script_lang_ts_ = (BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (BooleanInjectableComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/odata/datatypes/BooleanInjectableComponent.vue





/* normalize component */

var BooleanInjectableComponent_component = normalizeComponent(
  datatypes_BooleanInjectableComponentvue_type_script_lang_ts_,
  BooleanInjectableComponentvue_type_template_id_2eaf6980_render,
  BooleanInjectableComponentvue_type_template_id_2eaf6980_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var datatypes_BooleanInjectableComponent = (BooleanInjectableComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataBoolean.ts







var ODataBoolean_ODataBoolean =
/** @class */
function (_super) {
  __extends(ODataBoolean, _super);

  function ODataBoolean(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Center,
      operators: args.operators || [new operators_ODataBooleanIs()],
      getComponent: function getComponent(item, type) {
        return datatypes_BooleanInjectableComponent;
      },
      getEditableComponent: args.getEditableComponent,
      getHtml: args.getHtml,
      getString: args.getString,
      getValue: args.getValue
    }) || this;
    return _this;
  }

  ODataBoolean.prototype.getWildcardFilter = function (variable) {
    if (variable.toLowerCase() === "true" || variable.toLowerCase() === "false") {
      var filter = new odata_ODataColumnFilter(this);
      filter.operator = new operators_ODataBooleanIs();
      filter.value = variable;
      return filter.toODataString();
    }

    return undefined;
  };

  return ODataBoolean;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataBoolean = (ODataBoolean_ODataBoolean);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataEquals.ts



var ODataEquals_ODataEquals =
/** @class */
function (_super) {
  __extends(ODataEquals, _super);

  function ODataEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  ODataEquals.prototype.getFilter = function (name, variable) {
    return name + " eq " + this.escapeValue(variable);
  };

  return ODataEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataEquals = (ODataEquals_ODataEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataNotEquals.ts



var ODataNotEquals_ODataNotEquals =
/** @class */
function (_super) {
  __extends(ODataNotEquals, _super);

  function ODataNotEquals() {
    return _super.call(this, "≠", "pbascomponents.operators.not_equals", []) || this;
  }

  ODataNotEquals.prototype.getFilter = function (name, variable) {
    return name + " ne " + variable;
  };

  return ODataNotEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataNotEquals = (ODataNotEquals_ODataNotEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataGreaterThan.ts



var ODataGreaterThan_ODataGreaterThan =
/** @class */
function (_super) {
  __extends(ODataGreaterThan, _super);

  function ODataGreaterThan() {
    return _super.call(this, ">", "pbascomponents.operators.greater", []) || this;
  }

  ODataGreaterThan.prototype.getFilter = function (name, variable) {
    return name + " gt " + variable;
  };

  return ODataGreaterThan;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataGreaterThan = (ODataGreaterThan_ODataGreaterThan);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataGreaterThanOrEquals.ts



var ODataGreaterThanOrEquals_ODataGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(ODataGreaterThanOrEquals, _super);

  function ODataGreaterThanOrEquals() {
    return _super.call(this, ">=", "pbascomponents.operators.greater_or_equals", []) || this;
  }

  ODataGreaterThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + " ge " + variable;
  };

  return ODataGreaterThanOrEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataGreaterThanOrEquals = (ODataGreaterThanOrEquals_ODataGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataLowerThan.ts



var ODataLowerThan_ODataLowerThan =
/** @class */
function (_super) {
  __extends(ODataLowerThan, _super);

  function ODataLowerThan() {
    return _super.call(this, "<", "pbascomponents.operators.lower", []) || this;
  }

  ODataLowerThan.prototype.getFilter = function (name, variable) {
    return name + " lt " + variable;
  };

  return ODataLowerThan;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataLowerThan = (ODataLowerThan_ODataLowerThan);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataLowerThanOrEquals.ts



var ODataLowerThanOrEquals_ODataLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(ODataLowerThanOrEquals, _super);

  function ODataLowerThanOrEquals() {
    return _super.call(this, "<=", "pbascomponents.operators.lower_or_equals", []) || this;
  }

  ODataLowerThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + " le " + variable;
  };

  return ODataLowerThanOrEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataLowerThanOrEquals = (ODataLowerThanOrEquals_ODataLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataDateTime.ts















var ODataDateTime_ODataDateTime =
/** @class */
function (_super) {
  __extends(ODataDateTime, _super);

  function ODataDateTime(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators || [new operators_ODataEquals(), new operators_ODataNotEquals(), new operators_ODataGreaterThan(), new operators_ODataGreaterThanOrEquals(), new operators_ODataLowerThan(), new operators_ODataLowerThanOrEquals()],
      getValue: args.getValue,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getString: args.getString || function (item) {
        var v = _this.getValue(item, _this);

        console.log("v is ", v);

        if (v === null || v === undefined) {
          return "";
        }

        var _a = _this.getValue(item, _this).split("T"),
            date = _a[0],
            time = _a[1];

        var _b = date.split("-"),
            year = _b[0],
            month = _b[1],
            day = _b[2];

        var _c = time.split(":"),
            hours = _c[0],
            minutes = _c[1],
            seconds = _c[2];

        return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds.substring(0, 2) + " UTC";
      },
      getEditableComponent: args.getEditableComponent || function (filter, type) {
        var _data = {
          data: filter,
          menu: false,
          date: _this.toDateString(filter.value)
        };
        var v = external_vue_default.a.extend({
          template: "<div v-if=\"data\">\n                    <v-menu\n    v-model=\"menu\"\n    :close-on-content-click=\"false\"\n    :nudge-right=\"40\"\n    lazy\n    transition=\"scale-transition\"\n    offset-y\n    full-width\n    min-width=\"290px\"\n    max-width=\"290px\"\n  >\n    <template v-slot:activator=\"{ on }\">\n      <v-text-field\n        :value=\"date\"\n        :rules=\"data.operator.valueRules\"\n        readonly\n        v-on=\"on\"\n        @keyup.native=\"setDate($event.target.value)\"\n      ></v-text-field>\n    </template>\n    <v-date-picker v-model=\"date\" no-title scrollable>\n      <div class=\"flex-grow-1\"></div>\n      <v-btn text color=\"primary\" @click=\"menu = false\" >Cancel</v-btn>\n    </v-date-picker>\n  </v-menu>\n  </div>\n                    ",
          data: function data() {
            return _data;
          },
          components: {
            VDatePicker: lib_["VDatePicker"],
            VMenu: lib_["VMenu"],
            VBtn: lib_["VBtn"],
            VTextField: lib_["VTextField"]
          },
          watch: {
            date: {
              handler: function handler(val) {
                this.data.value = new Date(Date.parse(val)).toISOString();
                this.menu = false;
              }
            }
          },
          methods: {
            setDate: function setDate() {
              this.data.value = new Date(Date.parse(this.date)).toISOString();
              this.menu = false;
            }
          }
        });
        return v;
      }
    }) || this;
    return _this;
  }

  ODataDateTime.prototype.toDateString = function (variable) {
    var timestamp = Date.parse(variable);

    if (isNaN(timestamp)) {
      return "";
    }

    var _a = variable.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    var dateFormatted = year + "-" + month + "-" + day;
    return dateFormatted;
  };

  ODataDateTime.prototype.getWildcardFilter = function (variable) {
    var filter = new odata_ODataColumnFilter(this);
    filter.operator = new operators_ODataStringContains();
    filter.value = variable;
    return filter.toODataString(function (name) {
      return "cast(cast(" + name + ",Edm.DateTimeOffset), 'Edm.String')";
    });
  };

  ODataDateTime.prototype.typeString = function () {
    return "Date";
  };

  return ODataDateTime;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataDateTime = (ODataDateTime_ODataDateTime);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateEquals.ts




var ODataDateEquals_ODataDateEquals =
/** @class */
function (_super) {
  __extends(ODataDateEquals, _super);

  function ODataDateEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  ODataDateEquals.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") eq " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateEquals = (ODataDateEquals_ODataDateEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateNotEquals.ts




var ODataDateNotEquals_ODataDateNotEquals =
/** @class */
function (_super) {
  __extends(ODataDateNotEquals, _super);

  function ODataDateNotEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  ODataDateNotEquals.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") ne " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateNotEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateNotEquals = (ODataDateNotEquals_ODataDateNotEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateGreaterThan.ts




var ODataDateGreaterThan_ODataDateGreaterThan =
/** @class */
function (_super) {
  __extends(ODataDateGreaterThan, _super);

  function ODataDateGreaterThan() {
    return _super.call(this, ">", "pbascomponents.operators.greater", []) || this;
  }

  ODataDateGreaterThan.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") gt " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateGreaterThan;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateGreaterThan = (ODataDateGreaterThan_ODataDateGreaterThan);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateGreaterThanOrEquals.ts




var ODataDateGreaterThanOrEquals_ODataDateGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(ODataDateGreaterThanOrEquals, _super);

  function ODataDateGreaterThanOrEquals() {
    return _super.call(this, ">=", "pbascomponents.operators.greater_or_equals", []) || this;
  }

  ODataDateGreaterThanOrEquals.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") ge " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateGreaterThanOrEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateGreaterThanOrEquals = (ODataDateGreaterThanOrEquals_ODataDateGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateLowerThan.ts




var ODataDateLowerThan_ODataDateLowerThan =
/** @class */
function (_super) {
  __extends(ODataDateLowerThan, _super);

  function ODataDateLowerThan() {
    return _super.call(this, "<", "pbascomponents.operators.lower", []) || this;
  }

  ODataDateLowerThan.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") lt " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateLowerThan;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateLowerThan = (ODataDateLowerThan_ODataDateLowerThan);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataDateLowerThanOrEquals.ts




var ODataDateLowerThanOrEquals_ODataDateLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(ODataDateLowerThanOrEquals, _super);

  function ODataDateLowerThanOrEquals() {
    return _super.call(this, "<=", "pbascomponents.operators.lower_or_equals", []) || this;
  }

  ODataDateLowerThanOrEquals.prototype.getFilter = function (name, variable) {
    return "date(" + name + ") le " + this.escapeValue(variable).split('T')[0];
  };

  return ODataDateLowerThanOrEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataDateLowerThanOrEquals = (ODataDateLowerThanOrEquals_ODataDateLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataDate.ts












var ODataDate_ODataDate =
/** @class */
function (_super) {
  __extends(ODataDate, _super);

  function ODataDate(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args !== undefined ? args.alignment : undefined,
      operators: args !== undefined && args.operators !== undefined ? args.operators : [new operators_ODataDateEquals(), new operators_ODataDateNotEquals(), new operators_ODataDateGreaterThan(), new operators_ODataDateGreaterThanOrEquals(), new operators_ODataDateLowerThan(), new operators_ODataDateLowerThanOrEquals()],
      getString: args.getString || function (item) {
        var parsed = _this.parseValue(_this.getValue(item, _this));

        return parsed; // return new Date(Date.parse(parsed)).toLocaleDateString();
      },
      getComponent: args.getComponent,
      getHtml: args.getHtml,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  ODataDate.prototype.getWildcardFilter = function (variable) {
    var filter = new odata_ODataColumnFilter(this); // filter.operator = new ODataIndexOf();

    filter.operator = new operators_ODataStringContains();
    filter.value = variable; // return "(" + filter.toODataString((name: string) => `cast(${name}, 'Edm.String')`)
    //     + " ge 0 and " + filter.toODataString((name: string) => `cast(${name}, 'Edm.String')`) + " le 10)";

    return filter.toODataString(function (name) {
      return "cast(date(" + name + "), 'Edm.String')";
    });
  };

  ODataDate.prototype.typeString = function () {
    return "Date";
  };

  ODataDate.prototype.parseValue = function (dateString) {
    if (dateString === undefined || dateString === null) {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return ODataDate;
}(datatypes_ODataDateTime);

/* harmony default export */ var datatypes_ODataDate = (ODataDate_ODataDate);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataDecimal.ts
















var ODataDecimal_ODataDecimal =
/** @class */
function (_super) {
  __extends(ODataDecimal, _super);

  function ODataDecimal(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new operators_ODataEquals(), new operators_ODataNotEquals(), new operators_ODataGreaterThan(), new operators_ODataGreaterThanOrEquals(), new operators_ODataLowerThan(), new operators_ODataLowerThanOrEquals()],
      getString: args !== undefined && args.getString !== undefined ? args.getString : function (item, type) {
        var val = _this.getValue(item, _this);

        if (val !== undefined && val !== null) {
          return val.toFixed(2);
        }

        return "";
      },
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        var _data = {
          data: filter
        };
        var v = external_vue_default.a.extend({
          template: "<v-text-field autofocus label='Value' type='number' v-model='data.value' :rules='data.operator.valueRules'></v-text-field>",
          components: {
            VTextField: lib_["VTextField"]
          },
          data: function data() {
            return _data;
          }
        });
        return v;
      }
    }) || this;
    return _this;
  }

  ODataDecimal.prototype.getWildcardFilter = function (variable) {
    var str = variable.replace(/,/g, '').replace(/\$/g, '');
    var containsPercentage = str.indexOf("%") >= 0;
    str = str.replace(/%/g, '');
    var num = parseFloat(str);

    if (isNaN(num)) {
      return undefined;
    }

    if (containsPercentage) {
      num /= 100;
    }

    var filter = new odata_ODataColumnFilter(this);
    filter.operator = new operators_ODataStringContains();
    filter.value = num.toString();
    return filter.toODataString(function (name) {
      return "cast(" + name + ", 'Edm.String')";
    });
  };

  ODataDecimal.prototype.typeString = function () {
    return "Decimal";
  };

  return ODataDecimal;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataDecimal = (ODataDecimal_ODataDecimal);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataInteger.ts
















var ODataInteger_ODataInteger =
/** @class */
function (_super) {
  __extends(ODataInteger, _super);

  function ODataInteger(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new operators_ODataEquals(), new operators_ODataNotEquals(), new operators_ODataGreaterThan(), new operators_ODataGreaterThanOrEquals(), new operators_ODataLowerThan(), new operators_ODataLowerThanOrEquals()],
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        var _data = {
          data: filter
        };
        var v = external_vue_default.a.extend({
          template: "<v-text-field autofocus label='Value' type='number' v-model='data.value' :rules='data.operator.valueRules'></v-text-field>",
          components: {
            VTextField: lib_["VTextField"]
          },
          data: function data() {
            return _data;
          }
        });
        return v;
      }
    }) || this;
    return _this;
  }

  ODataInteger.prototype.getWildcardFilter = function (variable) {
    var str = variable.replace(/,/g, '').replace(/\$/g, '');
    var containsPercentage = str.indexOf("%") >= 0;
    str = str.replace(/%/g, '');
    var num = parseFloat(str);

    if (isNaN(num)) {
      return undefined;
    }

    if (containsPercentage) {
      num /= 100;
    }

    var filter = new odata_ODataColumnFilter(this);
    filter.operator = new operators_ODataStringContains();
    filter.value = num.toString();
    return filter.toODataString(function (name) {
      return "cast(" + name + ", 'Edm.String')";
    });
  };

  ODataInteger.prototype.typeString = function () {
    return "Integer";
  };

  return ODataInteger;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataInteger = (ODataInteger_ODataInteger);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringEquals.ts



var ODataStringEquals_ODataStrinEquals =
/** @class */
function (_super) {
  __extends(ODataStrinEquals, _super);

  function ODataStrinEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  ODataStrinEquals.prototype.getFilter = function (name, variable) {
    return "tolower(" + name + ") eq '" + this.escapeValue(variable.toLowerCase()) + "'";
  };

  return ODataStrinEquals;
}(odata_ODataOperator);

/* harmony default export */ var ODataStringEquals = (ODataStringEquals_ODataStrinEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringNotEquals.ts



var ODataStringNotEquals_ODataStringNotEquals =
/** @class */
function (_super) {
  __extends(ODataStringNotEquals, _super);

  function ODataStringNotEquals() {
    return _super.call(this, "≠", "pbascomponents.operators.not_equals", []) || this;
  }

  ODataStringNotEquals.prototype.getFilter = function (name, variable) {
    return "tolower(" + name + ") ne '" + this.escapeValue(variable.toLowerCase()) + "'";
  };

  return ODataStringNotEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataStringNotEquals = (ODataStringNotEquals_ODataStringNotEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringNotContains.ts



var ODataStringNotContains_ODataStringNotContains =
/** @class */
function (_super) {
  __extends(ODataStringNotContains, _super);

  function ODataStringNotContains() {
    return _super.call(this, "⊄", "pbascomponents.operators.not_contains", []) || this;
  }

  ODataStringNotContains.prototype.getFilter = function (name, variable) {
    return "not contains(tolower(" + name + "), '" + this.escapeValue(variable.toLowerCase()) + "')";
  };

  return ODataStringNotContains;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataStringNotContains = (ODataStringNotContains_ODataStringNotContains);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringStartsWith.ts



var ODataStringStartsWith_ODataStringStartsWith =
/** @class */
function (_super) {
  __extends(ODataStringStartsWith, _super);

  function ODataStringStartsWith() {
    return _super.call(this, "A..", "pbascomponents.operators.starts_with", []) || this;
  }

  ODataStringStartsWith.prototype.getFilter = function (name, variable) {
    return "startswith(tolower(" + name + "), '" + this.escapeValue(variable.toLowerCase()) + "')";
  };

  return ODataStringStartsWith;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataStringStartsWith = (ODataStringStartsWith_ODataStringStartsWith);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataStringEndsWith.ts



var ODataStringEndsWith_ODataStringEndsWith =
/** @class */
function (_super) {
  __extends(ODataStringEndsWith, _super);

  function ODataStringEndsWith() {
    return _super.call(this, "..A", "pbascomponents.operators.ends_with", []) || this;
  }

  ODataStringEndsWith.prototype.getFilter = function (name, variable) {
    return "endswith(tolower(" + name + "), '" + this.escapeValue(variable.toLowerCase()) + "')";
  };

  return ODataStringEndsWith;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataStringEndsWith = (ODataStringEndsWith_ODataStringEndsWith);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataString.ts










var ODataString_ODataString =
/** @class */
function (_super) {
  __extends(ODataString, _super);

  function ODataString(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators === undefined ? [new operators_ODataStringContains(), new operators_ODataStringNotContains(), new ODataStringEquals(), new operators_ODataStringNotEquals(), new operators_ODataStringStartsWith(), new operators_ODataStringEndsWith()] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent,
      defaultFilters: args.defaultFilters || [],
      additionalKeys: args.additionalKeys || []
    }) || this;
    return _this;
  }

  return ODataString;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataString = (ODataString_ODataString);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataEnumEquals.ts



var ODataEnumEquals_ODataEnumEquals =
/** @class */
function (_super) {
  __extends(ODataEnumEquals, _super);

  function ODataEnumEquals(dropdownItems) {
    var _this = _super.call(this, "=", "pbascomponents.operators.equals", []) || this;

    _this.dropdownItems = dropdownItems;
    return _this;
  }

  ODataEnumEquals.prototype.getFilter = function (name, variable) {
    return name + " eq '" + this.escapeValue(variable) + "'";
  };

  return ODataEnumEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataEnumEquals = (ODataEnumEquals_ODataEnumEquals);
// CONCATENATED MODULE: ./src/lib/odata/operators/ODataEnumNotEquals.ts



var ODataEnumNotEquals_ODataEnumNotEquals =
/** @class */
function (_super) {
  __extends(ODataEnumNotEquals, _super);

  function ODataEnumNotEquals(dropdownItems) {
    var _this = _super.call(this, "≠", "pbascomponents.operators.not_equals", []) || this;

    _this.dropdownItems = dropdownItems;
    return _this;
  }

  ODataEnumNotEquals.prototype.getFilter = function (name, variable) {
    return name + " ne '" + this.escapeValue(variable) + "'";
  };

  return ODataEnumNotEquals;
}(odata_ODataOperator);

/* harmony default export */ var operators_ODataEnumNotEquals = (ODataEnumNotEquals_ODataEnumNotEquals);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/odata/components/EnumComponent.vue?vue&type=template&id=b92f7422&
var EnumComponentvue_type_template_id_b92f7422_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Value","items":_vm.data.operator.dropdownItems,"rules":_vm.data.operator.valueRules},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v(_vm._s(_vm.$t("enums." + data.item)))]}},{key:"item",fn:function(data){return [_c('v-list-item-content',{domProps:{"textContent":_vm._s(_vm.$t('enums.' + data.item))}})]}}]),model:{value:(_vm.data.value),callback:function ($$v) {_vm.$set(_vm.data, "value", $$v)},expression:"data.value"}})}
var EnumComponentvue_type_template_id_b92f7422_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/odata/components/EnumComponent.vue?vue&type=template&id=b92f7422&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/odata/components/EnumComponent.vue?vue&type=script&lang=ts&




var EnumComponentvue_type_script_lang_ts_EnumComponent =
/** @class */
function (_super) {
  __extends(EnumComponent, _super);

  function EnumComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], EnumComponent.prototype, "data", void 0);

  EnumComponent = __decorate([vue_class_component_common_default()({
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"],
      VSelect: lib_["VSelect"]
    }
  })], EnumComponent);
  return EnumComponent;
}(external_vue_default.a);

/* harmony default export */ var EnumComponentvue_type_script_lang_ts_ = (EnumComponentvue_type_script_lang_ts_EnumComponent);
// CONCATENATED MODULE: ./src/lib/odata/components/EnumComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_EnumComponentvue_type_script_lang_ts_ = (EnumComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/odata/components/EnumComponent.vue





/* normalize component */

var EnumComponent_component = normalizeComponent(
  components_EnumComponentvue_type_script_lang_ts_,
  EnumComponentvue_type_template_id_b92f7422_render,
  EnumComponentvue_type_template_id_b92f7422_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_EnumComponent = (EnumComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataEnum.ts








var ODataEnum_ODataEnum =
/** @class */
function (_super) {
  __extends(ODataEnum, _super);

  function ODataEnum(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators === undefined ? [new operators_ODataEnumEquals(args.dropdownItems ? args.dropdownItems : []), new operators_ODataEnumNotEquals(args.dropdownItems ? args.dropdownItems : [])] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        return components_EnumComponent;
      }
    }) || this;
    return _this;
  }

  ODataEnum.prototype.getWildcardFilter = function (variable) {
    var matches = [];
    var filter = new odata_ODataColumnFilter(this);
    filter.operator = this.operators[0];

    for (var _i = 0, _a = filter.operator.dropdownItems; _i < _a.length; _i++) {
      var enumValue = _a[_i];

      if (enumValue.toLocaleLowerCase().indexOf(variable.toLocaleLowerCase()) > -1) {
        matches.push(enumValue);
      }
    }

    if (matches.length > 0) {
      var basic = [];

      for (var _b = 0, matches_1 = matches; _b < matches_1.length; _b++) {
        var match = matches_1[_b];
        var filter2 = new odata_ODataColumnFilter(this);
        filter2.operator = this.operators[0];
        filter2.value = match;
        var filterString = filter2.toODataString();

        if (filterString !== undefined) {
          basic.push(filterString);
        }
      }

      return "(" + basic.join(" or ") + ")";
    }

    return undefined;
  };

  return ODataEnum;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataEnum = (ODataEnum_ODataEnum);
// CONCATENATED MODULE: ./src/lib/odata/datatypes/ODataCustom.ts





var ODataCustom_ODataCustom =
/** @class */
function (_super) {
  __extends(ODataCustom, _super);

  function ODataCustom(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Center,
      operators: args.operators || [new operators_ODataBooleanIs()],
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent,
      getHtml: args.getHtml,
      getString: args.getString,
      getValue: args.getValue
    }) || this;
    _this.pGetWildcardFilter = args.getWildcardFilter !== undefined ? args.getWildcardFilter : function (wildcard) {
      return _this.buildExpression(function (name) {
        return "contains(" + name + ", '" + wildcard + "')";
      });
    };
    _this.pGetFilter = args.getFilter !== undefined ? args.getFilter : _super.prototype.buildExpression;
    return _this;
  }

  ODataCustom.prototype.getWildcardFilter = function (variable) {
    return this.pGetWildcardFilter(variable);
  };

  ODataCustom.prototype.buildExpression = function (callback) {
    return this.pGetFilter(callback);
  };

  return ODataCustom;
}(odata_ODataType);

/* harmony default export */ var datatypes_ODataCustom = (ODataCustom_ODataCustom);
// CONCATENATED MODULE: ./src/lib/inmemory/InMemoryColumnFilter.ts



var InMemoryColumnFilter_InMemoryColumnFilter =
/** @class */
function (_super) {
  __extends(InMemoryColumnFilter, _super);

  function InMemoryColumnFilter(type) {
    return _super.call(this, type) || this;
  }

  return InMemoryColumnFilter;
}(lib_ColumnFilter);

/* harmony default export */ var inmemory_InMemoryColumnFilter = (InMemoryColumnFilter_InMemoryColumnFilter);
// CONCATENATED MODULE: ./src/lib/inmemory/InMemoryType.ts







var InMemoryType_InMemoryType =
/** @class */
function (_super) {
  __extends(InMemoryType, _super);

  function InMemoryType(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, args.alignment || lib_HeaderAlignment.Left, args.operators || [], args.getValue || function (item, type) {
      var parts = _this.key.split('/');

      var obj = item;

      var _loop_1 = function _loop_1() {
        var partKey = _this.removeAnnotation(parts.shift());

        if (partKey !== undefined) {
          if (obj instanceof Array) {
            obj = obj.map(function (o) {
              return o[partKey];
            });

            if (obj.some(function (o) {
              return o instanceof Array;
            })) {
              obj = obj.reduce(function (a, b) {
                return a.concat(b);
              });
            }
          } else {
            if (obj !== null && obj !== undefined) {
              obj = obj[partKey];
            } else {
              obj = null;
            }
          }
        }
      };

      while (parts.length > 0) {
        _loop_1();
      }

      return obj;
    }, args.getString, args.getHtml, args.getComponent, args.getEditableComponent, args.defaultFilters) || this;
    _this.filters = [];
    _this.defaultFilters = [];
    return _this;
  }
  /*public addNewFilter(header: InMemoryHeader) {
      this.filters.push(new InMemoryColumnFilter(header));
  }*/


  InMemoryType.prototype.createNewFilter = function () {
    return new inmemory_InMemoryColumnFilter(this);
  };

  InMemoryType.prototype.applyWildcardFilter = function (item, variable) {
    if (variable === undefined) {
      return false;
    }

    if (this.getString(item, this) === undefined) {
      return false;
    }

    return this.getString(item, this).toLowerCase().indexOf(variable.toLowerCase()) > -1;
  };

  InMemoryType.prototype.escapeValue = function (value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return encodeURI(value.replace(/\'/g, "''"));
  };
  /*protected getFilter(callback: (name: string) => string): string | undefined {
      const split = this.key.split('/');
      return this.recursiveGetFilter(split, "", callback);
  }*/


  InMemoryType.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  return InMemoryType;
}(lib_DataType);

/* harmony default export */ var inmemory_InMemoryType = (InMemoryType_InMemoryType);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.sort.js
var es6_array_sort = __webpack_require__("55dd");

// CONCATENATED MODULE: ./src/lib/inmemory/InMemoryOperator.ts



var InMemoryOperator_InMemoryOperator =
/** @class */
function (_super) {
  __extends(InMemoryOperator, _super);

  function InMemoryOperator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return InMemoryOperator;
}(lib_Operator);

/* harmony default export */ var inmemory_InMemoryOperator = (InMemoryOperator_InMemoryOperator);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryEquals.ts



var InMemoryEquals_InMemoryEquals =
/** @class */
function (_super) {
  __extends(InMemoryEquals, _super);

  function InMemoryEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  InMemoryEquals.prototype.applyFilter = function (source, variable) {
    console.log("apply filter: ", source, variable);
    return source === variable;
  };

  return InMemoryEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryEquals = (InMemoryEquals_InMemoryEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryNotEquals.ts



var InMemoryNotEquals_InMemoryNotEquals =
/** @class */
function (_super) {
  __extends(InMemoryNotEquals, _super);

  function InMemoryNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  InMemoryNotEquals.prototype.applyFilter = function (source, variable) {
    return source !== variable;
  };

  return InMemoryNotEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryNotEquals = (InMemoryNotEquals_InMemoryNotEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryGreaterThan.ts



var InMemoryGreaterThan_InMemoryGreaterThan =
/** @class */
function (_super) {
  __extends(InMemoryGreaterThan, _super);

  function InMemoryGreaterThan() {
    return _super.call(this, ">", "Greater", []) || this;
  }

  InMemoryGreaterThan.prototype.applyFilter = function (source, variable) {
    return source > variable;
  };

  return InMemoryGreaterThan;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryGreaterThan = (InMemoryGreaterThan_InMemoryGreaterThan);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryGreaterThanOrEquals.ts



var InMemoryGreaterThanOrEquals_InMemoryGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(InMemoryGreaterThanOrEquals, _super);

  function InMemoryGreaterThanOrEquals() {
    return _super.call(this, ">=", "Greater or Equals", []) || this;
  }

  InMemoryGreaterThanOrEquals.prototype.applyFilter = function (source, variable) {
    return source >= variable;
  };

  return InMemoryGreaterThanOrEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryGreaterThanOrEquals = (InMemoryGreaterThanOrEquals_InMemoryGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryLowerThan.ts



var InMemoryLowerThan_InMemoryLowerThan =
/** @class */
function (_super) {
  __extends(InMemoryLowerThan, _super);

  function InMemoryLowerThan() {
    return _super.call(this, "<", "Lower", []) || this;
  }

  InMemoryLowerThan.prototype.applyFilter = function (source, variable) {
    return source < variable;
  };

  return InMemoryLowerThan;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryLowerThan = (InMemoryLowerThan_InMemoryLowerThan);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryLowerThanOrEquals.ts



var InMemoryLowerThanOrEquals_InMemoryLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(InMemoryLowerThanOrEquals, _super);

  function InMemoryLowerThanOrEquals() {
    return _super.call(this, "<=", "Lower or Equals", []) || this;
  }

  InMemoryLowerThanOrEquals.prototype.applyFilter = function (source, variable) {
    return source <= variable;
  };

  return InMemoryLowerThanOrEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryLowerThanOrEquals = (InMemoryLowerThanOrEquals_InMemoryLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryInteger.ts










var InMemoryInteger_InMemoryInteger =
/** @class */
function (_super) {
  __extends(InMemoryInteger, _super);

  function InMemoryInteger(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new operators_InMemoryEquals(), new operators_InMemoryNotEquals(), new operators_InMemoryGreaterThan(), new operators_InMemoryGreaterThanOrEquals(), new operators_InMemoryLowerThan(), new operators_InMemoryLowerThanOrEquals()],
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  return InMemoryInteger;
}(inmemory_InMemoryType);

/* harmony default export */ var datatypes_InMemoryInteger = (InMemoryInteger_InMemoryInteger);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalEquals.ts



var InMemoryDecimalEquals_InMemoryDecimalEquals =
/** @class */
function (_super) {
  __extends(InMemoryDecimalEquals, _super);

  function InMemoryDecimalEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  InMemoryDecimalEquals.prototype.applyFilter = function (source, variable) {
    console.log("apply filter: ", source, variable);
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s === v;
  };

  return InMemoryDecimalEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryDecimalEquals = (InMemoryDecimalEquals_InMemoryDecimalEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalNotEquals.ts



var InMemoryDecimalNotEquals_InMemoryNotEquals =
/** @class */
function (_super) {
  __extends(InMemoryNotEquals, _super);

  function InMemoryNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  InMemoryNotEquals.prototype.applyFilter = function (source, variable) {
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s !== v;
  };

  return InMemoryNotEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var InMemoryDecimalNotEquals = (InMemoryDecimalNotEquals_InMemoryNotEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalGreaterThan.ts



var InMemoryDecimalGreaterThan_InMemoryDecimalGreaterThan =
/** @class */
function (_super) {
  __extends(InMemoryDecimalGreaterThan, _super);

  function InMemoryDecimalGreaterThan() {
    return _super.call(this, ">", "Greater", []) || this;
  }

  InMemoryDecimalGreaterThan.prototype.applyFilter = function (source, variable) {
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s > v;
  };

  return InMemoryDecimalGreaterThan;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryDecimalGreaterThan = (InMemoryDecimalGreaterThan_InMemoryDecimalGreaterThan);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalGreaterThanOrEquals.ts



var InMemoryDecimalGreaterThanOrEquals_InMemoryGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(InMemoryGreaterThanOrEquals, _super);

  function InMemoryGreaterThanOrEquals() {
    return _super.call(this, ">=", "Greater or Equals", []) || this;
  }

  InMemoryGreaterThanOrEquals.prototype.applyFilter = function (source, variable) {
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s >= v;
  };

  return InMemoryGreaterThanOrEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var InMemoryDecimalGreaterThanOrEquals = (InMemoryDecimalGreaterThanOrEquals_InMemoryGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalLowerThan.ts



var InMemoryDecimalLowerThan_InMemoryLowerThan =
/** @class */
function (_super) {
  __extends(InMemoryLowerThan, _super);

  function InMemoryLowerThan() {
    return _super.call(this, "<", "Lower", []) || this;
  }

  InMemoryLowerThan.prototype.applyFilter = function (source, variable) {
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s < v;
  };

  return InMemoryLowerThan;
}(inmemory_InMemoryOperator);

/* harmony default export */ var InMemoryDecimalLowerThan = (InMemoryDecimalLowerThan_InMemoryLowerThan);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDecimalLowerThanOrEquals.ts



var InMemoryDecimalLowerThanOrEquals_InMemoryLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(InMemoryLowerThanOrEquals, _super);

  function InMemoryLowerThanOrEquals() {
    return _super.call(this, "<=", "Lower or Equals", []) || this;
  }

  InMemoryLowerThanOrEquals.prototype.applyFilter = function (source, variable) {
    var s = parseFloat(source);
    var v = parseFloat(variable);
    return s <= v;
  };

  return InMemoryLowerThanOrEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var InMemoryDecimalLowerThanOrEquals = (InMemoryDecimalLowerThanOrEquals_InMemoryLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryDecimal.ts












var InMemoryDecimal_InMemoryDecimal =
/** @class */
function (_super) {
  __extends(InMemoryDecimal, _super);

  function InMemoryDecimal(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new operators_InMemoryDecimalEquals(), new InMemoryDecimalNotEquals(), new operators_InMemoryDecimalGreaterThan(), new InMemoryDecimalGreaterThanOrEquals(), new InMemoryDecimalLowerThan(), new InMemoryDecimalLowerThanOrEquals()],
      getString: function getString(item) {
        return args !== undefined && args.getString !== undefined ? args.getString(item, _this) : _this.getValue(item, _this).toFixed(2);
      },
      getComponent: args.getComponent,
      getEditableComponent: function getEditableComponent(filter, type) {
        console.log("in memory decimal: get editable component: ", filter, type);
        var _data = {
          filter: filter
        };
        var v = external_vue_default.a.extend({
          template: "<v-text-field label='Value' type='number' v-model='filter.value' :rules='filter.operator.valueRules'></v-text-field>",
          components: {
            VTextField: lib_["VTextField"]
          },
          data: function data() {
            return _data;
          }
        });
        return v;
      }
    }) || this;
    return _this;
  }

  return InMemoryDecimal;
}(inmemory_InMemoryType);

/* harmony default export */ var datatypes_InMemoryDecimal = (InMemoryDecimal_InMemoryDecimal);
// CONCATENATED MODULE: ./src/lib/inmemory/InMemoryProvider.ts









var InMemoryProvider_InMemoryProvider =
/** @class */
function (_super) {
  __extends(InMemoryProvider, _super);

  function InMemoryProvider(items, headers) {
    var _this = _super.call(this) || this;

    _this.items = items;
    _this.headers = headers;
    return _this;
  }

  InMemoryProvider.prototype.fetchAsync = function (startIndex, count, sortOptions, wildcard, columnFilters, keys) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.getResultAsync(startIndex, count, sortOptions, wildcard, columnFilters)];
      });
    });
  };

  InMemoryProvider.prototype.getResultAsync = function (startIndex, count, sortOptions, wildcard, filters) {
    return __awaiter(this, void 0, Promise, function () {
      var items, length, header_1;
      return __generator(this, function (_a) {
        items = this.applyFilters(JSON.parse(JSON.stringify(this.items)), filters);

        if (wildcard !== undefined) {
          items = this.applyWildcardFilter(items, wildcard);
        }

        length = items.length;

        if (sortOptions !== undefined && sortOptions.length > 0 && sortOptions[0].header) {
          header_1 = this.headers.filter(function (o) {
            return o.type.key === sortOptions[0].header.type.key;
          })[0];
          items = items.sort(function (a, b) {
            if (header_1.type instanceof datatypes_InMemoryInteger || header_1.type instanceof datatypes_InMemoryDecimal) {
              var sortA = header_1.type.getValue(a, header_1.type);
              var sortB = header_1.type.getValue(b, header_1.type);

              if (sortOptions[0].direction === lib_SortDirection.Ascending) {
                if (sortA < sortB) {
                  return -1;
                }

                if (sortA > sortB) {
                  return 1;
                }

                return 0;
              } else {
                if (sortA < sortB) {
                  return 1;
                }

                if (sortA > sortB) {
                  return -1;
                }

                return 0;
              }
            } else {
              var sortA = header_1.type.getString(a, header_1.type);
              var sortB = header_1.type.getString(b, header_1.type);

              if (sortOptions[0].direction === lib_SortDirection.Ascending) {
                if (sortA < sortB) {
                  return -1;
                }

                if (sortA > sortB) {
                  return 1;
                }

                return 0;
              } else {
                if (sortA < sortB) {
                  return 1;
                }

                if (sortA > sortB) {
                  return -1;
                }

                return 0;
              }
            }
          });
        }

        if (count !== undefined && count > 0 && startIndex !== undefined) {
          items = items.slice(startIndex, count + startIndex);
        }
        /*if (keys !== undefined) {
            let headers = this.headers;
            headers = headers.filter((h) => keys.some((k) => k === h.type.key))
            items = items.map((o)=> (this.createSelect(headers)) => ({ a, c }))(o))
        }*/


        return [2
        /*return*/
        , new lib_FetchResult(length, items)];
      });
    });
  };
  /*private createSelect(headers: InMemoryHeader[]): any {
      let obj = {};
      for (const h of headers) {
           h.type.key
      }
      return obj
  }
  private pick(o, ...props) {
      return Object.assign({}, ...props.map(prop => ({[prop]: o[prop]})));
  }*/


  InMemoryProvider.prototype.applyWildcardFilter = function (items, filter) {
    // console.log(items, filter);
    if (filter !== undefined && filter !== "") {
      var result = [];

      var _loop_1 = function _loop_1(header) {
        var filtered = items.filter(function (o) {
          return header.type.applyWildcardFilter(o, filter) !== false;
        }); // console.log(header, filtered);

        for (var _i = 0, filtered_1 = filtered; _i < filtered_1.length; _i++) {
          var res = filtered_1[_i];

          if (result.indexOf(res) < 0) {
            result.push(res);
          }
        }
      };

      for (var _i = 0, _a = this.headers.filter(function (h) {
        return h.allowVisibilityChange && h.searchable;
      }); _i < _a.length; _i++) {
        var header = _a[_i];

        _loop_1(header);
      }

      return result;
    }

    return [].concat.apply([], items);
  };

  InMemoryProvider.prototype.applyFilters = function (items, filters) {
    // console.log(items, filters);
    if (filters === undefined || filters.length === 0) {
      return [].concat.apply([], items);
    }

    var result = [];

    var _loop_2 = function _loop_2(f) {
      // console.log("filter: ", f);
      var header = this_1.headers.filter(function (o) {
        return o.type.key === f.type.key;
      })[0];
      result = items.filter(function (o) {
        return f.operator.applyFilter(header.type.getString(o, header.type), f.value);
      });
    };

    var this_1 = this;

    for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
      var f = filters_1[_i];

      _loop_2(f);
    }

    return result;
  };

  return InMemoryProvider;
}(lib_DataProvider);

/* harmony default export */ var inmemory_InMemoryProvider = (InMemoryProvider_InMemoryProvider);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryBooleanIs.ts




var InMemoryBooleanIs_InMemoryBooleanIs =
/** @class */
function (_super) {
  __extends(InMemoryBooleanIs, _super);

  function InMemoryBooleanIs() {
    return _super.call(this, "=", "Is", ["True", "False"]) || this;
  }

  InMemoryBooleanIs.prototype.applyFilter = function (source, variable) {
    if (variable.toLowerCase() === "true") {
      return source.toString().toLowerCase() === "true";
    }

    return source.toString().toLowerCase() === "false";
  };

  return InMemoryBooleanIs;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryBooleanIs = (InMemoryBooleanIs_InMemoryBooleanIs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/inmemory/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=56f4c9c6&
var BooleanInjectableComponentvue_type_template_id_56f4c9c6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"input-value":_vm.data.header.type.getValue(_vm.data.item, _vm.data.header.type),"readonly":true}})],1)}
var BooleanInjectableComponentvue_type_template_id_56f4c9c6_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=56f4c9c6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/inmemory/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&




var datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent =
/** @class */
function (_super) {
  __extends(BooleanInjectableComponent, _super);

  function BooleanInjectableComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], BooleanInjectableComponent.prototype, "data", void 0);

  BooleanInjectableComponent = __decorate([vue_class_component_common_default()({
    name: "BooleanInjectableComponent",
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"]
    }
  })], BooleanInjectableComponent);
  return BooleanInjectableComponent;
}(external_vue_default.a);

/* harmony default export */ var inmemory_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var lib_inmemory_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (inmemory_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/BooleanInjectableComponent.vue





/* normalize component */

var datatypes_BooleanInjectableComponent_component = normalizeComponent(
  lib_inmemory_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_,
  BooleanInjectableComponentvue_type_template_id_56f4c9c6_render,
  BooleanInjectableComponentvue_type_template_id_56f4c9c6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var inmemory_datatypes_BooleanInjectableComponent = (datatypes_BooleanInjectableComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryBoolean.ts






var InMemoryBoolean_InMemoryBoolean =
/** @class */
function (_super) {
  __extends(InMemoryBoolean, _super);

  function InMemoryBoolean(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Center,
      operators: args.operators || [new operators_InMemoryBooleanIs()],
      getComponent: function getComponent(item, type) {
        return inmemory_datatypes_BooleanInjectableComponent;
      },
      getEditableComponent: args.getEditableComponent,
      getHtml: args.getHtml,
      getString: args.getString,
      getValue: args.getValue
    }) || this;
    return _this;
  }

  InMemoryBoolean.prototype.applyWildcardFilter = function (source, variable) {
    // console.log(source, variable);
    if (variable.toLowerCase() === "true" || variable.toLowerCase() === "false") {
      return this.getString(source, this).toLowerCase().indexOf(variable.toLowerCase()) > -1;
    }

    return false;
  };

  return InMemoryBoolean;
}(inmemory_InMemoryType);

/* harmony default export */ var datatypes_InMemoryBoolean = (InMemoryBoolean_InMemoryBoolean);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDateEquals.ts




var InMemoryDateEquals_InMemoryDateEquals =
/** @class */
function (_super) {
  __extends(InMemoryDateEquals, _super);

  function InMemoryDateEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  InMemoryDateEquals.prototype.applyFilter = function (source, variable) {
    // console.log(source, variable);
    return source === this.parseValue(variable);
  };

  InMemoryDateEquals.prototype.parseValue = function (dateString) {
    if (dateString === undefined || dateString === null) {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return InMemoryDateEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryDateEquals = (InMemoryDateEquals_InMemoryDateEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryDateNotEquals.ts




var InMemoryDateNotEquals_InMemoryDateNotEquals =
/** @class */
function (_super) {
  __extends(InMemoryDateNotEquals, _super);

  function InMemoryDateNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  InMemoryDateNotEquals.prototype.applyFilter = function (source, variable) {
    return source !== this.parseValue(variable);
  };

  InMemoryDateNotEquals.prototype.parseValue = function (dateString) {
    if (dateString === undefined || dateString === null) {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return InMemoryDateNotEquals;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryDateNotEquals = (InMemoryDateNotEquals_InMemoryDateNotEquals);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryDateTime.ts













var InMemoryDateTime_InMemoryDateTime =
/** @class */
function (_super) {
  __extends(InMemoryDateTime, _super);

  function InMemoryDateTime(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators || [new operators_InMemoryDateEquals(), new operators_InMemoryDateNotEquals(), new operators_InMemoryGreaterThan(), new operators_InMemoryGreaterThanOrEquals(), new operators_InMemoryLowerThan(), new operators_InMemoryLowerThanOrEquals()],
      getValue: args.getValue,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getString: args.getString || function (item) {
        return new Date(Date.parse(_this.getValue(item, _this))).toLocaleDateString();
      },
      getEditableComponent: args.getEditableComponent || function (filter, type) {
        var _data = {
          data: filter,
          menu: false,
          date: _this.toDateString(filter.value)
        };
        var v = external_vue_default.a.extend({
          template: "<div v-if=\"data\">\n                    <v-menu\n    v-model=\"menu\"\n    :close-on-content-click=\"false\"\n    :nudge-right=\"40\"\n    lazy\n    transition=\"scale-transition\"\n    offset-y\n    full-width\n    min-width=\"290px\"\n    max-width=\"290px\"\n  >\n    <template v-slot:activator=\"{ on }\">\n      <v-text-field\n        :value=\"date\"\n        :rules=\"data.operator.valueRules\"\n        readonly\n        v-on=\"on\"\n        @keyup.native=\"setDate($event.target.value)\"\n      ></v-text-field>\n    </template>\n    <v-date-picker v-model=\"date\" no-title scrollable>\n      <div class=\"flex-grow-1\"></div>\n      <v-btn text color=\"primary\" @click=\"menu = false\" >Cancel</v-btn>\n    </v-date-picker>\n  </v-menu>\n  </div>\n                    ",
          data: function data() {
            return _data;
          },
          components: {
            VDatePicker: lib_["VDatePicker"],
            VMenu: lib_["VMenu"],
            VBtn: lib_["VBtn"],
            VTextField: lib_["VTextField"]
          },
          watch: {
            date: {
              handler: function handler(val) {
                this.data.value = new Date(Date.parse(val)).toISOString();
                this.menu = false;
              }
            }
          },
          methods: {
            setDate: function setDate() {
              this.data.value = new Date(Date.parse(this.date)).toISOString();
              this.menu = false;
            }
          }
        });
        return v;
      }
    }) || this;
    return _this;
  }

  InMemoryDateTime.prototype.toDateString = function (variable) {
    var timestamp = Date.parse(variable);

    if (isNaN(timestamp)) {
      return "";
    }

    var _a = variable.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    var dateFormatted = year + "-" + month + "-" + day;
    return dateFormatted;
  };

  return InMemoryDateTime;
}(inmemory_InMemoryType);

/* harmony default export */ var datatypes_InMemoryDateTime = (InMemoryDateTime_InMemoryDateTime);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryDate.ts










var InMemoryDate_InMemoryDate =
/** @class */
function (_super) {
  __extends(InMemoryDate, _super);

  function InMemoryDate(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args !== undefined ? args.alignment : undefined,
      operators: args !== undefined ? args.operators : [new operators_InMemoryDateEquals(), new operators_InMemoryDateNotEquals(), new operators_InMemoryGreaterThan(), new operators_InMemoryGreaterThanOrEquals(), new operators_InMemoryLowerThan(), new operators_InMemoryLowerThanOrEquals()],
      getValue: undefined,
      getString: args.getString || function (item) {
        var parsed = _this.parseValue(_this.getValue(item, _this));

        return parsed; // return new Date(Date.parse(parsed)).toLocaleDateString();
      },
      getComponent: args.getComponent,
      getHtml: args.getHtml,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  InMemoryDate.prototype.parseValue = function (dateString) {
    // console.log("inmemoryDate: parseValue: date is: ", dateString);
    if (dateString === undefined || dateString === null || dateString === "") {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return InMemoryDate;
}(datatypes_InMemoryDateTime);

/* harmony default export */ var datatypes_InMemoryDate = (InMemoryDate_InMemoryDate);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryStringContains.ts



var InMemoryStringContains_InMemoryStringContains =
/** @class */
function (_super) {
  __extends(InMemoryStringContains, _super);

  function InMemoryStringContains() {
    return _super.call(this, "⊆", "Contains", []) || this;
  }

  InMemoryStringContains.prototype.applyFilter = function (source, variable) {
    if (source === null || source === undefined) {
      return false;
    }

    if (Array.isArray(source)) {
      return source.join(" ").toLowerCase().indexOf(variable.toLowerCase()) > -1;
    } // console.log(source, variable);


    return source.toLowerCase().indexOf(variable.toLowerCase()) > -1;
  };

  return InMemoryStringContains;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryStringContains = (InMemoryStringContains_InMemoryStringContains);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryStringNotContains.ts



var InMemoryStringNotContains_InMemoryStringNotContains =
/** @class */
function (_super) {
  __extends(InMemoryStringNotContains, _super);

  function InMemoryStringNotContains() {
    return _super.call(this, "⊄", "Not Contains", []) || this;
  }

  InMemoryStringNotContains.prototype.applyFilter = function (source, variable) {
    if (source === null || source === undefined) {
      return true;
    }

    if (Array.isArray(source)) {
      return source.join(" ").toLowerCase().indexOf(variable.toLowerCase()) === -1;
    } // console.log(source, variable);


    return source.toLowerCase().indexOf(variable.toLowerCase()) === -1;
  };

  return InMemoryStringNotContains;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryStringNotContains = (InMemoryStringNotContains_InMemoryStringNotContains);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryStringStartsWith.ts




var InMemoryStringStartsWith_InMemoryStringStartsWith =
/** @class */
function (_super) {
  __extends(InMemoryStringStartsWith, _super);

  function InMemoryStringStartsWith() {
    return _super.call(this, "A..", "Starts With", []) || this;
  }

  InMemoryStringStartsWith.prototype.applyFilter = function (source, variable) {
    if (source === null || source === undefined) {
      return false;
    }

    if (Array.isArray(source)) {
      return source.join(" ").toLowerCase().startsWith(variable.toLowerCase());
    }

    return source.toLowerCase().startsWith(variable.toLowerCase());
  };

  return InMemoryStringStartsWith;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryStringStartsWith = (InMemoryStringStartsWith_InMemoryStringStartsWith);
// CONCATENATED MODULE: ./src/lib/inmemory/operators/InMemoryStringEndsWith.ts




var InMemoryStringEndsWith_InMemoryStringEndsWith =
/** @class */
function (_super) {
  __extends(InMemoryStringEndsWith, _super);

  function InMemoryStringEndsWith() {
    return _super.call(this, "..A", "Ends With", []) || this;
  }

  InMemoryStringEndsWith.prototype.applyFilter = function (source, variable) {
    if (source === null || source === undefined) {
      return false;
    }

    if (Array.isArray(source)) {
      return source.join(" ").toLowerCase().endsWith(variable.toLowerCase());
    }

    return source.toLowerCase().endsWith(variable.toLowerCase());
  };

  return InMemoryStringEndsWith;
}(inmemory_InMemoryOperator);

/* harmony default export */ var operators_InMemoryStringEndsWith = (InMemoryStringEndsWith_InMemoryStringEndsWith);
// CONCATENATED MODULE: ./src/lib/inmemory/datatypes/InMemoryString.ts










var InMemoryString_InMemoryString =
/** @class */
function (_super) {
  __extends(InMemoryString, _super);

  function InMemoryString(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators === undefined ? [new operators_InMemoryStringContains(), new operators_InMemoryStringNotContains(), new operators_InMemoryEquals(), new operators_InMemoryNotEquals(), new operators_InMemoryStringStartsWith(), new operators_InMemoryStringEndsWith()] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  return InMemoryString;
}(inmemory_InMemoryType);

/* harmony default export */ var datatypes_InMemoryString = (InMemoryString_InMemoryString);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsBooleanIs.ts





var LogicalExpressionsBooleanIs_LogicalExpressionsBooleanIs =
/** @class */
function (_super) {
  __extends(LogicalExpressionsBooleanIs, _super);

  function LogicalExpressionsBooleanIs() {
    return _super.call(this, "=", "Is", ["True", "False"]) || this;
  }

  LogicalExpressionsBooleanIs.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);

    if (variable.toString().toLowerCase() === "true") {
      result.expression = "[" + source + "] == true";
      return result;
    }

    result.expression = "[" + source + "] == false";
    return result;
  };

  return LogicalExpressionsBooleanIs;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var operators_LogicalExpressionsBooleanIs = (LogicalExpressionsBooleanIs_LogicalExpressionsBooleanIs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/logicalExpressions/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=565600b1&
var BooleanInjectableComponentvue_type_template_id_565600b1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"input-value":_vm.data.header.type.getValue(_vm.data.item, _vm.data.header.type),"readonly":true}})],1)}
var BooleanInjectableComponentvue_type_template_id_565600b1_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=565600b1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/logicalExpressions/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&




var logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent =
/** @class */
function (_super) {
  __extends(BooleanInjectableComponent, _super);

  function BooleanInjectableComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], BooleanInjectableComponent.prototype, "data", void 0);

  BooleanInjectableComponent = __decorate([vue_class_component_common_default()({
    name: "BooleanInjectableComponent",
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"]
    }
  })], BooleanInjectableComponent);
  return BooleanInjectableComponent;
}(external_vue_default.a);

/* harmony default export */ var logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var lib_logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/BooleanInjectableComponent.vue





/* normalize component */

var logicalExpressions_datatypes_BooleanInjectableComponent_component = normalizeComponent(
  lib_logicalExpressions_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_,
  BooleanInjectableComponentvue_type_template_id_565600b1_render,
  BooleanInjectableComponentvue_type_template_id_565600b1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var logicalExpressions_datatypes_BooleanInjectableComponent = (logicalExpressions_datatypes_BooleanInjectableComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/LogicalExpressionsBoolean.ts





var LogicalExpressionsBoolean_LogicalExpressionsBoolean =
/** @class */
function (_super) {
  __extends(LogicalExpressionsBoolean, _super);

  function LogicalExpressionsBoolean(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      operators: args.operators || [new operators_LogicalExpressionsBooleanIs()],
      getComponent: function getComponent(item, type) {
        return logicalExpressions_datatypes_BooleanInjectableComponent;
      },
      getEditableComponent: args.getEditableComponent,
      getHtml: args.getHtml,
      getString: args.getString,
      getValue: args.getValue
    }) || this;
    return _this;
  }

  LogicalExpressionsBoolean.prototype.stringToOperator = function (operator) {
    return new operators_LogicalExpressionsBooleanIs();
  };

  LogicalExpressionsBoolean.prototype.stringToValue = function (valueStr) {
    return valueStr.toLowerCase() === "true" ? 'True' : 'False';
  };

  LogicalExpressionsBoolean.prototype.copy = function () {
    return new LogicalExpressionsBoolean(this.key);
  };

  return LogicalExpressionsBoolean;
}(logicalExpressions_LogicalExpressionsType);

/* harmony default export */ var datatypes_LogicalExpressionsBoolean = (LogicalExpressionsBoolean_LogicalExpressionsBoolean);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsStringEquals.ts




var LogicalExpressionsStringEquals_LogicalExpressionsEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsEquals, _super);

  function LogicalExpressionsEquals() {
    return _super.call(this, "=", "Equals", []) || this;
  }

  LogicalExpressionsEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] == '" + variable + "'";
    return result;
  };

  return LogicalExpressionsEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var LogicalExpressionsStringEquals = (LogicalExpressionsStringEquals_LogicalExpressionsEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/operators/LogicalExpressionsStringNotEquals.ts




var LogicalExpressionsStringNotEquals_LogicalExpressionsNotEquals =
/** @class */
function (_super) {
  __extends(LogicalExpressionsNotEquals, _super);

  function LogicalExpressionsNotEquals() {
    return _super.call(this, "≠", "Not Equals", []) || this;
  }

  LogicalExpressionsNotEquals.prototype.applyFilter = function (source, variable) {
    var result = new logicalExpressions_LogicalExpressionsOperatorResult(source);
    result.expression = "[" + source + "] != '" + variable + "'";
    return result;
  };

  return LogicalExpressionsNotEquals;
}(logicalExpressions_LogicalExpressionsOperator);

/* harmony default export */ var LogicalExpressionsStringNotEquals = (LogicalExpressionsStringNotEquals_LogicalExpressionsNotEquals);
// CONCATENATED MODULE: ./src/lib/logicalExpressions/datatypes/LogicalExpressionsString.ts






var LogicalExpressionsString_LogicalExpressionsString =
/** @class */
function (_super) {
  __extends(LogicalExpressionsString, _super);

  function LogicalExpressionsString(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      operators: args.operators === undefined ? [new LogicalExpressionsStringEquals(), new LogicalExpressionsStringNotEquals()] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent
    }) || this;
    return _this;
  }

  LogicalExpressionsString.prototype.stringToOperator = function (operator) {
    if (operator === "==") {
      return new LogicalExpressionsStringEquals();
    } else if (operator === "!=") {
      return new LogicalExpressionsStringNotEquals();
    } else {
      return undefined;
    }
  };

  LogicalExpressionsString.prototype.stringToValue = function (valueStr) {
    return valueStr.replace(/'/g, "");
  };

  LogicalExpressionsString.prototype.copy = function () {
    return new LogicalExpressionsString(this.key);
  };

  return LogicalExpressionsString;
}(logicalExpressions_LogicalExpressionsType);

/* harmony default export */ var datatypes_LogicalExpressionsString = (LogicalExpressionsString_LogicalExpressionsString);
// CONCATENATED MODULE: ./src/lib/redmine/RedmineColumnFilter.ts



var RedmineColumnFilter_RedmineColumnFilter =
/** @class */
function (_super) {
  __extends(RedmineColumnFilter, _super);

  function RedmineColumnFilter(type) {
    var _this = _super.call(this, type) || this;

    _this.type = type;
    return _this;
  }

  RedmineColumnFilter.prototype.toRedmineString = function (convertName) {
    var _this = this;

    return this.type.buildExpression(function (name) {
      return _this.operator.getFilter(convertName !== undefined ? convertName(name) : name, _this.value);
    });
  };

  return RedmineColumnFilter;
}(lib_ColumnFilter);

/* harmony default export */ var redmine_RedmineColumnFilter = (RedmineColumnFilter_RedmineColumnFilter);
// CONCATENATED MODULE: ./src/lib/redmine/RedmineType.ts








var RedmineType_RedmineType =
/** @class */
function (_super) {
  __extends(RedmineType, _super);

  function RedmineType(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, args.alignment || lib_HeaderAlignment.Left, args.operators || [], args.getValue || function (item, type) {
      var parts = _this.key.split("/");

      var obj = item;
      var tobreak = false;

      var _loop_1 = function _loop_1() {
        if (tobreak) {
          return "break";
        }

        var partKey = _this.removeAnnotation(parts.shift());

        if (partKey !== undefined) {
          if (obj instanceof Array) {
            obj = obj.map(function (o) {
              if (o[partKey] !== undefined) {
                return o[partKey];
              } else {
                tobreak = true;
                return o.Id;
              }
            });

            if (obj.some(function (o) {
              return o instanceof Array;
            })) {
              obj = obj.reduce(function (a, b) {
                return a.concat(b);
              });
            }
          } else {
            if (obj !== null && obj !== undefined) {
              obj = obj[partKey];
            } else {
              obj = null;
            }
          }
        }
      };

      while (parts.length > 0) {
        var state_1 = _loop_1();

        if (state_1 === "break") break;
      }

      return obj;
    }, args.getString, args.getHtml, args.getComponent, args.getEditableComponent, args.defaultFilters, args.additionalKeys) || this;
    _this.defaultFilters = [];

    if (args.searchKey === undefined) {
      _this.searchKey = key;
    } else {
      _this.searchKey = args.searchKey;
    }

    console.log(_this.searchKey, args);
    return _this;
  }

  RedmineType.prototype.getFilters = function () {
    return undefined;
  };

  RedmineType.prototype.createNewFilter = function () {
    return new redmine_RedmineColumnFilter(this);
  };

  RedmineType.prototype.getFiltersRedmineString = function (filters) {
    return filters.map(function (f) {
      return f.toRedmineString();
    }).filter(function (r) {
      return r !== undefined;
    }).join(" & ");
  };

  RedmineType.prototype.getWildcardFilter = function (variable) {
    return undefined;
  };

  RedmineType.prototype.getSelect = function () {
    // return this.removeAnnotation(this.key);
    return "";
  };

  RedmineType.prototype.getExpand = function () {
    var split = this.key.split("/");
    return "" + this.removeAnnotation(split.shift()) + this.recursiveBuildExpand(split);
  };

  RedmineType.prototype.buildExpression = function (callback) {
    console.log(this.searchKey);
    var split = this.searchKey.split("/");
    var res = this.recursiveGetFilter(split, "", callback);

    if (res === undefined) {
      return undefined;
    }

    var arr = [res];

    for (var _i = 0, _a = this.additionalKeys; _i < _a.length; _i++) {
      var sub = _a[_i];
      var ret = sub.buildExpression(callback);

      if (ret !== undefined) {
        arr.push(ret);
      }
    }

    return "" + arr.join("&");
  };

  RedmineType.prototype.escapeValue = function (value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return encodeURIComponent(value.replace(/\'/g, "''"));
  };

  RedmineType.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  RedmineType.prototype.recursiveGetFilter = function (parts, alias, callback) {
    if (parts.length === 0) {
      return callback("" + alias);
    }

    var next = parts[0];
    parts.shift();
    var prefix = alias !== "" ? "/" : "";

    if (next.endsWith("[]")) {
      if (parts.length === 0) {
        return undefined;
      }

      var newNext = this.removeAnnotation(next);
      var newAlias = alias.split('/').map(function (a) {
        return a[0];
      }).join("_") + "_" + newNext[0].toLowerCase();
      return "" + alias + prefix + newNext + "/any(" + newAlias + ": " + (this.recursiveGetFilter(parts, newAlias, callback) + ")");
    }

    return this.recursiveGetFilter(parts, "" + alias + (alias !== "" ? "/" : "") + next, callback);
  };

  RedmineType.prototype.recursiveBuildExpand = function (parts) {
    if (parts.length === 0) {
      return "";
    }

    if (parts.length === 1) {
      if (parts[0] !== "") {
        return "($select=" + this.removeAnnotation(parts[0]) + ")";
      }

      return "";
    } else {
      return "($expand=" + this.removeAnnotation(parts.shift()) + this.recursiveBuildExpand(parts) + ")";
    }
  };

  return RedmineType;
}(lib_DataType);

/* harmony default export */ var redmine_RedmineType = (RedmineType_RedmineType);
// CONCATENATED MODULE: ./src/lib/redmine/RedmineProvider.ts














var RedmineProvider_RedmineProvider =
/** @class */
function (_super) {
  __extends(RedmineProvider, _super);

  function RedmineProvider(http, uri, headers, entity, key, options) {
    var _this = _super.call(this) || this;

    _this.http = http;
    _this.uri = uri;
    _this.headers = headers;
    _this.entity = entity;
    _this.key = key;
    _this.options = options || {
      useSelect: true
    };
    return _this;
  }

  RedmineProvider.prototype.fetchAsync = function (startIndex, count, sortOptions, wildcard, columnFilters, keys) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.getResultAsync(this.getRedmineQueryString(startIndex, count, sortOptions, wildcard, columnFilters, keys))];
      });
    });
  };

  RedmineProvider.prototype.getExpandAsString = function () {
    var _this = this;

    var map = this.getExpandAsMap();
    var res = [];
    map.forEach(function (value, key) {
      if (value === "") {
        res.push("" + key);
      } else {
        var recursive = "" + _this.recursiveGetExpandAsString(value);

        if (recursive) {
          res.push(key + "(" + recursive + ")");
        } else {
          res.push("" + key);
        }
      }
    });
    return res.join(",");
  };

  RedmineProvider.prototype.getExpandAsMap = function () {
    var _this = this;

    var map = new Map();
    this.headers.filter(function (s) {
      return s.type.key.indexOf("[]") > 0;
    }).forEach(function (h) {
      // console.log("getExpandAsMap 1: ", h.type.key);
      var split = h.type.key.split("/");

      var key = _this.removeAnnotation(split.shift());

      if (split.length > 0) {
        var newMap = new Map();

        if (map.has(key)) {
          newMap = map.get(key);
        } // console.log("getExpandAsMap 2: ", h.type.key);


        _this.recursiveBuildExpand(split, newMap);

        map.set(key, newMap);
      } else {
        map.set(key, "");
      }

      h.subHeaders.filter(function (s) {
        return s.type.key.indexOf("/") > 0;
      }).forEach(function (sh) {
        split = sh.type.key.split("/");
        key = _this.removeAnnotation(split.shift());

        if (split.length > 0) {
          var newMap = new Map();

          if (map.has(key)) {
            newMap = map.get(key);
          } // console.log("getExpandAsMap 3: ", h.type.key, sh.type.key);


          _this.recursiveBuildExpand(split, newMap);

          map.set(key, newMap);
        } else {
          map.set(key, "");
        }
      });
    });
    return map;
  };

  RedmineProvider.prototype.getRedmineQueryString = function (startIndex, count, sortOptions, wildcard, columnFilters, keys) {
    var map = new Map(); // map.set("$count", "true");

    if (startIndex !== undefined) {
      map.set("offset", startIndex.toString());
    }

    if (count !== undefined) {
      map.set("limit", count.toString());
    }

    var headers = this.headers;

    if (keys !== undefined) {
      headers = headers.filter(function (h) {
        return keys.some(function (k) {
          return k === h.type.key;
        });
      });
    }

    var expandString = this.getExpandAsString();

    if (expandString !== undefined && expandString !== "") {
      var customKeys = keys !== undefined ? keys.filter(function (k) {
        return k.indexOf("(") >= 0;
      }) : [];
      map.set("include", expandString + (customKeys !== undefined && customKeys.length > 0 ? "," + customKeys.join(",") : ""));
    } // const select = headers
    //   .filter(
    //     (h) => h.type.key.indexOf("/") === -1 && h.type.key.indexOf("[]") === -1
    //   )
    //   .map((h) => {
    //     const mine = h.type.getSelect();
    //     const subs = (h as RedmineHeader).subHeaders
    //       .filter((s) => s.type.key.indexOf("/") === -1)
    //       .map((s) => s.type.getSelect());
    //     return [mine].concat(subs).join(",");
    //   })
    //   .concat(
    //     keys === undefined
    //       ? []
    //       : keys.filter((k) => !this.headers.some((h) => h.type.key === k))
    //   )
    //   .filter((m) => m.indexOf("(") < 0);
    // const uniq = new Set(select);
    // if (select.length > 0 && this.options.useSelect) {
    //   map.set("$select", Array.from(uniq.values()).join(","));
    // }


    if (sortOptions !== undefined && sortOptions.length > 0) {
      map.set("sort", sortOptions.filter(function (o) {
        return o.header !== undefined;
      }).map(function (o) {
        var mine = "" + (o.header.orderByKey !== undefined ? o.header.orderByKey : o.header.type.key) + (o.direction === lib_SortDirection.Ascending ? "" : ":desc");
        return mine;
      }).join(","));
    }

    console.log(map); // default filter

    var filters = [];

    if (this.filter !== undefined) {
      filters.push(this.filter);
    } // wildcard


    var filter = this.getWildcardFilter(wildcard);

    if (filter !== undefined) {
      filters.push(filter);
    } // advanced


    if (columnFilters !== undefined) {
      var newFilters = columnFilters.map(function (f) {
        return f.toRedmineString();
      }).filter(function (f) {
        return f !== undefined;
      });
      console.log("new filters: ", newFilters);

      if (newFilters.length > 0) {
        filters.push(newFilters.join("&"));
      }
    }

    var ret = this.uri + "?" + Array.from(map.keys()).map(function (key) {
      return key + "=" + map.get(key);
    }).join("&");

    if (filters.length > 0) {
      // map.set("$filter", filters.map((f) => `(${encodeURIComponent(f)})`).join(" and "));
      ret += "&" + filters.map(function (f) {
        return f;
      }).join("&");
    }

    return ret;
  };

  RedmineProvider.prototype.getResultAsync = function (url) {
    return __awaiter(this, void 0, Promise, function () {
      var headers, res, length, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            headers = {
              "Accept": "application/json",
              "X-Redmine-API-Key": this.key
            };
            console.log(headers);
            return [4
            /*yield*/
            , this.http.get(url, headers)];

          case 1:
            res = _a.sent();
            console.log(res);
            length = res.total_count;
            items = res[this.entity];
            return [2
            /*return*/
            , new lib_FetchResult(length, items)];
        }
      });
    });
  };

  RedmineProvider.prototype.getWildcardFilter = function (filter) {
    return undefined;
  };

  RedmineProvider.prototype.removeAnnotation = function (name) {
    if (name === undefined) {
      return "";
    }

    return name.replace(/\[\]/g, "").replace(/\{\}/g, "");
  };

  RedmineProvider.prototype.recursiveBuildExpand = function (parts, map) {
    // console.log("recursiveBuildExpand: ", parts, map);
    if (parts.length === 0) {
      throw new Error("Called recursive build expand with not parts");
    }

    if (parts.length === 1) {
      var key = this.removeAnnotation(parts[0]); // console.log("recursiveBuildExpand 2: ", parts[0], key, map);

      if (parts[0] !== "" && !map.has(key)) {
        map.set(key, "");
        return;
      }

      return;
    } else {
      var key = this.removeAnnotation(parts.shift());
      var newMap = new Map();

      if (map.has(key)) {
        newMap = map.get(key);
      }

      this.recursiveBuildExpand(parts, newMap);
      map.set(key, newMap);
    }
  };

  RedmineProvider.prototype.recursiveGetExpandAsString = function (map) {
    var _this = this;

    var expands = [];
    map.forEach(function (value, key) {
      if (value !== "") {
        var val = _this.recursiveGetExpandAsString(value);

        if (val) {
          expands.push(key + "(" + val + ")");
        } else {
          expands.push("" + key);
        }
      }
    });
    var res = [];

    if (expands.length > 0) {
      res.push("$expand=" + expands.join(","));
    }

    return res.join(";");
  };

  return RedmineProvider;
}(lib_DataProvider);

/* harmony default export */ var redmine_RedmineProvider = (RedmineProvider_RedmineProvider);
// CONCATENATED MODULE: ./src/lib/redmine/RedmineOperator.ts





var RedmineOperator_RedmineOperator =
/** @class */
function (_super) {
  __extends(RedmineOperator, _super);

  function RedmineOperator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RedmineOperator.prototype.escapeValue = function (value) {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return value.toString().replace(/\'/g, "''");
  };

  return RedmineOperator;
}(lib_Operator);

/* harmony default export */ var redmine_RedmineOperator = (RedmineOperator_RedmineOperator);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineBooleanIs.ts



var RedmineBooleanIs_RedmineBooleanIs =
/** @class */
function (_super) {
  __extends(RedmineBooleanIs, _super);

  function RedmineBooleanIs() {
    return _super.call(this, "=", "pbascomponents.operators.is", ["pbascomponents.operators.true", "pbascomponents.operators.false"]) || this;
  }

  RedmineBooleanIs.prototype.getFilter = function (name, variable) {
    return variable === "pbascomponents.operators.true" || variable.toLowerCase() === "true" ? name + "=true" : name + "=false";
  };

  return RedmineBooleanIs;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineBooleanIs = (RedmineBooleanIs_RedmineBooleanIs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/redmine/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=43821d4e&
var BooleanInjectableComponentvue_type_template_id_43821d4e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"input-value":_vm.data.header.type.getValue(_vm.data.item, _vm.data.header.type),"readonly":true}})],1)}
var BooleanInjectableComponentvue_type_template_id_43821d4e_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/redmine/datatypes/BooleanInjectableComponent.vue?vue&type=template&id=43821d4e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/redmine/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&




var redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent =
/** @class */
function (_super) {
  __extends(BooleanInjectableComponent, _super);

  function BooleanInjectableComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], BooleanInjectableComponent.prototype, "data", void 0);

  BooleanInjectableComponent = __decorate([vue_class_component_common_default()({
    name: "BooleanInjectableComponent",
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"]
    }
  })], BooleanInjectableComponent);
  return BooleanInjectableComponent;
}(external_vue_default.a);

/* harmony default export */ var redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_BooleanInjectableComponent);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/BooleanInjectableComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var lib_redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_ = (redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/BooleanInjectableComponent.vue





/* normalize component */

var redmine_datatypes_BooleanInjectableComponent_component = normalizeComponent(
  lib_redmine_datatypes_BooleanInjectableComponentvue_type_script_lang_ts_,
  BooleanInjectableComponentvue_type_template_id_43821d4e_render,
  BooleanInjectableComponentvue_type_template_id_43821d4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var redmine_datatypes_BooleanInjectableComponent = (redmine_datatypes_BooleanInjectableComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineBoolean.ts






var RedmineBoolean_RedmineBoolean =
/** @class */
function (_super) {
  __extends(RedmineBoolean, _super);

  function RedmineBoolean(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Center,
      operators: args.operators || [new operators_RedmineBooleanIs()],
      getComponent: function getComponent(item, type) {
        return redmine_datatypes_BooleanInjectableComponent;
      },
      getEditableComponent: args.getEditableComponent,
      getHtml: args.getHtml,
      getString: args.getString,
      getValue: args.getValue,
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  return RedmineBoolean;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineBoolean = (RedmineBoolean_RedmineBoolean);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineDateEquals.ts




var RedmineDateEquals_RedmineDateEquals =
/** @class */
function (_super) {
  __extends(RedmineDateEquals, _super);

  function RedmineDateEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  RedmineDateEquals.prototype.getFilter = function (name, variable) {
    return name + "=" + this.escapeValue(variable).split('T')[0] + "T00:00:00Z";
  };

  return RedmineDateEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineDateEquals = (RedmineDateEquals_RedmineDateEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineDateGreaterThanOrEquals.ts




var RedmineDateGreaterThanOrEquals_RedmineDateGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(RedmineDateGreaterThanOrEquals, _super);

  function RedmineDateGreaterThanOrEquals() {
    return _super.call(this, ">=", "pbascomponents.operators.greater_or_equals", []) || this;
  }

  RedmineDateGreaterThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + "=>=" + this.escapeValue(variable).split('T')[0] + "T00:00:00Z";
  };

  return RedmineDateGreaterThanOrEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineDateGreaterThanOrEquals = (RedmineDateGreaterThanOrEquals_RedmineDateGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineDateLowerThanOrEquals.ts




var RedmineDateLowerThanOrEquals_RedmineDateLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(RedmineDateLowerThanOrEquals, _super);

  function RedmineDateLowerThanOrEquals() {
    return _super.call(this, "<=", "pbascomponents.operators.lower_or_equals", []) || this;
  }

  RedmineDateLowerThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + "=<=" + this.escapeValue(variable).split('T')[0] + "T00:00:00Z";
  };

  return RedmineDateLowerThanOrEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineDateLowerThanOrEquals = (RedmineDateLowerThanOrEquals_RedmineDateLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineDateTime.ts






 // import RedmineDateGreaterThan from '../operators/RedmineDateGreaterThan';

 // import RedmineDateLowerThan from '../operators/RedmineDateLowerThan';



var RedmineDateTime_RedmineDateTime =
/** @class */
function (_super) {
  __extends(RedmineDateTime, _super);

  function RedmineDateTime(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators || [new operators_RedmineDateEquals(), // new RedmineDateNotEquals(),
      // new RedmineDateGreaterThan(),
      new operators_RedmineDateGreaterThanOrEquals(), // new RedmineDateLowerThan(),
      new operators_RedmineDateLowerThanOrEquals()],
      getValue: args.getValue,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getString: args.getString || function (item) {
        var v = _this.getValue(item, _this); // console.log("v is ", v);


        if (v === null || v === undefined) {
          return "";
        }

        var _a = _this.getValue(item, _this).split("T"),
            date = _a[0],
            time = _a[1];

        var _b = date.split("-"),
            year = _b[0],
            month = _b[1],
            day = _b[2];

        var _c = time.split(":"),
            hours = _c[0],
            minutes = _c[1],
            seconds = _c[2];

        return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds.substring(0, 2) + " UTC";
      },
      getEditableComponent: args.getEditableComponent || function (filter, type) {
        var _data = {
          data: filter,
          menu: false,
          date: _this.toDateString(filter.value)
        };
        var v = external_vue_default.a.extend({
          template: "<div v-if=\"data\">\n                    <v-menu\n    v-model=\"menu\"\n    :close-on-content-click=\"false\"\n    :nudge-right=\"40\"\n    lazy\n    transition=\"scale-transition\"\n    offset-y\n    full-width\n    min-width=\"290px\"\n    max-width=\"290px\"\n  >\n    <template v-slot:activator=\"{ on }\">\n      <v-text-field\n        :value=\"date\"\n        :rules=\"data.operator.valueRules\"\n        readonly\n        v-on=\"on\"\n        @keyup.native=\"setDate($event.target.value)\"\n      ></v-text-field>\n    </template>\n    <v-date-picker v-model=\"date\" no-title scrollable>\n      <div class=\"flex-grow-1\"></div>\n      <v-btn text color=\"primary\" @click=\"menu = false\" >Cancel</v-btn>\n    </v-date-picker>\n  </v-menu>\n  </div>\n                    ",
          data: function data() {
            return _data;
          },
          components: {
            VDatePicker: lib_["VDatePicker"],
            VMenu: lib_["VMenu"],
            VBtn: lib_["VBtn"],
            VTextField: lib_["VTextField"]
          },
          watch: {
            date: {
              handler: function handler(val) {
                this.data.value = new Date(Date.parse(val)).toISOString();
                this.menu = false;
              }
            }
          },
          methods: {
            setDate: function setDate() {
              this.data.value = new Date(Date.parse(this.date)).toISOString();
              this.menu = false;
            }
          }
        });
        return v;
      },
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  RedmineDateTime.prototype.toDateString = function (variable) {
    var timestamp = Date.parse(variable);

    if (isNaN(timestamp)) {
      return "";
    }

    var _a = variable.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    var dateFormatted = year + "-" + month + "-" + day;
    return dateFormatted;
  };

  RedmineDateTime.prototype.typeString = function () {
    return "Date";
  };

  return RedmineDateTime;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineDateTime = (RedmineDateTime_RedmineDateTime);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineDateNotEquals.ts




var RedmineDateNotEquals_RedmineDateNotEquals =
/** @class */
function (_super) {
  __extends(RedmineDateNotEquals, _super);

  function RedmineDateNotEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  RedmineDateNotEquals.prototype.getFilter = function (name, variable) {
    return name + "!=" + this.escapeValue(variable).split('T')[0] + "T00:00:00Z";
  };

  return RedmineDateNotEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineDateNotEquals = (RedmineDateNotEquals_RedmineDateNotEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineStringContains.ts



var RedmineStringContains_RedmineStringContains =
/** @class */
function (_super) {
  __extends(RedmineStringContains, _super);

  function RedmineStringContains() {
    return _super.call(this, "⊆", "pbascomponents.operators.contains", []) || this;
  }

  RedmineStringContains.prototype.getFilter = function (name, variable) {
    return name + "=~" + this.escapeValue(variable);
  };

  return RedmineStringContains;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineStringContains = (RedmineStringContains_RedmineStringContains);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineDate.ts




 // import RedmineDateGreaterThan from "../operators/RedmineDateGreaterThan";

 // import RedmineDateLowerThan from "../operators/RedmineDateLowerThan";





var RedmineDate_RedmineDate =
/** @class */
function (_super) {
  __extends(RedmineDate, _super);

  function RedmineDate(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args !== undefined ? args.alignment : undefined,
      operators: args !== undefined && args.operators !== undefined ? args.operators : [new operators_RedmineDateEquals(), new operators_RedmineDateNotEquals(), // new RedmineDateGreaterThan(),
      new operators_RedmineDateGreaterThanOrEquals(), // new RedmineDateLowerThan(),
      new operators_RedmineDateLowerThanOrEquals()],
      getString: args.getString || function (item) {
        var parsed = _this.parseValue(_this.getValue(item, _this));

        return parsed; // return new Date(Date.parse(parsed)).toLocaleDateString();
      },
      getComponent: args.getComponent,
      getHtml: args.getHtml,
      getEditableComponent: args.getEditableComponent,
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  RedmineDate.prototype.getWildcardFilter = function (variable) {
    var filter = new redmine_RedmineColumnFilter(this); // filter.operator = new RedmineIndexOf();

    filter.operator = new operators_RedmineStringContains();
    filter.value = variable; // return "(" + filter.toRedmineString((name: string) => `cast(${name}, 'Edm.String')`)
    //     + " ge 0 and " + filter.toRedmineString((name: string) => `cast(${name}, 'Edm.String')`) + " le 10)";

    return filter.toRedmineString(function (name) {
      return "cast(date(" + name + "), 'Edm.String')";
    });
  };

  RedmineDate.prototype.typeString = function () {
    return "Date";
  };

  RedmineDate.prototype.parseValue = function (dateString) {
    if (dateString === undefined || dateString === null) {
      return "";
    }

    var _a = dateString.split("T"),
        date = _a[0],
        time = _a[1];

    var _b = date.split("-"),
        year = _b[0],
        month = _b[1],
        day = _b[2];

    return year + "-" + month + "-" + day;
  };

  return RedmineDate;
}(datatypes_RedmineDateTime);

/* harmony default export */ var datatypes_RedmineDate = (RedmineDate_RedmineDate);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineEquals.ts



var RedmineEquals_RedmineStrinEquals =
/** @class */
function (_super) {
  __extends(RedmineStrinEquals, _super);

  function RedmineStrinEquals() {
    return _super.call(this, "=", "pbascomponents.operators.equals", []) || this;
  }

  RedmineStrinEquals.prototype.getFilter = function (name, variable) {
    return name + "=" + this.escapeValue(variable);
  };

  return RedmineStrinEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineEquals = (RedmineEquals_RedmineStrinEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineGreaterThan.ts



var RedmineGreaterThan_RedmineDateGreaterThan =
/** @class */
function (_super) {
  __extends(RedmineDateGreaterThan, _super);

  function RedmineDateGreaterThan() {
    return _super.call(this, ">", "pbascomponents.operators.greater", []) || this;
  }

  RedmineDateGreaterThan.prototype.getFilter = function (name, variable) {
    return name + ">" + this.escapeValue(variable);
  };

  return RedmineDateGreaterThan;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineGreaterThan = (RedmineGreaterThan_RedmineDateGreaterThan);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineGreaterThanOrEquals.ts



var RedmineGreaterThanOrEquals_RedmineDateGreaterThanOrEquals =
/** @class */
function (_super) {
  __extends(RedmineDateGreaterThanOrEquals, _super);

  function RedmineDateGreaterThanOrEquals() {
    return _super.call(this, ">=", "pbascomponents.operators.greater_or_equals", []) || this;
  }

  RedmineDateGreaterThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + ">=" + this.escapeValue(variable);
  };

  return RedmineDateGreaterThanOrEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineGreaterThanOrEquals = (RedmineGreaterThanOrEquals_RedmineDateGreaterThanOrEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineLowerThan.ts



var RedmineLowerThan_RedmineDateLowerThan =
/** @class */
function (_super) {
  __extends(RedmineDateLowerThan, _super);

  function RedmineDateLowerThan() {
    return _super.call(this, "<", "pbascomponents.operators.lower", []) || this;
  }

  RedmineDateLowerThan.prototype.getFilter = function (name, variable) {
    return name + "<" + this.escapeValue(variable);
  };

  return RedmineDateLowerThan;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineLowerThan = (RedmineLowerThan_RedmineDateLowerThan);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineLowerThanOrEquals.ts



var RedmineLowerThanOrEquals_RedmineDateLowerThanOrEquals =
/** @class */
function (_super) {
  __extends(RedmineDateLowerThanOrEquals, _super);

  function RedmineDateLowerThanOrEquals() {
    return _super.call(this, "<=", "pbascomponents.operators.lower_or_equals", []) || this;
  }

  RedmineDateLowerThanOrEquals.prototype.getFilter = function (name, variable) {
    return name + "<=" + this.escapeValue(variable);
  };

  return RedmineDateLowerThanOrEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineLowerThanOrEquals = (RedmineLowerThanOrEquals_RedmineDateLowerThanOrEquals);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineNotEquals.ts



var RedmineNotEquals_RedmineStringNotEquals =
/** @class */
function (_super) {
  __extends(RedmineStringNotEquals, _super);

  function RedmineStringNotEquals() {
    return _super.call(this, "≠", "pbascomponents.operators.not_equals", []) || this;
  }

  RedmineStringNotEquals.prototype.getFilter = function (name, variable) {
    return name + "!=" + this.escapeValue(variable);
  };

  return RedmineStringNotEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var RedmineNotEquals = (RedmineNotEquals_RedmineStringNotEquals);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineDecimal.ts












var RedmineDecimal_RedmineDecimal =
/** @class */
function (_super) {
  __extends(RedmineDecimal, _super);

  function RedmineDecimal(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new RedmineEquals(), new RedmineNotEquals(), new RedmineGreaterThan(), new RedmineGreaterThanOrEquals(), new RedmineLowerThan(), new RedmineLowerThanOrEquals()],
      getString: args !== undefined && args.getString !== undefined ? args.getString : function (item, type) {
        var val = _this.getValue(item, _this);

        if (val !== undefined && val !== null) {
          return val.toFixed(2);
        }

        return "";
      },
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        var _data = {
          data: filter
        };
        var v = external_vue_default.a.extend({
          template: "<v-text-field autofocus label='Value' type='number' v-model='data.value' :rules='data.operator.valueRules'></v-text-field>",
          components: {
            VTextField: lib_["VTextField"]
          },
          data: function data() {
            return _data;
          }
        });
        return v;
      },
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  RedmineDecimal.prototype.typeString = function () {
    return "Decimal";
  };

  return RedmineDecimal;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineDecimal = (RedmineDecimal_RedmineDecimal);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineInteger.ts












var RedmineInteger_RedmineInteger =
/** @class */
function (_super) {
  __extends(RedmineInteger, _super);

  function RedmineInteger(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Right,
      operators: args.operators || [new RedmineEquals(), new RedmineNotEquals(), new RedmineGreaterThan(), new RedmineGreaterThanOrEquals(), new RedmineLowerThan(), new RedmineLowerThanOrEquals()],
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        var _data = {
          data: filter
        };
        var v = external_vue_default.a.extend({
          template: "<v-text-field autofocus label='Value' type='number' v-model='data.value' :rules='data.operator.valueRules'></v-text-field>",
          components: {
            VTextField: lib_["VTextField"]
          },
          data: function data() {
            return _data;
          }
        });
        return v;
      },
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  RedmineInteger.prototype.typeString = function () {
    return "Integer";
  };

  return RedmineInteger;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineInteger = (RedmineInteger_RedmineInteger);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineStringNotContains.ts



var RedmineStringNotContains_RedmineStringNotContains =
/** @class */
function (_super) {
  __extends(RedmineStringNotContains, _super);

  function RedmineStringNotContains() {
    return _super.call(this, "⊄", "pbascomponents.operators.not_contains", []) || this;
  }

  RedmineStringNotContains.prototype.getFilter = function (name, variable) {
    return name + "!=~" + this.escapeValue(variable);
  };

  return RedmineStringNotContains;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineStringNotContains = (RedmineStringNotContains_RedmineStringNotContains);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineString.ts








var RedmineString_RedmineString =
/** @class */
function (_super) {
  __extends(RedmineString, _super);

  function RedmineString(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators === undefined ? [new operators_RedmineStringContains(), new operators_RedmineStringNotContains(), new RedmineEquals(), new RedmineNotEquals()] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent,
      defaultFilters: args.defaultFilters || [],
      additionalKeys: args.additionalKeys || [],
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  return RedmineString;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineString = (RedmineString_RedmineString);
// CONCATENATED MODULE: ./src/lib/redmine/operators/RedmineEnumEquals.ts



var RedmineEnumEquals_RedmineEnumEquals =
/** @class */
function (_super) {
  __extends(RedmineEnumEquals, _super);

  function RedmineEnumEquals(dropdownItems) {
    var _this = _super.call(this, "=", "pbascomponents.operators.equals", []) || this;

    _this.dropdownItems = dropdownItems;
    return _this;
  }

  RedmineEnumEquals.prototype.getFilter = function (name, variable) {
    return name + "=" + variable;
  };

  return RedmineEnumEquals;
}(redmine_RedmineOperator);

/* harmony default export */ var operators_RedmineEnumEquals = (RedmineEnumEquals_RedmineEnumEquals);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"8d2d355a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/redmine/components/EnumRedmineComponent.vue?vue&type=template&id=3ac62656&
var EnumRedmineComponentvue_type_template_id_3ac62656_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Value","items":_vm.data.operator.dropdownItems,"rules":_vm.data.operator.valueRules,"item-text":"name","item-value":"id"},model:{value:(_vm.data.value),callback:function ($$v) {_vm.$set(_vm.data, "value", $$v)},expression:"data.value"}})}
var EnumRedmineComponentvue_type_template_id_3ac62656_staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/redmine/components/EnumRedmineComponent.vue?vue&type=template&id=3ac62656&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/redmine/components/EnumRedmineComponent.vue?vue&type=script&lang=ts&




var EnumRedmineComponentvue_type_script_lang_ts_EnumRedmineComponent =
/** @class */
function (_super) {
  __extends(EnumRedmineComponent, _super);

  function EnumRedmineComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop(), __metadata("design:type", Object)], EnumRedmineComponent.prototype, "data", void 0);

  EnumRedmineComponent = __decorate([vue_class_component_common_default()({
    components: {
      VCheckbox: lib_["VCheckbox"],
      VIcon: lib_["VIcon"],
      VSelect: lib_["VSelect"]
    }
  })], EnumRedmineComponent);
  return EnumRedmineComponent;
}(external_vue_default.a);

/* harmony default export */ var EnumRedmineComponentvue_type_script_lang_ts_ = (EnumRedmineComponentvue_type_script_lang_ts_EnumRedmineComponent);
// CONCATENATED MODULE: ./src/lib/redmine/components/EnumRedmineComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_EnumRedmineComponentvue_type_script_lang_ts_ = (EnumRedmineComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/lib/redmine/components/EnumRedmineComponent.vue





/* normalize component */

var EnumRedmineComponent_component = normalizeComponent(
  components_EnumRedmineComponentvue_type_script_lang_ts_,
  EnumRedmineComponentvue_type_template_id_3ac62656_render,
  EnumRedmineComponentvue_type_template_id_3ac62656_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_EnumRedmineComponent = (EnumRedmineComponent_component.exports);
// CONCATENATED MODULE: ./src/lib/redmine/datatypes/RedmineEnum.ts






var RedmineEnum_RedmineEnum =
/** @class */
function (_super) {
  __extends(RedmineEnum, _super);

  function RedmineEnum(key, args) {
    var _this = this;

    if (args === undefined) {
      args = {};
    }

    _this = _super.call(this, key, {
      alignment: args.alignment || lib_HeaderAlignment.Left,
      operators: args.operators === undefined ? [new operators_RedmineEnumEquals(args.dropdownItems ? args.dropdownItems : [])] : undefined,
      getValue: args.getValue,
      getString: args.getString,
      getHtml: args.getHtml,
      getComponent: args.getComponent,
      getEditableComponent: args.getEditableComponent !== undefined ? args.getEditableComponent : function (filter, type) {
        return components_EnumRedmineComponent;
      },
      searchKey: args.searchKey
    }) || this;
    return _this;
  }

  return RedmineEnum;
}(redmine_RedmineType);

/* harmony default export */ var datatypes_RedmineEnum = (RedmineEnum_RedmineEnum);
// EXTERNAL MODULE: ./src/lib/IDataExporter.ts
var IDataExporter = __webpack_require__("da64");
var IDataExporter_default = /*#__PURE__*/__webpack_require__.n(IDataExporter);

// CONCATENATED MODULE: ./src/lib/exporters/CsvExporter.ts







var CsvExporter_CsvExporter =
/** @class */
function () {
  function CsvExporter() {
    this.label = "CSV";
    this.extension = "csv";
  }

  CsvExporter.prototype.getSupportedOperations = function (table) {
    var basic = ["pbascomponents.csvexporter.current_page", "pbascomponents.csvexporter.all_pages"];

    if (table.$data.selected !== undefined && table.$data.selected.length > 0) {
      basic.push("pbascomponents.csvexporter.selected");
    }

    return basic;
  };

  CsvExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.csvexporter.selected":
        return this.exportSelected(table);

      case "pbascomponents.csvexporter.current_page":
        return this.exportCurrentPage(table);

      default:
        return this.exportAll(table);
    }
  };

  CsvExporter.prototype.exportCurrentPage = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, rows, visibles, dyn, items, _i, items_1, item;

      return __generator(this, function (_a) {
        provider = table.$props.dataProvider;
        headers = provider.headers;
        rows = [];
        visibles = headers.filter(function (h) {
          return h.visible;
        });
        dyn = table;
        rows.push(this.valuesToCsvRow(visibles.map(function (h) {
          return dyn.$t !== undefined ? dyn.$t(h.title) : h.title;
        })));
        items = table.$data.fetchResult.items;

        for (_i = 0, items_1 = items; _i < items_1.length; _i++) {
          item = items_1[_i];
          rows.push(this.itemToCsvRow(visibles, item));
        }

        return [2
        /*return*/
        , this.toBlob(rows)];
      });
    });
  };

  CsvExporter.prototype.exportAll = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, rows, visibles, dyn, οpts, sortOptions, res, items, _i, items_2, item;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers;
            rows = [];
            visibles = headers.filter(function (h) {
              return h.visible;
            });
            dyn = table;
            rows.push(this.valuesToCsvRow(visibles.map(function (h) {
              return dyn.$t !== undefined ? dyn.$t(h.title) : h.title;
            })));
            οpts = table.$data.options;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            return [4
            /*yield*/
            , provider.fetchAsync(undefined, undefined, sortOptions, table.$data.search, table.$data.filters)];

          case 1:
            res = _a.sent();
            items = res.items;

            for (_i = 0, items_2 = items; _i < items_2.length; _i++) {
              item = items_2[_i];
              rows.push(this.itemToCsvRow(visibles, item));
            }

            return [2
            /*return*/
            , this.toBlob(rows)];
        }
      });
    });
  };

  CsvExporter.prototype.exportSelected = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, rows, visibles, dyn, items, _i, items_3, item;

      return __generator(this, function (_a) {
        provider = table.$props.dataProvider;
        headers = provider.headers;
        rows = [];
        visibles = headers.filter(function (h) {
          return h.visible;
        });
        dyn = table;
        rows.push(this.valuesToCsvRow(visibles.map(function (h) {
          return dyn.$t !== undefined ? dyn.$t(h.title) : h.title;
        })));
        items = table.$data.selected;

        for (_i = 0, items_3 = items; _i < items_3.length; _i++) {
          item = items_3[_i];
          rows.push(this.itemToCsvRow(visibles, item));
        }

        return [2
        /*return*/
        , this.toBlob(rows)];
      });
    });
  };

  CsvExporter.prototype.toBlob = function (result) {
    return new Blob(["\uFEFF", result.join("\r\n")], {
      type: "data:text/csv;charset=utf-8"
    });
  };

  CsvExporter.prototype.escapeQuotes = function (dataString) {
    if (dataString === undefined) {
      return "";
    }

    return dataString.replace(/\"/g, '""');
  };

  CsvExporter.prototype.itemToCsvRow = function (headers, row) {
    var _this = this;

    return headers.map(function (h) {
      return _this.valueToCsv(h.type.getString(row, h.type));
    }).join(",");
  };

  CsvExporter.prototype.valuesToCsvRow = function (data) {
    var _this = this;

    return data.map(function (s) {
      return _this.valueToCsv(s);
    }).join(",");
  };

  CsvExporter.prototype.valueToCsv = function (data) {
    return "\"" + this.escapeQuotes(data) + "\"";
  };

  return CsvExporter;
}();

/* harmony default export */ var exporters_CsvExporter = (CsvExporter_CsvExporter);
// CONCATENATED MODULE: ./src/lib/exporters/CsvWithHistoryExporter.ts







var CsvWithHistoryExporter_CsvWithHistoryExporter =
/** @class */
function (_super) {
  __extends(CsvWithHistoryExporter, _super);

  function CsvWithHistoryExporter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.label = "CSV";
    return _this;
  }

  CsvWithHistoryExporter.prototype.getSupportedOperations = function (table) {
    var ret = _super.prototype.getSupportedOperations.call(this, table);

    return ret.concat(["pbascomponents.csvexporter.current_page_with_history", "pbascomponents.csvexporter.all_pages_with_history"]);
  };

  CsvWithHistoryExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.csvexporter.current_page_with_history":
        return this.exportCurrentPageWithHistory(table);

      case "pbascomponents.csvexporter.all_pages_with_history":
        return this.exportAllWithHistory(table);

      default:
        return _super.prototype.export.call(this, table, funcName);
    }
  };

  CsvWithHistoryExporter.prototype.exportCurrentPageWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, rows, visibles, dyn, οpts, start, count, sortOptions, expands, res, items, _i, items_1, item, _a, _b, h;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers;
            rows = [];
            visibles = headers.filter(function (h) {
              return h.visible;
            });
            dyn = table;
            rows.push(this.valuesToCsvRow(visibles.map(function (h) {
              return dyn.$t !== undefined ? dyn.$t(h.title) : h.title;
            })));
            οpts = table.$data.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            return [4
            /*yield*/
            , provider.fetchAsync(start, count, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]))];

          case 1:
            res = _c.sent();
            items = res.items;

            for (_i = 0, items_1 = items; _i < items_1.length; _i++) {
              item = items_1[_i];
              rows.push(this.itemToCsvRow(visibles, item));

              if (item.ActualHistory !== undefined) {
                for (_a = 0, _b = item.ActualHistory; _a < _b.length; _a++) {
                  h = _b[_a];
                  rows.push(this.itemToCsvRow(visibles, h));
                }
              }
            }

            return [2
            /*return*/
            , this.toBlob(rows)];
        }
      });
    });
  };

  CsvWithHistoryExporter.prototype.exportAllWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, rows, visibles, dyn, οpts, sortOptions, expands, res, items, _i, items_2, item, _a, _b, h;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers;
            rows = [];
            visibles = headers.filter(function (h) {
              return h.visible;
            });
            dyn = table;
            rows.push(this.valuesToCsvRow(visibles.map(function (h) {
              return dyn.$t !== undefined ? dyn.$t(h.title) : h.title;
            })));
            οpts = table.$data.options;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            return [4
            /*yield*/
            , provider.fetchAsync(undefined, undefined, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]))];

          case 1:
            res = _c.sent();
            items = res.items;

            for (_i = 0, items_2 = items; _i < items_2.length; _i++) {
              item = items_2[_i];
              rows.push(this.itemToCsvRow(visibles, item));

              if (item.ActualHistory !== undefined) {
                for (_a = 0, _b = item.ActualHistory; _a < _b.length; _a++) {
                  h = _b[_a];
                  rows.push(this.itemToCsvRow(visibles, h));
                }
              }
            }

            return [2
            /*return*/
            , this.toBlob(rows)];
        }
      });
    });
  };

  return CsvWithHistoryExporter;
}(exporters_CsvExporter);

/* harmony default export */ var exporters_CsvWithHistoryExporter = (CsvWithHistoryExporter_CsvWithHistoryExporter);
// CONCATENATED MODULE: ./src/lib/exporters/DataToExcelConverter.ts



var DataToExcelConverter_DataToExcelConverter =
/** @class */
function () {
  function DataToExcelConverter(http, url) {
    this.http = http;
    this.url = url;
  }

  DataToExcelConverter.prototype.convert = function (data) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.http.post(this.url, data, {
              Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return DataToExcelConverter;
}();

/* harmony default export */ var exporters_DataToExcelConverter = (DataToExcelConverter_DataToExcelConverter);

var ExcelData =
/** @class */
function () {
  function ExcelData() {}

  return ExcelData;
}();



var HeaderInfo =
/** @class */
function () {
  function HeaderInfo(name, type) {
    this.name = name;
    this.type = type;
  }

  return HeaderInfo;
}();


// CONCATENATED MODULE: ./src/lib/exporters/ExcelExporter.ts







var ExcelExporter_ExcelExporter =
/** @class */
function () {
  function ExcelExporter(converter) {
    this.extension = "xlsx";
    this.label = "Microsoft Excel";
    this.converter = converter;
  }

  ExcelExporter.prototype.getSupportedOperations = function (table) {
    var basic = ["pbascomponents.excelexporter.current_page", "pbascomponents.excelexporter.all_pages"];

    if (table.$data.selected !== undefined && table.$data.selected.length > 0) {
      basic.push("pbascomponents.excelexporter.selected");
    }

    return basic;
  };

  ExcelExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.excelexporter.current_page":
        return this.exportCurrentPage(table);

      case "pbascomponents.excelexporter.all_pages":
        return this.exportAll(table);

      default:
        return this.exportSelected(table);
    }
  };

  ExcelExporter.prototype.exportCurrentPage = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            return [4
            /*yield*/
            , provider.fetchAsync(start, count, sortOptions, table.$data.search, table.$data.filters)];

          case 1:
            data = _a.sent();
            return [4
            /*yield*/
            , this.exportData(table, data, headers)];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  ExcelExporter.prototype.exportData = function (table, data, headers) {
    return __awaiter(this, void 0, Promise, function () {
      var body, myRows, _i, _a, item, newRow, _b, headers_1, h, val, hist, _c, _d, hItem, ih, _e, headers_2, h2, val, dyn;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            body = new ExcelData();
            myRows = [];

            for (_i = 0, _a = data.items; _i < _a.length; _i++) {
              item = _a[_i];
              newRow = [];

              for (_b = 0, headers_1 = headers; _b < headers_1.length; _b++) {
                h = headers_1[_b];

                if (h.title !== "ActualHistory") {
                  val = h.type.getString(item, h.type);
                  newRow.push(val);
                } else {
                  hist = [];

                  for (_c = 0, _d = item.ActualHistory; _c < _d.length; _c++) {
                    hItem = _d[_c];
                    ih = [];

                    for (_e = 0, headers_2 = headers; _e < headers_2.length; _e++) {
                      h2 = headers_2[_e];

                      if (h2.title !== "ActualHistory") {
                        val = h2.type.getString(hItem, h2.type);
                        ih.push(val);
                      }
                    }

                    hist.push(ih);
                  }

                  newRow.push(hist);
                }
              }

              myRows.push(newRow);
            }

            body.rows = myRows;
            dyn = table;
            body.headers = headers.map(function (header) {
              return new HeaderInfo(dyn.$t !== undefined ? dyn.$t(header.title) : header.title, header.type.typeString());
            });
            return [4
            /*yield*/
            , this.converter.convert(body)];

          case 1:
            return [2
            /*return*/
            , _f.sent()];
        }
      });
    });
  };

  ExcelExporter.prototype.exportAll = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = undefined;
            count = undefined;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            return [4
            /*yield*/
            , provider.fetchAsync(start, count, sortOptions, table.$data.search, table.$data.filters)];

          case 1:
            data = _a.sent();
            return [4
            /*yield*/
            , this.exportData(table, data, headers)];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  ExcelExporter.prototype.exportSelected = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            return [4
            /*yield*/
            , this.exportData(table, table.$data.selected, headers)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return ExcelExporter;
}();

/* harmony default export */ var exporters_ExcelExporter = (ExcelExporter_ExcelExporter);
// CONCATENATED MODULE: ./src/lib/exporters/ExcelWithHistoryExporter.ts










var ExcelWithHistoryExporter_ExcelWithHistoryExporter =
/** @class */
function (_super) {
  __extends(ExcelWithHistoryExporter, _super);

  function ExcelWithHistoryExporter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.label = "Microsoft Excel";
    return _this;
  }

  ExcelWithHistoryExporter.prototype.getSupportedOperations = function (table) {
    var ret = _super.prototype.getSupportedOperations.call(this, table);

    return ret.concat(["pbascomponents.excelexporter.current_page_with_history", "pbascomponents.excelexporter.all_pages_with_history"]);
  };

  ExcelWithHistoryExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.excelexporter.all_pages_with_history":
        return this.exportAllWithHistory(table);

      case "pbascomponents.excelexporter.current_page_with_history":
        return this.exportCurrentPageWithHistory(table);

      default:
        return _super.prototype.export.call(this, table, funcName);
    }
  };

  ExcelWithHistoryExporter.prototype.exportCurrentPageWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, expands, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            return [4
            /*yield*/
            , provider.fetchAsync(start, count, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]))];

          case 1:
            data = _a.sent();
            headers.push(new lib_Header({
              title: "ActualHistory",
              type: new ExcelWithHistoryExporter_ActualHistoryType(),
              isIdentifier: false
            }));
            return [4
            /*yield*/
            , this.exportData(table, data, headers)];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  ExcelWithHistoryExporter.prototype.exportAllWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, sortOptions, expands, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            return [4
            /*yield*/
            , provider.fetchAsync(undefined, undefined, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]))];

          case 1:
            data = _a.sent();
            headers.push(new lib_Header({
              title: "ActualHistory",
              type: new ExcelWithHistoryExporter_ActualHistoryType(),
              isIdentifier: false
            }));
            return [4
            /*yield*/
            , this.exportData(table, data, headers)];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return ExcelWithHistoryExporter;
}(exporters_ExcelExporter);

/* harmony default export */ var exporters_ExcelWithHistoryExporter = (ExcelWithHistoryExporter_ExcelWithHistoryExporter);

var ExcelWithHistoryExporter_ActualHistoryType =
/** @class */
function (_super) {
  __extends(ActualHistoryType, _super);

  function ActualHistoryType() {
    return _super.call(this, "ActualHistory") || this;
  }

  ActualHistoryType.prototype.createNewFilter = function (header) {
    return new lib_ColumnFilter(this);
  };

  ActualHistoryType.prototype.typeString = function () {
    return "String";
  };

  return ActualHistoryType;
}(lib_DataType);
// CONCATENATED MODULE: ./src/lib/exporters/DirectExcelExporter.ts







var DirectExcelExporter_DirectExcelExporter =
/** @class */
function () {
  function DirectExcelExporter(converter) {
    this.extension = "xlsx";
    this.label = "Microsoft Excel";
    this.headers = {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
    this.converter = converter;
  }

  DirectExcelExporter.prototype.getSupportedOperations = function (table) {
    var basic = ["pbascomponents.excelexporter.current_page", "pbascomponents.excelexporter.all_pages"];

    if (table.$data.selected !== undefined && table.$data.selected.length > 0) {
      basic.push("pbascomponents.excelexporter.selected");
    }

    return basic;
  };

  DirectExcelExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.excelexporter.current_page":
        return this.exportCurrentPage(table);

      case "pbascomponents.excelexporter.all_pages":
        return this.exportAll(table);

      default:
        return this.exportSelected(table);
    }
  };

  DirectExcelExporter.prototype.exportCurrentPage = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            url = provider.getODataQueryString(start, count, sortOptions, table.$data.search, table.$data.filters);
            return [4
            /*yield*/
            , provider.http.get(url, this.headers)];

          case 1:
            data = _a.sent();
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  DirectExcelExporter.prototype.exportAll = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = undefined;
            count = undefined;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            url = provider.getODataQueryString(start, count, sortOptions, table.$data.search, table.$data.filters);
            return [4
            /*yield*/
            , provider.http.get(url, this.headers)];

          case 1:
            data = _a.sent();
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  DirectExcelExporter.prototype.exportData = function (table, data, headers) {
    return __awaiter(this, void 0, Promise, function () {
      var body, myRows, _i, _a, item, newRow, _b, headers_1, h, val, hist, _c, _d, hItem, ih, _e, headers_2, h2, val, dyn;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            body = new ExcelData();
            myRows = [];

            for (_i = 0, _a = data.items; _i < _a.length; _i++) {
              item = _a[_i];
              newRow = [];

              for (_b = 0, headers_1 = headers; _b < headers_1.length; _b++) {
                h = headers_1[_b];

                if (h.title !== "ActualHistory") {
                  val = h.type.getString(item, h.type);
                  newRow.push(val);
                } else {
                  hist = [];

                  for (_c = 0, _d = item.ActualHistory; _c < _d.length; _c++) {
                    hItem = _d[_c];
                    ih = [];

                    for (_e = 0, headers_2 = headers; _e < headers_2.length; _e++) {
                      h2 = headers_2[_e];

                      if (h2.title !== "ActualHistory") {
                        val = h2.type.getString(hItem, h2.type);
                        ih.push(val);
                      }
                    }

                    hist.push(ih);
                  }

                  newRow.push(hist);
                }
              }

              myRows.push(newRow);
            }

            body.rows = myRows;
            dyn = table;
            body.headers = headers.map(function (header) {
              return new HeaderInfo(dyn.$t !== undefined ? dyn.$t(header.title) : header.title, header.type.typeString());
            });
            return [4
            /*yield*/
            , this.converter.convert(body)];

          case 1:
            return [2
            /*return*/
            , _f.sent()];
        }
      });
    });
  };

  DirectExcelExporter.prototype.exportSelected = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            return [4
            /*yield*/
            , this.exportData(table, table.$data.selected, headers)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return DirectExcelExporter;
}();

/* harmony default export */ var exporters_DirectExcelExporter = (DirectExcelExporter_DirectExcelExporter);
// CONCATENATED MODULE: ./src/lib/exporters/DirectExcelWithHistoryExporter.ts









var DirectExcelWithHistoryExporter_ExcelWithHistoryExporter =
/** @class */
function (_super) {
  __extends(ExcelWithHistoryExporter, _super);

  function ExcelWithHistoryExporter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.label = "Microsoft Excel";
    return _this;
  }

  ExcelWithHistoryExporter.prototype.getSupportedOperations = function (table) {
    var ret = _super.prototype.getSupportedOperations.call(this, table);

    return ret.concat(["pbascomponents.excelexporter.current_page_with_history", "pbascomponents.excelexporter.all_pages_with_history"]);
  };

  ExcelWithHistoryExporter.prototype.export = function (table, funcName) {
    switch (funcName) {
      case "pbascomponents.excelexporter.all_pages_with_history":
        return this.exportAllWithHistory(table);

      case "pbascomponents.excelexporter.current_page_with_history":
        return this.exportCurrentPageWithHistory(table);

      default:
        return _super.prototype.export.call(this, table, funcName);
    }
  };

  ExcelWithHistoryExporter.prototype.exportCurrentPageWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, start, count, sortOptions, expands, url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            start = (οpts.page - 1) * οpts.itemsPerPage;
            count = οpts.itemsPerPage;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            url = provider.getODataQueryString(start, count, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]));
            return [4
            /*yield*/
            , provider.http.get(url, this.headers)];

          case 1:
            data = _a.sent();
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ExcelWithHistoryExporter.prototype.exportAllWithHistory = function (table) {
    return __awaiter(this, void 0, Promise, function () {
      var provider, headers, οpts, sortOptions, expands, url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = table.$props.dataProvider;
            headers = provider.headers.filter(function (h) {
              return h.visible;
            });
            οpts = table.$data.options;
            sortOptions = οpts.sortBy.map(function (header, index) {
              if (provider !== undefined) {
                var headerObj = provider.headers.filter(function (h) {
                  return h.type.key === header;
                })[0];
                return new lib_SortOption(headerObj, οpts.sortDesc[index] ? lib_SortDirection.Descending : lib_SortDirection.Ascending);
              }
            });
            expands = provider.getExpandAsString();
            url = provider.getODataQueryString(undefined, undefined, sortOptions, table.$data.search, table.$data.filters, provider.headers.map(function (h) {
              return h.type.key;
            }).concat(["ActualHistory($expand=" + expands + ")"]));
            return [4
            /*yield*/
            , provider.http.get(url, this.headers)];

          case 1:
            data = _a.sent();
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return ExcelWithHistoryExporter;
}(exporters_DirectExcelExporter);

/* harmony default export */ var DirectExcelWithHistoryExporter = (DirectExcelWithHistoryExporter_ExcelWithHistoryExporter);

var DirectExcelWithHistoryExporter_ActualHistoryType =
/** @class */
function (_super) {
  __extends(ActualHistoryType, _super);

  function ActualHistoryType() {
    return _super.call(this, "ActualHistory") || this;
  }

  ActualHistoryType.prototype.createNewFilter = function (header) {
    return new lib_ColumnFilter(this);
  };

  ActualHistoryType.prototype.typeString = function () {
    return "String";
  };

  return ActualHistoryType;
}(lib_DataType);
// CONCATENATED MODULE: ./src/lib/CodeFunction.ts
var CodeFunction =
/** @class */
function () {
  function CodeFunction(name, description, example, args) {
    this.name = name;
    this.description = description;
    this.example = example;
    this.args = args;
  }

  return CodeFunction;
}();

var CodeArgument =
/** @class */
function () {
  function CodeArgument(name, label, description, defaultValue, type, parameterType) {
    this.name = name;
    this.label = label;
    this.description = description;
    this.defaultValue = defaultValue;
    this.type = type;
    this.parameterType = parameterType;
  }

  return CodeArgument;
}();


// CONCATENATED MODULE: ./src/index.ts




















var Components = {
  PbasDataTable: components_PbasDataTable,
  LogicalExpressions: components_LogicalExpressions,
  PbasSimpleTable: components_PbasSimpleTable,
  PbasDatePicker: components_PbasDatePicker,
  PbasColumnFilters: PbasColumnFilters,
  PbasCustomizeColumns: components_PbasCustomizeColumns,
  MaterialCard: components_MaterialCard,
  MaterialStatsCard: components_MaterialStatsCard,
  CodeEditor: components_CodeEditor,
  AceEditor: components_AceEditor,
  NodeComponent: components_NodeComponent,
  CodeToolbox: components_CodeToolbox,
  CardDesigner: components_CardDesigner,
  ToolTipButton: ToolTipButton
};
Object.keys(Components).forEach(function (name) {
  external_vue_default.a.component(name, Components[name]);
});
external_vue_default.a.directive("clickAsync", {
  bind: function bind(el, binding, vnode) {
    // console.log("element click async", el, binding, vnode);
    if (vnode.componentInstance === undefined) {
      return;
    }

    vnode.componentInstance.$on("click", function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var span, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (vnode.componentInstance === undefined) {
                return [2
                /*return*/
                ];
              }

              el.classList.add("v-btn--loading");
              span = document.createElement("span");
              span.classList.add("v-btn__loader");
              span.innerHTML = "<div role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" class=\"v-progress-circular v-progress-circular--indeterminate\" style=\"height: 23px; width: 23px;\">\n               <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381\" style=\"transform: rotate(0deg);\">\n                  <circle fill=\"transparent\" cx=\"43.80952380952381\" cy=\"43.80952380952381\" r=\"20\" stroke-width=\"3.8095238095238093\" stroke-dasharray=\"125.664\" stroke-dashoffset=\"125.66370614359172px\" class=\"v-progress-circular__overlay\"></circle>\n               </svg>\n               <div class=\"v-progress-circular__info\"></div>\n            </div>";
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3, 4, 5]);

              el.appendChild(span);
              return [4
              /*yield*/
              , binding.value()];

            case 2:
              _a.sent();

              return [3
              /*break*/
              , 5];

            case 3:
              error_1 = _a.sent();
              throw error_1;

            case 4:
              el.removeChild(span);
              el.classList.remove("v-btn--loading");
              return [7
              /*endfinally*/
              ];

            case 5:
              return [2
              /*return*/
              ];
          }
        });
      });
    });
  }
});












 // odata data types








 // odata operators
















 // inmemory data types






 // inmemory operators














 // odata data types





 // odata operators
























 // redmine data types







 // redmine operators




















/* harmony default export */ var src = (Components);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ }),

/***/ "fdef":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "fe1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasCustomizeColumns_vue_vue_type_style_index_0_id_313c9c82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e61");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasCustomizeColumns_vue_vue_type_style_index_0_id_313c9c82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasCustomizeColumns_vue_vue_type_style_index_0_id_313c9c82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PbasCustomizeColumns_vue_vue_type_style_index_0_id_313c9c82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ })

/******/ });
//# sourceMappingURL=pbas-vue-components.common.js.map